/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AboutSectionCategory {
  i_about_section_category: number;
  translations?: AboutSectionCategoryTranslation[];
}

export interface AboutSectionCategoryTranslation {
  i_language: number;
  lang_code: string;
  name: string;
  parameters: string;
}

export interface ActivationRule {
  question_id?: string;
  ref_value?: number;
  rules?: string[];
  /** @example "==" */
  type: "&&" | "<=" | "==" | ">=" | "||";
}

export interface ActivitiesPagination {
  limit?: number;
  offset?: number;
  total_count?: number;
}

export interface Activity {
  activity_date: number;
  /** @example "call" */
  activity_type: "call" | "email" | "meeting" | "note";
  contact_name: string;
  created: number;
  crm_activity_guid: string;
  crm_standalone_contact_guid: string;
  description: string;
  updated?: number;
}

export interface ActivityDeletedCount {
  deleted_count: number;
}

export interface ActivityDeletedCountSuccess {
  response?: ActivityDeletedCount;
  /** @default true */
  success?: boolean;
}

export interface ActivityList {
  data?: Activity[];
  pagination?: ActivitiesPagination;
}

export interface ActivityListSuccess {
  response?: ActivityList;
  /** @default true */
  success?: boolean;
}

export interface ActivitySuccess {
  response?: Activity;
  /** @default true */
  success?: boolean;
}

export interface Address {
  city: string;
  country: string;
  name?: string;
  name2?: string;
  name3?: string;
  street: string;
  zip: string;
}

export interface AdminProductOrder {
  product_order?: AdminProductOrderItem;
}

export interface AdminProductOrderCreateLineItem {
  box_price_cents?: number;
  i_product: number;
  quantity: number;
  unit_price_cents?: number;
  /**
   * @default "single"
   * @example "box"
   */
  unit_type?: "box" | "single";
}

export interface AdminProductOrderCreateRequest {
  /**
   * @default "SEPARATE"
   * @example "SEPARATE"
   */
  fulfillment_mode?: "MERGE_WITH_NEXT_ORDER" | "SEPARATE";
  line_items: AdminProductOrderCreateLineItem[];
  partner_guid: string;
}

export interface AdminProductOrderItem {
  attached_goodwill_orders?: PartnerProductOrderTransferBundle[];
  auto_created?: boolean;
  billing_cycle_month?: number;
  billing_cycle_year?: number;
  /** @format date-time */
  cancelled?: string;
  cancelled_by?: number;
  /** @format date-time */
  created?: string;
  discount_cents?: number;
  discount_reason?: string;
  discounted_by?: number;
  discounted_by_name?: string;
  fulfillment_mode?: string;
  generated_follow_up_order_id?: number;
  grand_total_cents?: number;
  has_insufficient_inventory?: boolean;
  i_partner_invoice?: number;
  i_partner_product_order?: number;
  /** @format date-time */
  invoiced?: string;
  item_count?: number;
  line_items?: AdminProductOrderLineItem[];
  manually_changed?: boolean;
  notes?: string;
  partner_guid?: string;
  partner_invoice_guid?: string;
  partner_name?: string;
  /**
   * Originating contract start date, following the source order for follow-ups; unlinked orders use POC contracts existing when the original order was created
   * @format date-time
   */
  partner_start_date?: string;
  shipment_cancelled?: number;
  shipment_code?: string;
  shipment_external_id?: string;
  shipment_id?: number;
  shipment_received?: number;
  shipment_sent?: number;
  shipping_cost_cents?: number;
  source_i_partner_product_order?: number;
  status?: string;
  subtotal_cents?: number;
  transfer_status?: string;
  transfer_target_order_id?: number;
  /** @format date-time */
  updated?: string;
  updated_by?: number;
  updated_by_name?: string;
}

export interface AdminProductOrderLineItem {
  allocations?: ProductOrderLineItemAllocation[];
  applied_incentives?: object;
  available_quantity?: number;
  batch_numbers?: string[];
  box_price_cents?: number;
  box_size?: number;
  has_sufficient_inventory?: boolean;
  i_partner_product_order_item?: number;
  i_product?: number;
  line_total_cents?: number;
  missing_quantity?: number;
  product_name?: string;
  product_type?: string;
  quantity?: number;
  serial_numbers?: string[];
  source_i_partner_product_order_item?: number;
  specimen_type?: string;
  unit_price_cents?: number;
  unit_type?: string;
}

export interface AdminProductOrderList {
  product_orders?: AdminProductOrderItem[];
}

export interface AdminProductOrderListSuccess {
  response?: AdminProductOrderList;
  /** @default true */
  success?: boolean;
}

export interface AdminProductOrderPriceRequest {
  /**
   * @default "SEPARATE"
   * @example "SEPARATE"
   */
  fulfillment_mode?: "MERGE_WITH_NEXT_ORDER" | "SEPARATE";
  line_items: AdminProductOrderCreateLineItem[];
}

export interface AdminProductOrderSuccess {
  response?: AdminProductOrder;
  /** @default true */
  success?: boolean;
}

export interface AgbDocument {
  agb_document_guid: string;
  created: number;
  created_by: string;
  /** @example "CaboLAB" */
  product_type: "CaboLAB" | "CaboPOC" | "CaboVAX";
  thumbnail?: string;
  updated?: number;
  updated_by?: string;
  url?: string;
  valid_from: string;
}

export interface AgbDocumentList {
  agb_documents?: AgbDocument[];
}

export interface AgbDocumentListSuccess {
  response?: AgbDocumentList;
  /** @default true */
  success?: boolean;
}

export interface AgbDocumentSuccess {
  response?: AgbDocument;
  /** @default true */
  success?: boolean;
}

export interface AnswerOption {
  answer_option_id: string;
  image_url?: string;
  sort: number;
  translations?: AnswerOptionTranslation[];
  value: string;
}

export interface AnswerOptionTranslation {
  i_language: number;
  lang_code: string;
  value: string;
}

export interface ApiApiMinigameResultListError {
  /** @example "played" */
  error: "played";
  /** @default false */
  success?: boolean;
}

export interface ApiBlogPostPublishError {
  /** @example "not_found" */
  error: "not_found" | "published";
  /** @default false */
  success?: boolean;
}

export interface ApiCaboLabSettingsPut {
  invalid_sample_fee_cents: number;
}

export interface ApiCollectedTestKitReplaceError {
  /** @example "not_found" */
  error: "discarded" | "invalid_new_test_kit" | "not_collected" | "not_found";
}

export interface ApiContractAcceptancePost {
  /** @maxLength 70 */
  acceptance_token: string;
  poc_kit_orders?: ContractAcceptancePocKitOrder[];
}

export interface ApiCouponActivateVaccinationError {
  /** @example "not_found" */
  error:
    | "activated"
    | "coupon_vaccination_exists"
    | "not_found"
    | "not_printed"
    | "vaccination_not_found"
    | "vaccination_required";
  /** @default false */
  success?: boolean;
}

export interface ApiCouponActivateVaccinationSuccess {
  coupon_vaccination_guid: string;
  vaccination_guid?: string;
  vaccination_name?: string;
  validation_token: string;
}

export interface ApiCouponActivateVaccinationSuccessSuccess {
  response?: ApiCouponActivateVaccinationSuccess;
  /** @default true */
  success?: boolean;
}

export interface ApiCouponCheckError {
  /** @example "not_found" */
  error: "access_blocked" | "incorrect_pin" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiCouponCheckForVaccinationError {
  /** @example "not_found" */
  error: "already_activated" | "not_found" | "pin_required";
  /** @default false */
  success?: boolean;
}

export interface ApiCouponGenerationSuccess {
  end: string;
  start: string;
}

export interface ApiCouponGenerationSuccessSuccess {
  response?: ApiCouponGenerationSuccess;
  /** @default true */
  success?: boolean;
}

export interface ApiCouponGetByValidationTokenError {
  /** @example "not_found" */
  error: "not_activated" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiCouponPocSampleResultPdfError {
  /** @example "not_found" */
  error: "access_blocked" | "incorrect_pin" | "not_found" | "results_not_available";
}

export interface ApiCouponUpdatePatientDetailsError {
  /** @example "not_found" */
  error: "not_activated" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiCouponUpdatePatientDetailsSuccess {
  coupon_vaccination_guid: string;
  validation_token: string;
}

export interface ApiCouponUpdatePatientDetailsSuccessSuccess {
  response?: ApiCouponUpdatePatientDetailsSuccess;
  /** @default true */
  success?: boolean;
}

export interface ApiDashboardUserListError {
  /** @example "not_found" */
  error: "not_found" | "sales_organization_required";
  /** @default false */
  success?: boolean;
}

export interface ApiDashboardUserRoleError {
  /** @example "not_found" */
  error: "cannot_delete_self" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiEmailTemplatePut {
  active: boolean;
}

export interface ApiEmailTemplateTranslationPut {
  html_content: string;
  i_language: number;
  subject?: string;
}

export interface ApiEndUserPreregistrationError {
  /** @example "unknown_bundle_id" */
  error: "unknown_bundle_id";
  /** @default false */
  success?: boolean;
}

export interface ApiEquipmentShipmentItemError {
  /** @example "not_found" */
  error: "cancelled" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiEquipmentShipmentLabelBulkError {
  /** @example "not_found" */
  error: "cancelled" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiEquipmentShipmentLabelError {
  /** @example "not_found" */
  error: "cancelled" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiEquipmentShipmentListError {
  /** @example "not_found" */
  error: "cancelled" | "dhl_error" | "not_found" | "processed";
  /** @default false */
  success?: boolean;
}

export interface ApiEquipmentShipmentListPost {
  infos: EquipmentShipmentInfo[];
  partner_equipment_stock_request_guid: string;
  partner_guid: string;
}

export interface ApiEquipmentShipmentPackOptionError {
  /** @example "not_found" */
  error: "not_found" | "with_partners";
  /** @default false */
  success?: boolean;
}

export interface ApiFaqListPost {
  auto_translate?: boolean;
  available_for_partners?: boolean;
  available_for_users?: boolean;
  sort: number;
  translations: FaqTranslation[];
}

export interface ApiInitUserEmailUpdateError {
  /** @example "email_registered" */
  error: "email_registered";
  /** @default false */
  success?: boolean;
}

export interface ApiInsuranceCompanyError {
  /** @example "not_found" */
  error: "duplicated" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiInsuranceCompanyListError {
  /** @example "duplicated" */
  error: "duplicated";
  /** @default false */
  success?: boolean;
}

export interface ApiInventoryCorrectionPost {
  counted_quantity: number;
  i_product_batch?: number | null;
  inventory_location_guid: string;
  notes?: string;
  product_guid: string;
  serial_numbers?: string[];
}

export interface ApiInventoryLocationListPost {
  is_fulfillable?: boolean;
  name: string;
  partner_guid?: string;
  /** @example "INTERNAL" */
  type: "INTERNAL" | "PARTNER" | "SYSTEM";
}

export interface ApiInventoryTransferPost {
  i_product_batch?: number | null;
  notes?: string;
  product_guid: string;
  quantity: number;
  serial_numbers?: string[];
  source_inventory_location_guid: string;
  target_inventory_location_guid: string;
}

export interface ApiMedicalProfileGroupError {
  /** @example "not_found" */
  error: "assigned" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiMedicalProfileGroupLinkDeleteError {
  /** @example "not_found" */
  error: "custom_medical_test_profile" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiMedicalProfileGroupLinkPostError {
  /** @example "not_found" */
  error: "custom_medical_test_profile" | "invalid_start" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiMedicalTestError {
  /** @example "not_found" */
  error: "custom_medical_test" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiMedicalTestGroupError {
  /** @example "not_found" */
  error: "not_found" | "with_medical_tests";
  /** @default false */
  success?: boolean;
}

export interface ApiMedicalTestGroupListPost {
  auto_translate?: boolean;
  translations: MedicalTestGroupTranslation[];
}

export interface ApiMedicalTestListError {
  /** @example "not_found" */
  error: "child_medical_test" | "not_found" | "wait_time";
  /** @default false */
  success?: boolean;
}

export interface ApiMedicalTestListPost {
  adaptors?: number;
  amount: number;
  auto_translate?: boolean;
  dead_specimen_amount: number;
  hide_results?: boolean;
  i_test_kit_type: number;
  info?: string;
  lanzettes?: number;
  medical_test_group_guid: string;
  parent_medical_test_guid?: string;
  time_sensitive: boolean;
  translations: MedicalTestTranslation[];
  wait_time?: number;
}

export interface ApiMedicalTestParameterFaqListPost {
  auto_translate?: boolean;
  translations: MedicalTestParameterFaqTranslation[];
}

export interface ApiMedicalTestParameterLinkError {
  /** @example "not_found" */
  error: "linked" | "missing_labclinic_v11_parameter_id" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiMedicalTestProfileAboutSectionCategoryPost {
  auto_translate?: boolean;
  translations: AboutSectionCategoryTranslation[];
}

export interface ApiMedicalTestProfileBuildPost {
  create?: boolean;
  description?: string;
  medical_test_parameters: string[];
  name: string;
  partner_guid?: string;
}

export interface ApiMedicalTestProfileDiscountGroupLinkError {
  /** @example "not_found" */
  error: "all_profiles" | "not_found";
}

export interface ApiMedicalTestProfileDiscountGroupPartnerError {
  /** @example "not_found" */
  error: "all_partners" | "not_found";
}

export interface ApiMedicalTestProfileError {
  /** @example "not_found" */
  error: "custom_medical_test_profile" | "invalid_patient_form" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiMedicalTestProfileLinkDeleteError {
  /** @example "not_found" */
  error: "custom_medical_test" | "custom_medical_test_profile" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiMedicalTestProfileLinkPostError {
  /** @example "not_found" */
  error: "child_medical_test" | "custom_medical_test" | "custom_medical_test_profile" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiMedicalTestProfileListError {
  /** @example "not_found" */
  error: "invalid_patient_form" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiMedicalTestProfileListPost {
  auto_translate?: boolean;
  available: boolean;
  featured?: number;
  patient_details_form: PatientForm;
  translations: MedicalTestProfileTranslation[];
  url: string;
}

export interface ApiMedicalTestProfilePut {
  available?: boolean;
  featured?: number;
  patient_details_form?: PatientForm;
  url?: string;
}

export interface ApiMedicalTestProfileTagListPost {
  translations: MedicalTestProfileTagTranslation[];
}

export interface ApiPartnerAppointmentCancellationError {
  /** @example "not_found" */
  error: "cancelled" | "not_allowed" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerAppointmentDeleteError {
  /** @example "not_found" */
  error: "cancelled" | "not_attended" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerAppointmentListError {
  /** @example "not_found" */
  error:
    | "beyond_lead_time"
    | "email_required"
    | "invalid_start_time"
    | "no_available_slot"
    | "not_found"
    | "unavailable_product_inventory";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerAppointmentNotAttendedError {
  /** @example "not_found" */
  error: "cancelled" | "not_attended" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerAppointmentNoteError {
  /** @example "not_found" */
  error: "not_found" | "published";
}

export interface ApiPartnerAppointmentNotePublishError {
  /** @example "not_found" */
  error: "not_found" | "published";
}

export interface ApiPartnerAppointmentPutError {
  /** @example "not_found" */
  error: "cancelled" | "not_attended" | "not_found" | "unavailable_product_inventory";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerAppointmentTypeListPost {
  add_document_description?: string;
  after_test_appointment?: boolean;
  attachments_descriptions?: string;
  availability_time?: AvailabilityTime[][];
  /** @example "direct" */
  booking_mode?: "direct" | "request";
  can_add_documents?: boolean;
  can_select_test_profile?: boolean;
  description?: string;
  duration?: number;
  lead_time_days?: number;
  name?: string;
  notification_email?: string;
  product_guid?: string;
  request_hint_text?: string;
  sort?: number;
  vaccination_guids?: string[];
}

export interface ApiPartnerAppointmentValidationError {
  /** @example "not_found" */
  error: "cancelled" | "not_found" | "validated";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerCollectSampleError {
  /** @example "not_found" */
  error:
    | "collection_deadline"
    | "end_date"
    | "expired_test_sample"
    | "invalid_test_kit_type"
    | "missing_parent_collection"
    | "not_found"
    | "parent_collection_expired"
    | "patient_form_incompleted"
    | "sample_cancelled"
    | "sample_collected"
    | "test_execution_consent_required"
    | "test_kit_discarded"
    | "test_kit_expired"
    | "test_kit_used"
    | "unavailable_medical_test_profile"
    | "wait_time";
  expiration?: string;
  parent_collection?: number;
  /** @default false */
  success?: boolean;
  wait_time?: number;
}

export interface ApiPartnerCompleteTrainingError {
  /** @example "not_found" */
  error: "completed" | "not_found" | "starter_pack_not_received";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerCopyDataError {
  /** @example "bad_request" */
  error:
    | "bad_request"
    | "forbidden"
    | "not_found"
    | "same_partner"
    | "serial_number_already_assigned"
    | "target_not_empty";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerCouponActivateError {
  /** @example "not_found" */
  error:
    | "activated"
    | "cabopoc_contract_required"
    | "coupon_vaccination_exists"
    | "disabled"
    | "end_date"
    | "invalid_cabopoc_test_kit"
    | "invalid_medical_test_profile"
    | "invalid_partner_appointment"
    | "missing_activation_target"
    | "missing_profile_or_vaccination"
    | "not_found"
    | "partner_appointment_not_found"
    | "partner_inactive"
    | "start_date"
    | "training_incompleted"
    | "unavailable_medical_test_profile"
    | "usage_limit"
    | "user_signature_required"
    | "vaccination_not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerCouponChangePocTestKitError {
  /** @example "not_found" */
  error:
    | "forbidden"
    | "invalid_cabopoc_test_kit"
    | "no_open_poc_sample"
    | "not_activated"
    | "not_found"
    | "test_execution_consent_already_accepted";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerCouponCheckError {
  /** @example "not_found" */
  error: "invalid_pin" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerCouponEmailError {
  /** @example "not_found" */
  error: "invalid_action" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerCouponPatientDetailFormError {
  /** @example "not_found" */
  error: "collected" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerCouponPocSampleCancelError {
  /** @example "not_found" */
  error: "already_cancelled" | "already_completed" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerCouponPocSampleCancelRequest {
  /** True if the test kit was not used and should be returned to inventory; false if it was used/discarded. */
  test_kit_available: boolean;
}

export interface ApiPartnerCouponPocSampleResultError {
  /** @example "not_found" */
  error:
    | "already_cancelled"
    | "already_completed"
    | "incomplete_results"
    | "invalid_medical_test_parameter"
    | "invalid_results"
    | "not_found"
    | "test_execution_consent_required";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerCouponPocSampleResultPdfError {
  /** @example "not_found" */
  error: "not_found" | "results_not_available";
}

export interface ApiPartnerCouponPocSampleTestKitNumberError {
  /** @example "not_found" */
  error: "duplicated_test_kit_number" | "invalid_test_kit_number" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerCouponPocSampleTestStartedError {
  /** @example "not_found" */
  error: "already_cancelled" | "already_completed" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerCouponSharingRequestEmailError {
  /** @example "email_failed" */
  error: "email_failed";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerCouponSharingRequestError {
  /** @example "not_found" */
  error: "email_required" | "not_found" | "patient_form_incompleted";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerDeviceRegistration {
  auth_token: string;
  auth_token_expires_at?: number;
  session_expires_at?: number;
}

export interface ApiPartnerDeviceRegistrationError {
  /** @example "invalid_email_or_password" */
  error: "invalid_email_or_password" | "invalid_token" | "select_partner";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerDeviceRegistrationSuccess {
  response?: ApiPartnerDeviceRegistration;
  /** @default true */
  success?: boolean;
}

export interface ApiPartnerDiscardTestKitError {
  /** @example "not_found" */
  error: "not_found" | "test_kit_discarded" | "test_kit_used";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerEquipmentStockBatchUpdateError {
  /** @example "bad_request" */
  error: "bad_request" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerEquipmentStockBatchUpdatePost {
  items: PartnerEquipmentStockBatchUpdateItem[];
}

export interface ApiPartnerEquipmentStockRequestItemError {
  /** @example "not_found" */
  error: "cancelled" | "not_found" | "processed";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerEquipmentStockRequestListPost {
  items: PartnerEquipmentStockRequestItem[];
}

export interface ApiPartnerEquipmentStockRequestListPut {
  items: PartnerEquipmentStockRequestItem[];
}

export interface ApiPartnerError {
  /** @example "not_found" */
  error: "not_found" | "serial_number_already_assigned" | "starter_pack_sent";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerInvoiceApproveError {
  /** @example "not_found" */
  error: "approved" | "cancelled" | "dev_partner" | "not_closed" | "not_delivered" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerInvoiceCancelError {
  /** @example "not_found" */
  error: "cancelled" | "not_closed" | "not_found" | "sent";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerInvoiceItemError {
  /** @example "not_found" */
  error: "invalid_discount" | "not_found" | "paid" | "payment_intent_in_progress";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerInvoicePayError {
  /** @example "not_found" */
  error: "cancelled" | "not_found" | "not_sent" | "paid";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerInvoicePdfGetError {
  /** @example "not_found" */
  error: "dev_partner" | "not_approved" | "not_closed" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerInvoicePdfPutError {
  /** @example "not_found" */
  error: "dev_partner" | "not_approved" | "not_closed" | "not_found" | "pdf_sent";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerInvoiceRegeneratePdfError {
  /** @example "not_found" */
  error: "cancelled" | "forbidden" | "not_approved" | "not_closed" | "not_delivered" | "not_found" | "not_sent";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerInvoiceReminderError {
  /** @example "not_found" */
  error: "forbidden" | "invoice_not_eligible_for_reminder" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerInvoiceResendError {
  /** @example "not_found" */
  error:
    | "cancelled"
    | "forbidden"
    | "not_approved"
    | "not_closed"
    | "not_delivered"
    | "not_found"
    | "not_sent"
    | "paid";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerInvoiceSendError {
  /** @example "not_found" */
  error: "already_sent" | "cancelled" | "forbidden" | "not_approved" | "not_closed" | "not_delivered" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerInvoiceStripeIntentError {
  /** @example "not_found" */
  error:
    | "invoice already has a stripe intent"
    | "invoice already paid"
    | "invoice cancelled"
    | "invoice not approved"
    | "invoice not closed"
    | "invoice not sent"
    | "not_delivered"
    | "not_found"
    | "not_sepa"
    | "payment_intent_in_progress";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerMedicalTestProfileDeleteError {
  /** @example "not_found" */
  error: "not_empty" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerMedicalTestProfileError {
  /** @example "not_found" */
  error: "internal" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerPreregistrationCompletionError {
  /** @example "not_found" */
  error: "cancelled" | "completed" | "no_contract_templates_selected" | "not_found" | "pack_option_not_selected";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerPreregistrationCompletionPost {
  /** @maxLength 70 */
  completion_token: string;
  /** @maxLength 70 */
  password: string;
  poc_kit_orders?: PocKitOrder[];
}

export interface ApiPartnerPreregistrationDeleteError {
  /** @example "not_found" */
  error: "cancelled" | "completed" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerPreregistrationListError {
  /** @example "unknown_bundle_id" */
  error:
    | "email_registered"
    | "invalid_referral_source"
    | "missing_apozin_short_code"
    | "missing_referral_source_other"
    | "unknown_bundle_id";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerPreregistrationListPost {
  /** @maxLength 80 */
  apozin_short_code?: string;
  /** @maxLength 50 */
  city: string;
  /** @maxLength 100 */
  client_bundle_id: string;
  /** @maxLength 2 */
  country: string;
  /** @maxLength 2 */
  device_locale: string;
  /** @maxLength 80 */
  email: string;
  /** @maxLength 80 */
  first_name: string;
  /** Array of interested product types (e.g., ['CaboLAB', 'CaboVAX']) */
  interested_service_types?: string[];
  /** @maxLength 80 */
  last_name: string;
  misc_info?: string;
  /** @maxLength 50 */
  partner_name: string;
  /** @maxLength 80 */
  referral_source?: string;
  referral_source_other?: string;
  /** @maxLength 6 */
  salutation?: string;
  /** @default false */
  skip_email_check?: boolean;
  /** @maxLength 100 */
  street: string;
  /** @maxLength 25 */
  telephone: string;
  /** @maxLength 15 */
  title?: string;
  /** @maxLength 8 */
  zip: string;
}

export interface ApiPartnerPreregistrationPut {
  /** @maxLength 80 */
  apozin_short_code?: string;
  /** @maxLength 50 */
  city?: string;
  contract_template_ids?: number[];
  /** @maxLength 2 */
  country?: string;
  /** @maxLength 2 */
  default_locale?: string;
  deferred?: boolean;
  /** @maxLength 80 */
  email?: string;
  /** @maxLength 80 */
  first_name?: string;
  i_equipment_shipment_pack_option?: number;
  i_medical_profile_group?: number;
  /** @maxLength 80 */
  last_name?: string;
  misc_info?: string;
  not_interested?: boolean;
  /** @maxLength 50 */
  partner_name?: string;
  /** @maxLength 18 */
  referrer_partner_guid?: string;
  /** @maxLength 6 */
  salutation?: string;
  start_date?: string;
  starter_pack_notes?: string;
  /** @maxLength 100 */
  street?: string;
  /** @maxLength 25 */
  telephone?: string;
  /** @maxLength 15 */
  title?: string;
  /** @maxLength 8 */
  zip?: string;
}

export interface ApiPartnerPreregistrationUpdateError {
  /** @example "not_found" */
  error: "cancelled" | "completed" | "not_found" | "not_validated";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerPreregistrationValidationResendError {
  /** @example "not_found" */
  error: "cancelled" | "not_found" | "validated";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerPreregistrationVerificationError {
  /** @example "not_found" */
  error:
    | "cancelled"
    | "completed"
    | "email_registered"
    | "medical_profile_group_not_selected"
    | "no_contract_templates_selected"
    | "not_found"
    | "not_validated"
    | "pack_option_not_selected";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerProductInventoryBatchUpdateError {
  /** @example "bad_request" */
  error: "bad_request" | "inventory_conflict" | "not_found";
  message?: string;
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerProductInventoryBatchUpdatePost {
  items: PartnerProductInventoryBatchUpdateItem[];
  last_product_inventory_update?: string;
  new_batches?: PartnerProductInventoryNewBatch[];
}

export interface ApiPartnerQuestionnaireAnswer {
  answer_options?: string[];
  question_id: string;
}

export interface ApiPartnerQuestionnaireAnswerError {
  /** @example "not_found" */
  error: "invalid_answers" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerQuestionnaireAnswerList {
  answers?: ApiPartnerQuestionnaireAnswer[];
}

export interface ApiPartnerSampleCancelError {
  /** @example "not_found" */
  error: "cancelled" | "not_found" | "sample_sent" | "shipment_packed" | "test_kit_discarded" | "test_kit_used";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerSampleCollectionUpdateError {
  /** @example "not_found" */
  error: "cancelled" | "not_collected" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerSamplePackError {
  /** @example "not_found" */
  error: "cancelled" | "invalid_shipment" | "not_found" | "packed" | "shipment_not_assigned";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerTeamListDeleteError {
  /** @example "not_found" */
  error: "not_found" | "partner_owner";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerTeamListPutError {
  /** @example "not_found" */
  error: "email_not_verified" | "not_found" | "partner_owner";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerTeamLoginError {
  /** @example "not_found" */
  error: "invalid_pin" | "not_found" | "pin_unset";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerTestSampleEmailResultPdfError {
  /** @example "not_found" */
  error: "email_not_available" | "invalid_pin" | "not_found" | "results_not_available";
}

export interface ApiPartnerTestSampleError {
  /** @example "not_found" */
  error: "invalid_pin" | "not_found";
}

export interface ApiPartnerTestSampleResultPdfError {
  /** @example "not_found" */
  error: "invalid_pin" | "not_found" | "results_not_available";
}

export interface ApiPartnerTestSampleShipmentLabelBulkError {
  /** @example "not_found" */
  error: "dhl_error" | "no_shipments" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerTestSampleShipmentLabelError {
  /** @example "not_found" */
  error: "cancelled" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPartnerUnpackedSampleListError {
  /** @example "not_found" */
  error: "medical_test_not_available" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiPocShippingTierListPost {
  /** @default true */
  active?: boolean;
  effective_from: string;
  max_order_amount_cents?: number;
  shipping_cost_cents: number;
}

export interface ApiPreregistrationValidationError {
  /** @example "not_found" */
  error: "cancelled" | "not_found" | "validated";
  /** @default false */
  success?: boolean;
}

export interface ApiProductBatchListPost {
  batch_number: string;
  delivery_date?: string;
  expiration_date?: string;
  i_product: number;
  order_date?: string;
  purchase_price: number;
  quantity?: number;
  /**
   * Igloo Pro only; applied to every device in this batch. Defaults to dx365.
   * @example "dx365"
   */
  result_provider?: "dx365" | "polaris";
  serial_numbers?: string[];
}

export interface ApiProductBatchPut {
  batch_number?: string;
  delivery_date?: string;
  expiration_date?: string;
  order_date?: string;
  purchase_price?: number;
  quantity?: number;
}

export interface ApiProductFaqListPost {
  auto_translate?: boolean;
  translations: ProductFaqTranslation[];
}

export interface ApiProductListPost {
  auto_reorderable?: boolean;
  description?: string;
  first_order_selectable?: boolean;
  instructions?: string;
  name: string;
  needs_serial_numbers?: boolean;
  online_orderable?: boolean;
  /** @example "TEST_KIT" */
  product_type: "PRODUCT" | "TEST_KIT";
  /** @example "BLOOD" */
  specimen_type?: "BLOOD" | "SALIVA" | "STOOL" | "URINE";
  temporarily_unavailable?: boolean;
}

export interface ApiProductOrderIncentiveListPost {
  /** @default true */
  active?: boolean;
  description?: string;
  discount_percentage: number;
  effective_from: string;
  effective_to?: string;
  min_order_amount_cents: number;
  name: string;
}

export interface ApiProductOrderPut {
  discount_cents?: number;
  discount_reason?: string;
  line_items?: ApiProductOrderPutLineItem[];
  notes?: string;
  shipping_cost_cents?: number;
}

export interface ApiProductOrderPutLineItem {
  box_price_cents?: number;
  i_product: number;
  quantity: number;
  unit_price_cents?: number;
  /**
   * @default "single"
   * @example "box"
   */
  unit_type?: "box" | "single";
}

export interface ApiProductOrderShipmentLabelError {
  /** @example "not_found" */
  error: "cancelled" | "no_label" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiProductPriceListListPost {
  description?: string;
  effective_from: string;
  effective_to?: string;
  items: ProductPriceListItemInput[];
  name: string;
}

export interface ApiShipmentCancelError {
  /** @example "not_found" */
  error: "cancelled" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiSupplierDeliveryItemReceiptPost {
  batch_number?: string;
  delivery_date?: string;
  expiration_date?: string;
  inventory_location_guid?: string;
  purchase_price?: number;
  quantity: number;
  serial_numbers?: string[];
}

export interface ApiSupplierDeliveryPost {
  expected_delivery_date?: string;
  items: ApiSupplierDeliveryPostItem[];
  notes?: string;
  ordered_date: string;
  supplier_name: string;
  supplier_reference?: string;
}

export interface ApiSupplierDeliveryPostItem {
  ordered_quantity: number;
  product_guid: string;
  purchase_price: number;
}

export interface ApiSupplierDeliveryPut {
  expected_delivery_date?: string;
  items: ApiSupplierDeliveryPutItem[];
  notes?: string;
  ordered_date: string;
  supplier_name: string;
  supplier_reference?: string;
}

export interface ApiSupplierDeliveryPutItem {
  ordered_quantity: number;
  product_guid: string;
  purchase_price: number;
  supplier_delivery_item_guid?: string;
}

export interface ApiTestExecutionConsentError {
  /** @example "not_found" */
  error?:
    | "agb_confirmation_required"
    | "already_accepted"
    | "consent_confirmation_required"
    | "invalid_signature"
    | "invalid_signature_mime_type"
    | "not_found"
    | "patient_form_incompleted"
    | "patient_signature_required"
    | "privacy_confirmation_required";
  /** @default false */
  success?: boolean;
}

export interface ApiTestKitGenerationError {
  /** @example "not_found" */
  error: "not_found" | "overlap";
}

export interface ApiTestKitTypeListError {
  /** @example "not_found" */
  error: "duplicated" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiTestKitTypeListPost {
  adaptor_equipment_sku_id?: number;
  auto_translate?: boolean;
  color: string;
  i_equipment_sku: number;
  lanzette_equipment_sku_id?: number;
  specimen_max_amount: number;
  /** @example "BLOOD" */
  specimen_type: "BLOOD" | "SALIVA" | "URINE";
  specimen_unit: string;
  translations: TestKitTypeTranslation[];
}

export interface ApiTestSampleInvalidateError {
  /** @example "not_found" */
  error: "invalidated" | "not_found";
}

export interface ApiTestSampleNoteError {
  /** @example "not_found" */
  error: "not_found" | "published";
}

export interface ApiTestSampleNotePublishError {
  /** @example "not_found" */
  error: "not_found" | "published";
}

export interface ApiTestSampleResultInvalidateError {
  /** @example "not_found" */
  error: "invalidated" | "not_found";
}

export interface ApiTestSampleResultPdfError {
  /** @example "not_found" */
  error: "invalid_pin" | "not_found" | "results_not_available";
}

export interface ApiUserCouponCheckError {
  /** @example "not_found" */
  error: "invalid_pin" | "not_found";
}

export interface ApiUserPasswordError {
  /** @example "passwords_do_not_match" */
  error: "passwords_do_not_match";
  /** @default false */
  success?: boolean;
}

export interface ApiUserPinError {
  /** @example "invalid_pin" */
  error: "invalid_pin" | "invalid_pin_change_proof";
  /** @default false */
  success?: boolean;
}

export interface ApiUserSignatureError {
  /** @example "signature_too_large" */
  error: "invalid_base64" | "invalid_mime_type" | "signature_too_large" | "user_not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiUserSignatureNotFoundError {
  /** @example "no_signature_found" */
  error: "no_signature_found" | "user_not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiUserSignatureResponse {
  /** Base64 encoded signature image */
  signature_image: string;
  signature_mime_type: string;
  signature_uploaded_at: number;
  /** @default true */
  success?: boolean;
}

export interface ApiUserTestSampleResultPdfError {
  /** @example "not_found" */
  error: "not_found" | "results_not_available";
}

export interface ApiVendorListError {
  /** @example "duplicated" */
  error: "duplicated";
  /** @default false */
  success?: boolean;
}

export interface ApiVendorMedicalTestError {
  /** @example "not_found" */
  error: "custom_vendor_medical_test" | "duplicated" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiVendorMedicalTestListError {
  /** @example "not_found" */
  error: "duplicated" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiVendorMedicalTestParameterDeleteError {
  /** @example "not_found" */
  error: "linked" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiVendorMedicalTestParameterLinkError {
  /** @example "not_found" */
  error: "custom_vendor_medical_test" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiVendorMedicalTestParameterListError {
  /** @example "not_found" */
  error: "duplicated" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiVendorMedicalTestParameterPutError {
  /** @example "not_found" */
  error: "duplicated" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiVendorMedicalTestPriceError {
  /** @example "not_found" */
  error: "invalid_start" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ApiWebsiteBannerListPost {
  auto_translate?: boolean;
  available_for_partners?: boolean;
  available_for_users?: boolean;
  translations: WebsiteBannerTranslation[];
  url?: string;
}

export interface ApozinAppointmentWebhookPost {
  apoone_short_code?: string;
  apozin_short_code: string;
  booking_id: string;
  category?: string;
  client_city?: string;
  client_dob?: string;
  client_email?: string;
  client_first_name?: string;
  /** @example "m" */
  client_gender?: "f" | "m";
  client_last_name?: string;
  client_street?: string;
  client_telephone?: string;
  client_zip?: string;
  customer_email?: string;
  end?: string;
  end_local?: string;
  end_utc?: string;
  external_product_id?: string;
  productId?: string;
  star_local?: string;
  start?: string;
  start_local?: string;
  start_utc?: string;
  /** @example "booked" */
  status: "booked" | "BOOKING" | "cancelled" | "CANCELLED";
  type?: string;
  user_account_id?: string;
}

export interface ApozinAvailableService {
  /** @example "CaboVax" */
  category: "CaboPOC" | "CaboVax";
  description?: string;
  name: string;
  productId: string;
}

export interface ApozinAvailableServicesResponse {
  products: ApozinAvailableService[];
}

export interface ApozinAvailableServicesResponseSuccess {
  response?: ApozinAvailableServicesResponse;
  /** @default true */
  success?: boolean;
}

export interface ApozinDevTriggerResponse {
  booking_id: string;
  completion_guid: string;
  /** @example "CaboVAX" */
  product_type: "CaboPOC" | "CaboVAX";
}

export interface ApozinDevTriggerResponseSuccess {
  response?: ApozinDevTriggerResponse;
  /** @default true */
  success?: boolean;
}

export interface ApozinInboundAppointment {
  booking_id: string;
  partner_appointment_guid: string;
  partner_appointment_type_name: string;
  source_system: string;
  /** @example "booked" */
  status: "booked" | "cancelled";
  user_account_id?: string;
}

export interface ApozinInboundAppointmentError {
  /** @example "apozin_short_code_required" */
  error:
    | "apozin_appointment_not_found"
    | "apozin_partner_not_found"
    | "apozin_product_not_found"
    | "apozin_short_code_required"
    | "bad_request";
  fields?: string[];
  message?: string;
  /** @default false */
  success?: boolean;
}

export interface ApozinInboundAppointmentResponse {
  appointment: ApozinInboundAppointment;
}

export interface ApozinInboundAppointmentResponseSuccess {
  response?: ApozinInboundAppointmentResponse;
  /** @default true */
  success?: boolean;
}

export interface Attachment {
  attachment_guid: string;
  content_type: string;
  created: number;
  url: string;
}

export interface AttachmentList {
  attachments?: Attachment[];
}

export interface AttachmentListSuccess {
  response?: AttachmentList;
  /** @default true */
  success?: boolean;
}

export interface AttachmentSuccess {
  response?: Attachment;
  /** @default true */
  success?: boolean;
}

export interface AuthCompleteAdminPartnerLogin {
  auth_token: string;
  auth_token_expires_at?: number;
  session_expires_at?: number;
  user_guid: string;
}

export interface AuthCompleteAdminPartnerLoginError {
  /** @example "completed" */
  error: "completed" | "expired";
  /** @default false */
  success?: boolean;
}

export interface AuthCompleteAdminPartnerLoginSuccess {
  response?: AuthCompleteAdminPartnerLogin;
  /** @default true */
  success?: boolean;
}

export interface AuthError {
  /** @example "user_is_blocked" */
  error: "expired_auth_session" | "expired_auth_token" | "unknown_auth_token" | "user_is_blocked";
  /** @default false */
  success?: boolean;
}

export interface AuthInitAdminPartnerLogin {
  token: string;
}

export interface AuthInitAdminPartnerLoginSuccess {
  response?: AuthInitAdminPartnerLogin;
  /** @default true */
  success?: boolean;
}

export interface AuthLoginError {
  /** @example "invalid_token" */
  error: "email_not_found" | "invalid_token";
  /** @default false */
  success?: boolean;
}

export interface AuthLogout {
  logged_out: boolean;
}

export interface AuthLogoutSuccess {
  response?: AuthLogout;
  /** @default true */
  success?: boolean;
}

export interface AuthPreRegLaunch {
  registration_token: string;
}

export interface AuthPreRegLaunchError {
  /** @example "unknown_bundle_id" */
  error: "unknown_bundle_id";
  /** @default false */
  success?: boolean;
}

export interface AuthPreRegLaunchSuccess {
  response?: AuthPreRegLaunch;
  /** @default true */
  success?: boolean;
}

export interface AuthRenewToken {
  auth_token: string;
  auth_token_expires_at?: number;
  session_expires_at?: number;
}

export interface AuthRenewTokenSuccess {
  response?: AuthRenewToken;
  /** @default true */
  success?: boolean;
}

export interface AuthValidateLogin {
  auth_token: string;
  auth_token_expires_at?: number;
  session_expires_at?: number;
  user_guid: string;
}

export interface AuthValidateLoginError {
  /** @example "email_already_validated" */
  error: "email_already_validated" | "email_token_expired" | "invalid_token";
  /** @default false */
  success?: boolean;
}

export interface AuthValidateLoginSuccess {
  response?: AuthValidateLogin;
  /** @default true */
  success?: boolean;
}

export interface AuthValidateRegDeepLink {
  auth_token: string;
  auth_token_expires_at?: number;
  session_expires_at?: number;
  user_guid: string;
}

export interface AuthValidateRegDeepLinkError {
  /** @example "validated" */
  error: "validated";
  /** @default false */
  success?: boolean;
}

export interface AuthValidateRegDeepLinkSuccess {
  response?: AuthValidateRegDeepLink;
  /** @default true */
  success?: boolean;
}

export interface AvailabilityTime {
  end: string;
  slot_capacity: number;
  start: string;
}

export interface AverageDeliveryTime {
  "1 Day": number;
  "2 Days": number;
  "3 Days": number;
  "4+ Days": number;
}

export interface AverageGrossMargin {
  avg_margin: number;
  lab_cost: number;
  medical_test_profile_revenue: number;
  month: number;
  shipping_cost: number;
  test_count: number;
  year: number;
}

export interface AverageGrossMarginList {
  margins?: AverageGrossMargin[];
}

export interface AverageGrossMarginListSuccess {
  response?: AverageGrossMarginList;
  /** @default true */
  success?: boolean;
}

export interface BlogPost {
  attachments?: string;
  available_for_partners?: boolean;
  available_for_users?: boolean;
  blog_post_guid: string;
  content?: string;
  created: number;
  product_type?: string;
  published: number;
  title?: string;
}

export interface BlogPostList {
  blog_posts?: BlogPost[];
}

export interface BlogPostListSuccess {
  response?: BlogPostList;
  /** @default true */
  success?: boolean;
}

export interface BlogPostSuccess {
  response?: BlogPost;
  /** @default true */
  success?: boolean;
}

export interface CaboLabSettings {
  cabolab_invalid_sample_fee_cents: number;
}

export interface CaboLabSettingsSuccess {
  response?: CaboLabSettings;
  /** @default true */
  success?: boolean;
}

export interface ChatMessage {
  chat_message_guid: string;
  created: number;
  from: string;
  message: string;
  metadata?: string;
}

export interface ChatSession {
  chat_session_guid: string;
  coupon_code?: string;
  coupon_guid?: string;
  coupon_poc_sample_guid?: string;
  created: number;
  created_by: string;
  medical_test_profile_guid?: string;
  medical_test_profile_name?: string;
  message_count?: number;
  messages?: ChatMessage[];
  partner_guid?: string;
  partner_name?: string;
  product_guid?: string;
  product_name?: string;
  test_sample_guid?: string;
  /** @maxLength 100 */
  title?: string;
}

export interface ChatSessionList {
  chat_sessions?: ChatSession[];
  pagination?: ChatSessionsPagination;
}

export interface ChatSessionListSuccess {
  response?: ChatSessionList;
  /** @default true */
  success?: boolean;
}

export interface ChatSessionsPagination {
  /** Limit for pagination */
  limit?: number;
  /** Offset for pagination */
  offset?: number;
  /** Sort direction for pagination */
  sort_direction?: string;
  /** Sort field for pagination */
  sort_field?: string;
  /** Total number of rows */
  total_count?: number;
}

export interface ChatSessionSuccess {
  response?: ChatSession;
  /** @default true */
  success?: boolean;
}

export interface Contact {
  company?: string;
  created: number;
  display_name: string;
  email?: string;
  guid: string;
  job_title?: string;
  notes?: string;
  /** Partner data from api_getPartner */
  partner?: object;
  /** Preregistration data from api_getPartnerPreregistrationRequest */
  potential?: object;
  source_guid: string;
  source_id: number;
  /** @example "PARTNER" */
  source_type: "PARTNER" | "PRE_REGISTRATION_REQUEST" | "STANDALONE";
  telephone?: string;
}

export interface ContactDetail {
  address?: string;
  company?: string;
  created: number;
  crm_standalone_contact_guid: string;
  display_name: string;
  email?: string;
  first_name?: string;
  job_title?: string;
  last_name?: string;
  /** Partner data from api_getPartner */
  partner?: object;
  /** Preregistration data from api_getPartnerPreregistrationRequest */
  potential?: object;
  source_guid: string;
  source_id: number;
  /** @example "PARTNER" */
  source_type: "PARTNER" | "PRE_REGISTRATION_REQUEST" | "STANDALONE";
  telephone?: string;
  updated?: number;
  website?: string;
}

export interface ContactDetailSuccess {
  response?: ContactDetail;
  /** @default true */
  success?: boolean;
}

export interface ContactList {
  data?: Contact[];
  pagination?: ContactsPagination;
}

export interface ContactListSuccess {
  response?: ContactList;
  /** @default true */
  success?: boolean;
}

export interface ContactRelationship {
  created: number;
  crm_contact_relationship_guid: string;
  description?: string;
  from_contact_guid: string;
  from_contact_name: string;
  /** @example "works_with" */
  relationship_type: "manages" | "other" | "reports_to" | "works_with";
  to_contact_company?: string;
  to_contact_email?: string;
  to_contact_guid: string;
  to_contact_name: string;
  to_contact_telephone?: string;
}

export interface ContactRelationshipList {
  data?: ContactRelationship[];
}

export interface ContactRelationshipListSuccess {
  response?: ContactRelationshipList;
  /** @default true */
  success?: boolean;
}

export interface ContactRelationshipSuccess {
  response?: ContactRelationship;
  /** @default true */
  success?: boolean;
}

export interface ContactsPagination {
  limit?: number;
  offset?: number;
  sort_direction?: string;
  sort_field?: string;
  total_count?: number;
}

export interface ContractAcceptanceDetails {
  cancellation_period_days: number;
  contract_body?: string;
  contract_template_name: string;
  default_locale: string;
  duration_months: number;
  email: string;
  min_first_order_price_cents?: number;
  monthly_price_after_minimum_duration_cents?: number;
  monthly_price_cents: number;
  needs_sepa: number;
  no_single_poc_test_kit_allowed: boolean;
  orders_only: boolean;
  partner_contract_guid: string;
  partner_guid: string;
  partner_name: string;
  /** @example "CaboLAB" */
  product_type: "CaboLAB" | "CaboPOC" | "CaboVAX";
  setup_fee_cents: number;
  /** @example "2026-04-01" */
  start_date: string;
  trial_period_days: number;
}

export interface ContractAcceptanceDetailsSuccess {
  response?: ContractAcceptanceDetails;
  /** @default true */
  success?: boolean;
}

export interface ContractAcceptancePocKitOrder {
  i_product: number;
  quantity: number;
  /** @example "box" */
  unit_type?: "box" | "single";
}

export interface ContractAcceptanceResult {
  status: string;
}

export interface ContractAcceptanceResultSuccess {
  response?: ContractAcceptanceResult;
  /** @default true */
  success?: boolean;
}

export interface ContractTemplate {
  active: boolean;
  active_contracts_count?: number;
  can_perform_tests: boolean;
  cancellation_period_days: number;
  contract_body?: string;
  contract_template_guid: string;
  created?: number;
  description?: string;
  duration_months: number;
  i_contract_template: number;
  i_starter_kit?: number;
  min_first_order_price_cents?: number;
  monthly_price_after_minimum_duration_cents?: number;
  monthly_price_cents: number;
  name: string;
  no_single_poc_test_kit_allowed: boolean;
  orders_only: boolean;
  /** @example "CaboLAB" */
  product_type: "CaboLAB" | "CaboPOC" | "CaboVAX";
  setup_fee_cents: number;
  show_on_registration: boolean;
  trial_period_days: number;
}

export interface ContractTemplateList {
  contract_templates?: ContractTemplate[];
}

export interface ContractTemplateListSuccess {
  response?: ContractTemplateList;
  /** @default true */
  success?: boolean;
}

export interface ContractTemplateSuccess {
  response?: ContractTemplate;
  /** @default true */
  success?: boolean;
}

export interface Coupon {
  activated?: number;
  code: string;
  coupon_guid: string;
  coupon_vaccinations?: CouponVaccination[];
  email?: string;
  is_vaccination_coupon?: boolean;
  linked?: boolean;
  partner_guid?: string;
  partner_name?: string;
  patient_details_form?: PatientForm;
  patient_details_form_completed?: number;
  pin_set?: boolean;
  poc_samples?: CouponPocSample[];
  prefix: string;
  printed?: number;
  serial_number: string;
  service_registration?: ServiceRegistration;
  test_execution_consent?: TestExecutionConsent;
  test_samples?: TestSample[];
  vaccination_guid?: string;
  vaccination_name?: string;
}

export interface CouponList {
  coupons?: Coupon[];
}

export interface CouponListSuccess {
  response?: CouponList;
  /** @default true */
  success?: boolean;
}

export interface CouponPocSample {
  batch_number?: string;
  cancelled?: number;
  completed?: number;
  coupon_poc_sample_guid: string;
  created: number;
  /** @example "exact" */
  dx365_match_type?: "exact" | "logical";
  medical_test_parameter_results?: CouponPocSampleMedicalTestParameterResult[];
  product_guid: string;
  product_name: string;
  test_kit_number?: string;
  test_started?: number;
  waiting_for_result?: number;
  waiting_for_result_error_at?: number;
  waiting_for_result_error_code?: string;
  waiting_for_result_error_details?: object;
}

export interface CouponPocSampleDetail {
  batch_number?: string;
  cancelled?: number;
  cancelled_by?: number;
  completed?: number;
  completed_by_name?: string;
  coupon_code: string;
  coupon_guid: string;
  coupon_poc_sample_guid: string;
  created: number;
  /** @example "exact" */
  dx365_match_type?: "exact" | "logical";
  medical_test_parameter_results?: CouponPocSampleMedicalTestParameterResult[];
  medical_test_parameters?: CouponPocSampleMedicalTestParameter[];
  partner_city?: string;
  partner_guid: string;
  partner_name: string;
  product_guid: string;
  product_name: string;
  /** @example "dx365" */
  result_source?: "dx365" | "manual" | "polaris";
  test_kit_number?: string;
  test_started?: number;
  waiting_for_result?: number;
  waiting_for_result_error_at?: number;
  waiting_for_result_error_code?: string;
  waiting_for_result_error_details?: object;
}

export interface CouponPocSampleDetailSuccess {
  response?: CouponPocSampleDetail;
  /** @default true */
  success?: boolean;
}

export interface CouponPocSampleExtended {
  batch_number?: string;
  cancelled?: number;
  completed?: number;
  completed_by_name?: string;
  coupon_code: string;
  coupon_guid: string;
  coupon_poc_sample_guid: string;
  created: number;
  /** @example "exact" */
  dx365_match_type?: "exact" | "logical";
  partner_city?: string;
  partner_guid: string;
  partner_name: string;
  product_guid: string;
  product_name: string;
  /** @example "dx365" */
  result_source?: "dx365" | "manual" | "polaris";
  test_kit_number?: string;
  test_started?: number;
  waiting_for_result?: number;
  waiting_for_result_error_at?: number;
  waiting_for_result_error_code?: string;
  waiting_for_result_error_details?: object;
}

export interface CouponPocSampleListPaginated {
  coupon_poc_samples?: CouponPocSampleExtended[];
  pagination?: TestSamplesPagination;
}

export interface CouponPocSampleListPaginatedSuccess {
  response?: CouponPocSampleListPaginated;
  /** @default true */
  success?: boolean;
}

export interface CouponPocSampleMedicalTestParameter {
  loinc_code?: string;
  medical_test_parameter_guid: string;
  name: string;
  reference_ranges?: MedicalTestParameterReferenceRange[];
  result_value?: number;
  unit?: string;
}

export interface CouponPocSampleMedicalTestParameterResult {
  medical_test_parameter_guid: string;
  name?: string;
  result_value: number;
  unit?: string;
}

export interface CouponPocSampleResultUpdateItem {
  medical_test_parameter_guid: string;
  result_value: number;
}

export interface CouponPocSampleResultUpdateRequest {
  results: CouponPocSampleResultUpdateItem[];
}

export interface CouponSuccess {
  response?: Coupon;
  /** @default true */
  success?: boolean;
}

export interface CouponVaccination {
  /** @example "left_deltoid_im" */
  administration_site?:
    | "left_abdomen_sc"
    | "left_arm_sc"
    | "left_deltoid_im"
    | "left_forearm_id"
    | "left_gluteus_im"
    | "left_thigh_anterolateral_im"
    | "other"
    | "right_abdomen_sc"
    | "right_arm_sc"
    | "right_deltoid_im"
    | "right_forearm_id"
    | "right_gluteus_im"
    | "right_thigh_anterolateral_im";
  batch_number?: string;
  completed?: number;
  coupon_vaccination_guid: string;
  created: number;
  education_completed?: number;
  education_confirmed?: boolean;
  education_released?: number;
  education_signature?: string;
  education_signature_mime_type?: string;
  education_text?: string;
  i_coupon_vaccination: number;
  i_product_question_group?: number;
  i_vaccination: number;
  indication?: string;
  product_question_group_guid?: string;
  product_questions_completed?: number;
  vaccination_guid: string;
  vaccination_name: string;
  validation_token?: string;
}

export interface CouponVaccinationDetail {
  /** @example "left_deltoid_im" */
  administration_site?:
    | "left_abdomen_sc"
    | "left_arm_sc"
    | "left_deltoid_im"
    | "left_forearm_id"
    | "left_gluteus_im"
    | "left_thigh_anterolateral_im"
    | "other"
    | "right_abdomen_sc"
    | "right_arm_sc"
    | "right_deltoid_im"
    | "right_forearm_id"
    | "right_gluteus_im"
    | "right_thigh_anterolateral_im";
  answers?: PartnerAppointmentAnswer[];
  batch_number?: string;
  completed?: number;
  coupon_code: string;
  coupon_guid: string;
  coupon_vaccination_guid: string;
  created: number;
  education_completed?: number;
  education_confirmed?: boolean;
  education_signature?: string;
  education_signature_mime_type?: string;
  education_text?: string;
  i_coupon_vaccination: number;
  i_product_question_group?: number;
  i_vaccination: number;
  indication?: string;
  partner_guid: string;
  partner_name: string;
  patient_details_form?: PatientForm;
  patient_details_form_encrypted?: number;
  product_question_group_guid?: string;
  product_questions_completed?: number;
  vaccination_guid: string;
  vaccination_name: string;
  validation_token?: string;
}

export interface CouponVaccinationDetailSuccess {
  response?: CouponVaccinationDetail;
  /** @default true */
  success?: boolean;
}

export interface CouponVaccinationExtended {
  /** @example "left_deltoid_im" */
  administration_site?:
    | "left_abdomen_sc"
    | "left_arm_sc"
    | "left_deltoid_im"
    | "left_forearm_id"
    | "left_gluteus_im"
    | "left_thigh_anterolateral_im"
    | "other"
    | "right_abdomen_sc"
    | "right_arm_sc"
    | "right_deltoid_im"
    | "right_forearm_id"
    | "right_gluteus_im"
    | "right_thigh_anterolateral_im";
  batch_number?: string;
  completed?: number;
  coupon_code: string;
  coupon_guid: string;
  coupon_vaccination_guid: string;
  created: number;
  education_completed?: number;
  education_confirmed?: boolean;
  education_released?: number;
  education_signature?: string;
  education_signature_mime_type?: string;
  education_text?: string;
  i_coupon_vaccination: number;
  i_product_question_group?: number;
  i_vaccination: number;
  indication?: string;
  partner_city?: string;
  partner_guid: string;
  partner_name: string;
  patient_first_name?: string;
  patient_last_name?: string;
  product_question_group_guid?: string;
  product_questions_completed?: number;
  vaccination_guid: string;
  vaccination_name: string;
  validation_token?: string;
}

export interface CouponVaccinationList {
  coupon_vaccinations?: CouponVaccination[];
}

export interface CouponVaccinationListPaginated {
  coupon_vaccinations?: CouponVaccinationExtended[];
  pagination?: TestSamplesPagination;
}

export interface CouponVaccinationListPaginatedSuccess {
  response?: CouponVaccinationListPaginated;
  /** @default true */
  success?: boolean;
}

export interface CouponVaccinationListSuccess {
  response?: CouponVaccinationList;
  /** @default true */
  success?: boolean;
}

export interface CouponVaccinationSuccess {
  response?: CouponVaccination;
  /** @default true */
  success?: boolean;
}

export interface Customer {
  city?: string;
  dob: string;
  email: string;
  first_name: string;
  gender: string;
  insurance_company?: string;
  insurance_number?: string;
  insurance_type?: string;
  last_name: string;
  street?: string;
  telephone?: string;
  zip?: string;
}

export interface CustomerList {
  customers?: Customer[];
}

export interface CustomerListSuccess {
  response?: CustomerList;
  /** @default true */
  success?: boolean;
}

export interface DashboardUser {
  email: string;
  first_name: string;
  last_login?: number;
  last_name: string;
  roles?: Role[];
  user_guid: string;
}

export interface DashboardUserList {
  users?: DashboardUser[];
}

export interface DashboardUserListSuccess {
  response?: DashboardUserList;
  /** @default true */
  success?: boolean;
}

export interface DashboardUserSuccess {
  response?: DashboardUser;
  /** @default true */
  success?: boolean;
}

export interface DeletedCount {
  deleted_count: number;
}

export interface DeletedCountSuccess {
  response?: DeletedCount;
  /** @default true */
  success?: boolean;
}

export interface DevApozinCompleteAppointmentError {
  /** @example "not_found" */
  error:
    | "apozin_error"
    | "apozin_invalid_response"
    | "apozin_request_exception"
    | "apozin_request_failed"
    | "appointment_cancelled"
    | "coupon_poc_sample_not_found"
    | "coupon_vaccination_not_found"
    | "invalid_results"
    | "no_signed_user_available"
    | "not_found"
    | "partner_user_not_found"
    | "unsupported_product_type";
  /** @default false */
  success?: boolean;
}

export interface DuplicateContact {
  company?: string;
  created: number;
  crm_standalone_contact_guid: string;
  display_name: string;
  email?: string;
  telephone?: string;
}

export interface DuplicateContactList {
  data?: DuplicateContact[];
}

export interface DuplicateContactListSuccess {
  response?: DuplicateContactList;
  /** @default true */
  success?: boolean;
}

export interface Dx365UnaccountedPocResultLog {
  created: number;
  device_id: string;
  file_key: string;
  partner_city?: string;
  partner_guid?: string;
  partner_name?: string;
  patient_id?: string;
  result_payload?: object;
  test_timestamp?: number;
  updated: number;
}

export interface Dx365UnaccountedPocResultLogListPaginated {
  dx365_unaccounted_poc_result_logs?: Dx365UnaccountedPocResultLog[];
  pagination?: TestSamplesPagination;
}

export interface Dx365UnaccountedPocResultLogListPaginatedSuccess {
  response?: Dx365UnaccountedPocResultLogListPaginated;
  /** @default true */
  success?: boolean;
}

export interface EmailLoginDeliveryError {
  /** @example "email_failed" */
  error: "email_failed";
  /** @default false */
  success?: boolean;
}

export interface EmailLoginRateLimitError {
  /** @example "rate_limit_exceeded" */
  error: "rate_limit_exceeded";
  /** @default false */
  success?: boolean;
}

export interface EmailLoginUnavailableError {
  /** @example "email_login_temporarily_unavailable" */
  error: "email_login_temporarily_unavailable";
  /** @default false */
  success?: boolean;
}

export interface EmailTemplate {
  active: boolean;
  created: number;
  description?: string;
  display_name: string;
  i_email_template: number;
  template_name: string;
  translations?: EmailTemplateTranslation[];
  updated?: number;
  variables?: EmailTemplateVariable[];
}

export interface EmailTemplateList {
  email_templates?: EmailTemplate[];
}

export interface EmailTemplateListSuccess {
  response?: EmailTemplateList;
  /** @default true */
  success?: boolean;
}

export interface EmailTemplateSuccess {
  response?: EmailTemplate;
  /** @default true */
  success?: boolean;
}

export interface EmailTemplateTranslation {
  html_content: string;
  i_language: number;
  lang_code: string;
  subject?: string;
}

export interface EmailTemplateVariable {
  description?: string;
  display_order?: number;
  example_value?: string;
  is_required: boolean;
  variable_name: string;
}

export interface EmployeePinLogin {
  auth_token: string;
  /** Single-use proof for replacing a temporary PIN */
  pin_change_proof?: string;
  user_guid: string;
}

export interface EmployeePinLoginSuccess {
  response?: EmployeePinLogin;
  /** @default true */
  success?: boolean;
}

export interface EmployeePinRateLimitError {
  /** @example "rate_limit_exceeded" */
  error: "rate_limit_exceeded";
  /** @default false */
  success?: boolean;
}

export interface EmployeePinUnavailableError {
  /** @example "employee_pin_temporarily_unavailable" */
  error: "employee_pin_temporarily_unavailable";
  /** @default false */
  success?: boolean;
}

export interface EquipmentShipment {
  cancelled?: number;
  code: string;
  created?: number;
  destination_address?: Address;
  events?: ShipmentEvent[];
  external_id?: string;
  i_equipment_shipment: number;
  items: EquipmentShipmentItem[];
  origination_address?: Address;
  packet_type?: string;
  partner_equipment_stock_request_guid: string;
  partner_guid: string;
  received?: number;
  sandbox: boolean;
  sent?: number;
}

export interface EquipmentShipmentInfo {
  i_equipment_sku: number;
  info: string;
}

export interface EquipmentShipmentItem {
  amount: number;
  i_equipment_shipment_item: number;
  i_equipment_sku: number;
  info?: string;
  name: string;
  starter_pack_sku: boolean;
  stock_movement_factor: number;
}

export interface EquipmentShipmentList {
  equipment_shipments?: EquipmentShipment[];
}

export interface EquipmentShipmentListSuccess {
  response?: EquipmentShipmentList;
  /** @default true */
  success?: boolean;
}

export interface EquipmentShipmentPackOption {
  i_equipment_shipment_pack_option: number;
  items?: EquipmentShipmentPackOptionItem[];
  name: string;
}

export interface EquipmentShipmentPackOptionItem {
  amount: number;
  i_equipment_sku: number;
  name: string;
  starter_pack_sku: boolean;
  stock_movement_factor: number;
}

export interface EquipmentShipmentPackOptionList {
  equipment_shipment_pack_options?: EquipmentShipmentPackOption[];
}

export interface EquipmentShipmentPackOptionListSuccess {
  response?: EquipmentShipmentPackOptionList;
  /** @default true */
  success?: boolean;
}

export interface EquipmentShipmentPackOptionSuccess {
  response?: EquipmentShipmentPackOption;
  /** @default true */
  success?: boolean;
}

export interface EquipmentShipmentSuccess {
  response?: EquipmentShipment;
  /** @default true */
  success?: boolean;
}

export interface EquipmentSku {
  i_equipment_sku: number;
  name: string;
  requestable: boolean;
  starter_pack_sku: boolean;
  stock_movement_factor: number;
  tracked: boolean;
}

export interface EquipmentSkuList {
  equipment_skus?: EquipmentSku[];
}

export interface EquipmentSkuListSuccess {
  response?: EquipmentSkuList;
  /** @default true */
  success?: boolean;
}

export interface Faq {
  available_for_microsite: boolean;
  available_for_partners: boolean;
  available_for_users: boolean;
  created: number;
  faq_guid: string;
  product_type: string;
  question: string;
  response: string;
  sort: number;
  translations?: FaqTranslation[];
}

export interface FaqList {
  faqs?: Faq[];
}

export interface FaqListSuccess {
  response?: FaqList;
  /** @default true */
  success?: boolean;
}

export interface FaqSuccess {
  response?: Faq;
  /** @default true */
  success?: boolean;
}

export interface FaqTranslation {
  i_language: number;
  lang_code: string;
  question: string;
  response: string;
}

export interface FileNotFoundError {
  /** @example "file_not_found" */
  error: "file_not_found";
  /** @default false */
  success?: boolean;
}

export interface ForbiddenError {
  /** @example "forbidden" */
  error: "forbidden";
  /** @default false */
  success?: boolean;
}

export interface FormChoice {
  label: string;
  translations?: FormChoiceTranslation[];
  value: string;
}

export interface FormChoiceTranslation {
  i_language: number;
  label: string;
  lang_code: string;
}

export interface FormQuestion {
  choices?: FormChoice[];
  id: string;
  max?: number;
  max_length?: number;
  min?: number;
  min_length?: number;
  question: string;
  required: boolean;
  response?: string;
  rule?: ActivationRule;
  sort: string;
  translations?: FormQuestionTranslation[];
  /** @example "STRING" */
  type: "CHOICE" | "DATE" | "INT" | "STRING";
}

export interface FormQuestionTranslation {
  i_language: number;
  lang_code: string;
  question: string;
}

export interface InsuranceCompany {
  abbreviation: string;
  active?: boolean;
  ik_number?: string;
  insurance_company_guid: string;
  name: string;
}

export interface InsuranceCompanyList {
  insurance_companies?: InsuranceCompany[];
}

export interface InsuranceCompanyListSuccess {
  response?: InsuranceCompanyList;
  /** @default true */
  success?: boolean;
}

export interface InsuranceCompanySuccess {
  response?: InsuranceCompany;
  /** @default true */
  success?: boolean;
}

export interface InventoryBalance {
  batch_number?: string;
  expiration_date?: number;
  i_product: number;
  i_product_batch?: number | null;
  in_transit_orders?: InventoryBalanceInTransitOrder[];
  inventory_location_guid: string;
  inventory_location_name: string;
  /** @example "INTERNAL" */
  inventory_location_type: "INTERNAL" | "PARTNER" | "SYSTEM";
  needs_serial_numbers?: boolean;
  partner_city?: string;
  partner_guid?: string;
  partner_name?: string;
  product_guid: string;
  product_name: string;
  product_type: string;
  quantity: number;
  serial_numbers?: string[];
  updated: number;
}

export interface InventoryBalanceInTransitOrder {
  i_partner_product_order: number;
  i_partner_product_order_item: number;
  i_product_batch_allocation: number;
  quantity: number;
  shipment_code?: string;
  shipment_external_id?: string;
  shipment_id: number;
}

export interface InventoryBalanceList {
  inventory_balances?: InventoryBalance[];
}

export interface InventoryBalanceListSuccess {
  response?: InventoryBalanceList;
  /** @default true */
  success?: boolean;
}

export interface InventoryLocation {
  created: number;
  created_by_name?: string;
  inventory_location_guid: string;
  is_active: boolean;
  is_fulfillable: boolean;
  is_main: boolean;
  name: string;
  partner_city?: string;
  partner_guid?: string;
  partner_name?: string;
  total_quantity?: number;
  /** @example "INTERNAL" */
  type: "INTERNAL" | "PARTNER" | "SYSTEM";
}

export interface InventoryLocationList {
  inventory_locations?: InventoryLocation[];
}

export interface InventoryLocationListSuccess {
  response?: InventoryLocationList;
  /** @default true */
  success?: boolean;
}

export interface InventoryLocationSuccess {
  response?: InventoryLocation;
  /** @default true */
  success?: boolean;
}

export interface InventoryMovementResult {
  counted_quantity?: number;
  current_quantity?: number;
  i_inventory_stock_movement?: number | null;
  movement_type?: string;
  quantity?: number;
  quantity_delta?: number;
}

export interface InventoryMovementResultSuccess {
  response?: InventoryMovementResult;
  /** @default true */
  success?: boolean;
}

export interface InventorySerialNumberSearchList {
  inventory_serial_numbers?: InventorySerialNumberSearchResult[];
}

export interface InventorySerialNumberSearchListSuccess {
  response?: InventorySerialNumberSearchList;
  /** @default true */
  success?: boolean;
}

export interface InventorySerialNumberSearchResult {
  batch_number?: string;
  current_inventory_location_guid?: string;
  current_inventory_location_name?: string;
  current_inventory_location_type?: string;
  current_partner_city?: string;
  current_partner_guid?: string;
  current_partner_name?: string;
  current_source?: string;
  current_status?: string;
  i_partner_product_order?: number;
  i_product: number;
  i_product_batch?: number | null;
  needs_serial_numbers?: boolean;
  product_guid: string;
  product_name: string;
  product_type: string;
  serial_number: string;
  shipment_code?: string;
  shipment_external_id?: string;
  shipment_id?: number;
  shipment_received?: number;
  shipment_sent?: number;
}

export interface InventoryStockMovement {
  batch_number?: string;
  coupon_code?: string;
  coupon_poc_sample_guid?: string;
  created: number;
  created_by_name?: string;
  i_inventory_stock_movement: number;
  i_product: number;
  i_product_batch?: number | null;
  notes?: string;
  product_guid: string;
  product_name: string;
  product_type: string;
  quantity: number;
  reference_id?: string;
  reference_type?: string;
  serial_numbers?: string[];
  source_inventory_location_guid?: string;
  source_inventory_location_name?: string;
  source_partner_city?: string;
  target_inventory_location_guid?: string;
  target_inventory_location_name?: string;
  target_partner_city?: string;
  type: string;
}

export interface InventoryStockMovementList {
  inventory_stock_movements?: InventoryStockMovement[];
}

export interface InventoryStockMovementListSuccess {
  response?: InventoryStockMovementList;
  /** @default true */
  success?: boolean;
}

export interface ISOLanguage {
  code: string;
  english_name: string;
  i_language: number;
}

export interface ISOLanguageList {
  iso_languages?: ISOLanguage[];
}

export interface ISOLanguageListSuccess {
  response?: ISOLanguageList;
  /** @default true */
  success?: boolean;
}

export interface KnowledgeBaseDocument {
  content_type?: string;
  created?: number;
  created_by?: string;
  knowledge_base_document_guid: string;
  last_access?: number;
  product_type: string;
  restricted?: boolean;
  sort?: number;
  thumbnail?: string;
  title: string;
  /** @example "DOCUMENT" */
  type: "DOCUMENT" | "TUTORIAL";
  updated?: number;
  updated_by?: string;
}

export interface KnowledgeBaseDocumentList {
  knowledge_base_documents?: KnowledgeBaseDocument[];
}

export interface KnowledgeBaseDocumentListSuccess {
  response?: KnowledgeBaseDocumentList;
  /** @default true */
  success?: boolean;
}

export interface KnowledgeBaseDocumentSuccess {
  response?: KnowledgeBaseDocument;
  /** @default true */
  success?: boolean;
}

export interface LabResultsTime {
  "0 Days": number;
  "1 Day": number;
  "2 Days": number;
  "3+ Days": number;
  month: number;
  year: number;
}

export interface LastScore {
  approved: boolean;
  created: number;
  finished: number;
  points: number;
  total_points: number;
}

export interface LinkedMedicalTestParameter {
  medical_test_parameter_guid: string;
  name: string;
}

export interface MarketingDocument {
  /** @example "SOCIAL_MEDIA" */
  category:
    | "DOCUMENT"
    | "LOGO"
    | "OTHER"
    | "PRESENTATION"
    | "PROMOTIONAL_MATERIAL"
    | "SOCIAL_MEDIA"
    | "TRAINING_MATERIAL"
    | "VIDEO";
  content_type: string;
  created: number;
  created_by: string;
  format: string;
  marketing_document_guid: string;
  product_type: string;
  public: boolean;
  sort: number;
  thumbnail?: string;
  title: string;
  updated?: number;
  updated_by?: string;
}

export interface MarketingDocumentList {
  marketing_documents?: MarketingDocument[];
}

export interface MarketingDocumentListSuccess {
  response?: MarketingDocumentList;
  /** @default true */
  success?: boolean;
}

export interface MarketingDocumentSuccess {
  response?: MarketingDocument;
  /** @default true */
  success?: boolean;
}

export interface MedicalProfileGroup {
  i_medical_profile_group: string;
  medical_test_profiles?: MedicalTestProfile[];
  name: string;
}

export interface MedicalProfileGroupList {
  medical_profile_groups?: MedicalProfileGroup[];
}

export interface MedicalProfileGroupListSuccess {
  response?: MedicalProfileGroupList;
  /** @default true */
  success?: boolean;
}

export interface MedicalProfileGroupSuccess {
  response?: MedicalProfileGroup;
  /** @default true */
  success?: boolean;
}

export interface MedicalTest {
  adaptors?: number;
  amount: number;
  child_medical_test_guid?: string;
  collection_deadline?: string;
  color: string;
  color_name: string;
  custom_vendor_medical_test?: boolean;
  dead_specimen_amount?: number;
  hide_results?: boolean;
  lanzettes?: number;
  medical_test_group_guid: string;
  medical_test_group_name: string;
  medical_test_guid: string;
  medical_test_parameters?: LinkedMedicalTestParameter[];
  name: string;
  parent_medical_test_guid?: string;
  partner_guid?: string;
  partner_name?: string;
  shipping_deadline?: string;
  specimen_image_url?: string;
  specimen_info?: string;
  /** @example "BLOOD" */
  specimen_type: "BLOOD" | "SALIVA" | "URINE";
  time_sensitive?: boolean;
  translations?: MedicalTestTranslation[];
  unit: string;
  vendor_guid?: string;
  vendor_medical_test_guid?: string;
  vendor_medical_test_name?: string;
  vendor_name?: string;
  wait_time?: number;
}

export interface MedicalTestGroup {
  medical_test_group_guid: string;
  name: string;
  translations?: MedicalTestGroupTranslation[];
}

export interface MedicalTestGroupList {
  medical_test_groups?: MedicalTestGroup[];
}

export interface MedicalTestGroupListSuccess {
  response?: MedicalTestGroupList;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestGroupSuccess {
  response?: MedicalTestGroup;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestGroupTranslation {
  i_language: number;
  lang_code: string;
  name: string;
}

export interface MedicalTestList {
  medical_tests?: MedicalTest[];
}

export interface MedicalTestListSuccess {
  response?: MedicalTestList;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestParameter {
  byo_enabled: boolean;
  created: number;
  faqs?: MedicalTestParameterFaq[];
  loinc_code?: string;
  medical_test_parameter_categories?: MedicalTestParameterCategory[];
  medical_test_parameter_guid: string;
  name: string;
  reference_ranges?: MedicalTestParameterReferenceRange[];
  unit?: string;
  vendor_medical_test_parameters?: VendorMedicalTestParameter[];
}

export interface MedicalTestParameterCategory {
  created: number;
  medical_test_parameter_category_guid: string;
  name: string;
}

export interface MedicalTestParameterCategoryList {
  medical_test_parameter_categories?: MedicalTestParameterCategory[];
}

export interface MedicalTestParameterCategoryListSuccess {
  response?: MedicalTestParameterCategoryList;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestParameterCategorySuccess {
  response?: MedicalTestParameterCategory;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestParameterFaq {
  medical_test_parameter_faq_guid: string;
  question: string;
  response: string;
  sort?: number;
  translations?: MedicalTestParameterFaqTranslation[];
}

export interface MedicalTestParameterFaqList {
  faqs?: MedicalTestParameterFaq[];
}

export interface MedicalTestParameterFaqListSuccess {
  response?: MedicalTestParameterFaqList;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestParameterFaqSuccess {
  response?: MedicalTestParameterFaq;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestParameterFaqTranslation {
  i_language: number;
  lang_code: string;
  question: string;
  response: string;
}

export interface MedicalTestParameterKpi {
  cabolab_parameter_usage: MedicalTestParameterUsage[];
  cabopoc_parameter_usage: MedicalTestParameterUsage[];
}

export interface MedicalTestParameterKpiSuccess {
  response?: MedicalTestParameterKpi;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestParameterList {
  medical_test_parameters?: MedicalTestParameter[];
}

export interface MedicalTestParameterListSuccess {
  response?: MedicalTestParameterList;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestParameterReferenceRange {
  /** @example "woman" */
  gender: "both" | "man" | "woman";
  max_age?: number;
  max_value?: number;
  min_age?: number;
  min_value?: number;
  /** @example "green" */
  result_color?: "green" | "red" | "yellow";
  result_text?: string;
}

export interface MedicalTestParameterSuccess {
  response?: MedicalTestParameter;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestParameterUsage {
  medical_test_parameter_guid: string;
  monthly_counts: MedicalTestParameterUsageMonth[];
  name: string;
  total_count: number;
}

export interface MedicalTestParameterUsageMonth {
  count: number;
  month: number;
  year: number;
}

export interface MedicalTestProfile {
  about_headline?: string;
  about_section_categories?: AboutSectionCategory[];
  about_text?: string;
  available?: boolean;
  calculated_total_price?: number;
  created?: number;
  custom?: boolean;
  description?: string;
  enabled?: boolean;
  enabled_for_microsite?: boolean;
  featured?: number;
  image_available?: number;
  image_url?: string;
  instructions?: string;
  internal?: boolean;
  medical_test_groups: MedicalTestGroup[];
  medical_test_parameters?: MedicalTestParameter[];
  medical_test_profile_guid: string;
  medical_tests: MedicalTest[];
  name: string;
  partner_guid?: string;
  partner_name?: string;
  partner_profile_is_unused?: boolean;
  patient_details_form?: PatientForm;
  popover?: string;
  price?: number;
  price_timeline?: MedicalTestProfilePrice[];
  results?: string;
  selling_price?: number;
  sort?: number;
  subline?: string;
  suggested_selling_price?: number;
  symptom?: string;
  tags?: MedicalTestProfileTag[];
  translations?: MedicalTestProfileTranslation[];
  url?: string;
  usage?: number;
  usage_limit?: number;
  vendor_available?: boolean;
  vendor_medical_tests_available?: boolean;
}

export interface MedicalTestProfileCount {
  count: number;
  medical_test_profile_guid: string;
  name: string;
}

export interface MedicalTestProfileDiscountGroup {
  all_partners: boolean;
  all_profiles: boolean;
  coupons_limit?: number;
  created: number;
  discount: number;
  end?: number;
  medical_test_profile_discount_group_guid: string;
  medical_test_profiles?: MedicalTestProfile[];
  name: string;
  partners?: Partner[];
  start: number;
  time_limit?: number;
}

export interface MedicalTestProfileDiscountGroupList {
  medical_test_profile_discount_groups?: MedicalTestProfileDiscountGroup[];
}

export interface MedicalTestProfileDiscountGroupListSuccess {
  response?: MedicalTestProfileDiscountGroupList;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestProfileDiscountGroupSuccess {
  response?: MedicalTestProfileDiscountGroup;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestProfileDistribution {
  count: number;
  medical_test_profile_guid: string;
  name: string;
  percentage: number;
}

export interface MedicalTestProfileDistributionKpi {
  medical_test_profiles: MedicalTestProfileDistribution[];
  total_count: number;
}

export interface MedicalTestProfileDistributionKpiSuccess {
  response?: MedicalTestProfileDistributionKpi;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestProfileKpi {
  lab_results: LabResultsTime[];
  test_count_by_month?: TestCountByMonth[];
  top_medical_test_profiles?: MedicalTestProfileCount[];
}

export interface MedicalTestProfileKpiSuccess {
  response?: MedicalTestProfileKpi;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestProfileList {
  medical_test_profiles?: MedicalTestProfile[];
}

export interface MedicalTestProfileListSuccess {
  response?: MedicalTestProfileList;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestProfilePrice {
  created: number;
  end?: number;
  price: number;
  start: number;
  suggested_selling_price: number;
}

export interface MedicalTestProfileSuccess {
  response?: MedicalTestProfile;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestProfileTag {
  medical_test_profile_tag_guid: string;
  name: string;
  translations?: MedicalTestProfileTagTranslation[];
}

export interface MedicalTestProfileTagList {
  tags?: MedicalTestProfileTag[];
}

export interface MedicalTestProfileTagListSuccess {
  response?: MedicalTestProfileTagList;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestProfileTagSuccess {
  response?: MedicalTestProfileTag;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestProfileTagTranslation {
  i_language: number;
  lang_code: string;
  name: string;
}

export interface MedicalTestProfileTranslation {
  about_headline?: string;
  about_text?: string;
  description?: string;
  i_language: number;
  instructions?: string;
  lang_code: string;
  name: string;
  popover?: string;
  results?: string;
  subline?: string;
  symptom?: string;
}

export interface MedicalTestSuccess {
  response?: MedicalTest;
  /** @default true */
  success?: boolean;
}

export interface MedicalTestTranslation {
  i_language: number;
  lang_code: string;
  name: string;
}

export interface MinigameResult {
  created: number;
  first_name: string;
  last_name: string;
  partner_guid: string;
  partner_name: string;
  result: string;
  user_guid: string;
}

export interface MinigameResultList {
  results?: MinigameResult[];
}

export interface MinigameResultListSuccess {
  response?: MinigameResultList;
  /** @default true */
  success?: boolean;
}

export interface MinigameResultSuccess {
  response?: MinigameResult;
  /** @default true */
  success?: boolean;
}

export interface NotFoundError {
  /** @example "not_found" */
  error: "not_found";
  /** @default false */
  success?: boolean;
}

export interface Partner {
  active_contracts?: PartnerContractForPartner[];
  apozin_short_code?: string;
  appointments_token?: string;
  avv_acceptance_required?: boolean;
  avv_accepted_at?: number;
  avv_accepted_by?: User;
  avv_current_version?: string;
  avv_version?: string;
  blocked_because_of_payment: number;
  city: string;
  contracts?: PartnerContractForPartner[];
  country: string;
  created?: number;
  default_locale: string;
  development: boolean;
  dx365_devices: PartnerPocDevice[];
  email?: string;
  hardware_training_completed?: number;
  has_appointment_types: number;
  has_unaccepted_billable_contracts?: boolean;
  i_equipment_shipment_pack_option?: number;
  i_medical_profile_group: number;
  iframe?: string;
  invoice_email?: string;
  is_active: number;
  last_batch_inventory_update?: number;
  last_open_partner_invoice_approved_date?: number;
  medical_profile_group_name: string;
  micropage_short_url?: string;
  name: string;
  name2?: string;
  notes?: PartnerNote[];
  owner_subscribed_to_blogs?: number;
  partner_guid: string;
  partner_owner?: User;
  /** @example "SEPA" */
  payment_method: "MANUAL" | "SEPA";
  referral_source?: string;
  referral_source_other?: string;
  referrer_name?: string;
  referrer_partner_guid?: string;
  sales_organization_guid?: string;
  sales_organization_name?: string;
  sandbox: boolean;
  software_training_completed?: number;
  /** Earliest non-deleted contract start date */
  start_date?: number;
  starter_pack_notes?: string;
  starter_pack_received?: number;
  starter_pack_sent?: number;
  street: string;
  stripe_customer_id?: string;
  telephone: string;
  zip: string;
}

export interface PartnerAppointment {
  attachment_upload_token?: string;
  booking_id?: string;
  booking_mode?: string;
  client_city?: string;
  client_dob: string;
  client_email: string;
  client_first_name: string;
  client_gender: string;
  client_insurance_number?: string;
  /** @example "GKV" */
  client_insurance_type?: "GKV" | "PKV";
  client_last_name: string;
  client_street?: string;
  client_telephone: string;
  client_zip?: string;
  color?: string;
  created: number;
  decision_at?: number;
  decision_by?: number;
  decision_text?: string;
  end: number;
  has_questionnaire?: boolean;
  insurance_company_guid?: string;
  medical_test_profile_guid?: string;
  medical_test_profile_name?: string;
  notes?: PartnerAppointmentNote[];
  partner_appointment_guid: string;
  partner_appointment_type_guid: string;
  partner_appointment_type_name: string;
  partner_guid: string;
  partner_name: string;
  product_guid?: string;
  product_name?: string;
  product_question_groups?: PartnerAppointmentProductQuestionGroup[];
  questionnaire_completed?: boolean;
  /** @example "none" */
  request_status?: "approved" | "none" | "pending" | "rejected";
  source_system?: string;
  start: number;
  user_account_id?: string;
  vaccinations?: PartnerAppointmentVaccination[];
}

export interface PartnerAppointmentAnswer {
  answer_text?: string;
  answer_value?: number;
  created: number;
  i_partner_appointment_question_answer: number;
  i_product_question_group_question: number;
  question_text_snapshot: string;
  /** @example "yes_no" */
  question_type_snapshot:
    | "checkbox"
    | "freetext"
    | "number"
    | "select_with_custom"
    | "signature"
    | "stars"
    | "yes_no"
    | "yes_no_with_explanation";
}

export interface PartnerAppointmentAnswers {
  answers?: PartnerAppointmentAnswer[];
}

export interface PartnerAppointmentAnswersSuccess {
  response?: PartnerAppointmentAnswers;
  /** @default true */
  success?: boolean;
}

export interface PartnerAppointmentAttachment {
  partner_appointment_note_guid: string;
}

export interface PartnerAppointmentAttachmentSuccess {
  response?: PartnerAppointmentAttachment;
  /** @default true */
  success?: boolean;
}

export interface PartnerAppointmentList {
  partner_appointments?: PartnerAppointment[];
}

export interface PartnerAppointmentListSuccess {
  response?: PartnerAppointmentList;
  /** @default true */
  success?: boolean;
}

export interface PartnerAppointmentNote {
  attachments?: string;
  content: string;
  created: number;
  created_by: string;
  partner_appointment_note_guid: string;
  published?: number;
  updated: number;
}

export interface PartnerAppointmentProductQuestionGroup {
  product_question_group_guid: string;
  product_question_group_name?: string;
  vaccination_guid?: string;
  vaccination_name?: string;
}

export interface PartnerAppointmentSuccess {
  response?: PartnerAppointment;
  /** @default true */
  success?: boolean;
}

export interface PartnerAppointmentType {
  add_document_description?: string;
  after_test_appointment?: boolean;
  attachments?: string;
  attachments_descriptions?: string;
  availability_time?: AvailabilityTime[][];
  booking_mode?: string;
  can_add_documents?: boolean;
  can_select_test_profile?: boolean;
  color?: string;
  created: number;
  description?: string;
  duration: number;
  i_product?: number;
  lead_time_days?: number;
  name: string;
  notification_email?: string;
  partner_appointment_type_guid: string;
  product_guid?: string;
  product_name?: string;
  request_hint_text?: string;
  sort?: number;
  system_managed_source?: string;
  vaccinations?: PartnerAppointmentVaccination[];
}

export interface PartnerAppointmentTypeList {
  partner_appointment_types?: PartnerAppointmentType[];
}

export interface PartnerAppointmentTypeListSuccess {
  response?: PartnerAppointmentTypeList;
  /** @default true */
  success?: boolean;
}

export interface PartnerAppointmentTypeRef {
  name: string;
  partner_appointment_type_guid: string;
}

export interface PartnerAppointmentTypeSuccess {
  response?: PartnerAppointmentType;
  /** @default true */
  success?: boolean;
}

export interface PartnerAppointmentVaccination {
  product_question_group_guid?: string;
  product_question_group_name?: string;
  vaccination_guid: string;
  vaccination_name?: string;
}

export interface PartnerAvailableSlot {
  capacity_left: number;
  end: string;
  start: string;
}

export interface PartnerAvailableSlotList {
  partner_available_slots?: PartnerAvailableSlot[];
}

export interface PartnerAvailableSlotListSuccess {
  response?: PartnerAvailableSlotList;
  /** @default true */
  success?: boolean;
}

export interface PartnerContract {
  blocked_by_acceptance_for_invoice?: boolean;
  can_perform_tests: boolean;
  cancellation_period_days: number;
  contract_body?: string;
  contract_template_name: string;
  created: number;
  duration_months: number;
  /** @example "2026-11-28" */
  end_date: string;
  i_contract_template: number;
  i_partner_contract: number;
  is_active: number;
  monthly_price_after_minimum_duration_cents?: number;
  monthly_price_cents: number;
  orders_only: boolean;
  partner_contract_guid: string;
  /** @example "CaboLAB" */
  product_type: "CaboLAB" | "CaboPOC" | "CaboVAX";
  setup_fee_cents: number;
  /** @example "2026-04-01" */
  start_date: string;
  trial_period_days: number;
}

export interface PartnerContractForPartner {
  accepted?: number;
  blocked_by_acceptance_for_invoice?: boolean;
  can_perform_tests: boolean;
  cancellation_period_days: number;
  contract_body?: string;
  contract_template_name: string;
  created: number;
  duration_months: number;
  /** @example "2026-11-28" */
  end_date?: string;
  i_contract_template: number;
  i_partner_contract: number;
  is_active: number;
  monthly_price_cents: number;
  orders_only: boolean;
  partner_contract_guid: string;
  product_type: string;
  setup_fee_cents: number;
  /** @example "2026-04-01" */
  start_date: string;
  trial_period_days: number;
}

export interface PartnerContractList {
  contracts?: PartnerContract[];
}

export interface PartnerContractListSuccess {
  response?: PartnerContractList;
  /** @default true */
  success?: boolean;
}

export interface PartnerContractSuccess {
  response?: PartnerContract;
  /** @default true */
  success?: boolean;
}

export interface PartnerCopyDataResult {
  equipment_stock_items_copied: number;
  inventory_serial_numbers_moved: number;
  manual_serial_numbers_moved: number;
  medical_test_profiles_copied: number;
  partner_landing_copied: boolean;
  product_inventory_items_copied: number;
  product_selling_prices_copied: number;
}

export interface PartnerCopyDataResultSuccess {
  response?: PartnerCopyDataResult;
  /** @default true */
  success?: boolean;
}

export interface PartnerCouponPocSample {
  batch_number?: string;
  cancelled?: number;
  completed?: number;
  completed_by_name?: string;
  coupon_code: string;
  coupon_guid: string;
  coupon_poc_sample_guid: string;
  created: number;
  /** @example "exact" */
  dx365_match_type?: "exact" | "logical";
  medical_test_parameter_results?: CouponPocSampleMedicalTestParameterResult[];
  medical_test_parameters?: CouponPocSampleMedicalTestParameter[];
  product_guid: string;
  product_name: string;
  test_kit_number?: string;
  test_started?: number;
  test_started_by_name?: string;
  waiting_for_result?: number;
  waiting_for_result_error_at?: number;
  waiting_for_result_error_code?: string;
  waiting_for_result_error_details?: object;
}

export interface PartnerCouponPocSampleList {
  coupon_poc_samples?: PartnerCouponPocSample[];
}

export interface PartnerCouponPocSampleListSuccess {
  response?: PartnerCouponPocSampleList;
  /** @default true */
  success?: boolean;
}

export interface PartnerCouponPocSampleSuccess {
  response?: PartnerCouponPocSample;
  /** @default true */
  success?: boolean;
}

export interface PartnerCouponVaccinationList {
  coupon_vaccinations?: CouponVaccinationExtended[];
}

export interface PartnerCouponVaccinationListSuccess {
  response?: PartnerCouponVaccinationList;
  /** @default true */
  success?: boolean;
}

export interface PartnerDevice {
  build_version?: string;
  device_os?: string;
  last_seen?: number;
  locale?: string;
  name?: string;
  partner_device_guid: string;
  partner_guid?: string;
  partner_name?: string;
  roles?: Role[];
}

export interface PartnerDeviceList {
  partner_devices?: PartnerDevice[];
}

export interface PartnerDeviceListSuccess {
  response?: PartnerDeviceList;
  /** @default true */
  success?: boolean;
}

export interface PartnerDeviceSuccess {
  response?: PartnerDevice;
  /** @default true */
  success?: boolean;
}

export interface PartnerEquipmentStock {
  movements?: PartnerEquipmentStockSkuMovement[];
  stock?: PartnerEquipmentStockSku[];
}

export interface PartnerEquipmentStockBatchUpdateItem {
  amount: number;
  i_equipment_sku: number;
}

export interface PartnerEquipmentStockRequest {
  cancellation_reason?: string;
  cancelled?: number;
  created: number;
  i_equipment_shipment?: number;
  items?: PartnerEquipmentStockRequestItem[];
  notes?: string;
  partner_equipment_stock_request_guid: string;
  partner_guid?: string;
  partner_name?: string;
  processed?: number;
  shipments?: EquipmentShipment[];
  threshold: boolean;
  /** @example "STARTER_PACK" */
  type: "MANUAL" | "MANUAL_THRESHOLD" | "STARTER_PACK" | "THRESHOLD";
}

export interface PartnerEquipmentStockRequestItem {
  amount: number;
  created: number;
  i_equipment_sku: number;
  info?: string;
  name: string;
  stock_movement_factor: number;
  threshold?: boolean;
}

export interface PartnerEquipmentStockRequestList {
  requests?: PartnerEquipmentStockRequest[];
}

export interface PartnerEquipmentStockRequestListSuccess {
  response?: PartnerEquipmentStockRequestList;
  /** @default true */
  success?: boolean;
}

export interface PartnerEquipmentStockRequestSuccess {
  response?: PartnerEquipmentStockRequest;
  /** @default true */
  success?: boolean;
}

export interface PartnerEquipmentStockSku {
  amount: number;
  i_equipment_sku: number;
  in_transit: number;
  name: string;
  requested: number;
  sku: string;
  stock_movement_factor: number;
  suggested_amount: number;
  usage?: SkuUsage[];
}

export interface PartnerEquipmentStockSkuMovement {
  amount: number;
  coupon_code?: string;
  created: number;
  created_by?: string;
  i_equipment_shipment?: number;
  i_equipment_sku: number;
  id: number;
  notes?: string;
  shipment_code?: string;
  shipment_external_id?: string;
  sku_name: string;
  stock_movement_factor: number;
  test_kit_code?: string;
  test_kit_guid?: string;
  test_sample_guid?: string;
  /** @example "PARTNER_EQUIPMENT_STOCK_REQUEST" */
  type:
    | "EQUIPMENT_SHIPMENT"
    | "MANUAL"
    | "PARTNER_EQUIPMENT_STOCK_REQUEST"
    | "TEST_KIT_DISCARD"
    | "TEST_SAMPLE"
    | "TEST_SAMPLE_SHIPMENT";
}

export interface PartnerEquipmentStockSuccess {
  response?: PartnerEquipmentStock;
  /** @default true */
  success?: boolean;
}

export interface PartnerHeaderStats {
  coming_for_testing_count: number;
  pending_child_samples_count: number;
  upcoming_testing_appointments_count: number;
}

export interface PartnerHeaderStatsSuccess {
  response?: PartnerHeaderStats;
  /** @default true */
  success?: boolean;
}

export interface PartnerInvoice {
  approved: number;
  billing_cycle_month: number;
  billing_cycle_year: number;
  can_collect_sepa: boolean;
  cancelled?: number;
  city: string;
  closed?: number;
  /** Latest correction timestamp */
  corrected?: number;
  /** Original invoice issue timestamp */
  correction_original_approved?: number;
  correction_original_number?: number;
  created: number;
  customer_id: string;
  items?: PartnerInvoiceItem[];
  notes?: PartnerInvoiceNote[];
  number?: number;
  paid?: number;
  partner_guid: string;
  partner_invoice_guid: string;
  partner_name: string;
  payment_review_required: boolean;
  pdf_first_sent?: number;
  pdf_generated?: number;
  pdf_sent?: number;
  reminder_sent?: number;
  stripe_disputes?: PartnerInvoiceDispute[];
  stripe_intent_failure_code?: string;
  stripe_intent_failure_decline_code?: string;
  stripe_intent_failure_message?: string;
  stripe_intent_id?: string;
  stripe_intent_status?: string;
  stripe_intents?: PartnerInvoiceStripeIntent[];
  tax: number;
  total: number;
  total_discount: number;
  /** @example "CABOLAB" */
  type?: "CABOLAB" | "CABOPOC" | "CABOVAX";
  zip: string;
}

export interface PartnerInvoiceDispute {
  amount: number;
  charge_id: string;
  created: number;
  currency: string;
  dispute_id: string;
  funds_withdrawn: number;
  intent_id: string;
  reason: string;
  resolved_at?: number;
  resolved_by?: string;
  status: string;
}

export interface PartnerInvoiceItem {
  activated?: number;
  amount: number;
  batch_numbers?: string[];
  box_size?: number;
  collected?: number;
  coupon_code?: string;
  coupon_guid?: string;
  created: number;
  description: string;
  discount: number;
  discount_reason?: string;
  discounted_value?: number;
  order_id?: number;
  order_item_id?: number;
  original_value?: number;
  packed?: number;
  partner_guid?: string;
  partner_invoice_guid?: string;
  partner_invoice_item_guid: string;
  /** @example "CaboLAB" */
  product_type?: "CaboLAB" | "CaboPOC" | "CaboVAX";
  serial_numbers?: string[];
  /** @example "SETUP" */
  type: "COUPON" | "MONTHLY" | "PARTIAL_MONTHLY" | "POC_ORDER" | "SETUP" | "SHIPPING";
  unit_price?: number;
  /** @example "box" */
  unit_type?: "box" | "single";
  value: number;
}

export interface PartnerInvoiceItemList {
  partner_invoice_items?: PartnerInvoiceItem[];
}

export interface PartnerInvoiceItemListSuccess {
  response?: PartnerInvoiceItemList;
  /** @default true */
  success?: boolean;
}

export interface PartnerInvoiceList {
  partner_invoices?: PartnerInvoice[];
}

export interface PartnerInvoiceListSuccess {
  response?: PartnerInvoiceList;
  /** @default true */
  success?: boolean;
}

export interface PartnerInvoiceNote {
  attachments?: string;
  content: string;
  created: number;
  created_by: string;
  partner_invoice_note_guid: string;
  updated: number;
}

export interface PartnerInvoiceStripeIntent {
  amount: number;
  created: number;
  failure_code?: string;
  failure_decline_code?: string;
  failure_message?: string;
  intent_id: string;
  status: string;
  updated: number;
}

export interface PartnerInvoiceSuccess {
  response?: PartnerInvoice;
  /** @default true */
  success?: boolean;
}

export interface PartnerLanding {
  active_contracts?: object[];
  email: string;
  hero_subtitle: string;
  hide_pharmacy_name: boolean;
  iframe: string;
  image_url: string;
  logo_url: string;
  medical_test_profiles?: MedicalTestProfile[];
  opening_time: string;
  partner_guid: string;
  partner_name: string;
  poc_products?: ProductSellingPrice[];
  primary_color: string;
  secondary_color: string;
  short_code: string;
  short_url: string;
  show_iframe_as_url: boolean;
  telephone: string;
}

export interface PartnerLandingSuccess {
  response?: PartnerLanding;
  /** @default true */
  success?: boolean;
}

export interface PartnerList {
  partners?: Partner[];
}

export interface PartnerListSuccess {
  response?: PartnerList;
  /** @default true */
  success?: boolean;
}

export interface PartnerNote {
  attachments?: string;
  content: string;
  created: number;
  created_by: string;
  i_pre_registration_request?: number;
  partner_note_guid?: string;
  pre_registration_request_note_guid?: string;
  test_kit_code?: string;
  test_sample_created?: number;
  test_sample_guid?: string;
  test_sample_note_guid?: string;
  updated: number;
}

export interface PartnerOwnershipTransfer {
  expiration: number;
  login_email: string;
  new_owner_guid: string;
  new_owner_name: string;
  old_owner_guid: string;
  transfer_guid: string;
}

export interface PartnerOwnershipTransferError {
  /** @example "not_found" */
  error:
    | "email_failed"
    | "not_found"
    | "ownership_transfer_changed"
    | "ownership_transfer_email_invalid"
    | "ownership_transfer_expired";
  /** @default false */
  success?: boolean;
}

export interface PartnerOwnershipTransferStatus {
  transfer?: PartnerOwnershipTransfer;
}

export interface PartnerOwnershipTransferStatusSuccess {
  response?: PartnerOwnershipTransferStatus;
  /** @default true */
  success?: boolean;
}

export interface PartnerPatient {
  birth_year: number;
  created: number;
  email?: string;
  first_name: string;
  last_name: string;
  patient_guid: string;
  updated?: number;
}

export interface PartnerPatientEmail {
  content: string;
  email_guid: string;
  opened_at?: number;
  recipient: string;
  sent_at: number;
  subject: string;
}

export interface PartnerPatientEmailList {
  emails?: PartnerPatientEmail[];
}

export interface PartnerPatientEmailListSuccess {
  response?: PartnerPatientEmailList;
  /** @default true */
  success?: boolean;
}

export interface PartnerPatientList {
  patients?: PartnerPatientListItem[];
  total_count: number;
}

export interface PartnerPatientListItem {
  birth_year: number;
  first_name: string;
  last_name: string;
  last_test_at?: number;
  patient_guid: string;
}

export interface PartnerPatientListSuccess {
  response?: PartnerPatientList;
  /** @default true */
  success?: boolean;
}

export interface PartnerPatientNote {
  content: string;
  created: number;
  created_by_name?: string;
  created_by_user_guid?: string;
  note_guid: string;
  title: string;
  updated?: number;
  updated_by_name?: string;
  updated_by_user_guid?: string;
}

export interface PartnerPatientNoteList {
  notes?: PartnerPatientNote[];
}

export interface PartnerPatientNoteListSuccess {
  response?: PartnerPatientNoteList;
  /** @default true */
  success?: boolean;
}

export interface PartnerPatientNoteSuccess {
  response?: PartnerPatientNote;
  /** @default true */
  success?: boolean;
}

export interface PartnerPatientSuccess {
  response?: PartnerPatient;
  /** @default true */
  success?: boolean;
}

export interface PartnerPatientTask {
  completed_at?: number;
  created: number;
  created_by_name?: string;
  created_by_user_guid?: string;
  due_date: string;
  /** @example "OPEN" */
  status: "DONE" | "OPEN";
  task_guid: string;
  text?: string;
  title: string;
  updated?: number;
}

export interface PartnerPatientTaskList {
  tasks?: PartnerPatientTask[];
}

export interface PartnerPatientTaskListSuccess {
  response?: PartnerPatientTaskList;
  /** @default true */
  success?: boolean;
}

export interface PartnerPatientTaskSuccess {
  response?: PartnerPatientTask;
  /** @default true */
  success?: boolean;
}

export interface PartnerPatientTest {
  cabo_check_id: string;
  evaluated_at?: number;
  retrieved_at?: number;
  /** @example "LAB" */
  source_type: "LAB" | "POC";
  test_date?: number;
  test_name: string;
  test_sample_guid: string;
}

export interface PartnerPatientTestList {
  tests?: PartnerPatientTest[];
}

export interface PartnerPatientTestListSuccess {
  response?: PartnerPatientTestList;
  /** @default true */
  success?: boolean;
}

export interface PartnerPersonnelSchedule {
  appointment_types?: PartnerAppointmentTypeRef[];
  created: number;
  end_date: number;
  partner_personnel_schedule_guid: string;
  slots: PartnerPersonnelScheduleSlot[];
  start_date: number;
  updated: number;
}

export interface PartnerPersonnelScheduleListInput {
  appointment_type_guids?: string[];
  /** @example "2025-12-30" */
  end_date: string;
  slots: PartnerPersonnelScheduleSlot[];
  /** @example "2025-06-01" */
  start_date: string;
}

export interface PartnerPersonnelScheduleListOutput {
  partner_personnel_schedules?: PartnerPersonnelSchedule[];
}

export interface PartnerPersonnelScheduleListOutputSuccess {
  response?: PartnerPersonnelScheduleListOutput;
  /** @default true */
  success?: boolean;
}

export interface PartnerPersonnelScheduleSlot {
  /** @example "MON" */
  day_of_week: "FRI" | "MON" | "SAT" | "SUN" | "THU" | "TUE" | "WED";
  /** @example "12:00" */
  end_time: string;
  /** @example 2 */
  personnel_count: number;
  /** @example "08:00" */
  start_time: string;
}

export interface PartnerPocDevice {
  /** @maxLength 10 */
  firmware?: string;
  /** @example "dx365" */
  result_provider: "dx365" | "polaris";
  serial_number: string;
  /** @example "manual" */
  source: "manual" | "shipped";
}

export interface PartnerPocOrderLineItem {
  i_product: number;
  quantity: number;
  /**
   * @default "single"
   * @example "box"
   */
  unit_type?: "box" | "single";
}

export interface PartnerPocOrderPriceLineItem {
  i_product: number;
  quantity: number;
  /**
   * @default "single"
   * @example "box"
   */
  unit_type?: "box" | "single";
}

export interface PartnerPocOrderPriceRequest {
  line_items: PartnerPocOrderPriceLineItem[];
}

export interface PartnerPocOrderRequest {
  line_items: PartnerPocOrderLineItem[];
}

export interface PartnerPocOrderUpdateLineItem {
  i_product: number;
  quantity: number;
  /**
   * @default "single"
   * @example "box"
   */
  unit_type?: "box" | "single";
}

export interface PartnerPocOrderUpdateRequest {
  line_items: PartnerPocOrderUpdateLineItem[];
}

export interface PartnerPreregistrationRequest {
  apozin_short_code?: string;
  available_contract_templates?: PreregistrationContractTemplate[];
  cancellation_period_days?: number;
  cancelled?: number;
  city: string;
  completed?: number;
  contract_template_name?: string;
  contract_templates?: PreregistrationContractTemplate[];
  country: string;
  created: number;
  default_locale: string;
  deferred?: number;
  duration_months?: number;
  email: string;
  first_name: string;
  i_contract_template?: number;
  i_equipment_shipment_pack_option?: number;
  i_medical_profile_group?: number;
  i_pre_registration_request: number;
  /** Array of interested product types */
  interested_service_types?: string[];
  last_name: string;
  medical_profile_group_name?: string;
  misc_info?: string;
  monthly_price_cents?: number;
  not_interested?: number;
  notes?: PreregistrationRequestNote[];
  partner_guid?: string;
  partner_name: string;
  referral_source?: string;
  referral_source_other?: string;
  referrer_partner_guid?: string;
  salutation: string;
  setup_fee_cents?: number;
  start_date?: number;
  starter_pack_notes?: string;
  street: string;
  telephone: string;
  title: string;
  validated?: number;
  verified?: number;
  zip: string;
}

export interface PartnerPreregistrationRequestList {
  requests?: PartnerPreregistrationRequest[];
}

export interface PartnerPreregistrationRequestListSuccess {
  response?: PartnerPreregistrationRequestList;
  /** @default true */
  success?: boolean;
}

export interface PartnerPreregistrationRequestSuccess {
  response?: PartnerPreregistrationRequest;
  /** @default true */
  success?: boolean;
}

export interface PartnerProductAutoOrderSettingsItem {
  apply_20_percent_rule?: boolean;
  auto_order_quantity?: number | null;
  /** @example "box" */
  auto_order_unit_type?: "box" | "single";
  i_product: number;
  minimum_stock_quantity?: number | null;
}

export interface PartnerProductAutoOrderSettingsRequest {
  items: PartnerProductAutoOrderSettingsItem[];
}

export interface PartnerProductInventoryBatchUpdateItem {
  amount: number;
  i_product: number;
  i_product_batch?: number | null;
}

export interface PartnerProductInventoryItem {
  apply_20_percent_rule?: boolean;
  auto_order_quantity?: number | null;
  /** @example "box" */
  auto_order_unit_type?: "box" | "single";
  auto_reorderable?: boolean;
  available_quantity?: number;
  box_price_cents?: number;
  box_size?: number;
  i_product?: number;
  is_below_threshold?: boolean;
  minimum_stock_quantity?: number | null;
  name?: string;
  needs_serial_numbers?: boolean;
  online_orderable?: boolean;
  product_guid?: string;
  product_type?: string;
  specimen_type?: string;
  temporarily_unavailable?: boolean;
  unit_price_cents?: number;
}

export interface PartnerProductInventoryKnownBatch {
  batch_label: string;
  batch_number?: string;
  expiration_date?: number | null;
  i_product_batch: number;
}

export interface PartnerProductInventoryList {
  inventory?: PartnerProductInventoryItem[];
}

export interface PartnerProductInventoryListSuccess {
  response?: PartnerProductInventoryList;
  /** @default true */
  success?: boolean;
}

export interface PartnerProductInventoryNewBatch {
  /**
   * Actual stock, not quantity to add
   * @min 1
   */
  amount: number;
  /** @maxLength 50 */
  batch_number: string;
  /** YYYY-MM-DD, or null if unknown */
  expiration_date?: string | null;
  product_guid: string;
}

export interface PartnerProductInventoryStocktake {
  last_product_inventory_update?: string;
  products?: PartnerProductInventoryStocktakeProduct[];
}

export interface PartnerProductInventoryStocktakeBatch {
  available_quantity: number;
  batch_label: string;
  batch_number?: string;
  expiration_date?: number | null;
  i_product_batch?: number | null;
  is_legacy_batch: boolean;
}

export interface PartnerProductInventoryStocktakeProduct {
  apply_20_percent_rule?: boolean;
  auto_order_quantity?: number | null;
  /** @example "box" */
  auto_order_unit_type?: "box" | "single";
  auto_reorderable?: boolean;
  available_quantity?: number;
  batches?: PartnerProductInventoryStocktakeBatch[];
  box_price_cents?: number;
  box_size?: number;
  i_product?: number;
  is_below_threshold?: boolean;
  known_batches?: PartnerProductInventoryKnownBatch[];
  minimum_stock_quantity?: number | null;
  name?: string;
  online_orderable?: boolean;
  product_guid?: string;
  product_type?: string;
  specimen_type?: string;
  temporarily_unavailable?: boolean;
  unit_price_cents?: number;
}

export interface PartnerProductInventoryStocktakeSuccess {
  response?: PartnerProductInventoryStocktake;
  /** @default true */
  success?: boolean;
}

export interface PartnerProductOrderDetail {
  order?: PartnerProductOrderHistoryItem;
}

export interface PartnerProductOrderDetailSuccess {
  response?: PartnerProductOrderDetail;
  /** @default true */
  success?: boolean;
}

export interface PartnerProductOrderHistoryItem {
  attached_goodwill_orders?: PartnerProductOrderTransferBundle[];
  auto_created?: boolean;
  billing_cycle_month?: number;
  billing_cycle_year?: number;
  /** @format date-time */
  cancelled?: string;
  cancelled_by?: number;
  /** @format date-time */
  created?: string;
  created_by_name?: string;
  discount_cents?: number;
  discount_reason?: string;
  discounted_by?: number;
  discounted_by_name?: string;
  fulfillment_mode?: string;
  generated_follow_up_order_id?: number;
  grand_total_cents?: number;
  has_insufficient_inventory?: boolean;
  i_partner_invoice?: number;
  i_partner_product_order?: number;
  /** @format date-time */
  invoiced?: string;
  item_count?: number;
  line_items?: PartnerProductOrderHistoryLineItem[];
  manually_changed?: boolean;
  notes?: string;
  partner_invoice_guid?: string;
  shipment_cancelled?: number;
  shipment_code?: string;
  shipment_external_id?: string;
  shipment_id?: number;
  shipment_received?: number;
  shipment_sent?: number;
  shipping_cost_cents?: number;
  source_i_partner_product_order?: number;
  status?: string;
  subtotal_cents?: number;
  transfer_status?: string;
  transfer_target_order_id?: number;
  /** @format date-time */
  updated?: string;
  updated_by?: number;
  updated_by_name?: string;
}

export interface PartnerProductOrderHistoryLineItem {
  allocations?: ProductOrderLineItemAllocation[];
  applied_incentives?: ProductOrderPriceAppliedIncentive[];
  batch_numbers?: string[];
  box_price_cents?: number;
  box_size?: number;
  i_partner_product_order_item?: number;
  i_product?: number;
  line_total_cents?: number;
  product_name?: string;
  product_type?: string;
  quantity?: number;
  serial_numbers?: string[];
  source_i_partner_product_order_item?: number;
  specimen_type?: string;
  unit_price_cents?: number;
  unit_type?: string;
}

export interface PartnerProductOrderHistoryList {
  orders?: PartnerProductOrderHistoryItem[];
}

export interface PartnerProductOrderHistoryListSuccess {
  response?: PartnerProductOrderHistoryList;
  /** @default true */
  success?: boolean;
}

export interface PartnerProductOrderResponse {
  i_partner_product_order?: number;
  /** @default "success" */
  status?: string;
}

export interface PartnerProductOrderResponseSuccess {
  response?: PartnerProductOrderResponse;
  /** @default true */
  success?: boolean;
}

export interface PartnerProductOrderTransferBundle {
  i_partner_product_order?: number;
  line_items?: PartnerProductOrderHistoryLineItem[];
  transfer_status?: string;
}

export interface PartnerRegistrationKpi {
  month: number;
  new_potential_partners: number;
  new_registered_partners: number;
  potential_partners: number;
  registered_partners: number;
  year: number;
}

export interface PartnerRegistrationKpiList {
  partner_registration_kpis?: PartnerRegistrationKpi[];
}

export interface PartnerRegistrationKpiListSuccess {
  response?: PartnerRegistrationKpiList;
  /** @default true */
  success?: boolean;
}

export interface PartnerSearch {
  city: string;
  country: string;
  distance: number;
  email: string;
  logo_url?: string;
  name: string;
  partner_guid: string;
  short_url?: string;
  street: string;
  telephone?: string;
  zip: string;
}

export interface PartnerSearchList {
  partners?: PartnerSearch[];
}

export interface PartnerSearchListSuccess {
  response?: PartnerSearchList;
  /** @default true */
  success?: boolean;
}

export interface PartnerSpecialAvailability {
  appointment_types: PartnerAppointmentTypeRef[];
  capacity: number;
  end: number;
  override_blocked_periods: boolean;
  special_availability_guid: string;
  start: number;
}

export interface PartnerSpecialAvailabilityInput {
  /** @minItems 1 */
  appointment_type_guids: string[];
  /** @min 1 */
  capacity: number;
  /** ISO datetime with UTC offset */
  end: string;
  override_blocked_periods?: boolean;
  /** ISO datetime with UTC offset */
  start: string;
}

export interface PartnerSpecialAvailabilityList {
  special_availability: PartnerSpecialAvailability[];
}

export interface PartnerSpecialAvailabilityListSuccess {
  response?: PartnerSpecialAvailabilityList;
  /** @default true */
  success?: boolean;
}

export interface PartnerSuccess {
  response?: Partner;
  /** @default true */
  success?: boolean;
}

export interface PartnerTestSamples {
  name: string;
  partner_guid: string;
  start_date?: number;
  test_samples: TestSamplesCount[];
}

export interface PartnerTestSamplesCountKpi {
  partner_test_samples_count?: PartnerTestSamples[];
}

export interface PartnerTestSamplesCountKpiSuccess {
  response?: PartnerTestSamplesCountKpi;
  /** @default true */
  success?: boolean;
}

export interface PartnerUnfinishedTest {
  coupon_code: string;
  coupon_guid: string;
  created: number;
  name: string;
}

export interface PartnerUnfinishedTestList {
  unfinished_tests: PartnerUnfinishedTest[];
}

export interface PartnerUnfinishedTestListSuccess {
  response?: PartnerUnfinishedTestList;
  /** @default true */
  success?: boolean;
}

export interface PatientForm {
  questions?: FormQuestion[];
}

export interface Permission {
  /** @example "can_access_all_partners" */
  name:
    | "can_access_all_chats"
    | "can_access_all_partners"
    | "can_access_all_sales_organizations"
    | "can_access_all_vendors"
    | "can_access_partners_view"
    | "can_activate_partner_coupons"
    | "can_build_medical_test_profiles"
    | "can_cancel_shipments"
    | "can_chat"
    | "can_check_test_kits"
    | "can_check_test_sample_shipments"
    | "can_collect_sample"
    | "can_create_blog_posts"
    | "can_create_equipment_shipment"
    | "can_create_partner"
    | "can_create_partner_notes"
    | "can_generate_coupons"
    | "can_generate_partner_coupons"
    | "can_generate_test_kits"
    | "can_get_all_docs"
    | "can_get_kpis"
    | "can_get_medical_tests"
    | "can_get_minigame_results"
    | "can_get_partner"
    | "can_get_partner_invoices"
    | "can_get_partner_invoices_unapproved"
    | "can_get_partner_medical_tests"
    | "can_get_partner_prices"
    | "can_get_partner_stock"
    | "can_get_partner_team"
    | "can_get_partner_test_samples"
    | "can_get_partner_ticker_events"
    | "can_get_partners"
    | "can_get_public_medical_tests"
    | "can_get_restricted_kpis"
    | "can_get_sales_commission"
    | "can_get_shipments"
    | "can_get_std_docs"
    | "can_get_test_sample_pin"
    | "can_get_test_samples"
    | "can_get_vendors"
    | "can_invalidate_test_samples"
    | "can_login_partner_team_member"
    | "can_manage_inventory"
    | "can_manage_partner_patients"
    | "can_pack_samples"
    | "can_replace_test_kit"
    | "can_reset_coupon_access_attempts"
    | "can_set_initial_user_pin"
    | "can_take_certification_questionnaire"
    | "can_update_agb_documents"
    | "can_update_attachments"
    | "can_update_coupon_email"
    | "can_update_email"
    | "can_update_faqs"
    | "can_update_marketing_documents"
    | "can_update_medical_test_parameter_faqs"
    | "can_update_medical_test_profile_discounts"
    | "can_update_medical_tests"
    | "can_update_partner_appointments"
    | "can_update_partner_devices"
    | "can_update_partner_invoices"
    | "can_update_partner_landing"
    | "can_update_partner_profile_groups"
    | "can_update_partner_stock"
    | "can_update_partner_stock_groups"
    | "can_update_partner_team"
    | "can_update_sample_collection"
    | "can_update_test_sample_notes"
    | "can_update_users"
    | "can_update_vendor_medical_tests"
    | "can_update_vendor_test_machines"
    | "can_update_vendors"
    | "can_update_website_banners"
    | "can_view_inventory";
}

export interface PocKitOrder {
  i_product: number;
  quantity: number;
  /**
   * @default "single"
   * @example "box"
   */
  unit_type?: "box" | "single";
}

export interface PocOrderPriceLineItem {
  i_product: number;
  quantity: number;
  /**
   * @default "single"
   * @example "box"
   */
  unit_type?: "box" | "single";
}

export interface PocOrderPriceRequest {
  i_realm: number;
  line_items: PocOrderPriceLineItem[];
}

export interface PocProductDistribution {
  count: number;
  name: string;
  percentage: number;
  product_guid: string;
}

export interface PocProductDistributionKpi {
  products: PocProductDistribution[];
  total_count: number;
}

export interface PocProductDistributionKpiSuccess {
  response?: PocProductDistributionKpi;
  /** @default true */
  success?: boolean;
}

export interface PocShippingTier {
  active: boolean;
  created: number;
  created_by_name?: string;
  effective_from: number;
  max_order_amount_cents?: number;
  poc_shipping_tier_guid: string;
  shipping_cost_cents: number;
  /** @example "ACTIVE" */
  status: "ACTIVE" | "INACTIVE" | "SCHEDULED";
  updated?: number;
  updated_by_name?: string;
}

export interface PocShippingTierList {
  poc_shipping_tiers?: PocShippingTier[];
}

export interface PocShippingTierListSuccess {
  response?: PocShippingTierList;
  /** @default true */
  success?: boolean;
}

export interface PocShippingTierSuccess {
  response?: PocShippingTier;
  /** @default true */
  success?: boolean;
}

export interface PotentialPartnersKpi {
  month: number;
  request_count: number;
  year: number;
}

export interface PotentialPartnersKpiList {
  potential_partners?: PotentialPartnersKpi[];
}

export interface PotentialPartnersKpiListSuccess {
  response?: PotentialPartnersKpiList;
  /** @default true */
  success?: boolean;
}

export interface PreregistrationContractTemplate {
  can_perform_tests: boolean;
  cancellation_period_days: number;
  contract_body?: string;
  contract_template_guid: string;
  description?: string;
  duration_months: number;
  i_contract_template: number;
  min_first_order_price_cents?: number;
  monthly_price_after_minimum_duration_cents?: number;
  monthly_price_cents: number;
  name: string;
  no_single_poc_test_kit_allowed: boolean;
  /** @example "CaboLAB" */
  product_type: "CaboLAB" | "CaboPOC" | "CaboVAX";
  setup_fee_cents: number;
  trial_period_days: number;
}

export interface PreregistrationRequestNote {
  attachments?: string;
  content: string;
  created: number;
  created_by: string;
  pre_registration_request_note_guid: string;
  updated: number;
}

export interface Product {
  active_order_quantity?: number;
  auto_reorderable?: boolean;
  available_after_idle_quantity?: number;
  available_quantity?: number;
  available_with_waiting_quantity?: number;
  available_without_waiting_quantity?: number;
  box_price_cents?: number;
  box_size?: number;
  created: number;
  created_by_name?: string;
  deleted?: number;
  description?: string;
  earliest_expiration_date?: number;
  first_order_selectable?: boolean;
  i_product: number;
  idle_order_quantity?: number;
  incoming_from_supplier_quantity?: number;
  instructions?: string;
  medical_test_parameters?: object;
  name: string;
  needs_serial_numbers?: boolean;
  online_orderable?: boolean;
  ordered_from_supplier_quantity?: number;
  partner_shipment_quantity?: number;
  product_guid: string;
  /** @example "TEST_KIT" */
  product_type: "PRODUCT" | "TEST_KIT";
  received_from_supplier_quantity?: number;
  /** @example "BLOOD" */
  specimen_type?: "BLOOD" | "SALIVA" | "STOOL" | "URINE";
  temporarily_unavailable?: boolean;
  unit_price_cents?: number;
}

export interface ProductBatch {
  available_with_waiting_quantity?: number;
  available_without_waiting_quantity?: number;
  batch_number: string;
  created: number;
  created_by_name?: string;
  delivery_date?: number;
  expiration_date?: number;
  i_product: number;
  i_product_batch: number;
  initial_quantity: number;
  order_date?: number;
  product_name: string;
  product_type?: string;
  purchase_price: number;
  quantity: number;
  serial_numbers?: string[];
  specimen_type?: string;
}

export interface ProductBatchAllocation {
  batch_number: string;
  created: number;
  i_partner_product_order: number;
  i_partner_product_order_item: number;
  i_product_batch_allocation: number;
  inventory_location_guid?: string;
  inventory_location_name?: string;
  partner_guid: string;
  partner_name: string;
  product_name: string;
  quantity_allocated: number;
  serial_numbers?: string[];
}

export interface ProductBatchAllocationList {
  product_batch_allocations?: ProductBatchAllocation[];
}

export interface ProductBatchAllocationListSuccess {
  response?: ProductBatchAllocationList;
  /** @default true */
  success?: boolean;
}

export interface ProductBatchList {
  product_batches?: ProductBatch[];
}

export interface ProductBatchListSuccess {
  response?: ProductBatchList;
  /** @default true */
  success?: boolean;
}

export interface ProductBatchPartnerReceipt {
  partner_city?: string;
  partner_guid: string;
  partner_name: string;
  partner_street?: string;
  partner_zip?: string;
  quantity: number;
}

export interface ProductBatchPartnerReceiptList {
  partner_receipts?: ProductBatchPartnerReceipt[];
}

export interface ProductBatchPartnerReceiptListSuccess {
  response?: ProductBatchPartnerReceiptList;
  /** @default true */
  success?: boolean;
}

export interface ProductFaq {
  product_faq_guid: string;
  question: string;
  response: string;
  sort?: number;
  translations?: ProductFaqTranslation[];
}

export interface ProductFaqList {
  faqs?: ProductFaq[];
}

export interface ProductFaqListSuccess {
  response?: ProductFaqList;
  /** @default true */
  success?: boolean;
}

export interface ProductFaqSuccess {
  response?: ProductFaq;
  /** @default true */
  success?: boolean;
}

export interface ProductFaqTranslation {
  i_language: number;
  lang_code: string;
  question: string;
  response: string;
}

export interface ProductLatestPurchasePrice {
  batch_number?: string;
  purchase_date?: number;
  purchase_price?: number;
}

export interface ProductLatestPurchasePriceSuccess {
  response?: ProductLatestPurchasePrice;
  /** @default true */
  success?: boolean;
}

export interface ProductList {
  products?: Product[];
}

export interface ProductListSuccess {
  response?: ProductList;
  /** @default true */
  success?: boolean;
}

export interface ProductOrderDeliverySlip {
  contract_names?: string[];
  /** @format date-time */
  created?: string;
  generated_follow_up_order_id?: number;
  has_missing_items?: boolean;
  has_partial_delivery?: boolean;
  i_partner_product_order?: number;
  items?: ProductOrderDeliverySlipItem[];
  partner?: ProductOrderDeliverySlipPartner;
  status?: string;
}

export interface ProductOrderDeliverySlipItem {
  allocations?: ProductOrderLineItemAllocation[];
  batch_numbers?: string[];
  fulfilled_quantity?: number;
  key?: string;
  missing_quantity?: number;
  product_name?: string;
  requested_quantity?: number;
  serial_numbers?: string[];
  unit_label?: string;
}

export interface ProductOrderDeliverySlipPartner {
  city?: string;
  country?: string;
  name?: string;
  partner_guid?: string;
  street?: string;
  zip?: string;
}

export interface ProductOrderDeliverySlipResponse {
  delivery_slip?: ProductOrderDeliverySlip;
}

export interface ProductOrderDeliverySlipResponseSuccess {
  response?: ProductOrderDeliverySlipResponse;
  /** @default true */
  success?: boolean;
}

export interface ProductOrderIncentive {
  active: boolean;
  created: number;
  created_by_name?: string;
  description?: string;
  discount_percentage: number;
  effective_from: number;
  effective_to?: number;
  i_product_order_incentive: number;
  min_order_amount_cents: number;
  name: string;
  product_order_incentive_guid: string;
  /** @example "ACTIVE" */
  status: "ACTIVE" | "EXPIRED" | "INACTIVE" | "SCHEDULED";
  updated?: number;
  updated_by_name?: string;
}

export interface ProductOrderIncentiveList {
  product_order_incentives?: ProductOrderIncentive[];
}

export interface ProductOrderIncentiveListSuccess {
  response?: ProductOrderIncentiveList;
  /** @default true */
  success?: boolean;
}

export interface ProductOrderIncentiveSuccess {
  response?: ProductOrderIncentive;
  /** @default true */
  success?: boolean;
}

export interface ProductOrderLineItemAllocation {
  batch_number?: string;
  created?: number;
  expiration_date?: number;
  i_product_batch?: number;
  i_product_batch_allocation?: number;
  inventory_location_guid?: string;
  inventory_location_name?: string;
  quantity_allocated: number;
  serial_numbers: string[];
}

export interface ProductOrderPriceAppliedIncentive {
  discount_cents?: number;
  discount_percentage?: number;
  min_order_amount_cents?: number;
  name?: string;
  product_order_incentive_guid?: string;
}

export interface ProductOrderPriceResponse {
  applied_incentives?: ProductOrderPriceAppliedIncentive[];
  discount_cents: number;
  free_shipping_threshold_cents?: number | null;
  grand_total_cents: number;
  shipping_cost_cents: number;
  subtotal_cents: number;
  total_cents: number;
}

export interface ProductOrderPriceResponseSuccess {
  response?: ProductOrderPriceResponse;
  /** @default true */
  success?: boolean;
}

export interface ProductPriceList {
  created: number;
  created_by_name?: string;
  description?: string;
  effective_from: number;
  effective_to?: number;
  i_product_price_list: number;
  items?: ProductPriceListItem[];
  name: string;
  product_price_list_guid: string;
  /** @example "ACTIVE" */
  status: "ACTIVE" | "EXPIRED" | "SCHEDULED";
  updated?: number;
  updated_by_name?: string;
}

export interface ProductPriceListItem {
  box_price: number;
  box_size: number;
  i_product: number;
  i_product_price_list_item: number;
  product_name: string;
  product_type?: string;
  sort: number;
  /** @example "BLOOD" */
  specimen_type?: "BLOOD" | "SALIVA" | "STOOL" | "URINE";
  suggested_selling_price?: number;
  unit_price: number;
}

export interface ProductPriceListItemInput {
  box_price: number;
  box_size: number;
  i_product: number;
  sort?: number;
  suggested_selling_price?: number;
  unit_price: number;
}

export interface ProductPriceListList {
  product_price_lists?: ProductPriceList[];
}

export interface ProductPriceListListSuccess {
  response?: ProductPriceListList;
  /** @default true */
  success?: boolean;
}

export interface ProductPriceListSuccess {
  response?: ProductPriceList;
  /** @default true */
  success?: boolean;
}

export interface ProductQuestionGroup {
  created?: number;
  description?: string;
  name: string;
  product_question_group_guid: string;
  question_count?: number;
}

export interface ProductQuestionGroupList {
  product_question_groups?: ProductQuestionGroup[];
}

export interface ProductQuestionGroupListSuccess {
  response?: ProductQuestionGroupList;
  /** @default true */
  success?: boolean;
}

export interface ProductQuestionGroupQuestion {
  created?: number;
  deleted?: number;
  is_required: boolean;
  max_text_length?: number;
  number_max?: number;
  number_min?: number;
  product_question_group_question_guid: string;
  question_text: string;
  /** @example "yes_no" */
  question_type:
    | "checkbox"
    | "freetext"
    | "number"
    | "select_with_custom"
    | "signature"
    | "stars"
    | "yes_no"
    | "yes_no_with_explanation";
  select_options?: string;
  show_in_customer_form: boolean;
  sort?: number;
  stars_max?: number;
  stars_min?: number;
}

export interface ProductQuestionGroupQuestionList {
  questions?: ProductQuestionGroupQuestion[];
}

export interface ProductQuestionGroupQuestionListSuccess {
  response?: ProductQuestionGroupQuestionList;
  /** @default true */
  success?: boolean;
}

export interface ProductQuestionGroupQuestionSuccess {
  response?: ProductQuestionGroupQuestion;
  /** @default true */
  success?: boolean;
}

export interface ProductQuestionGroupSuccess {
  response?: ProductQuestionGroup;
  /** @default true */
  success?: boolean;
}

export interface ProductSellingPrice {
  available_quantity?: number;
  box_price_cents?: number;
  box_size?: number;
  description?: string;
  enabled: number;
  enabled_for_microsite?: boolean;
  instructions?: string;
  medical_test_parameters?: object;
  name: string;
  product_guid: string;
  selling_price?: number;
  sort: number;
  specimen_type?: string;
  suggested_selling_price?: number;
  unit_price_cents?: number;
}

export interface ProductSellingPriceList {
  products?: ProductSellingPrice[];
}

export interface ProductSellingPriceListSuccess {
  response?: ProductSellingPriceList;
  /** @default true */
  success?: boolean;
}

export interface ProductSellingPriceSuccess {
  response?: ProductSellingPrice;
  /** @default true */
  success?: boolean;
}

export interface ProductSuccess {
  response?: Product;
  /** @default true */
  success?: boolean;
}

export interface PublicMedicalTestProfile {
  about_headline?: string;
  about_text?: string;
  description?: string;
  featured?: number;
  image_available?: number;
  instructions?: string;
  medical_test_groups: MedicalTestGroup[];
  medical_test_parameters?: MedicalTestParameter[];
  medical_test_profile_guid: string;
  medical_tests: MedicalTest[];
  name: string;
  popover?: string;
  results?: string;
  subline?: string;
  symptom?: string;
  tags?: MedicalTestProfileTag[];
  translations?: MedicalTestProfileTranslation[];
  url?: string;
}

export interface PublicMedicalTestProfileList {
  medical_test_profiles?: PublicMedicalTestProfile[];
}

export interface PublicMedicalTestProfileListSuccess {
  response?: PublicMedicalTestProfileList;
  /** @default true */
  success?: boolean;
}

export interface Question {
  answer_options?: AnswerOption[];
  exclusive_answer: boolean;
  i_question_group?: number;
  image_url?: string;
  question: string;
  question_group_name?: string;
  question_id: string;
  sort: number;
  title: string;
  translations?: QuestionTranslation[];
}

export interface Questionnaire {
  i_questionnaire: number;
  last_score?: LastScore;
  name: string;
  questions?: Question[];
  translations?: QuestionnaireTranslation[];
}

export interface QuestionnaireList {
  questionnaires?: Questionnaire[];
}

export interface QuestionnaireListSuccess {
  response?: QuestionnaireList;
  /** @default true */
  success?: boolean;
}

export interface QuestionnaireSuccess {
  response?: Questionnaire;
  /** @default true */
  success?: boolean;
}

export interface QuestionnaireTranslation {
  i_language: number;
  lang_code: string;
  name: string;
}

export interface QuestionTranslation {
  i_language: number;
  lang_code: string;
  question: string;
  title: string;
}

export interface RelationshipDeletedCount {
  deleted_count: number;
}

export interface RelationshipDeletedCountSuccess {
  response?: RelationshipDeletedCount;
  /** @default true */
  success?: boolean;
}

export interface ResultsSharingRequest {
  accepted?: number | null;
  consent_text_version: string;
  expires_at: number;
  partner_name: string;
  sharing_duration_days: number;
  sharing_scope: string;
  test_sample_count: number;
}

export interface ResultsSharingRequestConsentPayload {
  consent_confirmed: boolean;
  consent_text_version: string;
  token: string;
}

export interface ResultsSharingRequestError {
  /** @example "accepted" */
  error: "accepted" | "consent_required" | "consent_version_mismatch" | "expired" | "not_found";
  /** @default false */
  success?: boolean;
}

export interface ResultsSharingRequestPreviewPayload {
  token: string;
}

export interface ResultsSharingRequestSuccess {
  response?: ResultsSharingRequest;
  /** @default true */
  success?: boolean;
}

export interface Role {
  display_name?: string;
  /** @example "admin" */
  name:
    | "accountant"
    | "admin"
    | "ai_analyst"
    | "logistics_team_member"
    | "partner_admin"
    | "partner_device"
    | "partner_personnel"
    | "sales_team_member"
    | "sample_manager";
  partner_guid?: string;
  partner_name?: string;
  permissions?: Permission[];
  sales_organization_guid?: string;
  sales_organization_name?: string;
}

export interface RoleList {
  roles?: Role[];
}

export interface RoleListSuccess {
  response?: RoleList;
  /** @default true */
  success?: boolean;
}

export interface SalesCommissionItem {
  activated: number;
  commission: number;
  coupon_code: string;
  coupon_guid: string;
  created: number;
  medical_test_profile_guid: string;
  medical_test_profile_name: string;
}

export interface SalesCommissionItemList {
  sales_commission_items?: SalesCommissionItem[];
}

export interface SalesCommissionItemListSuccess {
  response?: SalesCommissionItemList;
  /** @default true */
  success?: boolean;
}

export interface ServiceRegistration {
  answers?: ServiceRegistrationAnswer[];
  education_text?: string;
  medical_test_profile_guid?: string;
  patient_details_form?: PatientForm;
  product_guid?: string;
  questions: ProductQuestionGroupQuestion[];
  service_name: string;
  vaccination_guid?: string;
}

export interface ServiceRegistrationAnswer {
  answer_text?: string;
  answer_value?: number;
  product_question_group_question_guid: string;
}

export interface ServiceRegistrationCode {
  code: string;
  service_name: string;
}

export interface ServiceRegistrationEducation {
  education_confirmed: boolean;
  education_signature: string;
  education_signature_mime_type: string;
  education_text: string;
  vaccination_guid: string;
}

export interface ServiceRegistrationForm {
  services: ServiceRegistration[];
}

export interface ServiceRegistrationFormSuccess {
  response?: ServiceRegistrationForm;
  /** @default true */
  success?: boolean;
}

export interface ServiceRegistrationInput {
  answers: ServiceRegistrationAnswer[];
  education: ServiceRegistrationEducation[];
  email: string;
  patient_responses: ServiceRegistrationPatientResponse[];
  request_key: string;
}

export interface ServiceRegistrationPatientResponse {
  id: string;
  response: string;
}

export interface ServiceRegistrationResult {
  email_sent: boolean;
  registrations: ServiceRegistrationCode[];
}

export interface ServiceRegistrationResultSuccess {
  response?: ServiceRegistrationResult;
  /** @default true */
  success?: boolean;
}

export interface Shipment {
  cancelled?: number;
  code: string;
  created: number;
  destination_address: Address;
  events?: ShipmentEvent[];
  external_id?: string;
  i_equipment_shipment?: number;
  lab_entry?: number;
  origination_address: Address;
  packed?: number;
  packet_type?: string;
  partner_guid?: string;
  partner_name?: string;
  received?: number;
  sandbox: boolean;
  sent?: number;
  short_code?: string;
  test_sample_shipment_guid?: string;
  vendor_guid?: string;
  vendor_name?: string;
}

export interface ShipmentCount {
  "1 Test": number;
  "2 Tests": number;
  "3 Tests": number;
  "4+ Tests": number;
  month: number;
  year: number;
}

export interface ShipmentEvent {
  date: number;
  description?: string;
  event: string;
}

export interface ShipmentKpi {
  delivery_time?: AverageDeliveryTime;
  shipments: ShipmentCount[];
}

export interface ShipmentKpiSuccess {
  response?: ShipmentKpi;
  /** @default true */
  success?: boolean;
}

export interface ShipmentList {
  shipments?: Shipment[];
}

export interface ShipmentListSuccess {
  response?: ShipmentList;
  /** @default true */
  success?: boolean;
}

export interface ShipmentSuccess {
  response?: Shipment;
  /** @default true */
  success?: boolean;
}

export interface SkuUsage {
  month: number;
  usage: number;
  year: number;
}

export interface StandaloneContactCreated {
  crm_standalone_contact_guid: string;
  i_crm_standalone_contact: number;
}

export interface StandaloneContactCreatedSuccess {
  response?: StandaloneContactCreated;
  /** @default true */
  success?: boolean;
}

export interface StarterKit {
  i_starter_kit: number;
  items?: StarterKitItem[];
  name: string;
}

export interface StarterKitCreateRequest {
  items?: StarterKitRequestItem[];
  name: string;
}

export interface StarterKitItem {
  i_product: number;
  name: string;
  price_cents: number;
  product_guid: string;
  quantity: number;
}

export interface StarterKitList {
  starter_kits?: StarterKit[];
}

export interface StarterKitListSuccess {
  response?: StarterKitList;
  /** @default true */
  success?: boolean;
}

export interface StarterKitRequestItem {
  i_product: number;
  price_cents: number;
  quantity: number;
}

export interface StarterKitSuccess {
  response?: StarterKit;
  /** @default true */
  success?: boolean;
}

export interface StarterKitUpdateRequest {
  items?: StarterKitRequestItem[];
  name?: string;
}

export interface StripeCheckoutResponse {
  client_secret: string;
  status: string;
}

export interface StripeCheckoutResponseSuccess {
  response?: StripeCheckoutResponse;
  /** @default true */
  success?: boolean;
}

export interface StripePaymentMethod {
  id: string;
  last4?: string;
  type: string;
}

export interface StripePaymentMethodsResponse {
  payment_methods?: StripePaymentMethod[];
}

export interface StripePaymentMethodsResponseSuccess {
  response?: StripePaymentMethodsResponse;
  /** @default true */
  success?: boolean;
}

export interface Success {
  /** @default true */
  success?: boolean;
}

export interface SummarizedPartnerInvoice {
  approved: number;
  billing_cycle_month: number;
  billing_cycle_year: number;
  cancelled?: number;
  city: string;
  closed?: number;
  created: number;
  customer_id: string;
  invoice_product_types?: ("CaboLAB" | "CaboPOC" | "CaboVAX")[];
  items?: PartnerInvoiceItem[];
  n_tests: number;
  number?: number;
  paid?: number;
  partner_guid: string;
  partner_invoice_guid: string;
  partner_name: string;
  payment_review_required: boolean;
  pdf_first_sent?: number;
  pdf_generated?: number;
  pdf_sent?: number;
  reminder_sent?: number;
  stripe_intent_failure_code?: string;
  stripe_intent_failure_decline_code?: string;
  stripe_intent_failure_message?: string;
  stripe_intent_id?: string;
  stripe_intent_status?: string;
  summarized_items?: SummarizedPartnerInvoiceItem[];
  tax: number;
  total: number;
  total_discount: number;
  /** @example "CABOLAB" */
  type?: "CABOLAB" | "CABOPOC" | "CABOVAX";
  zip: string;
}

export interface SummarizedPartnerInvoiceItem {
  amount: number;
  box_size?: number;
  description: string;
  discount: number;
  original_value?: number;
  total: number;
  /** @example "SETUP" */
  type: "COUPON" | "MONTHLY" | "PARTIAL_MONTHLY" | "POC_ORDER" | "SETUP" | "SHIPPING";
  /** @example "box" */
  unit_type?: "box" | "single";
  value: number;
}

export interface SummarizedPartnerInvoiceList {
  summarized_partner_invoices?: SummarizedPartnerInvoice[];
}

export interface SummarizedPartnerInvoiceListSuccess {
  response?: SummarizedPartnerInvoiceList;
  /** @default true */
  success?: boolean;
}

export interface SupplierDelivery {
  created: number;
  created_by_name?: string;
  expected_delivery_date?: number;
  incoming_quantity: number;
  items: SupplierDeliveryItem[];
  notes?: string;
  ordered_date: number;
  ordered_quantity: number;
  received_quantity: number;
  /** @example "ORDERED" */
  status: "CANCELLED" | "ORDERED" | "PARTIALLY_RECEIVED" | "RECEIVED";
  supplier_delivery_guid: string;
  supplier_delivery_number: number;
  supplier_name: string;
  supplier_reference?: string;
}

export interface SupplierDeliveryItem {
  incoming_quantity: number;
  ordered_quantity: number;
  product_guid: string;
  product_name: string;
  purchase_price: number;
  received_quantity: number;
  supplier_delivery_item_guid: string;
}

export interface SupplierDeliveryList {
  supplier_deliveries?: SupplierDelivery[];
}

export interface SupplierDeliveryListSuccess {
  response?: SupplierDeliveryList;
  /** @default true */
  success?: boolean;
}

export interface SupplierDeliverySuccess {
  response?: SupplierDelivery;
  /** @default true */
  success?: boolean;
}

export interface Task {
  contact_name: string;
  created: number;
  crm_standalone_contact_guid: string;
  crm_task_guid: string;
  description?: string;
  due_date?: number;
  /** @example "low" */
  priority: "high" | "low" | "medium" | "urgent";
  /** @example "pending" */
  status: "cancelled" | "completed" | "in_progress" | "pending";
  title: string;
  updated?: number;
}

export interface TaskDeletedCount {
  deleted_count: number;
}

export interface TaskDeletedCountSuccess {
  response?: TaskDeletedCount;
  /** @default true */
  success?: boolean;
}

export interface TaskList {
  data?: Task[];
  pagination?: TasksPagination;
}

export interface TaskListSuccess {
  response?: TaskList;
  /** @default true */
  success?: boolean;
}

export interface TasksPagination {
  limit?: number;
  offset?: number;
  total_count?: number;
}

export interface TaskSuccess {
  response?: Task;
  /** @default true */
  success?: boolean;
}

export interface Team {
  team?: TeamMember[];
}

export interface TeamMember {
  email?: string;
  email_verified: boolean;
  first_name: string;
  has_signature?: boolean;
  last_login?: number;
  last_name: string;
  owner: boolean;
  pin_set: boolean;
  roles?: Role[];
  salutation?: string;
  subscribed_to_blogs: boolean;
  temp_pin: boolean;
  title?: string;
  user_guid: string;
}

export interface TeamSuccess {
  response?: Team;
  /** @default true */
  success?: boolean;
}

export interface TestCountByMonth {
  count: number;
  month: number;
  year: number;
}

export interface TestExecutionConsent {
  accepted?: number;
  activation_user_name: string;
  agb_document_guid?: string;
  agb_url?: string;
  agb_valid_from?: string;
  labs?: object[];
  partner_name: string;
  privacy_policy_url: string;
  privacy_policy_version: string;
  /** @example "CaboLAB" */
  product_type: "CaboLAB" | "CaboPOC";
  selected_tests: object[];
  test_execution_consent_guid: string;
  validation_token?: string;
}

export interface TestExecutionConsentSuccess {
  response?: TestExecutionConsent;
  /** @default true */
  success?: boolean;
}

export interface TestKit {
  code: string;
  collected?: number;
  color: string;
  color_name: string;
  coupon_guid?: string;
  discarded?: number;
  expiration?: number;
  partner_guid?: string;
  production?: number;
  test_kit_guid: string;
  test_sample_guid?: string;
}

export interface TestKitList {
  test_kits?: TestKit[];
}

export interface TestKitListSuccess {
  response?: TestKitList;
  /** @default true */
  success?: boolean;
}

export interface TestKitSuccess {
  response?: TestKit;
  /** @default true */
  success?: boolean;
}

export interface TestKitType {
  adaptor_equipment_sku_id?: number;
  adaptor_equipment_sku_name?: string;
  color: string;
  color_name: string;
  created: number;
  equipment_sku_name: string;
  i_equipment_sku: number;
  i_test_kit_type: number;
  lanzette_equipment_sku_id?: number;
  lanzette_equipment_sku_name?: string;
  specimen_max_amount: number;
  /** @example "BLOOD" */
  specimen_type: "BLOOD" | "SALIVA" | "URINE";
  specimen_unit: string;
  translations?: TestKitTypeTranslation[];
}

export interface TestKitTypeList {
  test_kit_types?: TestKitType[];
}

export interface TestKitTypeListSuccess {
  response?: TestKitTypeList;
  /** @default true */
  success?: boolean;
}

export interface TestKitTypeSuccess {
  response?: TestKitType;
  /** @default true */
  success?: boolean;
}

export interface TestKitTypeTranslation {
  color_name: string;
  i_language: number;
  lang_code: string;
}

export interface TestSample {
  adaptors?: number;
  blocked_until?: number;
  cabolab_invalid_sample_fee_cents?: number;
  cancellation_reason?: string;
  cancelled?: number;
  child_test_sample_guid?: string;
  collected?: number;
  collected_by_name?: string;
  collection_deadline?: string;
  color?: string;
  color_name?: string;
  coupon_code?: string;
  coupon_guid?: string;
  created: number;
  email?: string;
  has_notes?: boolean;
  hide_results?: boolean;
  invalidated?: number;
  invalidation_fee_cents?: number;
  invalidation_reason?: string;
  lab_entry?: number;
  lanzettes?: number;
  medical_test_guid: string;
  medical_test_name: string;
  medical_test_profile_guid: string;
  medical_test_profile_name: string;
  notes?: TestSampleNote[];
  packed?: number;
  parent_test_sample_guid?: string;
  partner_city?: string;
  partner_guid?: string;
  partner_name?: string;
  patient_details_form?: PatientForm;
  patient_details_form_completed?: number;
  pin_set?: boolean;
  received?: number;
  results?: TestSampleResult[];
  results_available?: number;
  results_received?: number;
  results_sent?: number;
  sent?: number;
  shared_until?: number;
  sharing_request_sent?: number;
  shipment_cancelled?: number;
  test_execution_consent_accepted?: number;
  test_kit_code?: string;
  test_kit_guid?: string;
  test_sample_guid: string;
  test_sample_shipment_guid?: string;
  time_sensitive?: boolean;
  vendor_api_version?: string;
  vendor_guid?: string;
  vendor_name?: string;
  wait_time?: number;
}

export interface TestSampleList {
  test_samples?: TestSample[];
}

export interface TestSampleListPagination {
  pagination?: TestSamplesPagination;
  test_samples?: TestSample[];
}

export interface TestSampleListPaginationSuccess {
  response?: TestSampleListPagination;
  /** @default true */
  success?: boolean;
}

export interface TestSampleListSuccess {
  response?: TestSampleList;
  /** @default true */
  success?: boolean;
}

export interface TestSampleNote {
  attachments?: string;
  content: string;
  created: number;
  created_by: string;
  published?: number;
  test_sample_note_guid: string;
  updated: number;
}

export interface TestSamplePin {
  pin: string;
}

export interface TestSamplePinSuccess {
  response?: TestSamplePin;
  /** @default true */
  success?: boolean;
}

export interface TestSampleResult {
  allergen?: string;
  i_vendor_medical_test_parameter_group?: number;
  i_vendor_medical_test_parameter_subgroup?: number;
  invalidated?: number;
  invalidation_reason?: string;
  level_color?: string;
  level_name?: string;
  long_name: string;
  lower_bound?: string;
  name: string;
  result?: string;
  result_time?: number;
  result_unit?: string;
  upper_bound?: string;
  vendor_medical_test_parameter_group_name?: string;
  vendor_medical_test_parameter_subgroup_name?: string;
}

export interface TestSamplesCount {
  count: number;
  month: number;
  year: number;
}

export interface TestSampleShipment {
  cancelled?: number;
  code?: string;
  created?: number;
  destination_address?: Address;
  events?: ShipmentEvent[];
  external_id?: string;
  lab_entry?: number;
  origination_address?: Address;
  packed?: number;
  packet_type?: string;
  partner_guid: string;
  partner_name: string;
  received?: number;
  sandbox: boolean;
  sent?: number;
  short_code?: string;
  test_sample_shipment_guid?: string;
  test_samples: TestSample[];
  time_sensitive?: boolean;
  vendor_guid: string;
  vendor_name: string;
}

export interface TestSampleShipmentList {
  test_sample_shipments?: TestSampleShipment[];
}

export interface TestSampleShipmentListSuccess {
  response?: TestSampleShipmentList;
  /** @default true */
  success?: boolean;
}

export interface TestSampleShipmentSuccess {
  response?: TestSampleShipment;
  /** @default true */
  success?: boolean;
}

export interface TestSamplesPagination {
  /** Limit for pagination */
  limit?: number;
  /** Offset for pagination */
  offset?: number;
  /** Sort direction for pagination */
  sort_direction?: string;
  /** Sort field for pagination */
  sort_field?: string;
  /** Total number of rows */
  total_count?: number;
}

export interface TestSampleSuccess {
  response?: TestSample;
  /** @default true */
  success?: boolean;
}

export interface TestSuccess {
  message: string;
}

export interface TickerEvent {
  client_first_name?: string;
  client_last_name?: string;
  coupon_code?: string;
  created: number;
  info_url?: string;
  invalidated?: number;
  invalidation_reason?: string;
  medical_test_guid?: string;
  medical_test_name?: string;
  message?: string;
  partner_appointment_guid?: string;
  partner_appointment_type_name?: string;
  results_available?: number;
  shared_until?: number;
  start?: number;
  test_kit_code?: string;
  test_kit_guid?: string;
  test_sample_guid?: string;
  test_sample_note_guid?: string;
  ticker_event_guid: string;
  title?: string;
  /** @example "INFO" */
  type: "APPOINTMENT_VALIDATED" | "INFO" | "SHARED_RESULTS_AVAILABLE" | "TEST_SAMPLE_INVALIDATED" | "TEST_SAMPLE_NOTE";
  viewed?: number;
}

export interface TickerEventList {
  ticker_events?: TickerEvent[];
}

export interface TickerEventListSuccess {
  response?: TickerEventList;
  /** @default true */
  success?: boolean;
}

export interface TickerEventSuccess {
  response?: TickerEvent;
  /** @default true */
  success?: boolean;
}

export interface User {
  certified_for_collection?: number;
  email: string;
  first_name: string;
  last_name: string;
  roles?: Role[];
  salutation?: string;
  subscribed_to_blogs?: number;
  title?: string;
  user_guid: string;
}

export interface UserSuccess {
  response?: User;
  /** @default true */
  success?: boolean;
}

export interface Vaccination {
  created: number;
  education_text?: string;
  i_product_question_group?: number;
  i_vaccination: number;
  name: string;
  patient_details_form?: PatientForm;
  price?: number;
  product_question_group_guid?: string;
  reminder_months?: number;
  vaccination_guid: string;
  vaccine_name?: string;
}

export interface VaccinationList {
  vaccinations?: Vaccination[];
}

export interface VaccinationListSuccess {
  response?: VaccinationList;
  /** @default true */
  success?: boolean;
}

export interface VaccinationSuccess {
  response?: Vaccination;
  /** @default true */
  success?: boolean;
}

export interface Vendor {
  city: string;
  country: string;
  name: string;
  name2?: string;
  name3?: string;
  street: string;
  vendor_guid: string;
  zip: string;
}

export interface VendorList {
  vendors?: Vendor[];
}

export interface VendorListSuccess {
  response?: VendorList;
  /** @default true */
  success?: boolean;
}

export interface VendorMedicalTest {
  available: boolean;
  custom: boolean;
  dead_specimen_amount?: number;
  long_name: string;
  medical_tests?: MedicalTest[];
  name: string;
  price?: number;
  price_timeline?: VendorMedicalTestPrice[];
  specimen_amount?: number;
  vendor_medical_test_guid: string;
  vendor_medical_test_parameters?: VendorMedicalTestParameter[];
}

export interface VendorMedicalTestList {
  vendor_medical_tests?: VendorMedicalTest[];
}

export interface VendorMedicalTestListSuccess {
  response?: VendorMedicalTestList;
  /** @default true */
  success?: boolean;
}

export interface VendorMedicalTestParameter {
  allergen?: string;
  color?: string;
  dead_specimen_amount?: number;
  i_test_kit_type: number;
  i_vendor_medical_test_parameter_group?: number;
  i_vendor_medical_test_parameter_subgroup?: number;
  labclinic_v11_parameter_id?: string;
  labclinic_v11_parameter_name?: string;
  long_name: string;
  name: string;
  price?: number;
  specimen_amount: number;
  specimen_max_amount?: number;
  /** @example "BLOOD" */
  specimen_type?: "BLOOD" | "SALIVA" | "URINE";
  specimen_unit?: string;
  vendor_guid?: string;
  vendor_medical_test_parameter_group_name?: string;
  vendor_medical_test_parameter_guid: string;
  vendor_medical_test_parameter_levels?: VendorMedicalTestParameterLevel[];
  vendor_medical_test_parameter_subgroup_name?: string;
  vendor_name?: string;
  vendor_test_machine_guid?: string;
  vendor_test_machine_name?: string;
}

export interface VendorMedicalTestParameterLevel {
  color: string;
  i_vendor_medical_test_parameter_level: number;
  lower_bound?: number;
  name: string;
  upper_bound?: number;
}

export interface VendorMedicalTestParameterList {
  vendor_medical_test_parameters?: VendorMedicalTestParameter[];
}

export interface VendorMedicalTestParameterListSuccess {
  response?: VendorMedicalTestParameterList;
  /** @default true */
  success?: boolean;
}

export interface VendorMedicalTestParameterSuccess {
  response?: VendorMedicalTestParameter;
  /** @default true */
  success?: boolean;
}

export interface VendorMedicalTestPrice {
  created: number;
  end?: number;
  start: number;
  value: number;
}

export interface VendorMedicalTestSuccess {
  response?: VendorMedicalTest;
  /** @default true */
  success?: boolean;
}

export interface VendorSuccess {
  response?: Vendor;
  /** @default true */
  success?: boolean;
}

export interface VendorTestMachine {
  created: number;
  dead_specimen_amount: number;
  name: string;
  vendor_test_machine_guid: string;
}

export interface VendorTestMachineList {
  vendor_test_machines?: VendorTestMachine[];
}

export interface VendorTestMachineListSuccess {
  response?: VendorTestMachineList;
  /** @default true */
  success?: boolean;
}

export interface VendorTestMachineSuccess {
  response?: VendorTestMachine;
  /** @default true */
  success?: boolean;
}

export interface VendorTimeoff {
  created: number;
  end: number;
  start: number;
  vendor_time_off_guid: string;
}

export interface VendorTimeoffList {
  timeoffs?: VendorTimeoff[];
}

export interface VendorTimeoffListSuccess {
  response?: VendorTimeoffList;
  /** @default true */
  success?: boolean;
}

export interface VendorTimeoffSuccess {
  response?: VendorTimeoff;
  /** @default true */
  success?: boolean;
}

export interface Version {
  config?: string;
  version: number;
}

export interface VersionSuccess {
  response?: Version;
  /** @default true */
  success?: boolean;
}

export interface WebsiteBanner {
  available_for_microsite: boolean;
  available_for_partners: boolean;
  available_for_users: boolean;
  available_from?: number;
  available_to?: number;
  background_color?: string;
  content: string;
  created: number;
  translations?: WebsiteBannerTranslation[];
  url?: string;
  website_banner_guid: string;
}

export interface WebsiteBannerList {
  website_banners?: WebsiteBanner[];
}

export interface WebsiteBannerListSuccess {
  response?: WebsiteBannerList;
  /** @default true */
  success?: boolean;
}

export interface WebsiteBannerSuccess {
  response?: WebsiteBanner;
  /** @default true */
  success?: boolean;
}

export interface WebsiteBannerTranslation {
  content: string;
  i_language: number;
  lang_code: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** Code-generated operation name for diagnostics; never patient input. */
  operation?: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E | undefined;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

import pino, { LoggerOptions } from "pino";
import { captureResponseDiagnostics } from "../utils/logDiagnostics";
const logger = pino({ level: (typeof process != "undefined" && process?.env.LOG_LEVEL) ?? "info" } as LoggerOptions);

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => {
    return fetch(...fetchParams);
  };

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    operation,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;
    const started = performance.now();

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type === ContentType.FormData ? {} : { "Content-Type": type || ContentType.Json }),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const clonedResponse = response.clone();
      const r = clonedResponse.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await clonedResponse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      const diagnostics = captureResponseDiagnostics(response, r, r.error);

      if (process.env.NODE_ENV === "development") {
        logger.info(
          {
            operation,
            request_id: diagnostics.request_id,
            method: params.method,
            duration_ms: Math.round(performance.now() - started),
            response: { ok: response.ok, status: response.status },
          },
          "API request completed",
        );
      }

      return data;
    });
  };
}

/**
 * @title CaboCheck
 * @version 1.0
 * @baseUrl /
 */
export class Api<SecurityDataType extends unknown> extends HttpClient {
  v1 = {
    /**
     * @description Endpoint to get AGB documents
     *
     * @tags default
     * @name GetApiAgbDocumentList
     * @request GET:/v1/agb_documents
     */
    getApiAgbDocumentList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        product_type?: "CaboLAB" | "CaboPOC" | "CaboVAX";
        /** @default false */
        public_only?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgbDocumentListSuccess, AuthError>({
        path: `/v1/agb_documents`,
        operation: "getApiAgbDocumentList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create AGB document
     *
     * @tags default
     * @name PostApiAgbDocumentList
     * @request POST:/v1/agb_documents
     */
    postApiAgbDocumentList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        product_type: "CaboLAB" | "CaboPOC" | "CaboVAX";
        valid_from: string;
        agb_document_guid?: string;
      },
      data: {
        document: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgbDocumentSuccess, AuthError | ForbiddenError>({
        path: `/v1/agb_documents`,
        operation: "postApiAgbDocumentList",
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get AGB document
     *
     * @tags default
     * @name GetApiAgbDocument
     * @request GET:/v1/agb_documents/{agb_document_guid}
     */
    getApiAgbDocument: (
      agbDocumentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgbDocumentSuccess, NotFoundError | AuthError>({
        path: `/v1/agb_documents/${agbDocumentGuid}`,
        operation: "getApiAgbDocument",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update AGB document
     *
     * @tags default
     * @name PutApiAgbDocument
     * @request PUT:/v1/agb_documents/{agb_document_guid}
     */
    putApiAgbDocument: (
      agbDocumentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        product_type?: "CaboLAB" | "CaboPOC" | "CaboVAX";
        valid_from?: string;
      },
      data: {
        document?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgbDocumentSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/agb_documents/${agbDocumentGuid}`,
        operation: "putApiAgbDocument",
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete AGB document
     *
     * @tags default
     * @name DeleteApiAgbDocument
     * @request DELETE:/v1/agb_documents/{agb_document_guid}
     */
    deleteApiAgbDocument: (
      agbDocumentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, NotFoundError | AuthError>({
        path: `/v1/agb_documents/${agbDocumentGuid}`,
        operation: "deleteApiAgbDocument",
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to download AGB document
     *
     * @tags default
     * @name GetApiAgbDocumentDownload
     * @request GET:/v1/agb_documents/{agb_document_guid}/download
     */
    getApiAgbDocumentDownload: (
      agbDocumentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, AuthError | FileNotFoundError>({
        path: `/v1/agb_documents/${agbDocumentGuid}/download`,
        operation: "getApiAgbDocumentDownload",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Public endpoint to get current valid AGB documents per product type
     *
     * @tags default
     * @name GetApiAgbDocumentPublicCurrent
     * @request GET:/v1/agb_documents/public/current
     */
    getApiAgbDocumentPublicCurrent: (
      query: {
        client_bundle_id: string;
        product_type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AgbDocumentListSuccess, AuthError>({
        path: `/v1/agb_documents/public/current`,
        operation: "getApiAgbDocumentPublicCurrent",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Signed Apozin endpoint to download a completed CaboVAX or CaboPOC PDF
     *
     * @tags default
     * @name GetApozinProductPdf
     * @request GET:/v1/apozin/{product_id}/pdf
     */
    getApozinProductPdf: (
      productId: string,
      query: {
        exp: number;
        sig: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, NotFoundError>({
        path: `/v1/apozin/${productId}/pdf`,
        operation: "getApozinProductPdf",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to get attachments
     *
     * @tags default
     * @name GetApiAttachmentList
     * @request GET:/v1/attachments
     */
    getApiAttachmentList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttachmentListSuccess, AuthError | ForbiddenError>({
        path: `/v1/attachments`,
        operation: "getApiAttachmentList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create attachment
     *
     * @tags default
     * @name PostApiAttachmentList
     * @request POST:/v1/attachments
     */
    postApiAttachmentList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        content_type: string;
      },
      data: {
        attachment: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttachmentSuccess, AuthError | ForbiddenError>({
        path: `/v1/attachments`,
        operation: "postApiAttachmentList",
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get attachment
     *
     * @tags default
     * @name GetApiAttachment
     * @request GET:/v1/attachments/{attachment_guid}
     */
    getApiAttachment: (
      attachmentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttachmentSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/attachments/${attachmentGuid}`,
        operation: "getApiAttachment",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete attachment
     *
     * @tags default
     * @name DeleteApiAttachment
     * @request DELETE:/v1/attachments/{attachment_guid}
     */
    deleteApiAttachment: (
      attachmentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/attachments/${attachmentGuid}`,
        operation: "deleteApiAttachment",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to complete admin partner login
     *
     * @tags default
     * @name PostAuthCompleteAdminPartnerLogin
     * @request POST:/v1/auth/admin_partner_login/complete
     */
    postAuthCompleteAdminPartnerLogin: (
      payload: {
        build_version?: string;
        client_bundle_id?: string;
        device_guid?: string;
        device_locale?: string;
        device_os?: string;
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthCompleteAdminPartnerLoginSuccess, AuthCompleteAdminPartnerLoginError>({
        path: `/v1/auth/admin_partner_login/complete`,
        operation: "postAuthCompleteAdminPartnerLogin",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to initiate admin partner login
     *
     * @tags default
     * @name PostAuthInitAdminPartnerLogin
     * @request POST:/v1/auth/admin_partner_login/init
     */
    postAuthInitAdminPartnerLogin: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        partner_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthInitAdminPartnerLoginSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/auth/admin_partner_login/init`,
        operation: "postAuthInitAdminPartnerLogin",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to validate registration deep link
     *
     * @tags default
     * @name PostAuthValidateRegDeepLink
     * @request POST:/v1/auth/deep_link/validate
     */
    postAuthValidateRegDeepLink: (
      payload: {
        build_version?: string;
        client_bundle_id?: string;
        device_guid?: string;
        device_locale?: string;
        device_os?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthValidateRegDeepLinkSuccess, AuthValidateRegDeepLinkError>({
        path: `/v1/auth/deep_link/validate`,
        operation: "postAuthValidateRegDeepLink",
        method: "POST",
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to login, it will send an validation code by email
     *
     * @tags default
     * @name PostAuthLogin
     * @request POST:/v1/auth/login
     */
    postAuthLogin: (
      payload: {
        code?: string;
        device_guid?: string;
        email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Success,
        AuthLoginError | EmailLoginRateLimitError | EmailLoginDeliveryError | EmailLoginUnavailableError
      >({
        path: `/v1/auth/login`,
        operation: "postAuthLogin",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to validate email
     *
     * @tags default
     * @name PostAuthValidateLogin
     * @request POST:/v1/auth/login/validate
     */
    postAuthValidateLogin: (
      payload: {
        device_guid?: string;
        email_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        AuthValidateLoginSuccess,
        AuthValidateLoginError | AuthError | ForbiddenError | EmailLoginRateLimitError | EmailLoginUnavailableError
      >({
        path: `/v1/auth/login/validate`,
        operation: "postAuthValidateLogin",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to revoke the current auth session
     *
     * @tags default
     * @name PostAuthLogout
     * @request POST:/v1/auth/logout
     */
    postAuthLogout: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthLogoutSuccess, AuthError>({
        path: `/v1/auth/logout`,
        operation: "postAuthLogout",
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to launch pre registration
     *
     * @tags default
     * @name PostAuthPreRegLaunch
     * @request POST:/v1/auth/prereg_launch
     */
    postAuthPreRegLaunch: (
      payload: {
        build_version?: string;
        client_bundle_id?: string;
        device_guid?: string;
        device_locale?: string;
        device_os?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthPreRegLaunchSuccess, AuthPreRegLaunchError>({
        path: `/v1/auth/prereg_launch`,
        operation: "postAuthPreRegLaunch",
        method: "POST",
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to renew auth token
     *
     * @tags default
     * @name PostAuthRenewToken
     * @request POST:/v1/auth/token/renew
     */
    postAuthRenewToken: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        renewal_token?: string;
        salt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuthRenewTokenSuccess, AuthError>({
        path: `/v1/auth/token/renew`,
        operation: "postAuthRenewToken",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get blog posts
     *
     * @tags default
     * @name GetApiBlogPostList
     * @request GET:/v1/blog_posts
     */
    getApiBlogPostList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlogPostListSuccess, AuthError | ForbiddenError>({
        path: `/v1/blog_posts`,
        operation: "getApiBlogPostList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create blog post
     *
     * @tags default
     * @name PostApiBlogPostList
     * @request POST:/v1/blog_posts
     */
    postApiBlogPostList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        attachments?: string;
        available_for_partners?: boolean;
        available_for_users?: boolean;
        content?: string;
        product_type?: string;
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlogPostSuccess, AuthError | ForbiddenError>({
        path: `/v1/blog_posts`,
        operation: "postApiBlogPostList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get blog post
     *
     * @tags default
     * @name GetApiBlogPost
     * @request GET:/v1/blog_posts/{blog_post_guid}
     */
    getApiBlogPost: (
      blogPostGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlogPostSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/blog_posts/${blogPostGuid}`,
        operation: "getApiBlogPost",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update blog post
     *
     * @tags default
     * @name PutApiBlogPost
     * @request PUT:/v1/blog_posts/{blog_post_guid}
     */
    putApiBlogPost: (
      blogPostGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        attachments?: string;
        available_for_partners?: boolean;
        available_for_users?: boolean;
        content?: string;
        product_type?: string;
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlogPostSuccess, NotFoundError | AuthError>({
        path: `/v1/blog_posts/${blogPostGuid}`,
        operation: "putApiBlogPost",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete blog post
     *
     * @tags default
     * @name DeleteApiBlogPost
     * @request DELETE:/v1/blog_posts/{blog_post_guid}
     */
    deleteApiBlogPost: (
      blogPostGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError>({
        path: `/v1/blog_posts/${blogPostGuid}`,
        operation: "deleteApiBlogPost",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to publish blog post
     *
     * @tags default
     * @name PutApiBlogPostPublish
     * @request PUT:/v1/blog_posts/{blog_post_guid}/publish
     */
    putApiBlogPostPublish: (
      blogPostGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlogPostSuccess, ApiBlogPostPublishError | AuthError | ForbiddenError>({
        path: `/v1/blog_posts/${blogPostGuid}/publish`,
        operation: "putApiBlogPostPublish",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get CaboLAB settings
     *
     * @tags default
     * @name GetApiCaboLabSettings
     * @request GET:/v1/cabolab/settings
     */
    getApiCaboLabSettings: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaboLabSettingsSuccess, AuthError>({
        path: `/v1/cabolab/settings`,
        operation: "getApiCaboLabSettings",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update CaboLAB settings
     *
     * @tags default
     * @name PutApiCaboLabSettings
     * @request PUT:/v1/cabolab/settings
     */
    putApiCaboLabSettings: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiCaboLabSettingsPut,
      params: RequestParams = {},
    ) =>
      this.request<CaboLabSettingsSuccess, AuthError | ForbiddenError>({
        path: `/v1/cabolab/settings`,
        operation: "putApiCaboLabSettings",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get chat session summaries
     *
     * @tags default
     * @name GetApiChatSessionList
     * @request GET:/v1/chat_sessions
     */
    getApiChatSessionList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        partner_guid?: string;
        offset?: number;
        limit?: number;
        sort_field?: string;
        sort_direction?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatSessionListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/chat_sessions`,
        operation: "getApiChatSessionList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: list contacts across partners, preregistrations, and standalone
     *
     * @tags default
     * @name GetApiContacts
     * @request GET:/v1/contacts
     */
    getApiContacts: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        search_query?: string;
        offset?: number;
        limit?: number;
        sort_field?: string;
        sort_direction?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactListSuccess, any>({
        path: `/v1/contacts`,
        operation: "getApiContacts",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: get contact detail by GUID
     *
     * @tags default
     * @name GetApiContact
     * @request GET:/v1/contacts/{crm_standalone_contact_guid}
     */
    getApiContact: (
      crmStandaloneContactGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactDetailSuccess, any>({
        path: `/v1/contacts/${crmStandaloneContactGuid}`,
        operation: "getApiContact",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: update standalone contact
     *
     * @tags default
     * @name PutApiContact
     * @request PUT:/v1/contacts/{crm_standalone_contact_guid}
     */
    putApiContact: (
      crmStandaloneContactGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        address?: string;
        company?: string;
        display_name?: string;
        email?: string;
        first_name?: string;
        job_title?: string;
        last_name?: string;
        telephone?: string;
        website?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactDetailSuccess, any>({
        path: `/v1/contacts/${crmStandaloneContactGuid}`,
        operation: "putApiContact",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: delete standalone contact (soft delete)
     *
     * @tags default
     * @name DeleteApiContact
     * @request DELETE:/v1/contacts/{crm_standalone_contact_guid}
     */
    deleteApiContact: (
      crmStandaloneContactGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeletedCountSuccess, any>({
        path: `/v1/contacts/${crmStandaloneContactGuid}`,
        operation: "deleteApiContact",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: list contact activities
     *
     * @tags default
     * @name GetApiContactActivities
     * @request GET:/v1/contacts/{crm_standalone_contact_guid}/activities
     */
    getApiContactActivities: (
      crmStandaloneContactGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        offset?: number;
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ActivityListSuccess, any>({
        path: `/v1/contacts/${crmStandaloneContactGuid}/activities`,
        operation: "getApiContactActivities",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: create contact activity
     *
     * @tags default
     * @name PostApiContactActivities
     * @request POST:/v1/contacts/{crm_standalone_contact_guid}/activities
     */
    postApiContactActivities: (
      crmStandaloneContactGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        activity_date?: number;
        activity_type?: string;
        description?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ActivitySuccess, any>({
        path: `/v1/contacts/${crmStandaloneContactGuid}/activities`,
        operation: "postApiContactActivities",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: get contact relationships
     *
     * @tags default
     * @name GetApiContactRelationships
     * @request GET:/v1/contacts/{crm_standalone_contact_guid}/relationships
     */
    getApiContactRelationships: (
      crmStandaloneContactGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** Recursion depth (default: 5) */
        depth?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactRelationshipListSuccess, any>({
        path: `/v1/contacts/${crmStandaloneContactGuid}/relationships`,
        operation: "getApiContactRelationships",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: create contact relationship
     *
     * @tags default
     * @name PostApiContactRelationships
     * @request POST:/v1/contacts/{crm_standalone_contact_guid}/relationships
     */
    postApiContactRelationships: (
      crmStandaloneContactGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        description?: string;
        related_contact_guid?: string;
        relationship_type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContactRelationshipSuccess, any>({
        path: `/v1/contacts/${crmStandaloneContactGuid}/relationships`,
        operation: "postApiContactRelationships",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: delete contact relationship
     *
     * @tags default
     * @name DeleteApiContactRelationship
     * @request DELETE:/v1/contacts/{crm_standalone_contact_guid}/relationships/{crm_contact_relationship_guid}
     */
    deleteApiContactRelationship: (
      crmStandaloneContactGuid: string,
      crmContactRelationshipGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RelationshipDeletedCountSuccess, any>({
        path: `/v1/contacts/${crmStandaloneContactGuid}/relationships/${crmContactRelationshipGuid}`,
        operation: "deleteApiContactRelationship",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: update contact activity
     *
     * @tags default
     * @name PutApiContactActivity
     * @request PUT:/v1/contacts/activities/{crm_activity_guid}
     */
    putApiContactActivity: (
      crmActivityGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        activity_date?: number;
        activity_type?: string;
        description?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ActivitySuccess, any>({
        path: `/v1/contacts/activities/${crmActivityGuid}`,
        operation: "putApiContactActivity",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: delete contact activity
     *
     * @tags default
     * @name DeleteApiContactActivity
     * @request DELETE:/v1/contacts/activities/{crm_activity_guid}
     */
    deleteApiContactActivity: (
      crmActivityGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ActivityDeletedCountSuccess, any>({
        path: `/v1/contacts/activities/${crmActivityGuid}`,
        operation: "deleteApiContactActivity",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: check for duplicate contacts
     *
     * @tags default
     * @name PostApiContactCheckDuplicates
     * @request POST:/v1/contacts/check-duplicates
     */
    postApiContactCheckDuplicates: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        email?: string;
        telephone?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DuplicateContactListSuccess, any>({
        path: `/v1/contacts/check-duplicates`,
        operation: "postApiContactCheckDuplicates",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: create standalone contact
     *
     * @tags default
     * @name PostApiContactCreate
     * @request POST:/v1/contacts/standalone
     */
    postApiContactCreate: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        address?: string;
        company?: string;
        display_name?: string;
        email?: string;
        first_name?: string;
        job_title?: string;
        last_name?: string;
        telephone?: string;
        website?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StandaloneContactCreatedSuccess, any>({
        path: `/v1/contacts/standalone`,
        operation: "postApiContactCreate",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: list tasks
     *
     * @tags default
     * @name GetApiTasks
     * @request GET:/v1/contacts/tasks
     */
    getApiTasks: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        crm_standalone_contact_guid?: string;
        status?: string;
        priority?: string;
        offset?: number;
        limit?: number;
        sort_field?: string;
        sort_direction?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TaskListSuccess, any>({
        path: `/v1/contacts/tasks`,
        operation: "getApiTasks",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: create task
     *
     * @tags default
     * @name PostApiTasks
     * @request POST:/v1/contacts/tasks
     */
    postApiTasks: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        crm_standalone_contact_guid?: string;
        description?: string;
        due_date?: number;
        priority?: string;
        status?: string;
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TaskSuccess, any>({
        path: `/v1/contacts/tasks`,
        operation: "postApiTasks",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: update task
     *
     * @tags default
     * @name PutApiTask
     * @request PUT:/v1/contacts/tasks/{crm_task_guid}
     */
    putApiTask: (
      crmTaskGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        description?: string;
        due_date?: number;
        priority?: string;
        status?: string;
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TaskSuccess, any>({
        path: `/v1/contacts/tasks/${crmTaskGuid}`,
        operation: "putApiTask",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Admin: delete task
     *
     * @tags default
     * @name DeleteApiTask
     * @request DELETE:/v1/contacts/tasks/{crm_task_guid}
     */
    deleteApiTask: (
      crmTaskGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TaskDeletedCountSuccess, any>({
        path: `/v1/contacts/tasks/${crmTaskGuid}`,
        operation: "deleteApiTask",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get contract templates (public endpoint)
     *
     * @tags default
     * @name GetApiContractTemplateList
     * @request GET:/v1/contract_templates
     */
    getApiContractTemplateList: (
      query: {
        client_bundle_id: string;
        device_locale: string;
        product_type?: string;
        /** @default true */
        active_only?: boolean;
        /** @default false */
        show_on_registration_only?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContractTemplateListSuccess, NotFoundError>({
        path: `/v1/contract_templates`,
        operation: "getApiContractTemplateList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create contract template
     *
     * @tags default
     * @name PostApiContractTemplateList
     * @request POST:/v1/contract_templates
     */
    postApiContractTemplateList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        can_perform_tests?: boolean;
        cancellation_period_days?: number;
        contract_body?: string;
        description?: string;
        duration_months?: number;
        i_starter_kit?: number;
        min_first_order_price_cents?: number;
        monthly_price_after_minimum_duration_cents?: number;
        monthly_price_cents?: number;
        name?: string;
        no_single_poc_test_kit_allowed?: boolean;
        orders_only?: boolean;
        product_type?: string;
        setup_fee_cents?: number;
        show_on_registration?: boolean;
        trial_period_days?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContractTemplateSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/contract_templates`,
        operation: "postApiContractTemplateList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get contract template
     *
     * @tags default
     * @name GetApiContractTemplate
     * @request GET:/v1/contract_templates/{contract_template_guid}
     */
    getApiContractTemplate: (
      contractTemplateGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContractTemplateSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/contract_templates/${contractTemplateGuid}`,
        operation: "getApiContractTemplate",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update contract template
     *
     * @tags default
     * @name PutApiContractTemplate
     * @request PUT:/v1/contract_templates/{contract_template_guid}
     */
    putApiContractTemplate: (
      contractTemplateGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        active?: boolean;
        can_perform_tests?: boolean;
        cancellation_period_days?: number;
        contract_body?: string;
        description?: string;
        duration_months?: number;
        i_starter_kit?: number;
        min_first_order_price_cents?: number;
        monthly_price_after_minimum_duration_cents?: number;
        monthly_price_cents?: number;
        name?: string;
        no_single_poc_test_kit_allowed?: boolean;
        orders_only?: boolean;
        setup_fee_cents?: number;
        show_on_registration?: boolean;
        trial_period_days?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContractTemplateSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/contract_templates/${contractTemplateGuid}`,
        operation: "putApiContractTemplate",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete or deactivate contract template
     *
     * @tags default
     * @name DeleteApiContractTemplate
     * @request DELETE:/v1/contract_templates/{contract_template_guid}
     */
    deleteApiContractTemplate: (
      contractTemplateGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/contract_templates/${contractTemplateGuid}`,
        operation: "deleteApiContractTemplate",
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * @description Get contract details by acceptance token
     *
     * @tags default
     * @name GetApiContractAcceptance
     * @request GET:/v1/contract-acceptance
     */
    getApiContractAcceptance: (
      query: {
        acceptance_token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContractAcceptanceDetailsSuccess, void>({
        path: `/v1/contract-acceptance`,
        operation: "getApiContractAcceptance",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Accept contract
     *
     * @tags default
     * @name PostApiContractAcceptance
     * @request POST:/v1/contract-acceptance
     */
    postApiContractAcceptance: (payload: ApiContractAcceptancePost, params: RequestParams = {}) =>
      this.request<ContractAcceptanceResultSuccess, void>({
        path: `/v1/contract-acceptance`,
        operation: "postApiContractAcceptance",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create Stripe customer and SetupIntent for contract acceptance
     *
     * @tags default
     * @name PostApiContractAcceptanceStripeSetup
     * @request POST:/v1/contract-acceptance/stripe-setup
     */
    postApiContractAcceptanceStripeSetup: (
      payload: {
        acceptance_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StripeCheckoutResponseSuccess, void>({
        path: `/v1/contract-acceptance/stripe-setup`,
        operation: "postApiContractAcceptanceStripeSetup",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get CaboPOC samples with pagination
     *
     * @tags default
     * @name GetApiCouponPocSampleListPaginated
     * @request GET:/v1/coupon_poc_samples_paginated
     */
    getApiCouponPocSampleListPaginated: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default 0 */
        offset?: number;
        /** @default 15 */
        limit?: number;
        /** @default "created" */
        sort_field?: string;
        /** @default "DESC" */
        sort_direction?: string;
        search_query?: string;
        partner_guid?: string;
        product_guid?: string;
        created_from?: number;
        created_to?: number;
        completed_from?: number;
        completed_to?: number;
        status?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponPocSampleListPaginatedSuccess, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/coupon_poc_samples_paginated`,
        operation: "getApiCouponPocSampleListPaginated",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get CaboPOC sample detail
     *
     * @tags default
     * @name GetApiCouponPocSampleDetail
     * @request GET:/v1/coupon_poc_samples/{coupon_poc_sample_guid}
     */
    getApiCouponPocSampleDetail: (
      couponPocSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponPocSampleDetailSuccess, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/coupon_poc_samples/${couponPocSampleGuid}`,
        operation: "getApiCouponPocSampleDetail",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get coupon POC sample result pdf
     *
     * @tags default
     * @name GetApiCouponPocSampleResultPdf
     * @request GET:/v1/coupon_poc_samples/{coupon_poc_sample_guid}/result_pdf
     */
    getApiCouponPocSampleResultPdf: (
      couponPocSampleGuid: string,
      query: {
        code: string;
        pin: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiCouponPocSampleResultPdfError>({
        path: `/v1/coupon_poc_samples/${couponPocSampleGuid}/result_pdf`,
        operation: "getApiCouponPocSampleResultPdf",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to get coupon POC sample result pdf without URL credentials
     *
     * @tags default
     * @name PostApiCouponPocSampleResultPdf
     * @request POST:/v1/coupon_poc_samples/{coupon_poc_sample_guid}/result_pdf
     */
    postApiCouponPocSampleResultPdf: (
      couponPocSampleGuid: string,
      payload: {
        client_bundle_id?: string;
        code?: string;
        device_locale?: string;
        pin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiCouponPocSampleResultPdfError>({
        path: `/v1/coupon_poc_samples/${couponPocSampleGuid}/result_pdf`,
        operation: "postApiCouponPocSampleResultPdf",
        method: "POST",
        body: payload,
        ...params,
      }),

    /**
     * @description Get paginated list of coupon vaccinations
     *
     * @tags default
     * @name GetApiCouponVaccinationListPaginated
     * @summary Get paginated list of all coupon vaccinations
     * @request GET:/v1/coupon_vaccinations_paginated
     */
    getApiCouponVaccinationListPaginated: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default 0 */
        offset?: number;
        /** @default 15 */
        limit?: number;
        /** @default "created" */
        sort_field?: string;
        /** @default "DESC" */
        sort_direction?: string;
        search_query?: string;
        partner_guid?: string;
        vaccination_guid?: string;
        created_from?: number;
        created_to?: number;
        completed_from?: number;
        completed_to?: number;
        status?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponVaccinationListPaginatedSuccess, AuthError | ForbiddenError>({
        path: `/v1/coupon_vaccinations_paginated`,
        operation: "getApiCouponVaccinationListPaginated",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get detailed coupon vaccination with patient form and answers
     *
     * @tags default
     * @name GetApiCouponVaccinationDetail
     * @summary Get detailed coupon vaccination information
     * @request GET:/v1/coupon_vaccinations/{coupon_vaccination_guid}
     */
    getApiCouponVaccinationDetail: (
      couponVaccinationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponVaccinationDetailSuccess, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/coupon_vaccinations/${couponVaccinationGuid}`,
        operation: "getApiCouponVaccinationDetail",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get coupon vaccination certificate pdf
     *
     * @tags default
     * @name GetApiCouponVaccinationPdf
     * @request GET:/v1/coupon_vaccinations/{coupon_vaccination_guid}/pdf
     */
    getApiCouponVaccinationPdf: (
      couponVaccinationGuid: string,
      query: {
        code: string;
        pin: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/coupon_vaccinations/${couponVaccinationGuid}/pdf`,
        operation: "getApiCouponVaccinationPdf",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to get coupon vaccination certificate pdf without URL credentials
     *
     * @tags default
     * @name PostApiCouponVaccinationPdf
     * @request POST:/v1/coupon_vaccinations/{coupon_vaccination_guid}/pdf
     */
    postApiCouponVaccinationPdf: (
      couponVaccinationGuid: string,
      payload: {
        client_bundle_id?: string;
        code?: string;
        device_locale?: string;
        pin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/coupon_vaccinations/${couponVaccinationGuid}/pdf`,
        operation: "postApiCouponVaccinationPdf",
        method: "POST",
        body: payload,
        ...params,
      }),

    /**
     * @description Customer-facing endpoint to activate coupon with vaccination
     *
     * @tags default
     * @name PostApiCouponActivateVaccination
     * @request POST:/v1/coupons/{coupon_code}/activate_vaccination
     */
    postApiCouponActivateVaccination: (
      couponCode: string,
      payload: {
        client_bundle_id?: string;
        device_locale?: string;
        vaccination_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiCouponActivateVaccinationSuccessSuccess, ApiCouponActivateVaccinationError>({
        path: `/v1/coupons/${couponCode}/activate_vaccination`,
        operation: "postApiCouponActivateVaccination",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to reset coupon access attempts
     *
     * @tags default
     * @name PutApiCouponAccessAttemptsReset
     * @request PUT:/v1/coupons/{coupon_guid}/reset_access_attempts
     */
    putApiCouponAccessAttemptsReset: (
      couponGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/coupons/${couponGuid}/reset_access_attempts`,
        operation: "putApiCouponAccessAttemptsReset",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Customer-facing endpoint to get coupon by validation token (includes patient_details_form)
     *
     * @tags default
     * @name GetApiCouponGetByValidationToken
     * @request GET:/v1/coupons/by_validation_token
     */
    getApiCouponGetByValidationToken: (
      query: {
        validation_token: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, ApiCouponGetByValidationTokenError>({
        path: `/v1/coupons/by_validation_token`,
        operation: "getApiCouponGetByValidationToken",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to check coupon by code
     *
     * @tags default
     * @name GetApiCouponCheck
     * @request GET:/v1/coupons/check
     */
    getApiCouponCheck: (
      query: {
        code: string;
        pin?: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, ApiCouponCheckError>({
        path: `/v1/coupons/check`,
        operation: "getApiCouponCheck",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to check coupon by code without URL credentials
     *
     * @tags default
     * @name PostApiCouponCheck
     * @request POST:/v1/coupons/check
     */
    postApiCouponCheck: (
      payload: {
        client_bundle_id?: string;
        code?: string;
        device_locale?: string;
        pin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, ApiCouponCheckError>({
        path: `/v1/coupons/check`,
        operation: "postApiCouponCheck",
        method: "POST",
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to check coupon by code for vaccination flow (no PIN required)
     *
     * @tags default
     * @name GetApiCouponCheckForVaccination
     * @request GET:/v1/coupons/check_for_vaccination
     */
    getApiCouponCheckForVaccination: (
      query: {
        code: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, ApiCouponCheckForVaccinationError>({
        path: `/v1/coupons/check_for_vaccination`,
        operation: "getApiCouponCheckForVaccination",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to check vaccination coupon without URL credentials
     *
     * @tags default
     * @name PostApiCouponCheckForVaccination
     * @request POST:/v1/coupons/check_for_vaccination
     */
    postApiCouponCheckForVaccination: (
      payload: {
        client_bundle_id?: string;
        code?: string;
        device_locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, ApiCouponCheckForVaccinationError>({
        path: `/v1/coupons/check_for_vaccination`,
        operation: "postApiCouponCheckForVaccination",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to generate coupons
     *
     * @tags default
     * @name PostApiCouponGeneration
     * @request POST:/v1/coupons/generate
     */
    postApiCouponGeneration: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        prefix?: string;
        quantity?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiCouponGenerationSuccessSuccess, AuthError | ForbiddenError>({
        path: `/v1/coupons/generate`,
        operation: "postApiCouponGeneration",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get coupons for print
     *
     * @tags default
     * @name GetApiCouponPrint
     * @request GET:/v1/coupons/print
     */
    getApiCouponPrint: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        prefix: string;
        start: number;
        end: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponListSuccess, AuthError | ForbiddenError>({
        path: `/v1/coupons/print`,
        operation: "getApiCouponPrint",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to mark coupons as printed. Returns a PDF file
     *
     * @tags default
     * @name PutApiCouponPrint
     * @request PUT:/v1/coupons/print
     */
    putApiCouponPrint: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        end?: number;
        prefix?: string;
        start?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, AuthError | ForbiddenError>({
        path: `/v1/coupons/print`,
        operation: "putApiCouponPrint",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Customer-facing endpoint to update personal details on activated coupon using validation token
     *
     * @tags default
     * @name PostApiCouponUpdatePatientDetails
     * @request POST:/v1/coupons/update_patient_details/{validation_token}
     */
    postApiCouponUpdatePatientDetails: (
      validationToken: string,
      payload: {
        client_bundle_id?: string;
        device_locale?: string;
        responses?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiCouponUpdatePatientDetailsSuccessSuccess, ApiCouponUpdatePatientDetailsError>({
        path: `/v1/coupons/update_patient_details/${validationToken}`,
        operation: "postApiCouponUpdatePatientDetails",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get dashboard roles
     *
     * @tags default
     * @name GetApiDashboardRoleList
     * @request GET:/v1/dashboard_roles
     */
    getApiDashboardRoleList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RoleListSuccess, AuthError | ForbiddenError>({
        path: `/v1/dashboard_roles`,
        operation: "getApiDashboardRoleList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Dev-only endpoint to activate and complete an Apozin appointment through the real Cabo flows
     *
     * @tags default
     * @name PostDevApozinCompleteAppointment
     * @request POST:/v1/dev/apozin/complete_appointment
     */
    postDevApozinCompleteAppointment: (
      payload: {
        apozin_short_code?: string;
        booking_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApozinDevTriggerResponseSuccess, DevApozinCompleteAppointmentError | ForbiddenError>({
        path: `/v1/dev/apozin/complete_appointment`,
        operation: "postDevApozinCompleteAppointment",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Dev-only endpoint to manually sync CaboPOC/CaboVAX services to Apozin
     *
     * @tags default
     * @name PostDevApozinSyncServices
     * @request POST:/v1/dev/apozin/sync_services
     */
    postDevApozinSyncServices: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, AuthError | ForbiddenError>({
        path: `/v1/dev/apozin/sync_services`,
        operation: "postDevApozinSyncServices",
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get coupons
     *
     * @tags default
     * @name GetDevCoupon
     * @request GET:/v1/dev/coupons
     */
    getDevCoupon: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponListSuccess, AuthError>({
        path: `/v1/dev/coupons`,
        operation: "getDevCoupon",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to generate coupons
     *
     * @tags default
     * @name PostDevCoupon
     * @request POST:/v1/dev/coupons
     */
    postDevCoupon: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        partner_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, AuthError>({
        path: `/v1/dev/coupons`,
        operation: "postDevCoupon",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to force auth token expiration
     *
     * @tags default
     * @name PutDevAuthTokenExpire
     * @request PUT:/v1/dev/expire_auth_token
     */
    putDevAuthTokenExpire: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, AuthError>({
        path: `/v1/dev/expire_auth_token`,
        operation: "putDevAuthTokenExpire",
        method: "PUT",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name GetDevLabordatenbankResult
     * @request GET:/v1/dev/pull_labordatenbank
     */
    getDevLabordatenbankResult: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError>({
        path: `/v1/dev/pull_labordatenbank`,
        operation: "getDevLabordatenbankResult",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to push samples to Lab.
     *
     * @tags default
     * @name GetDevPushLabordatenbankSamples
     * @request GET:/v1/dev/push_labordatenbank
     */
    getDevPushLabordatenbankSamples: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        shipment_code?: string;
        coupon_code?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestKitSuccess, AuthError>({
        path: `/v1/dev/push_labordatenbank`,
        operation: "getDevPushLabordatenbankSamples",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to make a payment intent
     *
     * @tags default
     * @name PostDevStripeMakePaymentIntent
     * @request POST:/v1/dev/stripe/make_payment_intent
     */
    postDevStripeMakePaymentIntent: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        amount?: number;
        partner_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, AuthError | NotFoundError>({
        path: `/v1/dev/stripe/make_payment_intent`,
        operation: "postDevStripeMakePaymentIntent",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name PutDevSyncDhlShipments
     * @request PUT:/v1/dev/sync_dhl
     */
    putDevSyncDhlShipments: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        force?: boolean;
        mock?: boolean;
        sandbox?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, AuthError>({
        path: `/v1/dev/sync_dhl`,
        operation: "putDevSyncDhlShipments",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name PutDevSyncLabordatenbankResult
     * @request PUT:/v1/dev/sync_labordatenbank
     */
    putDevSyncLabordatenbankResult: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        code?: string;
        mock?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleSuccess, NotFoundError | AuthError>({
        path: `/v1/dev/sync_labordatenbank`,
        operation: "putDevSyncLabordatenbankResult",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get test kits
     *
     * @tags default
     * @name GetDevTestKit
     * @request GET:/v1/dev/test_kits
     */
    getDevTestKit: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestKitListSuccess, AuthError>({
        path: `/v1/dev/test_kits`,
        operation: "getDevTestKit",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to generate test kit with a color
     *
     * @tags default
     * @name PostDevTestKit
     * @request POST:/v1/dev/test_kits
     */
    postDevTestKit: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        color?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestKitSuccess, AuthError>({
        path: `/v1/dev/test_kits`,
        operation: "postDevTestKit",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get DX365 unaccounted CaboPOC result logs with pagination
     *
     * @tags default
     * @name GetApiDx365UnaccountedPocResultLogList
     * @request GET:/v1/dx365_unaccounted_poc_result_logs
     */
    getApiDx365UnaccountedPocResultLogList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default 0 */
        offset?: number;
        /** @default 15 */
        limit?: number;
        /** @default "created" */
        sort_field?: string;
        /** @default "DESC" */
        sort_direction?: string;
        search_query?: string;
        created_from?: number;
        created_to?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Dx365UnaccountedPocResultLogListPaginatedSuccess, AuthError | ForbiddenError>({
        path: `/v1/dx365_unaccounted_poc_result_logs`,
        operation: "getApiDx365UnaccountedPocResultLogList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get all email templates (admin only)
     *
     * @tags default
     * @name GetApiEmailTemplateList
     * @request GET:/v1/email_templates
     */
    getApiEmailTemplateList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EmailTemplateListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/email_templates`,
        operation: "getApiEmailTemplateList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get single email template by name
     *
     * @tags default
     * @name GetApiEmailTemplate
     * @request GET:/v1/email_templates/{template_name}
     */
    getApiEmailTemplate: (
      templateName: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EmailTemplateSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/email_templates/${templateName}`,
        operation: "getApiEmailTemplate",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update email template
     *
     * @tags default
     * @name PutApiEmailTemplate
     * @request PUT:/v1/email_templates/{template_name}
     */
    putApiEmailTemplate: (
      templateName: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiEmailTemplatePut,
      params: RequestParams = {},
    ) =>
      this.request<EmailTemplateSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/email_templates/${templateName}`,
        operation: "putApiEmailTemplate",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update email template translation
     *
     * @tags default
     * @name PutApiEmailTemplateTranslation
     * @request PUT:/v1/email_templates/{template_name}/translations
     */
    putApiEmailTemplateTranslation: (
      templateName: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiEmailTemplateTranslationPut,
      params: RequestParams = {},
    ) =>
      this.request<EmailTemplateSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/email_templates/${templateName}/translations`,
        operation: "putApiEmailTemplateTranslation",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get equipment shipment pack options
     *
     * @tags default
     * @name GetApiEquipmentShipmentPackOptionList
     * @request GET:/v1/equipment_shipment_pack_options
     */
    getApiEquipmentShipmentPackOptionList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EquipmentShipmentPackOptionListSuccess, AuthError | ForbiddenError>({
        path: `/v1/equipment_shipment_pack_options`,
        operation: "getApiEquipmentShipmentPackOptionList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create equipment shipment pack option
     *
     * @tags default
     * @name PostApiEquipmentShipmentPackOptionList
     * @request POST:/v1/equipment_shipment_pack_options
     */
    postApiEquipmentShipmentPackOptionList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EquipmentShipmentPackOptionSuccess, AuthError | ForbiddenError>({
        path: `/v1/equipment_shipment_pack_options`,
        operation: "postApiEquipmentShipmentPackOptionList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get equipment shipment pack option
     *
     * @tags default
     * @name GetApiEquipmentShipmentPackOption
     * @request GET:/v1/equipment_shipment_pack_options/{i_equipment_shipment_pack_option}
     */
    getApiEquipmentShipmentPackOption: (
      iEquipmentShipmentPackOption: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EquipmentShipmentPackOptionSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/equipment_shipment_pack_options/${iEquipmentShipmentPackOption}`,
        operation: "getApiEquipmentShipmentPackOption",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update equipment shipment pack option
     *
     * @tags default
     * @name PutApiEquipmentShipmentPackOption
     * @request PUT:/v1/equipment_shipment_pack_options/{i_equipment_shipment_pack_option}
     */
    putApiEquipmentShipmentPackOption: (
      iEquipmentShipmentPackOption: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EquipmentShipmentPackOptionSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/equipment_shipment_pack_options/${iEquipmentShipmentPackOption}`,
        operation: "putApiEquipmentShipmentPackOption",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete equipment shipment pack option
     *
     * @tags default
     * @name DeleteApiEquipmentShipmentPackOption
     * @request DELETE:/v1/equipment_shipment_pack_options/{i_equipment_shipment_pack_option}
     */
    deleteApiEquipmentShipmentPackOption: (
      iEquipmentShipmentPackOption: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiEquipmentShipmentPackOptionError | AuthError | ForbiddenError>({
        path: `/v1/equipment_shipment_pack_options/${iEquipmentShipmentPackOption}`,
        operation: "deleteApiEquipmentShipmentPackOption",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update equipment shipment pack option items
     *
     * @tags default
     * @name PostApiEquipmentShipmentPackOptionItem
     * @request POST:/v1/equipment_shipment_pack_options/{i_equipment_shipment_pack_option}/items
     */
    postApiEquipmentShipmentPackOptionItem: (
      iEquipmentShipmentPackOption: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        amount?: number;
        i_equipment_sku?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<EquipmentShipmentPackOptionSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/equipment_shipment_pack_options/${iEquipmentShipmentPackOption}/items`,
        operation: "postApiEquipmentShipmentPackOptionItem",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update equipment shipment pack option items
     *
     * @tags default
     * @name PutApiEquipmentShipmentPackOptionItem
     * @request PUT:/v1/equipment_shipment_pack_options/{i_equipment_shipment_pack_option}/items
     */
    putApiEquipmentShipmentPackOptionItem: (
      iEquipmentShipmentPackOption: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        amount?: number;
        i_equipment_sku?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<EquipmentShipmentPackOptionSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/equipment_shipment_pack_options/${iEquipmentShipmentPackOption}/items`,
        operation: "putApiEquipmentShipmentPackOptionItem",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to remove equipment shipment pack option items
     *
     * @tags default
     * @name DeleteApiEquipmentShipmentPackOptionItem
     * @request DELETE:/v1/equipment_shipment_pack_options/{i_equipment_shipment_pack_option}/items
     */
    deleteApiEquipmentShipmentPackOptionItem: (
      iEquipmentShipmentPackOption: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        i_equipment_sku?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<EquipmentShipmentPackOptionSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/equipment_shipment_pack_options/${iEquipmentShipmentPackOption}/items`,
        operation: "deleteApiEquipmentShipmentPackOptionItem",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create equipment shipments
     *
     * @tags default
     * @name PostApiEquipmentShipmentList
     * @request POST:/v1/equipment_shipments
     */
    postApiEquipmentShipmentList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiEquipmentShipmentListPost,
      params: RequestParams = {},
    ) =>
      this.request<EquipmentShipmentListSuccess, ApiEquipmentShipmentListError | AuthError | ForbiddenError>({
        path: `/v1/equipment_shipments`,
        operation: "postApiEquipmentShipmentList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get equipment shipment
     *
     * @tags default
     * @name GetApiEquipmentShipment
     * @request GET:/v1/equipment_shipments/{i_equipment_shipment}
     */
    getApiEquipmentShipment: (
      iEquipmentShipment: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EquipmentShipmentSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/equipment_shipments/${iEquipmentShipment}`,
        operation: "getApiEquipmentShipment",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update item amount from equipment shipment
     *
     * @tags default
     * @name PutApiEquipmentShipmentItem
     * @request PUT:/v1/equipment_shipments/{i_equipment_shipment}/items/{i_equipment_shipment_item}
     */
    putApiEquipmentShipmentItem: (
      iEquipmentShipment: number,
      iEquipmentShipmentItem: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        info?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EquipmentShipmentSuccess, ApiEquipmentShipmentItemError | AuthError | ForbiddenError>({
        path: `/v1/equipment_shipments/${iEquipmentShipment}/items/${iEquipmentShipmentItem}`,
        operation: "putApiEquipmentShipmentItem",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get equipment shipment label. Returns a PDF file
     *
     * @tags default
     * @name GetApiEquipmentShipmentLabel
     * @request GET:/v1/equipment_shipments/{i_equipment_shipment}/label
     */
    getApiEquipmentShipmentLabel: (
      iEquipmentShipment: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiEquipmentShipmentLabelError | AuthError | ForbiddenError>({
        path: `/v1/equipment_shipments/${iEquipmentShipment}/label`,
        operation: "getApiEquipmentShipmentLabel",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to get equipment shipment labels in bulk. Returns a PDF file
     *
     * @tags default
     * @name GetApiEquipmentShipmentLabelBulk
     * @request GET:/v1/equipment_shipments/labels
     */
    getApiEquipmentShipmentLabelBulk: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** List of i_equipment_shipment */
        equipment_shipments: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiEquipmentShipmentLabelBulkError | AuthError | ForbiddenError>({
        path: `/v1/equipment_shipments/labels`,
        operation: "getApiEquipmentShipmentLabelBulk",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to get equipment skus
     *
     * @tags default
     * @name GetApiEquipmentSkuList
     * @request GET:/v1/equipment_skus
     */
    getApiEquipmentSkuList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EquipmentSkuListSuccess, AuthError | ForbiddenError>({
        path: `/v1/equipment_skus`,
        operation: "getApiEquipmentSkuList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get FAQs
     *
     * @tags default
     * @name GetApiFaqList
     * @request GET:/v1/faqs
     */
    getApiFaqList: (
      query: {
        device_guid?: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FaqListSuccess, NotFoundError | AuthError>({
        path: `/v1/faqs`,
        operation: "getApiFaqList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create FAQ
     *
     * @tags default
     * @name PostApiFaqList
     * @request POST:/v1/faqs
     */
    postApiFaqList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiFaqListPost,
      params: RequestParams = {},
    ) =>
      this.request<FaqSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/faqs`,
        operation: "postApiFaqList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get FAQ
     *
     * @tags default
     * @name GetApiFaq
     * @request GET:/v1/faqs/{faq_guid}
     */
    getApiFaq: (
      faqGuid: string,
      query: {
        device_guid?: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FaqSuccess, NotFoundError | AuthError>({
        path: `/v1/faqs/${faqGuid}`,
        operation: "getApiFaq",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update FAQ
     *
     * @tags default
     * @name PutApiFaq
     * @request PUT:/v1/faqs/{faq_guid}
     */
    putApiFaq: (
      faqGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        available_for_microsite?: boolean;
        available_for_partners?: boolean;
        available_for_users?: boolean;
        product_type?: string;
        sort?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<FaqSuccess, NotFoundError | AuthError>({
        path: `/v1/faqs/${faqGuid}`,
        operation: "putApiFaq",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete FAQ
     *
     * @tags default
     * @name DeleteApiFaq
     * @request DELETE:/v1/faqs/{faq_guid}
     */
    deleteApiFaq: (
      faqGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError>({
        path: `/v1/faqs/${faqGuid}`,
        operation: "deleteApiFaq",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to upsert FAQ translation
     *
     * @tags default
     * @name PostApiFaqTranslation
     * @request POST:/v1/faqs/{faq_guid}/translations
     */
    postApiFaqTranslation: (
      faqGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        auto_translate?: boolean;
        i_language?: number;
        question?: string;
        response?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FaqSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/faqs/${faqGuid}/translations`,
        operation: "postApiFaqTranslation",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all active insurance companies
     *
     * @tags default
     * @name GetApiInsuranceCompanyList
     * @summary Get all active insurance companies for the realm
     * @request GET:/v1/insurance_companies
     */
    getApiInsuranceCompanyList: (
      query: {
        client_bundle_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InsuranceCompanyListSuccess, AuthError>({
        path: `/v1/insurance_companies`,
        operation: "getApiInsuranceCompanyList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new insurance company
     *
     * @tags default
     * @name PostApiInsuranceCompanyList
     * @summary Create a new insurance company
     * @request POST:/v1/insurance_companies
     */
    postApiInsuranceCompanyList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        abbreviation?: string;
        ik_number?: string;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InsuranceCompanySuccess, ApiInsuranceCompanyListError | AuthError | ForbiddenError>({
        path: `/v1/insurance_companies`,
        operation: "postApiInsuranceCompanyList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an insurance company
     *
     * @tags default
     * @name PutApiInsuranceCompany
     * @summary Update an insurance company
     * @request PUT:/v1/insurance_companies/{insurance_company_guid}
     */
    putApiInsuranceCompany: (
      insuranceCompanyGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        abbreviation?: string;
        ik_number?: string;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InsuranceCompanySuccess, ApiInsuranceCompanyError | AuthError | ForbiddenError>({
        path: `/v1/insurance_companies/${insuranceCompanyGuid}`,
        operation: "putApiInsuranceCompany",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an insurance company (soft delete)
     *
     * @tags default
     * @name DeleteApiInsuranceCompany
     * @summary Delete an insurance company (soft delete by setting active=0)
     * @request DELETE:/v1/insurance_companies/{insurance_company_guid}
     */
    deleteApiInsuranceCompany: (
      insuranceCompanyGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/insurance_companies/${insuranceCompanyGuid}`,
        operation: "deleteApiInsuranceCompany",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get inventory balances
     *
     * @tags default
     * @name GetApiInventoryBalanceList
     * @request GET:/v1/inventory_balances
     */
    getApiInventoryBalanceList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        inventory_location_guid?: string;
        product_guid?: string;
        i_product_batch?: number;
        /** @default false */
        include_zero?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<InventoryBalanceListSuccess, AuthError | ForbiddenError>({
        path: `/v1/inventory_balances`,
        operation: "getApiInventoryBalanceList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Set counted inventory amount for a location/product/batch
     *
     * @tags default
     * @name PostApiInventoryCorrectionList
     * @request POST:/v1/inventory_corrections
     */
    postApiInventoryCorrectionList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiInventoryCorrectionPost,
      params: RequestParams = {},
    ) =>
      this.request<InventoryMovementResultSuccess, AuthError | ForbiddenError>({
        path: `/v1/inventory_corrections`,
        operation: "postApiInventoryCorrectionList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get inventory locations
     *
     * @tags default
     * @name GetApiInventoryLocationList
     * @request GET:/v1/inventory_locations
     */
    getApiInventoryLocationList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default false */
        include_inactive?: boolean;
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InventoryLocationListSuccess, AuthError | ForbiddenError>({
        path: `/v1/inventory_locations`,
        operation: "getApiInventoryLocationList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create an inventory location
     *
     * @tags default
     * @name PostApiInventoryLocationList
     * @request POST:/v1/inventory_locations
     */
    postApiInventoryLocationList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiInventoryLocationListPost,
      params: RequestParams = {},
    ) =>
      this.request<InventoryLocationSuccess, AuthError | ForbiddenError>({
        path: `/v1/inventory_locations`,
        operation: "postApiInventoryLocationList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an inventory location
     *
     * @tags default
     * @name PutApiInventoryLocation
     * @request PUT:/v1/inventory_locations/{inventory_location_guid}
     */
    putApiInventoryLocation: (
      inventoryLocationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        is_active?: boolean;
        is_fulfillable?: boolean;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InventoryLocationSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/inventory_locations/${inventoryLocationGuid}`,
        operation: "putApiInventoryLocation",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Archive an inventory location
     *
     * @tags default
     * @name DeleteApiInventoryLocation
     * @request DELETE:/v1/inventory_locations/{inventory_location_guid}
     */
    deleteApiInventoryLocation: (
      inventoryLocationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/inventory_locations/${inventoryLocationGuid}`,
        operation: "deleteApiInventoryLocation",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Search inventory serial numbers
     *
     * @tags default
     * @name GetApiInventorySerialNumberSearch
     * @request GET:/v1/inventory_serial_numbers
     */
    getApiInventorySerialNumberSearch: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        query: string;
        /** @default 50 */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<InventorySerialNumberSearchListSuccess, AuthError | ForbiddenError>({
        path: `/v1/inventory_serial_numbers`,
        operation: "getApiInventorySerialNumberSearch",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get inventory stock movement history
     *
     * @tags default
     * @name GetApiInventoryStockMovementList
     * @request GET:/v1/inventory_stock_movements
     */
    getApiInventoryStockMovementList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        inventory_location_guid?: string;
        product_guid?: string;
        i_product_batch?: number;
        /** @default 100 */
        limit?: number;
        /** @default 0 */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<InventoryStockMovementListSuccess, AuthError | ForbiddenError>({
        path: `/v1/inventory_stock_movements`,
        operation: "getApiInventoryStockMovementList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Transfer inventory between locations
     *
     * @tags default
     * @name PostApiInventoryTransferList
     * @request POST:/v1/inventory_transfers
     */
    postApiInventoryTransferList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiInventoryTransferPost,
      params: RequestParams = {},
    ) =>
      this.request<InventoryMovementResultSuccess, AuthError | ForbiddenError>({
        path: `/v1/inventory_transfers`,
        operation: "postApiInventoryTransferList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get ISO languages
     *
     * @tags default
     * @name GetApiIsoLanguage
     * @request GET:/v1/iso_languages
     */
    getApiIsoLanguage: (params: RequestParams = {}) =>
      this.request<ISOLanguageListSuccess, any>({
        path: `/v1/iso_languages`,
        operation: "getApiIsoLanguage",
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get knowledge base documents
     *
     * @tags default
     * @name GetApiKnowledgeBaseDocumentList
     * @request GET:/v1/knowledge_base_documents
     */
    getApiKnowledgeBaseDocumentList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KnowledgeBaseDocumentListSuccess, AuthError>({
        path: `/v1/knowledge_base_documents`,
        operation: "getApiKnowledgeBaseDocumentList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create knowledge base document
     *
     * @tags default
     * @name PostApiKnowledgeBaseDocumentList
     * @request POST:/v1/knowledge_base_documents
     */
    postApiKnowledgeBaseDocumentList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        title: string;
        content_type: string;
        type: "DOCUMENT" | "TUTORIAL";
        product_type: string;
        restricted: boolean;
      },
      data: {
        document: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<KnowledgeBaseDocumentSuccess, AuthError | ForbiddenError>({
        path: `/v1/knowledge_base_documents`,
        operation: "postApiKnowledgeBaseDocumentList",
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update knowledge base document
     *
     * @tags default
     * @name PutApiKnowledgeBaseDocument
     * @request PUT:/v1/knowledge_base_documents/{knowledge_base_document_guid}
     */
    putApiKnowledgeBaseDocument: (
      knowledgeBaseDocumentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        title?: string;
        content_type?: string;
        type?: "DOCUMENT" | "TUTORIAL";
        product_type?: string;
        restricted?: boolean;
        sort?: number;
      },
      data: {
        document?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<KnowledgeBaseDocumentSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/knowledge_base_documents/${knowledgeBaseDocumentGuid}`,
        operation: "putApiKnowledgeBaseDocument",
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete knowledge base document
     *
     * @tags default
     * @name DeleteApiKnowledgeBaseDocument
     * @request DELETE:/v1/knowledge_base_documents/{knowledge_base_document_guid}
     */
    deleteApiKnowledgeBaseDocument: (
      knowledgeBaseDocumentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, NotFoundError | AuthError>({
        path: `/v1/knowledge_base_documents/${knowledgeBaseDocumentGuid}`,
        operation: "deleteApiKnowledgeBaseDocument",
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to download document
     *
     * @tags default
     * @name GetApiKnowledgeBaseDocumentDownload
     * @request GET:/v1/knowledge_base_documents/{knowledge_base_document_guid}/download
     */
    getApiKnowledgeBaseDocumentDownload: (
      knowledgeBaseDocumentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, AuthError | FileNotFoundError>({
        path: `/v1/knowledge_base_documents/${knowledgeBaseDocumentGuid}/download`,
        operation: "getApiKnowledgeBaseDocumentDownload",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to get the average gross margin by month
     *
     * @tags default
     * @name GetApiAverageGrossMarginKpi
     * @request GET:/v1/kpis/average_gross_margin
     */
    getApiAverageGrossMarginKpi: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /**
         * @min 0
         * @default 6
         */
        months?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AverageGrossMarginListSuccess, AuthError | ForbiddenError>({
        path: `/v1/kpis/average_gross_margin`,
        operation: "getApiAverageGrossMarginKpi",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get completed medical test parameter KPIs by month
     *
     * @tags default
     * @name GetApiMedicalTestParameterKpi
     * @request GET:/v1/kpis/medical_test_parameters
     */
    getApiMedicalTestParameterKpi: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /**
         * @min 0
         * @default 6
         */
        months?: 12 | 24 | 6;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterKpiSuccess, AuthError | ForbiddenError>({
        path: `/v1/kpis/medical_test_parameters`,
        operation: "getApiMedicalTestParameterKpi",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test profile distribution by collection date
     *
     * @tags default
     * @name GetApiMedicalTestProfileDistributionKpi
     * @request GET:/v1/kpis/medical_test_profile_distribution
     */
    getApiMedicalTestProfileDistributionKpi: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @min 0 */
        collected_from: number;
        /** @min 0 */
        collected_to: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileDistributionKpiSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/kpis/medical_test_profile_distribution`,
        operation: "getApiMedicalTestProfileDistributionKpi",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test profile KPIs by month
     *
     * @tags default
     * @name GetApiMedicalTestProfileKpi
     * @request GET:/v1/kpis/medical_test_profiles
     */
    getApiMedicalTestProfileKpi: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /**
         * @min 0
         * @default 6
         */
        months?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileKpiSuccess, AuthError | ForbiddenError>({
        path: `/v1/kpis/medical_test_profiles`,
        operation: "getApiMedicalTestProfileKpi",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner registration KPIs by month
     *
     * @tags default
     * @name GetApiPartnerRegistrationKpi
     * @request GET:/v1/kpis/partner_registration
     */
    getApiPartnerRegistrationKpi: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerRegistrationKpiListSuccess, AuthError | ForbiddenError>({
        path: `/v1/kpis/partner_registration`,
        operation: "getApiPartnerRegistrationKpi",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner test samples count by month
     *
     * @tags default
     * @name GetApiPartnerTestSamplesByMonthKpi
     * @request GET:/v1/kpis/partners/test_samples_count
     */
    getApiPartnerTestSamplesByMonthKpi: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /**
         * @min 0
         * @default 3
         */
        months?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerTestSamplesCountKpiSuccess, AuthError | ForbiddenError>({
        path: `/v1/kpis/partners/test_samples_count`,
        operation: "getApiPartnerTestSamplesByMonthKpi",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get CaboPOC product distribution by test date
     *
     * @tags default
     * @name GetApiPocProductDistributionKpi
     * @request GET:/v1/kpis/poc_product_distribution
     */
    getApiPocProductDistributionKpi: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @min 0 */
        tested_from: number;
        /** @min 0 */
        tested_to: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PocProductDistributionKpiSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/kpis/poc_product_distribution`,
        operation: "getApiPocProductDistributionKpi",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get potential partners KPIs by month
     *
     * @tags default
     * @name GetApiPotentialPartnersKpi
     * @request GET:/v1/kpis/potential_partners
     */
    getApiPotentialPartnersKpi: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PotentialPartnersKpiListSuccess, AuthError | ForbiddenError>({
        path: `/v1/kpis/potential_partners`,
        operation: "getApiPotentialPartnersKpi",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get shipment KPIs by month
     *
     * @tags default
     * @name GetApiShipmentKpi
     * @request GET:/v1/kpis/shipments
     */
    getApiShipmentKpi: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /**
         * @min 0
         * @default 6
         */
        months?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShipmentKpiSuccess, AuthError | ForbiddenError>({
        path: `/v1/kpis/shipments`,
        operation: "getApiShipmentKpi",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get marketing documents
     *
     * @tags default
     * @name GetApiMarketingDocumentList
     * @request GET:/v1/marketing_documents
     */
    getApiMarketingDocumentList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MarketingDocumentListSuccess, AuthError>({
        path: `/v1/marketing_documents`,
        operation: "getApiMarketingDocumentList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create marketing document
     *
     * @tags default
     * @name PostApiMarketingDocumentList
     * @request POST:/v1/marketing_documents
     */
    postApiMarketingDocumentList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        title: string;
        content_type: string;
        format: string;
        category:
          | "DOCUMENT"
          | "LOGO"
          | "OTHER"
          | "PRESENTATION"
          | "PROMOTIONAL_MATERIAL"
          | "SOCIAL_MEDIA"
          | "TRAINING_MATERIAL"
          | "VIDEO";
        product_type: string;
        public: boolean;
      },
      data: {
        document: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<MarketingDocumentSuccess, AuthError | ForbiddenError>({
        path: `/v1/marketing_documents`,
        operation: "postApiMarketingDocumentList",
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get marketing document
     *
     * @tags default
     * @name GetApiMarketingDocument
     * @request GET:/v1/marketing_documents/{marketing_document_guid}
     */
    getApiMarketingDocument: (
      marketingDocumentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MarketingDocumentSuccess, NotFoundError | AuthError>({
        path: `/v1/marketing_documents/${marketingDocumentGuid}`,
        operation: "getApiMarketingDocument",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update marketing document
     *
     * @tags default
     * @name PutApiMarketingDocument
     * @request PUT:/v1/marketing_documents/{marketing_document_guid}
     */
    putApiMarketingDocument: (
      marketingDocumentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        title?: string;
        content_type?: string;
        format?: string;
        category?:
          | "DOCUMENT"
          | "LOGO"
          | "OTHER"
          | "PRESENTATION"
          | "PROMOTIONAL_MATERIAL"
          | "SOCIAL_MEDIA"
          | "TRAINING_MATERIAL"
          | "VIDEO";
        product_type?: string;
        public?: boolean;
        sort?: number;
      },
      data: {
        document?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<MarketingDocumentSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/marketing_documents/${marketingDocumentGuid}`,
        operation: "putApiMarketingDocument",
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete marketing document
     *
     * @tags default
     * @name DeleteApiMarketingDocument
     * @request DELETE:/v1/marketing_documents/{marketing_document_guid}
     */
    deleteApiMarketingDocument: (
      marketingDocumentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, NotFoundError | AuthError>({
        path: `/v1/marketing_documents/${marketingDocumentGuid}`,
        operation: "deleteApiMarketingDocument",
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to download marketing document
     *
     * @tags default
     * @name GetApiMarketingDocumentDownload
     * @request GET:/v1/marketing_documents/{marketing_document_guid}/download
     */
    getApiMarketingDocumentDownload: (
      marketingDocumentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, AuthError | FileNotFoundError>({
        path: `/v1/marketing_documents/${marketingDocumentGuid}/download`,
        operation: "getApiMarketingDocumentDownload",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to download marketing documents bulk
     *
     * @tags default
     * @name GetApiMarketingDocumentDownloadBulk
     * @request GET:/v1/marketing_documents/download/bulk
     */
    getApiMarketingDocumentDownloadBulk: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        document_guids: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, AuthError | FileNotFoundError>({
        path: `/v1/marketing_documents/download/bulk`,
        operation: "getApiMarketingDocumentDownloadBulk",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to get medical profile groups
     *
     * @tags default
     * @name GetApiMedicalProfileGroupList
     * @request GET:/v1/medical_profile_groups
     */
    getApiMedicalProfileGroupList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalProfileGroupListSuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_profile_groups`,
        operation: "getApiMedicalProfileGroupList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create medical profile group
     *
     * @tags default
     * @name PostApiMedicalProfileGroupList
     * @request POST:/v1/medical_profile_groups
     */
    postApiMedicalProfileGroupList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalProfileGroupSuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_profile_groups`,
        operation: "postApiMedicalProfileGroupList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical profile group
     *
     * @tags default
     * @name GetApiMedicalProfileGroup
     * @request GET:/v1/medical_profile_groups/{i_medical_profile_group}
     */
    getApiMedicalProfileGroup: (
      iMedicalProfileGroup: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalProfileGroupSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_profile_groups/${iMedicalProfileGroup}`,
        operation: "getApiMedicalProfileGroup",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update medical profile group
     *
     * @tags default
     * @name PutApiMedicalProfileGroup
     * @request PUT:/v1/medical_profile_groups/{i_medical_profile_group}
     */
    putApiMedicalProfileGroup: (
      iMedicalProfileGroup: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalProfileGroupSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_profile_groups/${iMedicalProfileGroup}`,
        operation: "putApiMedicalProfileGroup",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete medical profile group
     *
     * @tags default
     * @name DeleteApiMedicalProfileGroup
     * @request DELETE:/v1/medical_profile_groups/{i_medical_profile_group}
     */
    deleteApiMedicalProfileGroup: (
      iMedicalProfileGroup: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiMedicalProfileGroupError | AuthError | ForbiddenError>({
        path: `/v1/medical_profile_groups/${iMedicalProfileGroup}`,
        operation: "deleteApiMedicalProfileGroup",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to duplicate medical profile group
     *
     * @tags default
     * @name PostApiMedicalProfileGroupDuplicate
     * @request POST:/v1/medical_profile_groups/{i_medical_profile_group}/duplicate
     */
    postApiMedicalProfileGroupDuplicate: (
      iMedicalProfileGroup: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalProfileGroupSuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_profile_groups/${iMedicalProfileGroup}/duplicate`,
        operation: "postApiMedicalProfileGroupDuplicate",
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to add profile to a group
     *
     * @tags default
     * @name PostApiMedicalProfileGroupLink
     * @request POST:/v1/medical_profile_groups/{i_medical_profile_group}/medical_test_profiles
     */
    postApiMedicalProfileGroupLink: (
      iMedicalProfileGroup: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        end?: string;
        medical_test_profile_guid?: string;
        price?: number;
        start?: string;
        suggested_selling_price?: number;
        usage_limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalProfileGroupSuccess, ApiMedicalProfileGroupLinkPostError | AuthError | ForbiddenError>({
        path: `/v1/medical_profile_groups/${iMedicalProfileGroup}/medical_test_profiles`,
        operation: "postApiMedicalProfileGroupLink",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to remove profile from group
     *
     * @tags default
     * @name DeleteApiMedicalProfileGroupLink
     * @request DELETE:/v1/medical_profile_groups/{i_medical_profile_group}/medical_test_profiles
     */
    deleteApiMedicalProfileGroupLink: (
      iMedicalProfileGroup: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        medical_test_profile_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalProfileGroupSuccess, ApiMedicalProfileGroupLinkDeleteError | AuthError | ForbiddenError>({
        path: `/v1/medical_profile_groups/${iMedicalProfileGroup}/medical_test_profiles`,
        operation: "deleteApiMedicalProfileGroupLink",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test groups
     *
     * @tags default
     * @name GetApiMedicalTestGroupList
     * @request GET:/v1/medical_test_groups
     */
    getApiMedicalTestGroupList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestGroupListSuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_test_groups`,
        operation: "getApiMedicalTestGroupList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create medical test group
     *
     * @tags default
     * @name PostApiMedicalTestGroupList
     * @request POST:/v1/medical_test_groups
     */
    postApiMedicalTestGroupList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiMedicalTestGroupListPost,
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestGroupSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_groups`,
        operation: "postApiMedicalTestGroupList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test group
     *
     * @tags default
     * @name GetApiMedicalTestGroup
     * @request GET:/v1/medical_test_groups/{medical_test_group_guid}
     */
    getApiMedicalTestGroup: (
      medicalTestGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestGroupSuccess, NotFoundError | AuthError>({
        path: `/v1/medical_test_groups/${medicalTestGroupGuid}`,
        operation: "getApiMedicalTestGroup",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete medical test group
     *
     * @tags default
     * @name DeleteApiMedicalTestGroup
     * @request DELETE:/v1/medical_test_groups/{medical_test_group_guid}
     */
    deleteApiMedicalTestGroup: (
      medicalTestGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiMedicalTestGroupError | AuthError>({
        path: `/v1/medical_test_groups/${medicalTestGroupGuid}`,
        operation: "deleteApiMedicalTestGroup",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to upsert medical test group translation
     *
     * @tags default
     * @name PostApiMedicalTestGroupTranslation
     * @request POST:/v1/medical_test_groups/{medical_test_group_guid}/translations
     */
    postApiMedicalTestGroupTranslation: (
      medicalTestGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        auto_translate?: boolean;
        i_language?: number;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestGroupSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_groups/${medicalTestGroupGuid}/translations`,
        operation: "postApiMedicalTestGroupTranslation",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test parameter categories
     *
     * @tags default
     * @name GetApiMedicalTestParameterCategoryList
     * @request GET:/v1/medical_test_parameter_categories
     */
    getApiMedicalTestParameterCategoryList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterCategoryListSuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameter_categories`,
        operation: "getApiMedicalTestParameterCategoryList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create medical test parameter category
     *
     * @tags default
     * @name PostApiMedicalTestParameterCategoryList
     * @request POST:/v1/medical_test_parameter_categories
     */
    postApiMedicalTestParameterCategoryList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterCategorySuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameter_categories`,
        operation: "postApiMedicalTestParameterCategoryList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test parameter category
     *
     * @tags default
     * @name GetApiMedicalTestParameterCategory
     * @request GET:/v1/medical_test_parameter_categories/{medical_test_parameter_category_guid}
     */
    getApiMedicalTestParameterCategory: (
      medicalTestParameterCategoryGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterCategorySuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameter_categories/${medicalTestParameterCategoryGuid}`,
        operation: "getApiMedicalTestParameterCategory",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update medical test parameter category
     *
     * @tags default
     * @name PutApiMedicalTestParameterCategory
     * @request PUT:/v1/medical_test_parameter_categories/{medical_test_parameter_category_guid}
     */
    putApiMedicalTestParameterCategory: (
      medicalTestParameterCategoryGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterCategorySuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameter_categories/${medicalTestParameterCategoryGuid}`,
        operation: "putApiMedicalTestParameterCategory",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete medical test parameter category
     *
     * @tags default
     * @name DeleteApiMedicalTestParameterCategory
     * @request DELETE:/v1/medical_test_parameter_categories/{medical_test_parameter_category_guid}
     */
    deleteApiMedicalTestParameterCategory: (
      medicalTestParameterCategoryGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameter_categories/${medicalTestParameterCategoryGuid}`,
        operation: "deleteApiMedicalTestParameterCategory",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test parameter FAQs
     *
     * @tags default
     * @name GetApiMedicalTestParameterFaqList
     * @request GET:/v1/medical_test_parameter_faqs
     */
    getApiMedicalTestParameterFaqList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterFaqListSuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameter_faqs`,
        operation: "getApiMedicalTestParameterFaqList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create medical test parameter FAQ
     *
     * @tags default
     * @name PostApiMedicalTestParameterFaqList
     * @request POST:/v1/medical_test_parameter_faqs
     */
    postApiMedicalTestParameterFaqList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiMedicalTestParameterFaqListPost,
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterFaqSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameter_faqs`,
        operation: "postApiMedicalTestParameterFaqList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test parameter FAQ
     *
     * @tags default
     * @name GetApiMedicalTestParameterFaq
     * @request GET:/v1/medical_test_parameter_faqs/{medical_test_parameter_faq_guid}
     */
    getApiMedicalTestParameterFaq: (
      medicalTestParameterFaqGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterFaqSuccess, NotFoundError | AuthError>({
        path: `/v1/medical_test_parameter_faqs/${medicalTestParameterFaqGuid}`,
        operation: "getApiMedicalTestParameterFaq",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update medical test parameter FAQ
     *
     * @tags default
     * @name PutApiMedicalTestParameterFaq
     * @request PUT:/v1/medical_test_parameter_faqs/{medical_test_parameter_faq_guid}
     */
    putApiMedicalTestParameterFaq: (
      medicalTestParameterFaqGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        sort?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError>({
        path: `/v1/medical_test_parameter_faqs/${medicalTestParameterFaqGuid}`,
        operation: "putApiMedicalTestParameterFaq",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete medical test parameter FAQ
     *
     * @tags default
     * @name DeleteApiMedicalTestParameterFaq
     * @request DELETE:/v1/medical_test_parameter_faqs/{medical_test_parameter_faq_guid}
     */
    deleteApiMedicalTestParameterFaq: (
      medicalTestParameterFaqGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError>({
        path: `/v1/medical_test_parameter_faqs/${medicalTestParameterFaqGuid}`,
        operation: "deleteApiMedicalTestParameterFaq",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to upsert medical test parameter FAQ translation
     *
     * @tags default
     * @name PostApiMedicalTestParameterFaqTranslation
     * @request POST:/v1/medical_test_parameter_faqs/{medical_test_parameter_faq_guid}/translations
     */
    postApiMedicalTestParameterFaqTranslation: (
      medicalTestParameterFaqGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        auto_translate?: boolean;
        i_language?: number;
        question?: string;
        response?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterFaqSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameter_faqs/${medicalTestParameterFaqGuid}/translations`,
        operation: "postApiMedicalTestParameterFaqTranslation",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test parameters
     *
     * @tags default
     * @name GetApiMedicalTestParameterList
     * @request GET:/v1/medical_test_parameters
     */
    getApiMedicalTestParameterList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterListSuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameters`,
        operation: "getApiMedicalTestParameterList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create medical test parameter
     *
     * @tags default
     * @name PostApiMedicalTestParameterList
     * @request POST:/v1/medical_test_parameters
     */
    postApiMedicalTestParameterList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        byo_enabled?: boolean;
        loinc_code?: string;
        name?: string;
        reference_ranges?: string;
        unit?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameters`,
        operation: "postApiMedicalTestParameterList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test parameter
     *
     * @tags default
     * @name GetApiMedicalTestParameter
     * @request GET:/v1/medical_test_parameters/{medical_test_parameter_guid}
     */
    getApiMedicalTestParameter: (
      medicalTestParameterGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameters/${medicalTestParameterGuid}`,
        operation: "getApiMedicalTestParameter",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update medical test parameter
     *
     * @tags default
     * @name PutApiMedicalTestParameter
     * @request PUT:/v1/medical_test_parameters/{medical_test_parameter_guid}
     */
    putApiMedicalTestParameter: (
      medicalTestParameterGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        byo_enabled?: boolean;
        loinc_code?: string;
        name?: string;
        reference_ranges?: string;
        unit?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameters/${medicalTestParameterGuid}`,
        operation: "putApiMedicalTestParameter",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete medical test parameter
     *
     * @tags default
     * @name DeleteApiMedicalTestParameter
     * @request DELETE:/v1/medical_test_parameters/{medical_test_parameter_guid}
     */
    deleteApiMedicalTestParameter: (
      medicalTestParameterGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameters/${medicalTestParameterGuid}`,
        operation: "deleteApiMedicalTestParameter",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to add medical test parameter category link
     *
     * @tags default
     * @name PostApiMedicalTestParameterCategoryLink
     * @request POST:/v1/medical_test_parameters/{medical_test_parameter_guid}/categories
     */
    postApiMedicalTestParameterCategoryLink: (
      medicalTestParameterGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        medical_test_parameter_category_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameters/${medicalTestParameterGuid}/categories`,
        operation: "postApiMedicalTestParameterCategoryLink",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete medical test parameter category link
     *
     * @tags default
     * @name DeleteApiMedicalTestParameterCategoryLink
     * @request DELETE:/v1/medical_test_parameters/{medical_test_parameter_guid}/categories
     */
    deleteApiMedicalTestParameterCategoryLink: (
      medicalTestParameterGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        medical_test_parameter_category_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameters/${medicalTestParameterGuid}/categories`,
        operation: "deleteApiMedicalTestParameterCategoryLink",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to add FAQ to a parameter
     *
     * @tags default
     * @name PostApiMedicalTestParameterFaqLink
     * @request POST:/v1/medical_test_parameters/{medical_test_parameter_guid}/faqs
     */
    postApiMedicalTestParameterFaqLink: (
      medicalTestParameterGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        medical_test_parameter_faq_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameters/${medicalTestParameterGuid}/faqs`,
        operation: "postApiMedicalTestParameterFaqLink",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to remove FAQ from parameter
     *
     * @tags default
     * @name DeleteApiMedicalTestParameterFaqLink
     * @request DELETE:/v1/medical_test_parameters/{medical_test_parameter_guid}/faqs
     */
    deleteApiMedicalTestParameterFaqLink: (
      medicalTestParameterGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        medical_test_parameter_faq_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameters/${medicalTestParameterGuid}/faqs`,
        operation: "deleteApiMedicalTestParameterFaqLink",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to add medical test parameter link
     *
     * @tags default
     * @name PostApiMedicalTestParameterLink
     * @request POST:/v1/medical_test_parameters/{medical_test_parameter_guid}/links
     */
    postApiMedicalTestParameterLink: (
      medicalTestParameterGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        vendor_medical_test_parameter_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterSuccess, ApiMedicalTestParameterLinkError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameters/${medicalTestParameterGuid}/links`,
        operation: "postApiMedicalTestParameterLink",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete medical test parameter link
     *
     * @tags default
     * @name DeleteApiMedicalTestParameterLink
     * @request DELETE:/v1/medical_test_parameters/{medical_test_parameter_guid}/links
     */
    deleteApiMedicalTestParameterLink: (
      medicalTestParameterGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        vendor_medical_test_parameter_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_parameters/${medicalTestParameterGuid}/links`,
        operation: "deleteApiMedicalTestParameterLink",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test profile discount groups
     *
     * @tags default
     * @name GetApiMedicalTestProfileDiscountGroupList
     * @request GET:/v1/medical_test_profile_discount_groups
     */
    getApiMedicalTestProfileDiscountGroupList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileDiscountGroupListSuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_test_profile_discount_groups`,
        operation: "getApiMedicalTestProfileDiscountGroupList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create medical test profile discount group
     *
     * @tags default
     * @name PostApiMedicalTestProfileDiscountGroupList
     * @request POST:/v1/medical_test_profile_discount_groups
     */
    postApiMedicalTestProfileDiscountGroupList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        all_partners?: boolean;
        all_profiles?: boolean;
        coupons_limit?: number;
        discount?: number;
        end?: string;
        name?: string;
        start?: string;
        time_limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileDiscountGroupSuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_test_profile_discount_groups`,
        operation: "postApiMedicalTestProfileDiscountGroupList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test profile discount group
     *
     * @tags default
     * @name GetApiMedicalTestProfileDiscountGroup
     * @request GET:/v1/medical_test_profile_discount_groups/{medical_test_profile_discount_group_guid}
     */
    getApiMedicalTestProfileDiscountGroup: (
      medicalTestProfileDiscountGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileDiscountGroupSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profile_discount_groups/${medicalTestProfileDiscountGroupGuid}`,
        operation: "getApiMedicalTestProfileDiscountGroup",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update medical test profile discount group
     *
     * @tags default
     * @name PutApiMedicalTestProfileDiscountGroup
     * @request PUT:/v1/medical_test_profile_discount_groups/{medical_test_profile_discount_group_guid}
     */
    putApiMedicalTestProfileDiscountGroup: (
      medicalTestProfileDiscountGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        all_partners?: boolean;
        all_profiles?: boolean;
        coupons_limit?: number;
        discount?: number;
        end?: string;
        name?: string;
        start?: string;
        time_limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileDiscountGroupSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profile_discount_groups/${medicalTestProfileDiscountGroupGuid}`,
        operation: "putApiMedicalTestProfileDiscountGroup",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete medical test profile discount group
     *
     * @tags default
     * @name DeleteApiMedicalTestProfileDiscountGroup
     * @request DELETE:/v1/medical_test_profile_discount_groups/{medical_test_profile_discount_group_guid}
     */
    deleteApiMedicalTestProfileDiscountGroup: (
      medicalTestProfileDiscountGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profile_discount_groups/${medicalTestProfileDiscountGroupGuid}`,
        operation: "deleteApiMedicalTestProfileDiscountGroup",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to add profile to a group
     *
     * @tags default
     * @name PostApiMedicalTestProfileDiscountGroupLink
     * @request POST:/v1/medical_test_profile_discount_groups/{medical_test_profile_discount_group_guid}/medical_test_profiles
     */
    postApiMedicalTestProfileDiscountGroupLink: (
      medicalTestProfileDiscountGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        medical_test_profile_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        MedicalTestProfileDiscountGroupSuccess,
        ApiMedicalTestProfileDiscountGroupLinkError | AuthError | ForbiddenError
      >({
        path: `/v1/medical_test_profile_discount_groups/${medicalTestProfileDiscountGroupGuid}/medical_test_profiles`,
        operation: "postApiMedicalTestProfileDiscountGroupLink",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to remove profile from group
     *
     * @tags default
     * @name DeleteApiMedicalTestProfileDiscountGroupLink
     * @request DELETE:/v1/medical_test_profile_discount_groups/{medical_test_profile_discount_group_guid}/medical_test_profiles
     */
    deleteApiMedicalTestProfileDiscountGroupLink: (
      medicalTestProfileDiscountGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        medical_test_profile_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        MedicalTestProfileDiscountGroupSuccess,
        ApiMedicalTestProfileDiscountGroupLinkError | AuthError | ForbiddenError
      >({
        path: `/v1/medical_test_profile_discount_groups/${medicalTestProfileDiscountGroupGuid}/medical_test_profiles`,
        operation: "deleteApiMedicalTestProfileDiscountGroupLink",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to add profile to a group
     *
     * @tags default
     * @name PostApiMedicalTestProfileDiscountGroupPartner
     * @request POST:/v1/medical_test_profile_discount_groups/{medical_test_profile_discount_group_guid}/partners
     */
    postApiMedicalTestProfileDiscountGroupPartner: (
      medicalTestProfileDiscountGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        end?: string;
        partner_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        MedicalTestProfileDiscountGroupSuccess,
        ApiMedicalTestProfileDiscountGroupPartnerError | AuthError | ForbiddenError
      >({
        path: `/v1/medical_test_profile_discount_groups/${medicalTestProfileDiscountGroupGuid}/partners`,
        operation: "postApiMedicalTestProfileDiscountGroupPartner",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to remove profile from group
     *
     * @tags default
     * @name DeleteApiMedicalTestProfileDiscountGroupPartner
     * @request DELETE:/v1/medical_test_profile_discount_groups/{medical_test_profile_discount_group_guid}/partners
     */
    deleteApiMedicalTestProfileDiscountGroupPartner: (
      medicalTestProfileDiscountGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        partner_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        MedicalTestProfileDiscountGroupSuccess,
        ApiMedicalTestProfileDiscountGroupPartnerError | AuthError | ForbiddenError
      >({
        path: `/v1/medical_test_profile_discount_groups/${medicalTestProfileDiscountGroupGuid}/partners`,
        operation: "deleteApiMedicalTestProfileDiscountGroupPartner",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test profiles with minimal data for list view
     *
     * @tags default
     * @name GetApiMedicalTestProfileListMinimal
     * @request GET:/v1/medical_test_profile_list_minimal
     */
    getApiMedicalTestProfileListMinimal: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileListSuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_test_profile_list_minimal`,
        operation: "getApiMedicalTestProfileListMinimal",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test profile tags
     *
     * @tags default
     * @name GetApiMedicalTestProfileTagList
     * @request GET:/v1/medical_test_profile_tags
     */
    getApiMedicalTestProfileTagList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileTagListSuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_test_profile_tags`,
        operation: "getApiMedicalTestProfileTagList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create medical test profile tag
     *
     * @tags default
     * @name PostApiMedicalTestProfileTagList
     * @request POST:/v1/medical_test_profile_tags
     */
    postApiMedicalTestProfileTagList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiMedicalTestProfileTagListPost,
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileTagSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profile_tags`,
        operation: "postApiMedicalTestProfileTagList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test profile tag
     *
     * @tags default
     * @name GetApiMedicalTestProfileTag
     * @request GET:/v1/medical_test_profile_tags/{medical_test_profile_tag_guid}
     */
    getApiMedicalTestProfileTag: (
      medicalTestProfileTagGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileTagSuccess, NotFoundError | AuthError>({
        path: `/v1/medical_test_profile_tags/${medicalTestProfileTagGuid}`,
        operation: "getApiMedicalTestProfileTag",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete medical test profile tag
     *
     * @tags default
     * @name DeleteApiMedicalTestProfileTag
     * @request DELETE:/v1/medical_test_profile_tags/{medical_test_profile_tag_guid}
     */
    deleteApiMedicalTestProfileTag: (
      medicalTestProfileTagGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError>({
        path: `/v1/medical_test_profile_tags/${medicalTestProfileTagGuid}`,
        operation: "deleteApiMedicalTestProfileTag",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to upsert medical test profile tag translation
     *
     * @tags default
     * @name PostApiMedicalTestProfileTagTranslation
     * @request POST:/v1/medical_test_profile_tags/{medical_test_profile_tag_guid}/translations
     */
    postApiMedicalTestProfileTagTranslation: (
      medicalTestProfileTagGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        i_language?: number;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileTagSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profile_tags/${medicalTestProfileTagGuid}/translations`,
        operation: "postApiMedicalTestProfileTagTranslation",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test profiles
     *
     * @tags default
     * @name GetApiMedicalTestProfileList
     * @request GET:/v1/medical_test_profiles
     */
    getApiMedicalTestProfileList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default false */
        image_url?: boolean;
        /**
         * summary: names/prices/parameters; ordering: also tests/forms; details: also parameter FAQs and tags
         * @default "details"
         */
        view?: "details" | "ordering" | "summary";
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileListSuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles`,
        operation: "getApiMedicalTestProfileList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create medical test profile
     *
     * @tags default
     * @name PostApiMedicalTestProfileList
     * @request POST:/v1/medical_test_profiles
     */
    postApiMedicalTestProfileList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiMedicalTestProfileListPost,
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, ApiMedicalTestProfileListError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles`,
        operation: "postApiMedicalTestProfileList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test profile
     *
     * @tags default
     * @name GetApiMedicalTestProfile
     * @request GET:/v1/medical_test_profiles/{medical_test_profile_guid}
     */
    getApiMedicalTestProfile: (
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, NotFoundError | AuthError>({
        path: `/v1/medical_test_profiles/${medicalTestProfileGuid}`,
        operation: "getApiMedicalTestProfile",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update medical test profile
     *
     * @tags default
     * @name PutApiMedicalTestProfile
     * @request PUT:/v1/medical_test_profiles/{medical_test_profile_guid}
     */
    putApiMedicalTestProfile: (
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiMedicalTestProfilePut,
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, ApiMedicalTestProfileError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles/${medicalTestProfileGuid}`,
        operation: "putApiMedicalTestProfile",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete medical test profile
     *
     * @tags default
     * @name DeleteApiMedicalTestProfile
     * @request DELETE:/v1/medical_test_profiles/{medical_test_profile_guid}
     */
    deleteApiMedicalTestProfile: (
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles/${medicalTestProfileGuid}`,
        operation: "deleteApiMedicalTestProfile",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create profile's about section category
     *
     * @tags default
     * @name PostApiMedicalTestProfileAboutSectionCategory
     * @request POST:/v1/medical_test_profiles/{medical_test_profile_guid}/about_section_categories
     */
    postApiMedicalTestProfileAboutSectionCategory: (
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiMedicalTestProfileAboutSectionCategoryPost,
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles/${medicalTestProfileGuid}/about_section_categories`,
        operation: "postApiMedicalTestProfileAboutSectionCategory",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete profile's about section category
     *
     * @tags default
     * @name DeleteApiMedicalTestProfileAboutSectionCategory
     * @request DELETE:/v1/medical_test_profiles/{medical_test_profile_guid}/about_section_categories
     */
    deleteApiMedicalTestProfileAboutSectionCategory: (
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        i_about_section_category?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles/${medicalTestProfileGuid}/about_section_categories`,
        operation: "deleteApiMedicalTestProfileAboutSectionCategory",
        method: "DELETE",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to upsert profile's about section category translation
     *
     * @tags default
     * @name PostApiMedicalTestProfileAboutSectionCategoryTranslation
     * @request POST:/v1/medical_test_profiles/{medical_test_profile_guid}/about_section_categories/{i_about_section_category}/translations
     */
    postApiMedicalTestProfileAboutSectionCategoryTranslation: (
      medicalTestProfileGuid: string,
      iAboutSectionCategory: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        auto_translate?: boolean;
        i_language?: number;
        name?: string;
        parameters?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles/${medicalTestProfileGuid}/about_section_categories/${iAboutSectionCategory}/translations`,
        operation: "postApiMedicalTestProfileAboutSectionCategoryTranslation",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to upload medical test profile image
     *
     * @tags default
     * @name PostApiMedicalTestProfileImage
     * @request POST:/v1/medical_test_profiles/{medical_test_profile_guid}/image
     */
    postApiMedicalTestProfileImage: (
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      data: {
        image: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles/${medicalTestProfileGuid}/image`,
        operation: "postApiMedicalTestProfileImage",
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to add medical tests to a profile
     *
     * @tags default
     * @name PostApiMedicalTestProfileLink
     * @request POST:/v1/medical_test_profiles/{medical_test_profile_guid}/medical_tests
     */
    postApiMedicalTestProfileLink: (
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        medical_test_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, ApiMedicalTestProfileLinkPostError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles/${medicalTestProfileGuid}/medical_tests`,
        operation: "postApiMedicalTestProfileLink",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to remove medical tests from profile
     *
     * @tags default
     * @name DeleteApiMedicalTestProfileLink
     * @request DELETE:/v1/medical_test_profiles/{medical_test_profile_guid}/medical_tests
     */
    deleteApiMedicalTestProfileLink: (
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        medical_test_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, ApiMedicalTestProfileLinkDeleteError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles/${medicalTestProfileGuid}/medical_tests`,
        operation: "deleteApiMedicalTestProfileLink",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to add tag to a profile
     *
     * @tags default
     * @name PostApiMedicalTestProfileTagLink
     * @request POST:/v1/medical_test_profiles/{medical_test_profile_guid}/tags
     */
    postApiMedicalTestProfileTagLink: (
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        medical_test_profile_tag_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles/${medicalTestProfileGuid}/tags`,
        operation: "postApiMedicalTestProfileTagLink",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to remove tag from profile
     *
     * @tags default
     * @name DeleteApiMedicalTestProfileTagLink
     * @request DELETE:/v1/medical_test_profiles/{medical_test_profile_guid}/tags
     */
    deleteApiMedicalTestProfileTagLink: (
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        medical_test_profile_tag_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles/${medicalTestProfileGuid}/tags`,
        operation: "deleteApiMedicalTestProfileTagLink",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to upsert medical test profile translation
     *
     * @tags default
     * @name PostApiMedicalTestProfileTranslation
     * @request POST:/v1/medical_test_profiles/{medical_test_profile_guid}/translations
     */
    postApiMedicalTestProfileTranslation: (
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        about_headline?: string;
        about_text?: string;
        auto_translate?: boolean;
        description?: string;
        i_language?: number;
        instructions?: string;
        name?: string;
        popover?: string;
        results?: string;
        subline?: string;
        symptom?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles/${medicalTestProfileGuid}/translations`,
        operation: "postApiMedicalTestProfileTranslation",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create medical test profile from parameters
     *
     * @tags default
     * @name PostApiMedicalTestProfileBuild
     * @request POST:/v1/medical_test_profiles/build
     */
    postApiMedicalTestProfileBuild: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiMedicalTestProfileBuildPost,
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_test_profiles/build`,
        operation: "postApiMedicalTestProfileBuild",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical tests
     *
     * @tags default
     * @name GetApiMedicalTestList
     * @request GET:/v1/medical_tests
     */
    getApiMedicalTestList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestListSuccess, AuthError | ForbiddenError>({
        path: `/v1/medical_tests`,
        operation: "getApiMedicalTestList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create medical test
     *
     * @tags default
     * @name PostApiMedicalTestList
     * @request POST:/v1/medical_tests
     */
    postApiMedicalTestList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiMedicalTestListPost,
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestSuccess, ApiMedicalTestListError | AuthError | ForbiddenError>({
        path: `/v1/medical_tests`,
        operation: "postApiMedicalTestList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get medical test
     *
     * @tags default
     * @name GetApiMedicalTest
     * @request GET:/v1/medical_tests/{medical_test_guid}
     */
    getApiMedicalTest: (
      medicalTestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestSuccess, NotFoundError | AuthError>({
        path: `/v1/medical_tests/${medicalTestGuid}`,
        operation: "getApiMedicalTest",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update medical test
     *
     * @tags default
     * @name PutApiMedicalTest
     * @request PUT:/v1/medical_tests/{medical_test_guid}
     */
    putApiMedicalTest: (
      medicalTestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        adaptors?: number;
        amount?: number;
        collection_deadline?: string;
        dead_specimen_amount?: number;
        hide_results?: number;
        info?: string;
        lanzettes?: number;
        medical_test_group_guid?: string;
        parent_medical_test_guid?: string;
        time_sensitive?: boolean;
        vendor_medical_test_guid?: string;
        wait_time?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestSuccess, ApiMedicalTestError | AuthError | ForbiddenError>({
        path: `/v1/medical_tests/${medicalTestGuid}`,
        operation: "putApiMedicalTest",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete medical test
     *
     * @tags default
     * @name DeleteApiMedicalTest
     * @request DELETE:/v1/medical_tests/{medical_test_guid}
     */
    deleteApiMedicalTest: (
      medicalTestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_tests/${medicalTestGuid}`,
        operation: "deleteApiMedicalTest",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to upsert medical test translation
     *
     * @tags default
     * @name PostApiMedicalTestTranslation
     * @request POST:/v1/medical_tests/{medical_test_guid}/translations
     */
    postApiMedicalTestTranslation: (
      medicalTestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        auto_translate?: boolean;
        i_language?: number;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/medical_tests/${medicalTestGuid}/translations`,
        operation: "postApiMedicalTestTranslation",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get minigame results
     *
     * @tags default
     * @name GetApiMinigameResultList
     * @request GET:/v1/minigame_results
     */
    getApiMinigameResultList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinigameResultListSuccess, AuthError | ForbiddenError>({
        path: `/v1/minigame_results`,
        operation: "getApiMinigameResultList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create minigame result
     *
     * @tags default
     * @name PostApiMinigameResultList
     * @request POST:/v1/minigame_results
     */
    postApiMinigameResultList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        result?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinigameResultSuccess, ApiApiMinigameResultListError | AuthError>({
        path: `/v1/minigame_results`,
        operation: "postApiMinigameResultList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get equipment stock requests
     *
     * @tags default
     * @name GetApiPartnerEquipmentStockRequests
     * @request GET:/v1/partner_equipment_stock_requests
     */
    getApiPartnerEquipmentStockRequests: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        partner_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerEquipmentStockRequestListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partner_equipment_stock_requests`,
        operation: "getApiPartnerEquipmentStockRequests",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get all partner invoice items
     *
     * @tags default
     * @name GetApiPartnerInvoiceItems
     * @request GET:/v1/partner_invoice_items
     */
    getApiPartnerInvoiceItems: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        start?: string;
        end?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceItemListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partner_invoice_items`,
        operation: "getApiPartnerInvoiceItems",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to send partner invoices
     *
     * @tags default
     * @name PutApiPartnerInvoiceSendEmail
     * @request PUT:/v1/partner_invoices/send
     */
    putApiPartnerInvoiceSendEmail: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        subject_prefix?: string;
        test_email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceSuccess, AuthError | ForbiddenError>({
        path: `/v1/partner_invoices/send`,
        operation: "putApiPartnerInvoiceSendEmail",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner landing by code
     *
     * @tags default
     * @name GetApiPartnerLandingByCode
     * @request GET:/v1/partner_landings
     */
    getApiPartnerLandingByCode: (
      query: {
        code: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerLandingSuccess, NotFoundError>({
        path: `/v1/partner_landings`,
        operation: "getApiPartnerLandingByCode",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get one publicly available microsite medical test profile with details
     *
     * @tags default
     * @name GetApiPartnerLandingMedicalTestProfile
     * @request GET:/v1/partner_landings/medical_test_profiles/{medical_test_profile_guid}
     */
    getApiPartnerLandingMedicalTestProfile: (
      medicalTestProfileGuid: string,
      query: {
        code: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, NotFoundError>({
        path: `/v1/partner_landings/medical_test_profiles/${medicalTestProfileGuid}`,
        operation: "getApiPartnerLandingMedicalTestProfile",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get one publicly available microsite POC product with details
     *
     * @tags default
     * @name GetApiPartnerLandingPocProduct
     * @request GET:/v1/partner_landings/poc_products/{product_guid}
     */
    getApiPartnerLandingPocProduct: (
      productGuid: string,
      query: {
        code: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductSellingPriceSuccess, NotFoundError>({
        path: `/v1/partner_landings/poc_products/${productGuid}`,
        operation: "getApiPartnerLandingPocProduct",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner roles
     *
     * @tags default
     * @name GetApiPartnerRoleList
     * @request GET:/v1/partner_roles
     */
    getApiPartnerRoleList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RoleListSuccess, AuthError>({
        path: `/v1/partner_roles`,
        operation: "getApiPartnerRoleList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partners
     *
     * @tags default
     * @name GetApiPartnerList
     * @request GET:/v1/partners
     */
    getApiPartnerList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerListSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners`,
        operation: "getApiPartnerList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner
     *
     * @tags default
     * @name GetApiPartner
     * @request GET:/v1/partners/{partner_guid}
     */
    getApiPartner: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}`,
        operation: "getApiPartner",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner
     *
     * @tags default
     * @name PutApiPartner
     * @request PUT:/v1/partners/{partner_guid}
     */
    putApiPartner: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        apozin_short_code?: string;
        blocked_because_of_payment?: boolean;
        city?: string;
        country?: string;
        default_locale?: string;
        i_equipment_shipment_pack_option?: number;
        i_medical_profile_group?: number;
        invoice_email?: string;
        partner_name?: string;
        partner_name2?: string;
        sandbox?: boolean;
        starter_pack_notes?: string;
        street?: string;
        telephone?: string;
        zip?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSuccess, ApiPartnerError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}`,
        operation: "putApiPartner",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete partner
     *
     * @tags default
     * @name DeleteApiPartner
     * @request DELETE:/v1/partners/{partner_guid}
     */
    deleteApiPartner: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}`,
        operation: "deleteApiPartner",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to activate partner's coupon
     *
     * @tags default
     * @name PutApiPartnerCouponActivate
     * @request PUT:/v1/partners/{partner_guid}/activate_coupon
     */
    putApiPartnerCouponActivate: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        cabopoc_test_kit_guid?: string;
        coupon_guid?: string;
        medical_test_profile_guid?: string;
        partner_appointment_guid?: string;
        vaccination_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, ApiPartnerCouponActivateError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/activate_coupon`,
        operation: "putApiPartnerCouponActivate",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner appointment types
     *
     * @tags default
     * @name GetApiPartnerAppointmentTypeList
     * @request GET:/v1/partners/{partner_guid}/appointment_types
     */
    getApiPartnerAppointmentTypeList: (
      partnerGuid: string,
      query: {
        device_guid?: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentTypeListSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointment_types`,
        operation: "getApiPartnerAppointmentTypeList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create partner appointment type
     *
     * @tags default
     * @name PostApiPartnerAppointmentTypeList
     * @request POST:/v1/partners/{partner_guid}/appointment_types
     */
    postApiPartnerAppointmentTypeList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiPartnerAppointmentTypeListPost,
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentTypeSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointment_types`,
        operation: "postApiPartnerAppointmentTypeList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner appointment type
     *
     * @tags default
     * @name GetApiPartnerAppointmentType
     * @request GET:/v1/partners/{partner_guid}/appointment_types/{partner_appointment_type_guid}
     */
    getApiPartnerAppointmentType: (
      partnerGuid: string,
      partnerAppointmentTypeGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentTypeSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointment_types/${partnerAppointmentTypeGuid}`,
        operation: "getApiPartnerAppointmentType",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner appointment type
     *
     * @tags default
     * @name PutApiPartnerAppointmentType
     * @request PUT:/v1/partners/{partner_guid}/appointment_types/{partner_appointment_type_guid}
     */
    putApiPartnerAppointmentType: (
      partnerGuid: string,
      partnerAppointmentTypeGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiPartnerAppointmentTypeListPost,
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentTypeSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointment_types/${partnerAppointmentTypeGuid}`,
        operation: "putApiPartnerAppointmentType",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete partner appointment type
     *
     * @tags default
     * @name DeleteApiPartnerAppointmentType
     * @request DELETE:/v1/partners/{partner_guid}/appointment_types/{partner_appointment_type_guid}
     */
    deleteApiPartnerAppointmentType: (
      partnerGuid: string,
      partnerAppointmentTypeGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointment_types/${partnerAppointmentTypeGuid}`,
        operation: "deleteApiPartnerAppointmentType",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to upload attachment for appointment type
     *
     * @tags default
     * @name PostApiPartnerAppointmentTypeAttachment
     * @request POST:/v1/partners/{partner_guid}/appointment_types/{partner_appointment_type_guid}/attachment
     */
    postApiPartnerAppointmentTypeAttachment: (
      partnerGuid: string,
      partnerAppointmentTypeGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        content_type: string;
      },
      data: {
        attachment: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentTypeSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointment_types/${partnerAppointmentTypeGuid}/attachment`,
        operation: "postApiPartnerAppointmentTypeAttachment",
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete attachment for appointment type
     *
     * @tags default
     * @name DeleteApiPartnerAppointmentTypeAttachment
     * @request DELETE:/v1/partners/{partner_guid}/appointment_types/{partner_appointment_type_guid}/attachment
     */
    deleteApiPartnerAppointmentTypeAttachment: (
      partnerGuid: string,
      partnerAppointmentTypeGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        attachment_url?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentTypeSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointment_types/${partnerAppointmentTypeGuid}/attachment`,
        operation: "deleteApiPartnerAppointmentTypeAttachment",
        method: "DELETE",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner appointments
     *
     * @tags default
     * @name GetApiPartnerAppointmentList
     * @request GET:/v1/partners/{partner_guid}/appointments
     */
    getApiPartnerAppointmentList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        start?: string;
        end?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentListSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments`,
        operation: "getApiPartnerAppointmentList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create partner appointment
     *
     * @tags default
     * @name PostApiPartnerAppointmentList
     * @request POST:/v1/partners/{partner_guid}/appointments
     */
    postApiPartnerAppointmentList: (
      partnerGuid: string,
      query: {
        device_guid?: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        allow_empty_email?: boolean;
        client_city?: string;
        client_dob?: string;
        client_email?: string;
        client_first_name?: string;
        client_gender?: string;
        client_insurance_company_guid?: string;
        client_insurance_number?: string;
        client_insurance_type?: string;
        client_last_name?: string;
        client_street?: string;
        client_telephone?: string;
        client_zip?: string;
        medical_test_profile_guid?: string;
        partner_appointment_type_guid?: string;
        product_guid?: string;
        start?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentSuccess, ApiPartnerAppointmentListError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments`,
        operation: "postApiPartnerAppointmentList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner appointments in ICS calendar format for subscription
     *
     * @tags default
     * @name GetApiPartnerAppointmentIcsList
     * @request GET:/v1/partners/{partner_guid}/appointments.ics
     */
    getApiPartnerAppointmentIcsList: (
      partnerGuid: string,
      query: {
        start?: string;
        end?: string;
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments.ics`,
        operation: "getApiPartnerAppointmentIcsList",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to get partner appointment
     *
     * @tags default
     * @name GetApiPartnerAppointment
     * @request GET:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}
     */
    getApiPartnerAppointment: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}`,
        operation: "getApiPartnerAppointment",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner appointment
     *
     * @tags default
     * @name PutApiPartnerAppointment
     * @request PUT:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}
     */
    putApiPartnerAppointment: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        client_dob?: string;
        client_email?: string;
        client_first_name?: string;
        client_gender?: string;
        client_last_name?: string;
        client_telephone?: string;
        end?: string;
        medical_test_profile_guid?: string;
        partner_appointment_type_guid?: string;
        product_guid?: string;
        start?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentSuccess, ApiPartnerAppointmentPutError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}`,
        operation: "putApiPartnerAppointment",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to cancel partner appointment
     *
     * @tags default
     * @name DeleteApiPartnerAppointment
     * @request DELETE:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}
     */
    deleteApiPartnerAppointment: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentSuccess, ApiPartnerAppointmentDeleteError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}`,
        operation: "deleteApiPartnerAppointment",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get answers for an appointment
     *
     * @tags default
     * @name GetApiPartnerAppointmentAnswers
     * @request GET:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}/answers
     */
    getApiPartnerAppointmentAnswers: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      query?: {
        device_guid?: string;
        client_bundle_id?: string;
        device_locale?: string;
        validation_token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentAnswersSuccess, any>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}/answers`,
        operation: "getApiPartnerAppointmentAnswers",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Replace answers for an appointment
     *
     * @tags default
     * @name PutApiPartnerAppointmentAnswers
     * @request PUT:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}/answers
     */
    putApiPartnerAppointmentAnswers: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      payload: {
        answers?: string;
        validation_token?: string;
      },
      query?: {
        device_guid?: string;
        client_bundle_id?: string;
        device_locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, any>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}/answers`,
        operation: "putApiPartnerAppointmentAnswers",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Approve a pending appointment request
     *
     * @tags default
     * @name PostApiPartnerAppointmentApprove
     * @request POST:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}/approve
     */
    postApiPartnerAppointmentApprove: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        decision_text?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}/approve`,
        operation: "postApiPartnerAppointmentApprove",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create attachment
     *
     * @tags default
     * @name PostApiPartnerAppointmentNoteAttachment
     * @request POST:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}/attachment_notes
     */
    postApiPartnerAppointmentNoteAttachment: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      query: {
        device_guid?: string;
        content_type: string;
        client_bundle_id: string;
        /** @default "de" */
        device_locale?: string;
      },
      data: {
        attachment: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentAttachmentSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}/attachment_notes`,
        operation: "postApiPartnerAppointmentNoteAttachment",
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to mark partner appointment not attended
     *
     * @tags default
     * @name PutApiPartnerAppointmentNotAttended
     * @request PUT:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}/not_attended
     */
    putApiPartnerAppointmentNotAttended: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentSuccess, ApiPartnerAppointmentNotAttendedError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}/not_attended`,
        operation: "putApiPartnerAppointmentNotAttended",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create appointment note
     *
     * @tags default
     * @name PostApiPartnerAppointmentNoteList
     * @request POST:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}/notes
     */
    postApiPartnerAppointmentNoteList: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        attachments?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}/notes`,
        operation: "postApiPartnerAppointmentNoteList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update appointment note
     *
     * @tags default
     * @name PutApiPartnerAppointmentNote
     * @request PUT:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}/notes/{partner_appointment_note_guid}
     */
    putApiPartnerAppointmentNote: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      partnerAppointmentNoteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        attachments?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentSuccess, ApiPartnerAppointmentNoteError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}/notes/${partnerAppointmentNoteGuid}`,
        operation: "putApiPartnerAppointmentNote",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete appointment note
     *
     * @tags default
     * @name DeleteApiPartnerAppointmentNote
     * @request DELETE:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}/notes/{partner_appointment_note_guid}
     */
    deleteApiPartnerAppointmentNote: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      partnerAppointmentNoteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentSuccess, ApiPartnerAppointmentNoteError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}/notes/${partnerAppointmentNoteGuid}`,
        operation: "deleteApiPartnerAppointmentNote",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to publish appointment note
     *
     * @tags default
     * @name PutApiPartnerAppointmentNotePublish
     * @request PUT:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}/notes/{partner_appointment_note_guid}/publish
     */
    putApiPartnerAppointmentNotePublish: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      partnerAppointmentNoteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentSuccess, ApiPartnerAppointmentNotePublishError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}/notes/${partnerAppointmentNoteGuid}/publish`,
        operation: "putApiPartnerAppointmentNotePublish",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Reject a pending appointment request
     *
     * @tags default
     * @name PostApiPartnerAppointmentReject
     * @request POST:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}/reject
     */
    postApiPartnerAppointmentReject: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        decision_text?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}/reject`,
        operation: "postApiPartnerAppointmentReject",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Send questionnaire link to customer (manual resend)
     *
     * @tags default
     * @name PostApiPartnerAppointmentSendQuestionnaireLink
     * @request POST:/v1/partners/{partner_guid}/appointments/{partner_appointment_guid}/send_questionnaire_link
     */
    postApiPartnerAppointmentSendQuestionnaireLink: (
      partnerGuid: string,
      partnerAppointmentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments/${partnerAppointmentGuid}/send_questionnaire_link`,
        operation: "postApiPartnerAppointmentSendQuestionnaireLink",
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner appointment available slots
     *
     * @tags default
     * @name GetApiPartnerAppointmentAvailableSlots
     * @request GET:/v1/partners/{partner_guid}/appointments/available_slots
     */
    getApiPartnerAppointmentAvailableSlots: (
      partnerGuid: string,
      query: {
        device_guid?: string;
        client_bundle_id: string;
        device_locale: string;
        partner_appointment_type_guid: string;
        /**
         * @min 0
         * @default 2
         */
        n_days?: number;
        start?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAvailableSlotListSuccess, NotFoundError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/appointments/available_slots`,
        operation: "getApiPartnerAppointmentAvailableSlots",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner blog posts
     *
     * @tags default
     * @name GetApiPartnerBlogPostList
     * @request GET:/v1/partners/{partner_guid}/blog_posts
     */
    getApiPartnerBlogPostList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlogPostListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/blog_posts`,
        operation: "getApiPartnerBlogPostList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner blog post
     *
     * @tags default
     * @name GetApiPartnerBlogPost
     * @request GET:/v1/partners/{partner_guid}/blog_posts/{blog_post_guid}
     */
    getApiPartnerBlogPost: (
      partnerGuid: string,
      blogPostGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlogPostSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/blog_posts/${blogPostGuid}`,
        operation: "getApiPartnerBlogPost",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner CaboPOC TEST_KIT products
     *
     * @tags default
     * @name GetApiPartnerCaboPocTestKitList
     * @request GET:/v1/partners/{partner_guid}/cabo-poc/test-kits
     */
    getApiPartnerCaboPocTestKitList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductSellingPriceListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/cabo-poc/test-kits`,
        operation: "getApiPartnerCaboPocTestKitList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to cancel sample
     *
     * @tags default
     * @name PutApiPartnerSampleCancel
     * @request PUT:/v1/partners/{partner_guid}/cancel_sample
     */
    putApiPartnerSampleCancel: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        adaptors?: number;
        lanzettes?: number;
        reason?: string;
        test_kit_guid?: string;
        test_sample_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleSuccess, ApiPartnerSampleCancelError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/cancel_sample`,
        operation: "putApiPartnerSampleCancel",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Change the POC test kit on an already-activated coupon
     *
     * @tags default
     * @name PutApiPartnerCouponChangePocTestKit
     * @request PUT:/v1/partners/{partner_guid}/change_poc_test_kit
     */
    putApiPartnerCouponChangePocTestKit: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        cabopoc_test_kit_guid?: string;
        coupon_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, ApiPartnerCouponChangePocTestKitError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/change_poc_test_kit`,
        operation: "putApiPartnerCouponChangePocTestKit",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Search read-only parameter data for the chat assistant (up to 20 matches)
     *
     * @tags default
     * @name GetApiPartnerChatParameterList
     * @request GET:/v1/partners/{partner_guid}/chat_parameters
     */
    getApiPartnerChatParameterList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        query: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterListSuccess, any>({
        path: `/v1/partners/${partnerGuid}/chat_parameters`,
        operation: "getApiPartnerChatParameterList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Read parameter details and FAQs for the chat assistant
     *
     * @tags default
     * @name GetApiPartnerChatParameter
     * @request GET:/v1/partners/{partner_guid}/chat_parameters/{medical_test_parameter_guid}
     */
    getApiPartnerChatParameter: (
      partnerGuid: string,
      medicalTestParameterGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestParameterSuccess, any>({
        path: `/v1/partners/${partnerGuid}/chat_parameters/${medicalTestParameterGuid}`,
        operation: "getApiPartnerChatParameter",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner chat sessions
     *
     * @tags default
     * @name GetApiPartnerChatSessionList
     * @request GET:/v1/partners/{partner_guid}/chat_sessions
     */
    getApiPartnerChatSessionList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default false */
        general_only?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatSessionListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/chat_sessions`,
        operation: "getApiPartnerChatSessionList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create partner chat session
     *
     * @tags default
     * @name PostApiPartnerChatSessionList
     * @request POST:/v1/partners/{partner_guid}/chat_sessions
     */
    postApiPartnerChatSessionList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        coupon_poc_sample_guid?: string;
        test_sample_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatSessionSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/chat_sessions`,
        operation: "postApiPartnerChatSessionList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner chat session
     *
     * @tags default
     * @name GetApiPartnerChatSession
     * @request GET:/v1/partners/{partner_guid}/chat_sessions/{chat_session_guid}
     */
    getApiPartnerChatSession: (
      partnerGuid: string,
      chatSessionGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatSessionSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/chat_sessions/${chatSessionGuid}`,
        operation: "getApiPartnerChatSession",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create partner chat session message
     *
     * @tags default
     * @name PostApiPartnerChatSessionMessage
     * @request POST:/v1/partners/{partner_guid}/chat_sessions/{chat_session_guid}/messages
     */
    postApiPartnerChatSessionMessage: (
      partnerGuid: string,
      chatSessionGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        from?: string;
        message?: string;
        metadata?: string;
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatSessionSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/chat_sessions/${chatSessionGuid}/messages`,
        operation: "postApiPartnerChatSessionMessage",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to check partner coupon
     *
     * @tags default
     * @name GetApiPartnerCouponCheck
     * @request GET:/v1/partners/{partner_guid}/check_coupon
     */
    getApiPartnerCouponCheck: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        code: string;
        pin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, ApiPartnerCouponCheckError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/check_coupon`,
        operation: "getApiPartnerCouponCheck",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to collect sample
     *
     * @tags default
     * @name PutApiPartnerCollectSample
     * @request PUT:/v1/partners/{partner_guid}/collect_sample
     */
    putApiPartnerCollectSample: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        adaptors?: number;
        collection?: string;
        lanzettes?: number;
        test_kit_guid?: string;
        test_sample_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerCollectSampleError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/collect_sample`,
        operation: "putApiPartnerCollectSample",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get partner contracts
     *
     * @tags default
     * @name GetApiPartnerContractList
     * @request GET:/v1/partners/{partner_guid}/contracts
     */
    getApiPartnerContractList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        active_only?: boolean;
        product_type?: string;
        offset?: number;
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerContractListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/contracts`,
        operation: "getApiPartnerContractList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create partner contract
     *
     * @tags default
     * @name PostApiPartnerContractList
     * @request POST:/v1/partners/{partner_guid}/contracts
     */
    postApiPartnerContractList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        i_contract_template?: number;
        start_date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerContractSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/contracts`,
        operation: "postApiPartnerContractList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get partner contract
     *
     * @tags default
     * @name GetApiPartnerContract
     * @request GET:/v1/partners/{partner_guid}/contracts/{partner_contract_guid}
     */
    getApiPartnerContract: (
      partnerGuid: string,
      partnerContractGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerContractSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/contracts/${partnerContractGuid}`,
        operation: "getApiPartnerContract",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update partner contract
     *
     * @tags default
     * @name PutApiPartnerContract
     * @request PUT:/v1/partners/{partner_guid}/contracts/{partner_contract_guid}
     */
    putApiPartnerContract: (
      partnerGuid: string,
      partnerContractGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        end_date?: string;
        start_date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerContractSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/contracts/${partnerContractGuid}`,
        operation: "putApiPartnerContract",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete partner contract
     *
     * @tags default
     * @name DeleteApiPartnerContract
     * @request DELETE:/v1/partners/{partner_guid}/contracts/{partner_contract_guid}
     */
    deleteApiPartnerContract: (
      partnerGuid: string,
      partnerContractGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerContractSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/contracts/${partnerContractGuid}`,
        operation: "deleteApiPartnerContract",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Resend contract acceptance email
     *
     * @tags default
     * @name PostApiPartnerContractResendAcceptance
     * @request POST:/v1/partners/{partner_guid}/contracts/{partner_contract_guid}/resend-acceptance
     */
    postApiPartnerContractResendAcceptance: (
      partnerGuid: string,
      partnerContractGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/contracts/${partnerContractGuid}/resend-acceptance`,
        operation: "postApiPartnerContractResendAcceptance",
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to copy setup and stock data from one partner to a new empty partner
     *
     * @tags default
     * @name PostApiPartnerCopyData
     * @request POST:/v1/partners/{partner_guid}/copy-data
     */
    postApiPartnerCopyData: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        copy_equipment_stock?: boolean;
        copy_medical_test_profiles?: boolean;
        copy_partner_landing?: boolean;
        copy_product_inventory?: boolean;
        copy_product_selling_prices?: boolean;
        source_partner_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerCopyDataResultSuccess, ApiPartnerCopyDataError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/copy-data`,
        operation: "postApiPartnerCopyData",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner CaboPOC samples
     *
     * @tags default
     * @name GetApiPartnerCouponPocSampleList
     * @request GET:/v1/partners/{partner_guid}/coupon_poc_samples
     */
    getApiPartnerCouponPocSampleList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerCouponPocSampleListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/coupon_poc_samples`,
        operation: "getApiPartnerCouponPocSampleList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get one partner CaboPOC sample
     *
     * @tags default
     * @name GetApiPartnerCouponPocSample
     * @request GET:/v1/partners/{partner_guid}/coupon_poc_samples/{coupon_poc_sample_guid}
     */
    getApiPartnerCouponPocSample: (
      partnerGuid: string,
      couponPocSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerCouponPocSampleSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/coupon_poc_samples/${couponPocSampleGuid}`,
        operation: "getApiPartnerCouponPocSample",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Cancel a pending CaboPOC sample (Stornieren). Pass test_kit_available=true to restore the test kit back into inventory.
     *
     * @tags default
     * @name PostApiPartnerCouponPocSampleCancel
     * @request POST:/v1/partners/{partner_guid}/coupon_poc_samples/{coupon_poc_sample_guid}/cancel
     */
    postApiPartnerCouponPocSampleCancel: (
      partnerGuid: string,
      couponPocSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiPartnerCouponPocSampleCancelRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartnerCouponPocSampleSuccess, ApiPartnerCouponPocSampleCancelError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/coupon_poc_samples/${couponPocSampleGuid}/cancel`,
        operation: "postApiPartnerCouponPocSampleCancel",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to set CaboPOC result value
     *
     * @tags default
     * @name PutApiPartnerCouponPocSampleResult
     * @request PUT:/v1/partners/{partner_guid}/coupon_poc_samples/{coupon_poc_sample_guid}/result
     */
    putApiPartnerCouponPocSampleResult: (
      partnerGuid: string,
      couponPocSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: CouponPocSampleResultUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, ApiPartnerCouponPocSampleResultError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/coupon_poc_samples/${couponPocSampleGuid}/result`,
        operation: "putApiPartnerCouponPocSampleResult",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner CaboPOC sample result pdf
     *
     * @tags default
     * @name GetApiPartnerCouponPocSampleResultPdf
     * @request GET:/v1/partners/{partner_guid}/coupon_poc_samples/{coupon_poc_sample_guid}/result_pdf
     */
    getApiPartnerCouponPocSampleResultPdf: (
      partnerGuid: string,
      couponPocSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiPartnerCouponPocSampleResultPdfError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/coupon_poc_samples/${couponPocSampleGuid}/result_pdf`,
        operation: "getApiPartnerCouponPocSampleResultPdf",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to set CaboPOC test kit number
     *
     * @tags default
     * @name PutApiPartnerCouponPocSampleTestKitNumber
     * @request PUT:/v1/partners/{partner_guid}/coupon_poc_samples/{coupon_poc_sample_guid}/test_kit_number
     */
    putApiPartnerCouponPocSampleTestKitNumber: (
      partnerGuid: string,
      couponPocSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        test_kit_number?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, ApiPartnerCouponPocSampleTestKitNumberError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/coupon_poc_samples/${couponPocSampleGuid}/test_kit_number`,
        operation: "putApiPartnerCouponPocSampleTestKitNumber",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Mark a CaboPOC sample test as started
     *
     * @tags default
     * @name PostApiPartnerCouponPocSampleTestStarted
     * @request POST:/v1/partners/{partner_guid}/coupon_poc_samples/{coupon_poc_sample_guid}/test_started
     */
    postApiPartnerCouponPocSampleTestStarted: (
      partnerGuid: string,
      couponPocSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PartnerCouponPocSampleSuccess,
        ApiPartnerCouponPocSampleTestStartedError | AuthError | ForbiddenError
      >({
        path: `/v1/partners/${partnerGuid}/coupon_poc_samples/${couponPocSampleGuid}/test_started`,
        operation: "postApiPartnerCouponPocSampleTestStarted",
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all vaccinations for a coupon
     *
     * @tags default
     * @name GetApiPartnerCouponVaccinationList
     * @summary Get all vaccinations for a coupon
     * @request GET:/v1/partners/{partner_guid}/coupon_vaccinations
     */
    getApiPartnerCouponVaccinationList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        coupon_code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponVaccinationListSuccess, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/partners/${partnerGuid}/coupon_vaccinations`,
        operation: "getApiPartnerCouponVaccinationList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all vaccinations for a partner
     *
     * @tags default
     * @name GetApiPartnerCouponVaccinations
     * @summary Get all vaccinations for a partner
     * @request GET:/v1/partners/{partner_guid}/coupon_vaccinations_all
     */
    getApiPartnerCouponVaccinations: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerCouponVaccinationListSuccess, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/partners/${partnerGuid}/coupon_vaccinations_all`,
        operation: "getApiPartnerCouponVaccinations",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get detailed coupon vaccination with patient form and answers
     *
     * @tags default
     * @name GetApiPartnerCouponVaccinationDetail
     * @summary Get detailed coupon vaccination information
     * @request GET:/v1/partners/{partner_guid}/coupon_vaccinations/{coupon_vaccination_guid}
     */
    getApiPartnerCouponVaccinationDetail: (
      partnerGuid: string,
      couponVaccinationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponVaccinationDetailSuccess, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/partners/${partnerGuid}/coupon_vaccinations/${couponVaccinationGuid}`,
        operation: "getApiPartnerCouponVaccinationDetail",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get answers for a coupon vaccination
     *
     * @tags default
     * @name GetApiPartnerCouponVaccinationAnswers
     * @summary Get answers for a coupon vaccination
     * @request GET:/v1/partners/{partner_guid}/coupon_vaccinations/{coupon_vaccination_guid}/answers
     */
    getApiPartnerCouponVaccinationAnswers: (
      partnerGuid: string,
      couponVaccinationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentAnswersSuccess, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/partners/${partnerGuid}/coupon_vaccinations/${couponVaccinationGuid}/answers`,
        operation: "getApiPartnerCouponVaccinationAnswers",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Replace answers for a coupon vaccination
     *
     * @tags default
     * @name PutApiPartnerCouponVaccinationAnswers
     * @summary Replace answers for a coupon vaccination
     * @request PUT:/v1/partners/{partner_guid}/coupon_vaccinations/{coupon_vaccination_guid}/answers
     */
    putApiPartnerCouponVaccinationAnswers: (
      partnerGuid: string,
      couponVaccinationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        answers?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/partners/${partnerGuid}/coupon_vaccinations/${couponVaccinationGuid}/answers`,
        operation: "putApiPartnerCouponVaccinationAnswers",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Complete a coupon vaccination
     *
     * @tags default
     * @name PutApiPartnerCouponVaccinationComplete
     * @summary Complete a coupon vaccination (mark as done)
     * @request PUT:/v1/partners/{partner_guid}/coupon_vaccinations/{coupon_vaccination_guid}/complete
     */
    putApiPartnerCouponVaccinationComplete: (
      partnerGuid: string,
      couponVaccinationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        administration_site?: string;
        batch_number?: string;
        indication?: string;
        performing_user_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponVaccinationSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/coupon_vaccinations/${couponVaccinationGuid}/complete`,
        operation: "putApiPartnerCouponVaccinationComplete",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Send vaccination form link to patient via email
     *
     * @tags default
     * @name PostApiPartnerCouponVaccinationFormEmail
     * @request POST:/v1/partners/{partner_guid}/coupon_vaccinations/{coupon_vaccination_guid}/form/email
     */
    postApiPartnerCouponVaccinationFormEmail: (
      partnerGuid: string,
      couponVaccinationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        form_type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/coupon_vaccinations/${couponVaccinationGuid}/form/email`,
        operation: "postApiPartnerCouponVaccinationFormEmail",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get vaccination certificate PDF
     *
     * @tags default
     * @name GetApiPartnerCouponVaccinationPdf
     * @summary Download vaccination certificate PDF
     * @request GET:/v1/partners/{partner_guid}/coupon_vaccinations/{coupon_vaccination_guid}/pdf
     */
    getApiPartnerCouponVaccinationPdf: (
      partnerGuid: string,
      couponVaccinationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/partners/${partnerGuid}/coupon_vaccinations/${couponVaccinationGuid}/pdf`,
        operation: "getApiPartnerCouponVaccinationPdf",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Email vaccination certificate to patient
     *
     * @tags default
     * @name PostApiPartnerCouponVaccinationPdfEmail
     * @summary Send vaccination certificate via email (queues Celery task)
     * @request POST:/v1/partners/{partner_guid}/coupon_vaccinations/{coupon_vaccination_guid}/pdf/email
     */
    postApiPartnerCouponVaccinationPdfEmail: (
      partnerGuid: string,
      couponVaccinationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/coupon_vaccinations/${couponVaccinationGuid}/pdf/email`,
        operation: "postApiPartnerCouponVaccinationPdfEmail",
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to update coupon's email
     *
     * @tags default
     * @name PutApiPartnerCouponEmail
     * @request PUT:/v1/partners/{partner_guid}/coupons/{coupon_guid}/email
     */
    putApiPartnerCouponEmail: (
      partnerGuid: string,
      couponGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        pin: string;
      },
      payload: {
        new_email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, ApiPartnerCouponEmailError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/coupons/${couponGuid}/email`,
        operation: "putApiPartnerCouponEmail",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to submit patient details form responses
     *
     * @tags default
     * @name PutApiPartnerCouponPatientDetailForm
     * @request PUT:/v1/partners/{partner_guid}/coupons/{coupon_guid}/patient_details
     */
    putApiPartnerCouponPatientDetailForm: (
      partnerGuid: string,
      couponGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        responses?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, ApiPartnerCouponPatientDetailFormError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/coupons/${couponGuid}/patient_details`,
        operation: "putApiPartnerCouponPatientDetailForm",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to request results sharing
     *
     * @tags default
     * @name PostApiPartnerCouponSharingRequest
     * @request POST:/v1/partners/{partner_guid}/coupons/{coupon_guid}/sharing_request
     */
    postApiPartnerCouponSharingRequest: (
      partnerGuid: string,
      couponGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Success,
        ApiPartnerCouponSharingRequestError | AuthError | ForbiddenError | ApiPartnerCouponSharingRequestEmailError
      >({
        path: `/v1/partners/${partnerGuid}/coupons/${couponGuid}/sharing_request`,
        operation: "postApiPartnerCouponSharingRequest",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name PostApiPartnerTestExecutionConsentFormEmail
     * @request POST:/v1/partners/{partner_guid}/coupons/{coupon_guid}/test_execution_consent/form/email
     */
    postApiPartnerTestExecutionConsentFormEmail: (
      partnerGuid: string,
      couponGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/partners/${partnerGuid}/coupons/${couponGuid}/test_execution_consent/form/email`,
        operation: "postApiPartnerTestExecutionConsentFormEmail",
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name GetApiPartnerTestExecutionConsentPdf
     * @request GET:/v1/partners/{partner_guid}/coupons/{coupon_guid}/test_execution_consent/pdf
     */
    getApiPartnerTestExecutionConsentPdf: (
      partnerGuid: string,
      couponGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, AuthError>({
        path: `/v1/partners/${partnerGuid}/coupons/${couponGuid}/test_execution_consent/pdf`,
        operation: "getApiPartnerTestExecutionConsentPdf",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name PostApiPartnerTestExecutionConsentPdf
     * @request POST:/v1/partners/{partner_guid}/coupons/{coupon_guid}/test_execution_consent/pdf
     */
    postApiPartnerTestExecutionConsentPdf: (
      partnerGuid: string,
      couponGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      data: {
        document: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, AuthError>({
        path: `/v1/partners/${partnerGuid}/coupons/${couponGuid}/test_execution_consent/pdf`,
        operation: "postApiPartnerTestExecutionConsentPdf",
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name PostApiPartnerTestExecutionConsentPdfEmail
     * @request POST:/v1/partners/{partner_guid}/coupons/{coupon_guid}/test_execution_consent/pdf/email
     */
    postApiPartnerTestExecutionConsentPdfEmail: (
      partnerGuid: string,
      couponGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/partners/${partnerGuid}/coupons/${couponGuid}/test_execution_consent/pdf/email`,
        operation: "postApiPartnerTestExecutionConsentPdfEmail",
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to search partner's customers
     *
     * @tags default
     * @name GetApiPartnerCustomerSearch
     * @request GET:/v1/partners/{partner_guid}/customers/search
     */
    getApiPartnerCustomerSearch: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        dob: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/customers/search`,
        operation: "getApiPartnerCustomerSearch",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner devices
     *
     * @tags default
     * @name GetApiPartnerDeviceList
     * @request GET:/v1/partners/{partner_guid}/devices
     */
    getApiPartnerDeviceList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerDeviceListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/devices`,
        operation: "getApiPartnerDeviceList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner device
     *
     * @tags default
     * @name PutApiPartnerDevice
     * @request PUT:/v1/partners/{partner_guid}/devices/{partner_device_guid}
     */
    putApiPartnerDevice: (
      partnerGuid: string,
      partnerDeviceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/devices/${partnerDeviceGuid}`,
        operation: "putApiPartnerDevice",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete partner device
     *
     * @tags default
     * @name DeleteApiPartnerDevice
     * @request DELETE:/v1/partners/{partner_guid}/devices/{partner_device_guid}
     */
    deleteApiPartnerDevice: (
      partnerGuid: string,
      partnerDeviceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/devices/${partnerDeviceGuid}`,
        operation: "deleteApiPartnerDevice",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to discard test kit
     *
     * @tags default
     * @name PutApiPartnerDiscardTestKit
     * @request PUT:/v1/partners/{partner_guid}/discard_test_kit
     */
    putApiPartnerDiscardTestKit: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        adaptors?: number;
        lanzettes?: number;
        test_kit_guid?: string;
        test_sample_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerDiscardTestKitError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/discard_test_kit`,
        operation: "putApiPartnerDiscardTestKit",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner equipment stock
     *
     * @tags default
     * @name GetApiPartnerEquipmentStock
     * @request GET:/v1/partners/{partner_guid}/equipment_stock
     */
    getApiPartnerEquipmentStock: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default false */
        include_untracked?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerEquipmentStockSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/equipment_stock`,
        operation: "getApiPartnerEquipmentStock",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get equipment stock requests
     *
     * @tags default
     * @name GetApiPartnerEquipmentStockRequestList
     * @request GET:/v1/partners/{partner_guid}/equipment_stock_requests
     */
    getApiPartnerEquipmentStockRequestList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerEquipmentStockRequestListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/equipment_stock_requests`,
        operation: "getApiPartnerEquipmentStockRequestList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create partner equipment stock request
     *
     * @tags default
     * @name PostApiPartnerEquipmentStockRequestList
     * @request POST:/v1/partners/{partner_guid}/equipment_stock_requests
     */
    postApiPartnerEquipmentStockRequestList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiPartnerEquipmentStockRequestListPost,
      params: RequestParams = {},
    ) =>
      this.request<PartnerEquipmentStockRequestSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/equipment_stock_requests`,
        operation: "postApiPartnerEquipmentStockRequestList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner equipment stock request
     *
     * @tags default
     * @name PutApiPartnerEquipmentStockRequestList
     * @request PUT:/v1/partners/{partner_guid}/equipment_stock_requests
     */
    putApiPartnerEquipmentStockRequestList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiPartnerEquipmentStockRequestListPut,
      params: RequestParams = {},
    ) =>
      this.request<PartnerEquipmentStockRequestSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/equipment_stock_requests`,
        operation: "putApiPartnerEquipmentStockRequestList",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete partner equipment stock request
     *
     * @tags default
     * @name DeleteApiPartnerEquipmentStockRequestList
     * @request DELETE:/v1/partners/{partner_guid}/equipment_stock_requests
     */
    deleteApiPartnerEquipmentStockRequestList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/equipment_stock_requests`,
        operation: "deleteApiPartnerEquipmentStockRequestList",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner equipment stock request
     *
     * @tags default
     * @name GetApiPartnerEquipmentStockRequest
     * @request GET:/v1/partners/{partner_guid}/equipment_stock_requests/{partner_equipment_stock_request_guid}
     */
    getApiPartnerEquipmentStockRequest: (
      partnerGuid: string,
      partnerEquipmentStockRequestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerEquipmentStockRequestSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/equipment_stock_requests/${partnerEquipmentStockRequestGuid}`,
        operation: "getApiPartnerEquipmentStockRequest",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner equipment stock request
     *
     * @tags default
     * @name PutApiPartnerEquipmentStockRequest
     * @request PUT:/v1/partners/{partner_guid}/equipment_stock_requests/{partner_equipment_stock_request_guid}
     */
    putApiPartnerEquipmentStockRequest: (
      partnerGuid: string,
      partnerEquipmentStockRequestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        notes?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerEquipmentStockRequestSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/equipment_stock_requests/${partnerEquipmentStockRequestGuid}`,
        operation: "putApiPartnerEquipmentStockRequest",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner equipment stock request items
     *
     * @tags default
     * @name PostApiPartnerEquipmentStockRequestItem
     * @request POST:/v1/partners/{partner_guid}/equipment_stock_requests/{partner_equipment_stock_request_guid}/items
     */
    postApiPartnerEquipmentStockRequestItem: (
      partnerGuid: string,
      partnerEquipmentStockRequestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        amount?: number;
        i_equipment_sku?: number;
        info?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PartnerEquipmentStockRequestSuccess,
        ApiPartnerEquipmentStockRequestItemError | AuthError | ForbiddenError
      >({
        path: `/v1/partners/${partnerGuid}/equipment_stock_requests/${partnerEquipmentStockRequestGuid}/items`,
        operation: "postApiPartnerEquipmentStockRequestItem",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner equipment stock request items
     *
     * @tags default
     * @name PutApiPartnerEquipmentStockRequestItem
     * @request PUT:/v1/partners/{partner_guid}/equipment_stock_requests/{partner_equipment_stock_request_guid}/items
     */
    putApiPartnerEquipmentStockRequestItem: (
      partnerGuid: string,
      partnerEquipmentStockRequestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        amount?: number;
        i_equipment_sku?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PartnerEquipmentStockRequestSuccess,
        ApiPartnerEquipmentStockRequestItemError | AuthError | ForbiddenError
      >({
        path: `/v1/partners/${partnerGuid}/equipment_stock_requests/${partnerEquipmentStockRequestGuid}/items`,
        operation: "putApiPartnerEquipmentStockRequestItem",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to remove partner equipment stock request items
     *
     * @tags default
     * @name DeleteApiPartnerEquipmentStockRequestItem
     * @request DELETE:/v1/partners/{partner_guid}/equipment_stock_requests/{partner_equipment_stock_request_guid}/items
     */
    deleteApiPartnerEquipmentStockRequestItem: (
      partnerGuid: string,
      partnerEquipmentStockRequestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        i_equipment_sku?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        PartnerEquipmentStockRequestSuccess,
        ApiPartnerEquipmentStockRequestItemError | AuthError | ForbiddenError
      >({
        path: `/v1/partners/${partnerGuid}/equipment_stock_requests/${partnerEquipmentStockRequestGuid}/items`,
        operation: "deleteApiPartnerEquipmentStockRequestItem",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner equipment stock request items by threshold
     *
     * @tags default
     * @name PutApiPartnerEquipmentStockRequestUpdateThresholds
     * @request PUT:/v1/partners/{partner_guid}/equipment_stock_requests/{partner_equipment_stock_request_guid}/update_thresholds
     */
    putApiPartnerEquipmentStockRequestUpdateThresholds: (
      partnerGuid: string,
      partnerEquipmentStockRequestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerEquipmentStockRequestSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/equipment_stock_requests/${partnerEquipmentStockRequestGuid}/update_thresholds`,
        operation: "putApiPartnerEquipmentStockRequestUpdateThresholds",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to batch update partner equipment stock
     *
     * @tags default
     * @name PostApiPartnerEquipmentStockBatchUpdate
     * @request POST:/v1/partners/{partner_guid}/equipment_stock/batch_update
     */
    postApiPartnerEquipmentStockBatchUpdate: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiPartnerEquipmentStockBatchUpdatePost,
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerEquipmentStockBatchUpdateError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/equipment_stock/batch_update`,
        operation: "postApiPartnerEquipmentStockBatchUpdate",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create partner equipment stock movement
     *
     * @tags default
     * @name PostApiPartnerEquipmentStockMovement
     * @request POST:/v1/partners/{partner_guid}/equipment_stock/movements
     */
    postApiPartnerEquipmentStockMovement: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        amount?: number;
        i_equipment_sku?: number;
        notes?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/equipment_stock/movements`,
        operation: "postApiPartnerEquipmentStockMovement",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner equipment stock movement note
     *
     * @tags default
     * @name PutApiPartnerEquipmentStockMovementNote
     * @request PUT:/v1/partners/{partner_guid}/equipment_stock/movements/{id}
     */
    putApiPartnerEquipmentStockMovementNote: (
      partnerGuid: string,
      id: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        notes?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/equipment_stock/movements/${id}`,
        operation: "putApiPartnerEquipmentStockMovementNote",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner header stats
     *
     * @tags default
     * @name GetApiPartnerHeaderStats
     * @request GET:/v1/partners/{partner_guid}/header_stats
     */
    getApiPartnerHeaderStats: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerHeaderStatsSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/header_stats`,
        operation: "getApiPartnerHeaderStats",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner invoice email
     *
     * @tags default
     * @name PutApiPartnerInvoiceEmail
     * @request PUT:/v1/partners/{partner_guid}/invoice_email
     */
    putApiPartnerInvoiceEmail: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        invoice_email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoice_email`,
        operation: "putApiPartnerInvoiceEmail",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner invoice items
     *
     * @tags default
     * @name GetApiPartnerInvoiceItemList
     * @request GET:/v1/partners/{partner_guid}/invoice_items
     */
    getApiPartnerInvoiceItemList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        start?: string;
        end?: string;
        item_type?: "both" | "medical_profile" | "vaccination";
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceItemListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoice_items`,
        operation: "getApiPartnerInvoiceItemList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner invoices
     *
     * @tags default
     * @name GetApiPartnerInvoiceList
     * @request GET:/v1/partners/{partner_guid}/invoices
     */
    getApiPartnerInvoiceList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices`,
        operation: "getApiPartnerInvoiceList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner invoice
     *
     * @tags default
     * @name GetApiPartnerInvoice
     * @request GET:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}
     */
    getApiPartnerInvoice: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}`,
        operation: "getApiPartnerInvoice",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to approve partner invoice
     *
     * @tags default
     * @name PutApiPartnerInvoiceApprove
     * @request PUT:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/approve
     */
    putApiPartnerInvoiceApprove: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceSuccess, ApiPartnerInvoiceApproveError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/approve`,
        operation: "putApiPartnerInvoiceApprove",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to cancel partner invoice
     *
     * @tags default
     * @name PutApiPartnerInvoiceCancel
     * @request PUT:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/cancel
     */
    putApiPartnerInvoiceCancel: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceSuccess, ApiPartnerInvoiceCancelError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/cancel`,
        operation: "putApiPartnerInvoiceCancel",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner invoice item
     *
     * @tags default
     * @name PutApiPartnerInvoiceItem
     * @request PUT:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/items/{partner_invoice_item_guid}
     */
    putApiPartnerInvoiceItem: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      partnerInvoiceItemGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        discount?: number;
        discount_reason?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceSuccess, ApiPartnerInvoiceItemError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/items/${partnerInvoiceItemGuid}`,
        operation: "putApiPartnerInvoiceItem",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create partner invoice note
     *
     * @tags default
     * @name PostApiPartnerInvoiceNoteList
     * @request POST:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/notes
     */
    postApiPartnerInvoiceNoteList: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        attachments?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/notes`,
        operation: "postApiPartnerInvoiceNoteList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner invoice note
     *
     * @tags default
     * @name PutApiPartnerInvoiceNote
     * @request PUT:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/notes/{partner_invoice_note_guid}
     */
    putApiPartnerInvoiceNote: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      partnerInvoiceNoteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        attachments?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/notes/${partnerInvoiceNoteGuid}`,
        operation: "putApiPartnerInvoiceNote",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete partner invoice note
     *
     * @tags default
     * @name DeleteApiPartnerInvoiceNote
     * @request DELETE:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/notes/{partner_invoice_note_guid}
     */
    deleteApiPartnerInvoiceNote: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      partnerInvoiceNoteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/notes/${partnerInvoiceNoteGuid}`,
        operation: "deleteApiPartnerInvoiceNote",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to mark partner invoice as paid
     *
     * @tags default
     * @name PutApiPartnerInvoicePay
     * @request PUT:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/pay
     */
    putApiPartnerInvoicePay: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        paid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceSuccess, ApiPartnerInvoicePayError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/pay`,
        operation: "putApiPartnerInvoicePay",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner invoice pdf
     *
     * @tags default
     * @name GetApiPartnerInvoicePdf
     * @request GET:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/pdf
     */
    getApiPartnerInvoicePdf: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default false */
        view_only?: boolean;
        invoice_number?: number;
        cache_bust?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiPartnerInvoicePdfGetError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/pdf`,
        operation: "getApiPartnerInvoicePdf",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to update partner invoice pdf
     *
     * @tags default
     * @name PutApiPartnerInvoicePdf
     * @request PUT:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/pdf
     */
    putApiPartnerInvoicePdf: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiPartnerInvoicePdfPutError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/pdf`,
        operation: "putApiPartnerInvoicePdf",
        method: "PUT",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to regenerate one sent partner invoice pdf
     *
     * @tags default
     * @name PutApiPartnerInvoiceRegeneratePdf
     * @request PUT:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/pdf/regenerate
     */
    putApiPartnerInvoiceRegeneratePdf: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerInvoiceRegeneratePdfError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/pdf/regenerate`,
        operation: "putApiPartnerInvoiceRegeneratePdf",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to send reminder for partner invoice
     *
     * @tags default
     * @name PutApiPartnerInvoiceReminder
     * @request PUT:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/reminder
     */
    putApiPartnerInvoiceReminder: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceSuccess, ApiPartnerInvoiceReminderError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/reminder`,
        operation: "putApiPartnerInvoiceReminder",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to resend one partner invoice
     *
     * @tags default
     * @name PutApiPartnerInvoiceResend
     * @request PUT:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/resend
     */
    putApiPartnerInvoiceResend: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerInvoiceResendError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/resend`,
        operation: "putApiPartnerInvoiceResend",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Close accounting review of existing invoice disputes without changing settlement dates
     *
     * @tags default
     * @name PutApiPartnerInvoiceResolvePaymentReview
     * @request PUT:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/resolve_payment_review
     */
    putApiPartnerInvoiceResolvePaymentReview: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/resolve_payment_review`,
        operation: "putApiPartnerInvoiceResolvePaymentReview",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to send one partner invoice
     *
     * @tags default
     * @name PutApiPartnerInvoiceSend
     * @request PUT:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/send
     */
    putApiPartnerInvoiceSend: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        subject_prefix?: string;
        test_email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerInvoiceSuccess, ApiPartnerInvoiceSendError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/send`,
        operation: "putApiPartnerInvoiceSend",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create or retry a partner invoice Stripe SEPA payment intent
     *
     * @tags default
     * @name PutApiPartnerInvoiceStripeIntent
     * @request PUT:/v1/partners/{partner_guid}/invoices/{partner_invoice_guid}/stripe_intent
     */
    putApiPartnerInvoiceStripeIntent: (
      partnerGuid: string,
      partnerInvoiceGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerInvoiceStripeIntentError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/invoices/${partnerInvoiceGuid}/stripe_intent`,
        operation: "putApiPartnerInvoiceStripeIntent",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner landing
     *
     * @tags default
     * @name GetApiPartnerLanding
     * @request GET:/v1/partners/{partner_guid}/landing
     */
    getApiPartnerLanding: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerLandingSuccess, NotFoundError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/landing`,
        operation: "getApiPartnerLanding",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner landing
     *
     * @tags default
     * @name PutApiPartnerLanding
     * @request PUT:/v1/partners/{partner_guid}/landing
     */
    putApiPartnerLanding: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        email?: string;
        hero_subtitle?: string;
        hide_pharmacy_name?: boolean;
        iframe?: string;
        opening_time?: string;
        primary_color?: string;
        secondary_color?: string;
        show_iframe_as_url?: boolean;
        telephone?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerLandingSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/landing`,
        operation: "putApiPartnerLanding",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner landing image
     *
     * @tags default
     * @name PutApiPartnerLandingImage
     * @request PUT:/v1/partners/{partner_guid}/landing/image
     */
    putApiPartnerLandingImage: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      data: {
        image: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerLandingSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/landing/image`,
        operation: "putApiPartnerLandingImage",
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner landing logo
     *
     * @tags default
     * @name PutApiPartnerLandingLogo
     * @request PUT:/v1/partners/{partner_guid}/landing/logo
     */
    putApiPartnerLandingLogo: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      data: {
        image: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerLandingSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/landing/logo`,
        operation: "putApiPartnerLandingLogo",
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner's medical test profiles
     *
     * @tags default
     * @name GetApiPartnerMedicalTestProfileList
     * @request GET:/v1/partners/{partner_guid}/medical_test_profiles
     */
    getApiPartnerMedicalTestProfileList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /**
         * summary: names/prices/parameters; ordering: also tests/forms/usage; details: also parameter FAQs and tags
         * @default "details"
         */
        view?: "details" | "ordering" | "summary";
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/medical_test_profiles`,
        operation: "getApiPartnerMedicalTestProfileList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get one partner medical test profile with details
     *
     * @tags default
     * @name GetApiPartnerMedicalTestProfile
     * @request GET:/v1/partners/{partner_guid}/medical_test_profiles/{medical_test_profile_guid}
     */
    getApiPartnerMedicalTestProfile: (
      partnerGuid: string,
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, NotFoundError | AuthError>({
        path: `/v1/partners/${partnerGuid}/medical_test_profiles/${medicalTestProfileGuid}`,
        operation: "getApiPartnerMedicalTestProfile",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner's medical test profile
     *
     * @tags default
     * @name PutApiPartnerMedicalTestProfile
     * @request PUT:/v1/partners/{partner_guid}/medical_test_profiles/{medical_test_profile_guid}
     */
    putApiPartnerMedicalTestProfile: (
      partnerGuid: string,
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        enabled?: boolean;
        enabled_for_microsite?: boolean;
        name?: string;
        selling_price?: number;
        sort?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MedicalTestProfileSuccess, ApiPartnerMedicalTestProfileError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/medical_test_profiles/${medicalTestProfileGuid}`,
        operation: "putApiPartnerMedicalTestProfile",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete partner's medical test profile
     *
     * @tags default
     * @name DeleteApiPartnerMedicalTestProfile
     * @request DELETE:/v1/partners/{partner_guid}/medical_test_profiles/{medical_test_profile_guid}
     */
    deleteApiPartnerMedicalTestProfile: (
      partnerGuid: string,
      medicalTestProfileGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerMedicalTestProfileDeleteError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/medical_test_profiles/${medicalTestProfileGuid}`,
        operation: "deleteApiPartnerMedicalTestProfile",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create partner note
     *
     * @tags default
     * @name PostApiPartnerNoteList
     * @request POST:/v1/partners/{partner_guid}/notes
     */
    postApiPartnerNoteList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        attachments?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/notes`,
        operation: "postApiPartnerNoteList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner note
     *
     * @tags default
     * @name PutApiPartnerNote
     * @request PUT:/v1/partners/{partner_guid}/notes/{partner_note_guid}
     */
    putApiPartnerNote: (
      partnerGuid: string,
      partnerNoteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        attachments?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/notes/${partnerNoteGuid}`,
        operation: "putApiPartnerNote",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete partner note
     *
     * @tags default
     * @name DeleteApiPartnerNote
     * @request DELETE:/v1/partners/{partner_guid}/notes/{partner_note_guid}
     */
    deleteApiPartnerNote: (
      partnerGuid: string,
      partnerNoteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/notes/${partnerNoteGuid}`,
        operation: "deleteApiPartnerNote",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name GetApiPartnerOwnershipTransfer
     * @request GET:/v1/partners/{partner_guid}/ownership-transfer
     */
    getApiPartnerOwnershipTransfer: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerOwnershipTransferStatusSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/ownership-transfer`,
        operation: "getApiPartnerOwnershipTransfer",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name PostApiPartnerOwnershipTransfer
     * @request POST:/v1/partners/{partner_guid}/ownership-transfer
     */
    postApiPartnerOwnershipTransfer: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        email?: string;
        owner_guid?: string;
        user_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, PartnerOwnershipTransferError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/ownership-transfer`,
        operation: "postApiPartnerOwnershipTransfer",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name DeleteApiPartnerOwnershipTransfer
     * @request DELETE:/v1/partners/{partner_guid}/ownership-transfer
     */
    deleteApiPartnerOwnershipTransfer: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        transfer_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/ownership-transfer`,
        operation: "deleteApiPartnerOwnershipTransfer",
        method: "DELETE",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to pack sample
     *
     * @tags default
     * @name PutApiPartnerSamplePack
     * @request PUT:/v1/partners/{partner_guid}/pack_sample
     */
    putApiPartnerSamplePack: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        test_sample_guid?: string;
        test_sample_shipment_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerSamplePackError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/pack_sample`,
        operation: "putApiPartnerSamplePack",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List a partner's patients
     *
     * @tags default
     * @name GetApiPartnerPatientList
     * @request GET:/v1/partners/{partner_guid}/patients
     */
    getApiPartnerPatientList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        search_query?: string;
        /** @default 0 */
        offset?: number;
        /** @default 50 */
        limit?: number;
        /** @default "last_name" */
        sort_field?: "birth_year" | "first_name" | "last_name" | "last_test_at";
        /** @default "ASC" */
        sort_direction?: "asc" | "ASC" | "desc" | "DESC";
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPatientListSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/patients`,
        operation: "getApiPartnerPatientList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a partner patient
     *
     * @tags default
     * @name GetApiPartnerPatient
     * @request GET:/v1/partners/{partner_guid}/patients/{patient_guid}
     */
    getApiPartnerPatient: (
      partnerGuid: string,
      patientGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPatientSuccess, any>({
        path: `/v1/partners/${partnerGuid}/patients/${patientGuid}`,
        operation: "getApiPartnerPatient",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description List successfully sent emails archived for a patient
     *
     * @tags default
     * @name GetApiPartnerPatientEmailList
     * @request GET:/v1/partners/{partner_guid}/patients/{patient_guid}/emails
     */
    getApiPartnerPatientEmailList: (
      partnerGuid: string,
      patientGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPatientEmailListSuccess, any>({
        path: `/v1/partners/${partnerGuid}/patients/${patientGuid}/emails`,
        operation: "getApiPartnerPatientEmailList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description List patient notes
     *
     * @tags default
     * @name GetApiPartnerPatientNoteList
     * @request GET:/v1/partners/{partner_guid}/patients/{patient_guid}/notes
     */
    getApiPartnerPatientNoteList: (
      partnerGuid: string,
      patientGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPatientNoteListSuccess, any>({
        path: `/v1/partners/${partnerGuid}/patients/${patientGuid}/notes`,
        operation: "getApiPartnerPatientNoteList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a patient note
     *
     * @tags default
     * @name PostApiPartnerPatientNoteList
     * @request POST:/v1/partners/{partner_guid}/patients/{patient_guid}/notes
     */
    postApiPartnerPatientNoteList: (
      partnerGuid: string,
      patientGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        content?: string;
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPatientNoteSuccess, any>({
        path: `/v1/partners/${partnerGuid}/patients/${patientGuid}/notes`,
        operation: "postApiPartnerPatientNoteList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a patient note
     *
     * @tags default
     * @name PutApiPartnerPatientNote
     * @request PUT:/v1/partners/{partner_guid}/patients/{patient_guid}/notes/{note_guid}
     */
    putApiPartnerPatientNote: (
      partnerGuid: string,
      patientGuid: string,
      noteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        content?: string;
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPatientNoteSuccess, any>({
        path: `/v1/partners/${partnerGuid}/patients/${patientGuid}/notes/${noteGuid}`,
        operation: "putApiPartnerPatientNote",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a patient note
     *
     * @tags default
     * @name DeleteApiPartnerPatientNote
     * @request DELETE:/v1/partners/{partner_guid}/patients/{patient_guid}/notes/{note_guid}
     */
    deleteApiPartnerPatientNote: (
      partnerGuid: string,
      patientGuid: string,
      noteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/partners/${partnerGuid}/patients/${patientGuid}/notes/${noteGuid}`,
        operation: "deleteApiPartnerPatientNote",
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * @description List patient tasks
     *
     * @tags default
     * @name GetApiPartnerPatientTaskList
     * @request GET:/v1/partners/{partner_guid}/patients/{patient_guid}/tasks
     */
    getApiPartnerPatientTaskList: (
      partnerGuid: string,
      patientGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPatientTaskListSuccess, any>({
        path: `/v1/partners/${partnerGuid}/patients/${patientGuid}/tasks`,
        operation: "getApiPartnerPatientTaskList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a patient task
     *
     * @tags default
     * @name PostApiPartnerPatientTaskList
     * @request POST:/v1/partners/{partner_guid}/patients/{patient_guid}/tasks
     */
    postApiPartnerPatientTaskList: (
      partnerGuid: string,
      patientGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        due_date?: string;
        status?: string;
        text?: string;
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPatientTaskSuccess, any>({
        path: `/v1/partners/${partnerGuid}/patients/${patientGuid}/tasks`,
        operation: "postApiPartnerPatientTaskList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a patient task
     *
     * @tags default
     * @name PutApiPartnerPatientTask
     * @request PUT:/v1/partners/{partner_guid}/patients/{patient_guid}/tasks/{task_guid}
     */
    putApiPartnerPatientTask: (
      partnerGuid: string,
      patientGuid: string,
      taskGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        due_date?: string;
        status?: string;
        text?: string;
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPatientTaskSuccess, any>({
        path: `/v1/partners/${partnerGuid}/patients/${patientGuid}/tasks/${taskGuid}`,
        operation: "putApiPartnerPatientTask",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a patient task
     *
     * @tags default
     * @name DeleteApiPartnerPatientTask
     * @request DELETE:/v1/partners/{partner_guid}/patients/{patient_guid}/tasks/{task_guid}
     */
    deleteApiPartnerPatientTask: (
      partnerGuid: string,
      patientGuid: string,
      taskGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/partners/${partnerGuid}/patients/${patientGuid}/tasks/${taskGuid}`,
        operation: "deleteApiPartnerPatientTask",
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * @description List a patient's LAB and POC test metadata
     *
     * @tags default
     * @name GetApiPartnerPatientTestList
     * @request GET:/v1/partners/{partner_guid}/patients/{patient_guid}/tests
     */
    getApiPartnerPatientTestList: (
      partnerGuid: string,
      patientGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPatientTestListSuccess, any>({
        path: `/v1/partners/${partnerGuid}/patients/${patientGuid}/tests`,
        operation: "getApiPartnerPatientTestList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner payment method
     *
     * @tags default
     * @name PutApiPartnerPaymentMethod
     * @request PUT:/v1/partners/{partner_guid}/payment_method
     */
    putApiPartnerPaymentMethod: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        payment_method?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/payment_method`,
        operation: "putApiPartnerPaymentMethod",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner's pending test samples
     *
     * @tags default
     * @name GetApiPartnerPendingTestSamples
     * @request GET:/v1/partners/{partner_guid}/pending_test_samples
     */
    getApiPartnerPendingTestSamples: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/pending_test_samples`,
        operation: "getApiPartnerPendingTestSamples",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get personnel schedules for a partner
     *
     * @tags default
     * @name GetApiPartnerPersonnelScheduleList
     * @request GET:/v1/partners/{partner_guid}/personnel_schedules
     */
    getApiPartnerPersonnelScheduleList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPersonnelScheduleListOutputSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/personnel_schedules`,
        operation: "getApiPartnerPersonnelScheduleList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a personnel schedule for a partner (with weekly slots)
     *
     * @tags default
     * @name PostApiPartnerPersonnelScheduleList
     * @request POST:/v1/partners/{partner_guid}/personnel_schedules
     */
    postApiPartnerPersonnelScheduleList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: PartnerPersonnelScheduleListInput,
      params: RequestParams = {},
    ) =>
      this.request<PartnerPersonnelScheduleListOutputSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/personnel_schedules`,
        operation: "postApiPartnerPersonnelScheduleList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a specific personnel schedule for a partner
     *
     * @tags default
     * @name PutApiPartnerPersonnelSchedule
     * @request PUT:/v1/partners/{partner_guid}/personnel_schedules/{partner_personnel_schedule_guid}
     */
    putApiPartnerPersonnelSchedule: (
      partnerGuid: string,
      partnerPersonnelScheduleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: PartnerPersonnelScheduleListInput,
      params: RequestParams = {},
    ) =>
      this.request<PartnerPersonnelScheduleListOutputSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/personnel_schedules/${partnerPersonnelScheduleGuid}`,
        operation: "putApiPartnerPersonnelSchedule",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a specific personnel schedule for a partner
     *
     * @tags default
     * @name DeleteApiPartnerPersonnelSchedule
     * @request DELETE:/v1/partners/{partner_guid}/personnel_schedules/{partner_personnel_schedule_guid}
     */
    deleteApiPartnerPersonnelSchedule: (
      partnerGuid: string,
      partnerPersonnelScheduleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/personnel_schedules/${partnerPersonnelScheduleGuid}`,
        operation: "deleteApiPartnerPersonnelSchedule",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Add a manual Igloo device to a partner
     *
     * @tags default
     * @name PostApiPartnerPocDevice
     * @request POST:/v1/partners/{partner_guid}/poc_devices
     */
    postApiPartnerPocDevice: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        firmware?: string;
        result_provider?: string;
        serial_number?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/poc_devices`,
        operation: "postApiPartnerPocDevice",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Update firmware and result provider for a partner's manual or shipped Igloo device
     *
     * @tags default
     * @name PutApiPartnerPocDevice
     * @request PUT:/v1/partners/{partner_guid}/poc_devices
     */
    putApiPartnerPocDevice: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        firmware?: string;
        result_provider?: string;
        serial_number?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/poc_devices`,
        operation: "putApiPartnerPocDevice",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Remove a manual Igloo device from a partner; shipped devices require an inventory transfer
     *
     * @tags default
     * @name DeleteApiPartnerPocDevice
     * @request DELETE:/v1/partners/{partner_guid}/poc_devices
     */
    deleteApiPartnerPocDevice: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        serial_number?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/poc_devices`,
        operation: "deleteApiPartnerPocDevice",
        method: "DELETE",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Calculate POC order price with incentives for authenticated partner
     *
     * @tags default
     * @name PostApiPartnerPocOrderPrice
     * @request POST:/v1/partners/{partner_guid}/poc_order_price
     */
    postApiPartnerPocOrderPrice: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: PartnerPocOrderPriceRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProductOrderPriceResponseSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/poc_order_price`,
        operation: "postApiPartnerPocOrderPrice",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List POC test kit orders for partner
     *
     * @tags default
     * @name GetApiPartnerPocOrderList
     * @request GET:/v1/partners/{partner_guid}/poc_orders
     */
    getApiPartnerPocOrderList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerProductOrderHistoryListSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/poc_orders`,
        operation: "getApiPartnerPocOrderList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a POC test kit order for partner
     *
     * @tags default
     * @name PostApiPartnerPocOrderList
     * @request POST:/v1/partners/{partner_guid}/poc_orders
     */
    postApiPartnerPocOrderList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: PartnerPocOrderRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartnerProductOrderResponseSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/poc_orders`,
        operation: "postApiPartnerPocOrderList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get single POC test kit order for partner
     *
     * @tags default
     * @name GetApiPartnerPocOrder
     * @request GET:/v1/partners/{partner_guid}/poc_orders/{i_partner_product_order}
     */
    getApiPartnerPocOrder: (
      partnerGuid: string,
      iPartnerProductOrder: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerProductOrderDetailSuccess, AuthError | ForbiddenError | void>({
        path: `/v1/partners/${partnerGuid}/poc_orders/${iPartnerProductOrder}`,
        operation: "getApiPartnerPocOrder",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update single POC test kit order for partner
     *
     * @tags default
     * @name PutApiPartnerPocOrder
     * @request PUT:/v1/partners/{partner_guid}/poc_orders/{i_partner_product_order}
     */
    putApiPartnerPocOrder: (
      partnerGuid: string,
      iPartnerProductOrder: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: PartnerPocOrderUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartnerProductOrderDetailSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/poc_orders/${iPartnerProductOrder}`,
        operation: "putApiPartnerPocOrder",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Cancel single POC test kit order for partner
     *
     * @tags default
     * @name DeleteApiPartnerPocOrder
     * @request DELETE:/v1/partners/{partner_guid}/poc_orders/{i_partner_product_order}
     */
    deleteApiPartnerPocOrder: (
      partnerGuid: string,
      iPartnerProductOrder: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerProductOrderDetailSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/poc_orders/${iPartnerProductOrder}`,
        operation: "deleteApiPartnerPocOrder",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to generate and print partner coupons. Returns a PDF file
     *
     * @tags default
     * @name PostApiPartnerCouponPrint
     * @request POST:/v1/partners/{partner_guid}/print_coupons
     */
    postApiPartnerCouponPrint: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        is_cabopoc_coupon?: boolean;
        is_vaccination_coupon?: boolean;
        vaccination_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/print_coupons`,
        operation: "postApiPartnerCouponPrint",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get POC product inventory for partner. POC stock maps to reports/products; general consumables use reports/inventory and equipment_stock.
     *
     * @tags default
     * @name GetApiPartnerProductInventory
     * @request GET:/v1/partners/{partner_guid}/product_inventory
     */
    getApiPartnerProductInventory: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerProductInventoryListSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/product_inventory`,
        operation: "getApiPartnerProductInventory",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update partner product auto-order settings
     *
     * @tags default
     * @name PutApiPartnerProductInventory
     * @request PUT:/v1/partners/{partner_guid}/product_inventory
     */
    putApiPartnerProductInventory: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: PartnerProductAutoOrderSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartnerProductInventoryListSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/product_inventory`,
        operation: "putApiPartnerProductInventory",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Save a POC stocktake, including newly registered external batches. Amounts are actual stock, not quantities to add.
     *
     * @tags default
     * @name PostApiPartnerProductInventoryBatchUpdate
     * @request POST:/v1/partners/{partner_guid}/product_inventory/batch_update
     */
    postApiPartnerProductInventoryBatchUpdate: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiPartnerProductInventoryBatchUpdatePost,
      params: RequestParams = {},
    ) =>
      this.request<
        PartnerProductInventoryListSuccess,
        ApiPartnerProductInventoryBatchUpdateError | AuthError | ForbiddenError
      >({
        path: `/v1/partners/${partnerGuid}/product_inventory/batch_update`,
        operation: "postApiPartnerProductInventoryBatchUpdate",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get partner POC inventory stocktake grouped by product and charge.
     *
     * @tags default
     * @name GetApiPartnerProductInventoryStocktake
     * @request GET:/v1/partners/{partner_guid}/product_inventory/stocktake
     */
    getApiPartnerProductInventoryStocktake: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerProductInventoryStocktakeSuccess, AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/product_inventory/stocktake`,
        operation: "getApiPartnerProductInventoryStocktake",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner's product selling prices
     *
     * @tags default
     * @name GetApiPartnerProductSellingPriceList
     * @request GET:/v1/partners/{partner_guid}/product-selling-prices
     */
    getApiPartnerProductSellingPriceList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductSellingPriceListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/product-selling-prices`,
        operation: "getApiPartnerProductSellingPriceList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner's product selling price
     *
     * @tags default
     * @name PutApiPartnerProductSellingPrice
     * @request PUT:/v1/partners/{partner_guid}/product-selling-prices/{product_guid}
     */
    putApiPartnerProductSellingPrice: (
      partnerGuid: string,
      productGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        enabled?: boolean;
        enabled_for_microsite?: boolean;
        selling_price?: number;
        sort?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductSellingPriceSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/product-selling-prices/${productGuid}`,
        operation: "putApiPartnerProductSellingPrice",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get questionnaires
     *
     * @tags default
     * @name GetApiPartnerQuestionnaireList
     * @request GET:/v1/partners/{partner_guid}/questionnaires
     */
    getApiPartnerQuestionnaireList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<QuestionnaireListSuccess, AuthError>({
        path: `/v1/partners/${partnerGuid}/questionnaires`,
        operation: "getApiPartnerQuestionnaireList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get questionnaire questions
     *
     * @tags default
     * @name GetApiPartnerQuestionnaire
     * @request GET:/v1/partners/{partner_guid}/questionnaires/{i_questionnaire}
     */
    getApiPartnerQuestionnaire: (
      partnerGuid: string,
      iQuestionnaire: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<QuestionnaireSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/questionnaires/${iQuestionnaire}`,
        operation: "getApiPartnerQuestionnaire",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to answer questionnaire
     *
     * @tags default
     * @name PutApiPartnerQuestionnaireAnswer
     * @request PUT:/v1/partners/{partner_guid}/questionnaires/{i_questionnaire}/answer
     */
    putApiPartnerQuestionnaireAnswer: (
      partnerGuid: string,
      iQuestionnaire: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiPartnerQuestionnaireAnswerList,
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerQuestionnaireAnswerError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/questionnaires/${iQuestionnaire}/answer`,
        operation: "putApiPartnerQuestionnaireAnswer",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner referrals
     *
     * @tags default
     * @name GetApiPartnerReferralsList
     * @request GET:/v1/partners/{partner_guid}/referrals
     */
    getApiPartnerReferralsList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/referrals`,
        operation: "getApiPartnerReferralsList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name GetApiPartnerServiceRegistration
     * @request GET:/v1/partners/{partner_guid}/service_registrations
     */
    getApiPartnerServiceRegistration: (
      partnerGuid: string,
      query: {
        client_bundle_id: string;
        device_locale: string;
        partner_appointment_type_guid: string;
        medical_test_profile_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ServiceRegistrationFormSuccess, any>({
        path: `/v1/partners/${partnerGuid}/service_registrations`,
        operation: "getApiPartnerServiceRegistration",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name PostApiPartnerServiceRegistration
     * @request POST:/v1/partners/{partner_guid}/service_registrations
     */
    postApiPartnerServiceRegistration: (
      partnerGuid: string,
      query: {
        client_bundle_id: string;
        device_locale: string;
        partner_appointment_type_guid: string;
        medical_test_profile_guid?: string;
      },
      payload: ServiceRegistrationInput,
      params: RequestParams = {},
    ) =>
      this.request<ServiceRegistrationResultSuccess, any>({
        path: `/v1/partners/${partnerGuid}/service_registrations`,
        operation: "postApiPartnerServiceRegistration",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner's shared test samples
     *
     * @tags default
     * @name GetApiPartnerSharedTestSamples
     * @request GET:/v1/partners/{partner_guid}/shared_test_samples
     */
    getApiPartnerSharedTestSamples: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/shared_test_samples`,
        operation: "getApiPartnerSharedTestSamples",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name GetApiPartnerSpecialAvailabilityList
     * @request GET:/v1/partners/{partner_guid}/special_availability
     */
    getApiPartnerSpecialAvailabilityList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSpecialAvailabilityListSuccess, any>({
        path: `/v1/partners/${partnerGuid}/special_availability`,
        operation: "getApiPartnerSpecialAvailabilityList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name PostApiPartnerSpecialAvailabilityList
     * @request POST:/v1/partners/{partner_guid}/special_availability
     */
    postApiPartnerSpecialAvailabilityList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: PartnerSpecialAvailabilityInput,
      params: RequestParams = {},
    ) =>
      this.request<PartnerSpecialAvailabilityListSuccess, any>({
        path: `/v1/partners/${partnerGuid}/special_availability`,
        operation: "postApiPartnerSpecialAvailabilityList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name PutApiPartnerSpecialAvailability
     * @request PUT:/v1/partners/{partner_guid}/special_availability/{special_availability_guid}
     */
    putApiPartnerSpecialAvailability: (
      partnerGuid: string,
      specialAvailabilityGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: PartnerSpecialAvailabilityInput,
      params: RequestParams = {},
    ) =>
      this.request<PartnerSpecialAvailabilityListSuccess, any>({
        path: `/v1/partners/${partnerGuid}/special_availability/${specialAvailabilityGuid}`,
        operation: "putApiPartnerSpecialAvailability",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name DeleteApiPartnerSpecialAvailability
     * @request DELETE:/v1/partners/{partner_guid}/special_availability/{special_availability_guid}
     */
    deleteApiPartnerSpecialAvailability: (
      partnerGuid: string,
      specialAvailabilityGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSpecialAvailabilityListSuccess, any>({
        path: `/v1/partners/${partnerGuid}/special_availability/${specialAvailabilityGuid}`,
        operation: "deleteApiPartnerSpecialAvailability",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner team members
     *
     * @tags default
     * @name GetApiPartnerTeamList
     * @request GET:/v1/partners/{partner_guid}/team
     */
    getApiPartnerTeamList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TeamSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/team`,
        operation: "getApiPartnerTeamList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to register partner team member
     *
     * @tags default
     * @name PostApiPartnerTeamList
     * @request POST:/v1/partners/{partner_guid}/team
     */
    postApiPartnerTeamList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        first_name?: string;
        last_name?: string;
        role_name?: string;
        salutation?: string;
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/team`,
        operation: "postApiPartnerTeamList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner team member
     *
     * @tags default
     * @name PutApiPartnerTeamList
     * @request PUT:/v1/partners/{partner_guid}/team
     */
    putApiPartnerTeamList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        first_name?: string;
        last_name?: string;
        role_name?: string;
        salutation?: string;
        subscribed_to_blogs?: boolean;
        title?: string;
        user_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserSuccess, ApiPartnerTeamListPutError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/team`,
        operation: "putApiPartnerTeamList",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to remove partner team member
     *
     * @tags default
     * @name DeleteApiPartnerTeamList
     * @request DELETE:/v1/partners/{partner_guid}/team
     */
    deleteApiPartnerTeamList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        user_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerTeamListDeleteError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/team`,
        operation: "deleteApiPartnerTeamList",
        method: "DELETE",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to team member's email
     *
     * @tags default
     * @name PutApiPartnerTeamEmail
     * @request PUT:/v1/partners/{partner_guid}/team/{user_guid}/email
     */
    putApiPartnerTeamEmail: (
      partnerGuid: string,
      userGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/team/${userGuid}/email`,
        operation: "putApiPartnerTeamEmail",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to login team member in partner device
     *
     * @tags default
     * @name PostApiPartnerTeamLogin
     * @request POST:/v1/partners/{partner_guid}/team/{user_guid}/login
     */
    postApiPartnerTeamLogin: (
      partnerGuid: string,
      userGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        pin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        EmployeePinLoginSuccess,
        ApiPartnerTeamLoginError | AuthError | ForbiddenError | EmployeePinRateLimitError | EmployeePinUnavailableError
      >({
        path: `/v1/partners/${partnerGuid}/team/${userGuid}/login`,
        operation: "postApiPartnerTeamLogin",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to set initial pin code for team member
     *
     * @tags default
     * @name PutApiPartnerTeamInitialPin
     * @request PUT:/v1/partners/{partner_guid}/team/{user_guid}/pin
     */
    putApiPartnerTeamInitialPin: (
      partnerGuid: string,
      userGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        pin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        Success,
        NotFoundError | AuthError | ForbiddenError | EmployeePinRateLimitError | EmployeePinUnavailableError
      >({
        path: `/v1/partners/${partnerGuid}/team/${userGuid}/pin`,
        operation: "putApiPartnerTeamInitialPin",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name GetApiPartnerTestExecutionConsentTemplatePdf
     * @request GET:/v1/partners/{partner_guid}/test_execution_consent/template/pdf
     */
    getApiPartnerTestExecutionConsentTemplatePdf: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, AuthError>({
        path: `/v1/partners/${partnerGuid}/test_execution_consent/template/pdf`,
        operation: "getApiPartnerTestExecutionConsentTemplatePdf",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to get partner test sample shipments
     *
     * @tags default
     * @name GetApiPartnerTestSampleShipmentList
     * @request GET:/v1/partners/{partner_guid}/test_sample_shipments
     */
    getApiPartnerTestSampleShipmentList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleShipmentListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/test_sample_shipments`,
        operation: "getApiPartnerTestSampleShipmentList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner test sample shipment
     *
     * @tags default
     * @name GetApiPartnerTestSampleShipment
     * @request GET:/v1/partners/{partner_guid}/test_sample_shipments/{test_sample_shipment_guid}
     */
    getApiPartnerTestSampleShipment: (
      partnerGuid: string,
      testSampleShipmentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleShipmentSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/test_sample_shipments/${testSampleShipmentGuid}`,
        operation: "getApiPartnerTestSampleShipment",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner test sample shipment label
     *
     * @tags default
     * @name GetApiPartnerTestSampleShipmentLabel
     * @request GET:/v1/partners/{partner_guid}/test_sample_shipments/{test_sample_shipment_guid}/label
     */
    getApiPartnerTestSampleShipmentLabel: (
      partnerGuid: string,
      testSampleShipmentGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiPartnerTestSampleShipmentLabelError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/test_sample_shipments/${testSampleShipmentGuid}/label`,
        operation: "getApiPartnerTestSampleShipmentLabel",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to check partner's test sample shipment
     *
     * @tags default
     * @name GetApiPartnerTestSampleShipmentCheck
     * @request GET:/v1/partners/{partner_guid}/test_sample_shipments/check
     */
    getApiPartnerTestSampleShipmentCheck: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleShipmentSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/test_sample_shipments/check`,
        operation: "getApiPartnerTestSampleShipmentCheck",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner shipments label in bulk. Returns a PDF file
     *
     * @tags default
     * @name GetApiPartnerTestSampleShipmentLabelBulk
     * @request GET:/v1/partners/{partner_guid}/test_sample_shipments/label
     */
    getApiPartnerTestSampleShipmentLabelBulk: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default "all" */
        filter?: "all" | "express" | "normal";
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiPartnerTestSampleShipmentLabelBulkError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/test_sample_shipments/label`,
        operation: "getApiPartnerTestSampleShipmentLabelBulk",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to get partner's test samples
     *
     * @tags default
     * @name GetApiPartnerTestSampleList
     * @request GET:/v1/partners/{partner_guid}/test_samples
     */
    getApiPartnerTestSampleList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/test_samples`,
        operation: "getApiPartnerTestSampleList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner's test sample
     *
     * @tags default
     * @name GetApiPartnerTestSample
     * @request GET:/v1/partners/{partner_guid}/test_samples/{test_sample_guid}
     */
    getApiPartnerTestSample: (
      partnerGuid: string,
      testSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        pin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleSuccess, ApiPartnerTestSampleError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/test_samples/${testSampleGuid}`,
        operation: "getApiPartnerTestSample",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Read a test sample with credentials in the JSON body
     *
     * @tags default
     * @name PostApiPartnerTestSample
     * @request POST:/v1/partners/{partner_guid}/test_samples/{test_sample_guid}
     */
    postApiPartnerTestSample: (
      partnerGuid: string,
      testSampleGuid: string,
      payload: {
        client_bundle_id?: string;
        device_guid?: string;
        device_locale?: string;
        pin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleSuccess, any>({
        path: `/v1/partners/${partnerGuid}/test_samples/${testSampleGuid}`,
        operation: "postApiPartnerTestSample",
        method: "POST",
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to send partner's test sample result pdf by email
     *
     * @tags default
     * @name PostApiPartnerTestSampleEmailResultPdf
     * @request POST:/v1/partners/{partner_guid}/test_samples/{test_sample_guid}/email_results_pdf
     */
    postApiPartnerTestSampleEmailResultPdf: (
      partnerGuid: string,
      testSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        pin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerTestSampleEmailResultPdfError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/test_samples/${testSampleGuid}/email_results_pdf`,
        operation: "postApiPartnerTestSampleEmailResultPdf",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner's test sample result pdf
     *
     * @tags default
     * @name GetApiPartnerTestSampleResultPdf
     * @request GET:/v1/partners/{partner_guid}/test_samples/{test_sample_guid}/results_pdf
     */
    getApiPartnerTestSampleResultPdf: (
      partnerGuid: string,
      testSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        pin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiPartnerTestSampleResultPdfError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/test_samples/${testSampleGuid}/results_pdf`,
        operation: "getApiPartnerTestSampleResultPdf",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Read a result PDF with credentials in the JSON body
     *
     * @tags default
     * @name PostApiPartnerTestSampleResultPdf
     * @request POST:/v1/partners/{partner_guid}/test_samples/{test_sample_guid}/results_pdf
     */
    postApiPartnerTestSampleResultPdf: (
      partnerGuid: string,
      testSampleGuid: string,
      payload: {
        client_bundle_id?: string;
        device_guid?: string;
        device_locale?: string;
        pin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/partners/${partnerGuid}/test_samples/${testSampleGuid}/results_pdf`,
        operation: "postApiPartnerTestSampleResultPdf",
        method: "POST",
        body: payload,
        ...params,
      }),

    /**
     * @description Endpoint to get partner ticker events
     *
     * @tags default
     * @name GetApiPartnerTickerEventList
     * @request GET:/v1/partners/{partner_guid}/ticker_events
     */
    getApiPartnerTickerEventList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TickerEventListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/ticker_events`,
        operation: "getApiPartnerTickerEventList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner ticker event
     *
     * @tags default
     * @name GetApiPartnerTickerEvent
     * @request GET:/v1/partners/{partner_guid}/ticker_events/{ticker_event_guid}
     */
    getApiPartnerTickerEvent: (
      partnerGuid: string,
      tickerEventGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TickerEventSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/ticker_events/${tickerEventGuid}`,
        operation: "getApiPartnerTickerEvent",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner ticker event viewed status
     *
     * @tags default
     * @name PutApiPartnerTickerEventView
     * @request PUT:/v1/partners/{partner_guid}/ticker_events/{ticker_event_guid}/view
     */
    putApiPartnerTickerEventView: (
      partnerGuid: string,
      tickerEventGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TickerEventSuccess, NotFoundError | AuthError>({
        path: `/v1/partners/${partnerGuid}/ticker_events/${tickerEventGuid}/view`,
        operation: "putApiPartnerTickerEventView",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to complete partner's training
     *
     * @tags default
     * @name PutApiPartnerCompleteTraining
     * @request PUT:/v1/partners/{partner_guid}/training/complete
     */
    putApiPartnerCompleteTraining: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSuccess, ApiPartnerCompleteTrainingError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/training/complete`,
        operation: "putApiPartnerCompleteTraining",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get today's unfinished services (Europe/Berlin), once per coupon
     *
     * @tags default
     * @name GetApiPartnerUnfinishedTests
     * @request GET:/v1/partners/{partner_guid}/unfinished_tests
     */
    getApiPartnerUnfinishedTests: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerUnfinishedTestListSuccess, any>({
        path: `/v1/partners/${partnerGuid}/unfinished_tests`,
        operation: "getApiPartnerUnfinishedTests",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get unpacked sample
     *
     * @tags default
     * @name GetApiPartnerUnpackedSampleList
     * @request GET:/v1/partners/{partner_guid}/unpacked_samples
     */
    getApiPartnerUnpackedSampleList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleShipmentListSuccess, ApiPartnerUnpackedSampleListError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/unpacked_samples`,
        operation: "getApiPartnerUnpackedSampleList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get unpacked sample. This endpoint will generate the shipments
     *
     * @tags default
     * @name PostApiPartnerUnpackedSampleList
     * @request POST:/v1/partners/{partner_guid}/unpacked_samples
     */
    postApiPartnerUnpackedSampleList: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleShipmentListSuccess, ApiPartnerUnpackedSampleListError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/unpacked_samples`,
        operation: "postApiPartnerUnpackedSampleList",
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update sample collection datetime
     *
     * @tags default
     * @name PutApiPartnerSampleCollectionUpdate
     * @request PUT:/v1/partners/{partner_guid}/update_sample_collection
     */
    putApiPartnerSampleCollectionUpdate: (
      partnerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        collection?: string;
        test_sample_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleSuccess, ApiPartnerSampleCollectionUpdateError | AuthError | ForbiddenError>({
        path: `/v1/partners/${partnerGuid}/update_sample_collection`,
        operation: "putApiPartnerSampleCollectionUpdate",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to cancel appointment
     *
     * @tags default
     * @name GetApiPartnerAppointmentCancellation
     * @request GET:/v1/partners/appointments/cancel
     */
    getApiPartnerAppointmentCancellation: (
      query: {
        cancellation_token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiPartnerAppointmentCancellationError>({
        path: `/v1/partners/appointments/cancel`,
        operation: "getApiPartnerAppointmentCancellation",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to get appointment for questionnaire page
     *
     * @tags default
     * @name GetApiPartnerAppointmentQuestionnaire
     * @request GET:/v1/partners/appointments/questionnaire
     */
    getApiPartnerAppointmentQuestionnaire: (
      query: {
        validation_token: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerAppointmentSuccess, NotFoundError>({
        path: `/v1/partners/appointments/questionnaire`,
        operation: "getApiPartnerAppointmentQuestionnaire",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to validate appointment
     *
     * @tags default
     * @name GetApiPartnerAppointmentValidation
     * @request GET:/v1/partners/appointments/validate
     */
    getApiPartnerAppointmentValidation: (
      query: {
        validation_token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiPartnerAppointmentValidationError>({
        path: `/v1/partners/appointments/validate`,
        operation: "getApiPartnerAppointmentValidation",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to get partner device info
     *
     * @tags default
     * @name GetApiPartnerDeviceInfo
     * @request GET:/v1/partners/devices/info
     */
    getApiPartnerDeviceInfo: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerDeviceSuccess, AuthError>({
        path: `/v1/partners/devices/info`,
        operation: "getApiPartnerDeviceInfo",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to register partner device
     *
     * @tags default
     * @name PostApiPartnerDeviceRegistration
     * @request POST:/v1/partners/devices/registration
     */
    postApiPartnerDeviceRegistration: (
      payload: {
        device_guid?: string;
        email?: string;
        password?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPartnerDeviceRegistrationSuccess, ApiPartnerDeviceRegistrationError>({
        path: `/v1/partners/devices/registration`,
        operation: "postApiPartnerDeviceRegistration",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name PostApiCompletePartnerOwnershipTransfer
     * @request POST:/v1/partners/ownership-transfer/complete
     */
    postApiCompletePartnerOwnershipTransfer: (
      payload: {
        client_bundle_id?: string;
        password?: string;
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, PartnerOwnershipTransferError>({
        path: `/v1/partners/ownership-transfer/complete`,
        operation: "postApiCompletePartnerOwnershipTransfer",
        method: "POST",
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to search partners
     *
     * @tags default
     * @name GetApiPartnerSearch
     * @request GET:/v1/partners/search
     */
    getApiPartnerSearch: (
      query: {
        zip: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerSearchListSuccess, NotFoundError | ForbiddenError>({
        path: `/v1/partners/search`,
        operation: "getApiPartnerSearch",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Calculate POC order price and applied discounts; line_items have quantity + unit_type (box/single)
     *
     * @tags default
     * @name PostApiPocOrderPrice
     * @request POST:/v1/poc_order_price
     */
    postApiPocOrderPrice: (payload: PocOrderPriceRequest, params: RequestParams = {}) =>
      this.request<ProductOrderPriceResponseSuccess, void>({
        path: `/v1/poc_order_price`,
        operation: "postApiPocOrderPrice",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get POC shipping tiers
     *
     * @tags default
     * @name GetApiPocShippingTierList
     * @request GET:/v1/poc_shipping_tiers
     */
    getApiPocShippingTierList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default false */
        include_inactive?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PocShippingTierListSuccess, AuthError | ForbiddenError>({
        path: `/v1/poc_shipping_tiers`,
        operation: "getApiPocShippingTierList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a POC shipping tier
     *
     * @tags default
     * @name PostApiPocShippingTierList
     * @request POST:/v1/poc_shipping_tiers
     */
    postApiPocShippingTierList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiPocShippingTierListPost,
      params: RequestParams = {},
    ) =>
      this.request<PocShippingTierSuccess, AuthError | ForbiddenError>({
        path: `/v1/poc_shipping_tiers`,
        operation: "postApiPocShippingTierList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a POC shipping tier
     *
     * @tags default
     * @name PutApiPocShippingTier
     * @request PUT:/v1/poc_shipping_tiers/{poc_shipping_tier_guid}
     */
    putApiPocShippingTier: (
      pocShippingTierGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        active?: boolean;
        clear_max_order_amount?: boolean;
        effective_from?: string;
        max_order_amount_cents?: number;
        shipping_cost_cents?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PocShippingTierSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/poc_shipping_tiers/${pocShippingTierGuid}`,
        operation: "putApiPocShippingTier",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a POC shipping tier
     *
     * @tags default
     * @name DeleteApiPocShippingTier
     * @request DELETE:/v1/poc_shipping_tiers/{poc_shipping_tier_guid}
     */
    deleteApiPocShippingTier: (
      pocShippingTierGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/poc_shipping_tiers/${pocShippingTierGuid}`,
        operation: "deleteApiPocShippingTier",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create preregistration request note
     *
     * @tags default
     * @name PostApiPreregistrationRequestNoteList
     * @request POST:/v1/pre_registration/{i_pre_registration_request}/notes
     */
    postApiPreregistrationRequestNoteList: (
      iPreRegistrationRequest: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        attachments?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPreregistrationRequestSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/pre_registration/${iPreRegistrationRequest}/notes`,
        operation: "postApiPreregistrationRequestNoteList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update preregistration request note
     *
     * @tags default
     * @name PutApiPreregistrationRequestNote
     * @request PUT:/v1/pre_registration/{i_pre_registration_request}/notes/{pre_registration_request_note_guid}
     */
    putApiPreregistrationRequestNote: (
      iPreRegistrationRequest: number,
      preRegistrationRequestNoteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        attachments?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPreregistrationRequestSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/pre_registration/${iPreRegistrationRequest}/notes/${preRegistrationRequestNoteGuid}`,
        operation: "putApiPreregistrationRequestNote",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete preregistration request note
     *
     * @tags default
     * @name DeleteApiPreregistrationRequestNote
     * @request DELETE:/v1/pre_registration/{i_pre_registration_request}/notes/{pre_registration_request_note_guid}
     */
    deleteApiPreregistrationRequestNote: (
      iPreRegistrationRequest: number,
      preRegistrationRequestNoteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPreregistrationRequestSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/pre_registration/${iPreRegistrationRequest}/notes/${preRegistrationRequestNoteGuid}`,
        operation: "deleteApiPreregistrationRequestNote",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to pre register end user
     *
     * @tags default
     * @name PostApiEndUserPreregistration
     * @request POST:/v1/pre_registration/end_users
     */
    postApiEndUserPreregistration: (
      payload: {
        client_bundle_id?: string;
        device_locale?: string;
        email?: string;
        zip?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiEndUserPreregistrationError>({
        path: `/v1/pre_registration/end_users`,
        operation: "postApiEndUserPreregistration",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Endpoint to get partner pre-registration requests
     *
     * @tags default
     * @name GetApiPartnerPreregistrationList
     * @request GET:/v1/pre_registration/partners
     */
    getApiPartnerPreregistrationList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPreregistrationRequestListSuccess, AuthError | ForbiddenError>({
        path: `/v1/pre_registration/partners`,
        operation: "getApiPartnerPreregistrationList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to pre register partner
     *
     * @tags default
     * @name PostApiPartnerPreregistrationList
     * @request POST:/v1/pre_registration/partners
     */
    postApiPartnerPreregistrationList: (
      payload: ApiPartnerPreregistrationListPost,
      query?: {
        device_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPreregistrationRequestSuccess, ApiPartnerPreregistrationListError>({
        path: `/v1/pre_registration/partners`,
        operation: "postApiPartnerPreregistrationList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner pre-registration request
     *
     * @tags default
     * @name GetApiPartnerPreregistration
     * @request GET:/v1/pre_registration/partners/{i_pre_registration_request}
     */
    getApiPartnerPreregistration: (
      iPreRegistrationRequest: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPreregistrationRequestSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/pre_registration/partners/${iPreRegistrationRequest}`,
        operation: "getApiPartnerPreregistration",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update partner pre-registration request
     *
     * @tags default
     * @name PutApiPartnerPreregistration
     * @request PUT:/v1/pre_registration/partners/{i_pre_registration_request}
     */
    putApiPartnerPreregistration: (
      iPreRegistrationRequest: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiPartnerPreregistrationPut,
      params: RequestParams = {},
    ) =>
      this.request<
        PartnerPreregistrationRequestSuccess,
        ApiPartnerPreregistrationUpdateError | AuthError | ForbiddenError
      >({
        path: `/v1/pre_registration/partners/${iPreRegistrationRequest}`,
        operation: "putApiPartnerPreregistration",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to cancel partner pre-registration request
     *
     * @tags default
     * @name DeleteApiPartnerPreregistration
     * @request DELETE:/v1/pre_registration/partners/{i_pre_registration_request}
     */
    deleteApiPartnerPreregistration: (
      iPreRegistrationRequest: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerPreregistrationDeleteError | AuthError | ForbiddenError>({
        path: `/v1/pre_registration/partners/${iPreRegistrationRequest}`,
        operation: "deleteApiPartnerPreregistration",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to resend validation email
     *
     * @tags default
     * @name PutApiPartnerPreregistrationValidationResend
     * @request PUT:/v1/pre_registration/partners/{i_pre_registration_request}/resend_validation
     */
    putApiPartnerPreregistrationValidationResend: (
      iPreRegistrationRequest: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerPreregistrationValidationResendError | AuthError | ForbiddenError>({
        path: `/v1/pre_registration/partners/${iPreRegistrationRequest}/resend_validation`,
        operation: "putApiPartnerPreregistrationValidationResend",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to verify partner registration
     *
     * @tags default
     * @name PostApiPartnerPreregistrationVerification
     * @request POST:/v1/pre_registration/partners/{i_pre_registration_request}/verify
     */
    postApiPartnerPreregistrationVerification: (
      iPreRegistrationRequest: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerPreregistrationVerificationError | AuthError | ForbiddenError>({
        path: `/v1/pre_registration/partners/${iPreRegistrationRequest}/verify`,
        operation: "postApiPartnerPreregistrationVerification",
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner registration with completion_token
     *
     * @tags default
     * @name GetApiPartnerPreregistrationCompletion
     * @request GET:/v1/pre_registration/partners/complete
     */
    getApiPartnerPreregistrationCompletion: (
      query: {
        completion_token: string;
        /** @default "de" */
        device_locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerPreregistrationRequestSuccess, ApiPartnerPreregistrationCompletionError>({
        path: `/v1/pre_registration/partners/complete`,
        operation: "getApiPartnerPreregistrationCompletion",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to complete partner registration
     *
     * @tags default
     * @name PostApiPartnerPreregistrationCompletion
     * @request POST:/v1/pre_registration/partners/complete
     */
    postApiPartnerPreregistrationCompletion: (
      payload: ApiPartnerPreregistrationCompletionPost,
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiPartnerPreregistrationCompletionError>({
        path: `/v1/pre_registration/partners/complete`,
        operation: "postApiPartnerPreregistrationCompletion",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to validate pre-registration
     *
     * @tags default
     * @name GetApiPreregistrationValidation
     * @request GET:/v1/pre_registration/validate
     */
    getApiPreregistrationValidation: (
      query: {
        validation_token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiPreregistrationValidationError>({
        path: `/v1/pre_registration/validate`,
        operation: "getApiPreregistrationValidation",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Create Stripe customer and SetupIntent for pre-registration
     *
     * @tags default
     * @name PostApiPreRegistrationStripeSetup
     * @summary Create Stripe customer and SetupIntent for pre-registration flow
     * @request POST:/v1/pre-registration-stripe-setup
     */
    postApiPreRegistrationStripeSetup: (
      payload: {
        completion_token?: string;
        device_locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StripeCheckoutResponseSuccess, void>({
        path: `/v1/pre-registration-stripe-setup`,
        operation: "postApiPreRegistrationStripeSetup",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get product batch allocations
     *
     * @tags default
     * @name GetApiProductBatchAllocationList
     * @request GET:/v1/product_batch_allocations
     */
    getApiProductBatchAllocationList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductBatchAllocationListSuccess, AuthError | ForbiddenError>({
        path: `/v1/product_batch_allocations`,
        operation: "getApiProductBatchAllocationList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get product batches
     *
     * @tags default
     * @name GetApiProductBatchList
     * @request GET:/v1/product_batches
     */
    getApiProductBatchList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        product_type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductBatchListSuccess, AuthError | ForbiddenError>({
        path: `/v1/product_batches`,
        operation: "getApiProductBatchList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a product batch
     *
     * @tags default
     * @name PostApiProductBatchList
     * @request POST:/v1/product_batches
     */
    postApiProductBatchList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiProductBatchListPost,
      params: RequestParams = {},
    ) =>
      this.request<Success, AuthError | ForbiddenError>({
        path: `/v1/product_batches`,
        operation: "postApiProductBatchList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a product batch
     *
     * @tags default
     * @name PutApiProductBatch
     * @request PUT:/v1/product_batches/{i_product_batch}
     */
    putApiProductBatch: (
      iProductBatch: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiProductBatchPut,
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/product_batches/${iProductBatch}`,
        operation: "putApiProductBatch",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a product batch
     *
     * @tags default
     * @name DeleteApiProductBatch
     * @request DELETE:/v1/product_batches/{i_product_batch}
     */
    deleteApiProductBatch: (
      iProductBatch: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/product_batches/${iProductBatch}`,
        operation: "deleteApiProductBatch",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get partners that received a product batch
     *
     * @tags default
     * @name GetApiProductBatchPartnerReceiptList
     * @request GET:/v1/product_batches/{i_product_batch}/partner_receipts
     */
    getApiProductBatchPartnerReceiptList: (
      iProductBatch: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductBatchPartnerReceiptListSuccess, AuthError | ForbiddenError>({
        path: `/v1/product_batches/${iProductBatch}/partner_receipts`,
        operation: "getApiProductBatchPartnerReceiptList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get product FAQs
     *
     * @tags default
     * @name GetApiProductFaqList
     * @request GET:/v1/product_faqs
     */
    getApiProductFaqList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductFaqListSuccess, AuthError | ForbiddenError>({
        path: `/v1/product_faqs`,
        operation: "getApiProductFaqList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create product FAQ
     *
     * @tags default
     * @name PostApiProductFaqList
     * @request POST:/v1/product_faqs
     */
    postApiProductFaqList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiProductFaqListPost,
      params: RequestParams = {},
    ) =>
      this.request<ProductFaqSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/product_faqs`,
        operation: "postApiProductFaqList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get product FAQ
     *
     * @tags default
     * @name GetApiProductFaq
     * @request GET:/v1/product_faqs/{product_faq_guid}
     */
    getApiProductFaq: (
      productFaqGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductFaqSuccess, NotFoundError | AuthError>({
        path: `/v1/product_faqs/${productFaqGuid}`,
        operation: "getApiProductFaq",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update product FAQ
     *
     * @tags default
     * @name PutApiProductFaq
     * @request PUT:/v1/product_faqs/{product_faq_guid}
     */
    putApiProductFaq: (
      productFaqGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        sort?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/product_faqs/${productFaqGuid}`,
        operation: "putApiProductFaq",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete product FAQ
     *
     * @tags default
     * @name DeleteApiProductFaq
     * @request DELETE:/v1/product_faqs/{product_faq_guid}
     */
    deleteApiProductFaq: (
      productFaqGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/product_faqs/${productFaqGuid}`,
        operation: "deleteApiProductFaq",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to upsert product FAQ translation
     *
     * @tags default
     * @name PostApiProductFaqTranslation
     * @request POST:/v1/product_faqs/{product_faq_guid}/translations
     */
    postApiProductFaqTranslation: (
      productFaqGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        auto_translate?: boolean;
        i_language?: number;
        question?: string;
        response?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductFaqSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/product_faqs/${productFaqGuid}/translations`,
        operation: "postApiProductFaqTranslation",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Get product order incentives
     *
     * @tags default
     * @name GetApiProductOrderIncentiveList
     * @request GET:/v1/product_order_incentives
     */
    getApiProductOrderIncentiveList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default false */
        include_expired?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductOrderIncentiveListSuccess, AuthError | ForbiddenError>({
        path: `/v1/product_order_incentives`,
        operation: "getApiProductOrderIncentiveList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a product order incentive
     *
     * @tags default
     * @name PostApiProductOrderIncentiveList
     * @request POST:/v1/product_order_incentives
     */
    postApiProductOrderIncentiveList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiProductOrderIncentiveListPost,
      params: RequestParams = {},
    ) =>
      this.request<ProductOrderIncentiveSuccess, AuthError | ForbiddenError>({
        path: `/v1/product_order_incentives`,
        operation: "postApiProductOrderIncentiveList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get product order incentive details
     *
     * @tags default
     * @name GetApiProductOrderIncentive
     * @request GET:/v1/product_order_incentives/{product_order_incentive_guid}
     */
    getApiProductOrderIncentive: (
      productOrderIncentiveGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductOrderIncentiveSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/product_order_incentives/${productOrderIncentiveGuid}`,
        operation: "getApiProductOrderIncentive",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a product order incentive
     *
     * @tags default
     * @name PutApiProductOrderIncentive
     * @request PUT:/v1/product_order_incentives/{product_order_incentive_guid}
     */
    putApiProductOrderIncentive: (
      productOrderIncentiveGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        active?: boolean;
        description?: string;
        discount_percentage?: number;
        effective_from?: string;
        effective_to?: string;
        min_order_amount_cents?: number;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductOrderIncentiveSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/product_order_incentives/${productOrderIncentiveGuid}`,
        operation: "putApiProductOrderIncentive",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a product order incentive
     *
     * @tags default
     * @name DeleteApiProductOrderIncentive
     * @request DELETE:/v1/product_order_incentives/{product_order_incentive_guid}
     */
    deleteApiProductOrderIncentive: (
      productOrderIncentiveGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/product_order_incentives/${productOrderIncentiveGuid}`,
        operation: "deleteApiProductOrderIncentive",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get all partner product orders (admin)
     *
     * @tags default
     * @name GetApiProductOrderList
     * @request GET:/v1/product_orders
     */
    getApiProductOrderList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminProductOrderListSuccess, AuthError | ForbiddenError>({
        path: `/v1/product_orders`,
        operation: "getApiProductOrderList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a partner product order as admin
     *
     * @tags default
     * @name PostApiProductOrderList
     * @request POST:/v1/product_orders
     */
    postApiProductOrderList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: AdminProductOrderCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartnerProductOrderResponseSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/product_orders`,
        operation: "postApiProductOrderList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get single partner product order (admin)
     *
     * @tags default
     * @name GetApiProductOrder
     * @request GET:/v1/product_orders/{i_partner_product_order}
     */
    getApiProductOrder: (
      iPartnerProductOrder: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminProductOrderSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/product_orders/${iPartnerProductOrder}`,
        operation: "getApiProductOrder",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update partner product order line items or notes (admin)
     *
     * @tags default
     * @name PutApiProductOrder
     * @request PUT:/v1/product_orders/{i_partner_product_order}
     */
    putApiProductOrder: (
      iPartnerProductOrder: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiProductOrderPut,
      params: RequestParams = {},
    ) =>
      this.request<AdminProductOrderSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/product_orders/${iPartnerProductOrder}`,
        operation: "putApiProductOrder",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Force activate pending partner product order (admin)
     *
     * @tags default
     * @name PostApiProductOrderActivate
     * @request POST:/v1/product_orders/{i_partner_product_order}/activate
     */
    postApiProductOrderActivate: (
      iPartnerProductOrder: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminProductOrderSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/product_orders/${iPartnerProductOrder}/activate`,
        operation: "postApiProductOrderActivate",
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Soft-cancel partner product order (admin)
     *
     * @tags default
     * @name PostApiProductOrderCancel
     * @request POST:/v1/product_orders/{i_partner_product_order}/cancel
     */
    postApiProductOrderCancel: (
      iPartnerProductOrder: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminProductOrderSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/product_orders/${iPartnerProductOrder}/cancel`,
        operation: "postApiProductOrderCancel",
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get delivery slip data for a partner product order (admin)
     *
     * @tags default
     * @name GetApiProductOrderDeliverySlip
     * @request GET:/v1/product_orders/{i_partner_product_order}/delivery_slip
     */
    getApiProductOrderDeliverySlip: (
      iPartnerProductOrder: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductOrderDeliverySlipResponseSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/product_orders/${iPartnerProductOrder}/delivery_slip`,
        operation: "getApiProductOrderDeliverySlip",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Execute partner product order and create DHL shipment (admin)
     *
     * @tags default
     * @name PostApiProductOrderExecute
     * @request POST:/v1/product_orders/{i_partner_product_order}/execute
     */
    postApiProductOrderExecute: (
      iPartnerProductOrder: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminProductOrderSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/product_orders/${iPartnerProductOrder}/execute`,
        operation: "postApiProductOrderExecute",
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Mark partner product order shipment as delivered (admin)
     *
     * @tags default
     * @name PostApiProductOrderMarkDelivered
     * @request POST:/v1/product_orders/{i_partner_product_order}/mark_delivered
     */
    postApiProductOrderMarkDelivered: (
      iPartnerProductOrder: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminProductOrderSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/product_orders/${iPartnerProductOrder}/mark_delivered`,
        operation: "postApiProductOrderMarkDelivered",
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner product order shipment label. Returns a PDF file
     *
     * @tags default
     * @name GetApiProductOrderShipmentLabel
     * @request GET:/v1/product_orders/{i_partner_product_order}/shipment/label
     */
    getApiProductOrderShipmentLabel: (
      iPartnerProductOrder: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiProductOrderShipmentLabelError | AuthError | ForbiddenError>({
        path: `/v1/product_orders/${iPartnerProductOrder}/shipment/label`,
        operation: "getApiProductOrderShipmentLabel",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Preview partner product order pricing with admin price overrides
     *
     * @tags default
     * @name PostApiProductOrderPrice
     * @request POST:/v1/product_orders/price
     */
    postApiProductOrderPrice: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: AdminProductOrderPriceRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProductOrderPriceResponseSuccess, void | AuthError | ForbiddenError>({
        path: `/v1/product_orders/price`,
        operation: "postApiProductOrderPrice",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get product price lists
     *
     * @tags default
     * @name GetApiProductPriceListList
     * @request GET:/v1/product_price_lists
     */
    getApiProductPriceListList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default false */
        include_expired?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductPriceListListSuccess, AuthError | ForbiddenError>({
        path: `/v1/product_price_lists`,
        operation: "getApiProductPriceListList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a product price list
     *
     * @tags default
     * @name PostApiProductPriceListList
     * @request POST:/v1/product_price_lists
     */
    postApiProductPriceListList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiProductPriceListListPost,
      params: RequestParams = {},
    ) =>
      this.request<ProductPriceListSuccess, AuthError | ForbiddenError>({
        path: `/v1/product_price_lists`,
        operation: "postApiProductPriceListList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get product price list details
     *
     * @tags default
     * @name GetApiProductPriceList
     * @request GET:/v1/product_price_lists/{product_price_list_guid}
     */
    getApiProductPriceList: (
      productPriceListGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductPriceListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/product_price_lists/${productPriceListGuid}`,
        operation: "getApiProductPriceList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a product price list
     *
     * @tags default
     * @name PutApiProductPriceList
     * @request PUT:/v1/product_price_lists/{product_price_list_guid}
     */
    putApiProductPriceList: (
      productPriceListGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        description?: string;
        effective_from?: string;
        effective_to?: string;
        items?: string;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductPriceListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/product_price_lists/${productPriceListGuid}`,
        operation: "putApiProductPriceList",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a product price list
     *
     * @tags default
     * @name DeleteApiProductPriceList
     * @request DELETE:/v1/product_price_lists/{product_price_list_guid}
     */
    deleteApiProductPriceList: (
      productPriceListGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/product_price_lists/${productPriceListGuid}`,
        operation: "deleteApiProductPriceList",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description List all question groups
     *
     * @tags default
     * @name GetApiProductQuestionGroupList
     * @request GET:/v1/product_question_groups
     */
    getApiProductQuestionGroupList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        include_deleted?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductQuestionGroupListSuccess, AuthError>({
        path: `/v1/product_question_groups`,
        operation: "getApiProductQuestionGroupList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new question group
     *
     * @tags default
     * @name PostApiProductQuestionGroupList
     * @request POST:/v1/product_question_groups
     */
    postApiProductQuestionGroupList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        description?: string;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductQuestionGroupSuccess, AuthError>({
        path: `/v1/product_question_groups`,
        operation: "postApiProductQuestionGroupList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a single question group
     *
     * @tags default
     * @name GetApiProductQuestionGroup
     * @request GET:/v1/product_question_groups/{product_question_group_guid}
     */
    getApiProductQuestionGroup: (
      productQuestionGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductQuestionGroupSuccess, AuthError | NotFoundError>({
        path: `/v1/product_question_groups/${productQuestionGroupGuid}`,
        operation: "getApiProductQuestionGroup",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a question group
     *
     * @tags default
     * @name PutApiProductQuestionGroup
     * @request PUT:/v1/product_question_groups/{product_question_group_guid}
     */
    putApiProductQuestionGroup: (
      productQuestionGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        description?: string;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductQuestionGroupSuccess, AuthError | NotFoundError>({
        path: `/v1/product_question_groups/${productQuestionGroupGuid}`,
        operation: "putApiProductQuestionGroup",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Soft delete a question group
     *
     * @tags default
     * @name DeleteApiProductQuestionGroup
     * @request DELETE:/v1/product_question_groups/{product_question_group_guid}
     */
    deleteApiProductQuestionGroup: (
      productQuestionGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, AuthError | NotFoundError>({
        path: `/v1/product_question_groups/${productQuestionGroupGuid}`,
        operation: "deleteApiProductQuestionGroup",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description List questions for a question group
     *
     * @tags default
     * @name GetApiProductQuestionGroupQuestionList
     * @request GET:/v1/product_question_groups/{product_question_group_guid}/questions
     */
    getApiProductQuestionGroupQuestionList: (
      productQuestionGroupGuid: string,
      query?: {
        include_deleted?: boolean;
        customer_visible_only?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductQuestionGroupQuestionListSuccess, NotFoundError>({
        path: `/v1/product_question_groups/${productQuestionGroupGuid}/questions`,
        operation: "getApiProductQuestionGroupQuestionList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create or update a question for a question group
     *
     * @tags default
     * @name PostApiProductQuestionGroupQuestionList
     * @request POST:/v1/product_question_groups/{product_question_group_guid}/questions
     */
    postApiProductQuestionGroupQuestionList: (
      productQuestionGroupGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        is_required?: boolean;
        max_text_length?: number;
        number_max?: number;
        number_min?: number;
        product_question_group_question_guid?: string;
        question_text?: string;
        question_type?: string;
        select_options?: string;
        show_in_customer_form?: boolean;
        sort?: number;
        stars_max?: number;
        stars_min?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductQuestionGroupQuestionSuccess, AuthError | ForbiddenError>({
        path: `/v1/product_question_groups/${productQuestionGroupGuid}/questions`,
        operation: "postApiProductQuestionGroupQuestionList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a question group question
     *
     * @tags default
     * @name PutApiProductQuestionGroupQuestion
     * @request PUT:/v1/product_question_groups/{product_question_group_guid}/questions/{product_question_group_question_guid}
     */
    putApiProductQuestionGroupQuestion: (
      productQuestionGroupGuid: string,
      productQuestionGroupQuestionGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        is_required?: boolean;
        max_text_length?: number;
        number_max?: number;
        number_min?: number;
        question_text?: string;
        question_type?: string;
        select_options?: string;
        show_in_customer_form?: boolean;
        sort?: number;
        stars_max?: number;
        stars_min?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductQuestionGroupQuestionSuccess, AuthError | ForbiddenError>({
        path: `/v1/product_question_groups/${productQuestionGroupGuid}/questions/${productQuestionGroupQuestionGuid}`,
        operation: "putApiProductQuestionGroupQuestion",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Soft delete a question group question
     *
     * @tags default
     * @name DeleteApiProductQuestionGroupQuestion
     * @request DELETE:/v1/product_question_groups/{product_question_group_guid}/questions/{product_question_group_question_guid}
     */
    deleteApiProductQuestionGroupQuestion: (
      productQuestionGroupGuid: string,
      productQuestionGroupQuestionGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, AuthError | ForbiddenError>({
        path: `/v1/product_question_groups/${productQuestionGroupGuid}/questions/${productQuestionGroupQuestionGuid}`,
        operation: "deleteApiProductQuestionGroupQuestion",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get products (public - no auth required)
     *
     * @tags default
     * @name GetApiProductList
     * @request GET:/v1/products
     */
    getApiProductList: (
      query?: {
        /** @default 1 */
        i_realm?: number;
        /** @default "de" */
        device_locale?: string;
        product_type?: string;
        /** @default false */
        online_orderable_only?: boolean;
        /** @default false */
        first_order_selectable_only?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductListSuccess, any>({
        path: `/v1/products`,
        operation: "getApiProductList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a product
     *
     * @tags default
     * @name PostApiProductList
     * @request POST:/v1/products
     */
    postApiProductList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiProductListPost,
      params: RequestParams = {},
    ) =>
      this.request<ProductSuccess, AuthError | ForbiddenError>({
        path: `/v1/products`,
        operation: "postApiProductList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get product details
     *
     * @tags default
     * @name GetApiProduct
     * @request GET:/v1/products/{product_guid}
     */
    getApiProduct: (
      productGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/products/${productGuid}`,
        operation: "getApiProduct",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a product
     *
     * @tags default
     * @name PutApiProduct
     * @request PUT:/v1/products/{product_guid}
     */
    putApiProduct: (
      productGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        auto_reorderable?: boolean;
        description?: string;
        first_order_selectable?: boolean;
        instructions?: string;
        name?: string;
        needs_serial_numbers?: boolean;
        online_orderable?: boolean;
        specimen_type?: string;
        temporarily_unavailable?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/products/${productGuid}`,
        operation: "putApiProduct",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a product
     *
     * @tags default
     * @name DeleteApiProduct
     * @request DELETE:/v1/products/{product_guid}
     */
    deleteApiProduct: (
      productGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/products/${productGuid}`,
        operation: "deleteApiProduct",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to link a product FAQ to a product
     *
     * @tags default
     * @name PostApiProductFaqLink
     * @request POST:/v1/products/{product_guid}/faqs
     */
    postApiProductFaqLink: (
      productGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        product_faq_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductFaqSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/products/${productGuid}/faqs`,
        operation: "postApiProductFaqLink",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to unlink a product FAQ from a product
     *
     * @tags default
     * @name DeleteApiProductFaqLink
     * @request DELETE:/v1/products/{product_guid}/faqs
     */
    deleteApiProductFaqLink: (
      productGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        product_faq_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductFaqSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/products/${productGuid}/faqs`,
        operation: "deleteApiProductFaqLink",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Get latest purchase price from booked product batches
     *
     * @tags default
     * @name GetApiProductLatestPurchasePrice
     * @request GET:/v1/products/{product_guid}/latest_purchase_price
     */
    getApiProductLatestPurchasePrice: (
      productGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductLatestPurchasePriceSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/products/${productGuid}/latest_purchase_price`,
        operation: "getApiProductLatestPurchasePrice",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to link a medical test parameter to a product
     *
     * @tags default
     * @name PostApiProductMedicalTestParameterLink
     * @request POST:/v1/products/{product_guid}/medical_test_parameters
     */
    postApiProductMedicalTestParameterLink: (
      productGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        medical_test_parameter_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/products/${productGuid}/medical_test_parameters`,
        operation: "postApiProductMedicalTestParameterLink",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to unlink a medical test parameter from a product
     *
     * @tags default
     * @name DeleteApiProductMedicalTestParameterLink
     * @request DELETE:/v1/products/{product_guid}/medical_test_parameters
     */
    deleteApiProductMedicalTestParameterLink: (
      productGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        medical_test_parameter_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/products/${productGuid}/medical_test_parameters`,
        operation: "deleteApiProductMedicalTestParameterLink",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Get CaboPOC product summaries
     *
     * @tags default
     * @name GetApiPocProductSummaryList
     * @request GET:/v1/products/poc_summary
     */
    getApiPocProductSummaryList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        product_type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProductListSuccess, AuthError | ForbiddenError>({
        path: `/v1/products/poc_summary`,
        operation: "getApiPocProductSummaryList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Public catalog of available, non-internal, non-custom medical test profiles. No authentication, patient forms, costs, or vendor details.
     *
     * @tags default
     * @name GetApiPublicMedicalTestProfileList
     * @request GET:/v1/public/medical_test_profiles
     */
    getApiPublicMedicalTestProfileList: (
      query: {
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PublicMedicalTestProfileListSuccess, NotFoundError>({
        path: `/v1/public/medical_test_profiles`,
        operation: "getApiPublicMedicalTestProfileList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get questionnaires
     *
     * @tags default
     * @name GetApiQuestionnaireList
     * @request GET:/v1/questionnaires
     */
    getApiQuestionnaireList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<QuestionnaireListSuccess, AuthError>({
        path: `/v1/questionnaires`,
        operation: "getApiQuestionnaireList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get sales organization's partners
     *
     * @tags default
     * @name GetApiSalesOrganizationPartnerList
     * @request GET:/v1/sales_organizations/{sales_organization_guid}/partners
     */
    getApiSalesOrganizationPartnerList: (
      salesOrganizationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartnerListSuccess, AuthError | ForbiddenError>({
        path: `/v1/sales_organizations/${salesOrganizationGuid}/partners`,
        operation: "getApiSalesOrganizationPartnerList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get sales commission items
     *
     * @tags default
     * @name GetApiSalesCommissionItemsList
     * @request GET:/v1/sales_organizations/{sales_organization_guid}/sales_commission_items
     */
    getApiSalesCommissionItemsList: (
      salesOrganizationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default "json" */
        output?: "csv" | "json" | "xlsx";
        start?: string;
        end?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalesCommissionItemListSuccess, AuthError | ForbiddenError>({
        path: `/v1/sales_organizations/${salesOrganizationGuid}/sales_commission_items`,
        operation: "getApiSalesCommissionItemsList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get shipments
     *
     * @tags default
     * @name GetApiShipmentList
     * @request GET:/v1/shipments
     */
    getApiShipmentList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShipmentListSuccess, AuthError | ForbiddenError>({
        path: `/v1/shipments`,
        operation: "getApiShipmentList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to cancel shipment
     *
     * @tags default
     * @name PutApiShipmentCancel
     * @request PUT:/v1/shipments/cancel
     */
    putApiShipmentCancel: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        i_equipment_shipment?: number;
        test_sample_shipment_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiShipmentCancelError | AuthError | ForbiddenError>({
        path: `/v1/shipments/cancel`,
        operation: "putApiShipmentCancel",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to check shipments
     *
     * @tags default
     * @name GetApiShipmentCheck
     * @request GET:/v1/shipments/check
     */
    getApiShipmentCheck: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShipmentSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/shipments/check`,
        operation: "getApiShipmentCheck",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get shipment by external code
     *
     * @tags default
     * @name GetApiShipmentExternalCode
     * @request GET:/v1/shipments/external_code
     */
    getApiShipmentExternalCode: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShipmentSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/shipments/external_code`,
        operation: "getApiShipmentExternalCode",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get starter kits
     *
     * @tags default
     * @name GetApiStarterKitList
     * @request GET:/v1/starter_kits
     */
    getApiStarterKitList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StarterKitListSuccess, AuthError | ForbiddenError>({
        path: `/v1/starter_kits`,
        operation: "getApiStarterKitList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create starter kit
     *
     * @tags default
     * @name PostApiStarterKitList
     * @request POST:/v1/starter_kits
     */
    postApiStarterKitList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: StarterKitCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<StarterKitSuccess, AuthError | ForbiddenError>({
        path: `/v1/starter_kits`,
        operation: "postApiStarterKitList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get starter kit
     *
     * @tags default
     * @name GetApiStarterKit
     * @request GET:/v1/starter_kits/{i_starter_kit}
     */
    getApiStarterKit: (
      iStarterKit: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StarterKitSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/starter_kits/${iStarterKit}`,
        operation: "getApiStarterKit",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update starter kit
     *
     * @tags default
     * @name PutApiStarterKit
     * @request PUT:/v1/starter_kits/{i_starter_kit}
     */
    putApiStarterKit: (
      iStarterKit: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: StarterKitUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<StarterKitSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/starter_kits/${iStarterKit}`,
        operation: "putApiStarterKit",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete starter kit
     *
     * @tags default
     * @name DeleteApiStarterKit
     * @request DELETE:/v1/starter_kits/{i_starter_kit}
     */
    deleteApiStarterKit: (
      iStarterKit: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/starter_kits/${iStarterKit}`,
        operation: "deleteApiStarterKit",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get partner payment methods
     *
     * @tags default
     * @name GetApiStripePaymentMethods
     * @summary Retrieve payment methods for the partner
     * @request GET:/v1/stripe/payment_methods
     */
    getApiStripePaymentMethods: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        partner_guid: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StripePaymentMethodsResponseSuccess, AuthError>({
        path: `/v1/stripe/payment_methods`,
        operation: "getApiStripePaymentMethods",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete a partner payment method
     *
     * @tags default
     * @name DeleteApiStripePaymentMethods
     * @summary Delete a payment method for the partner
     * @request DELETE:/v1/stripe/payment_methods
     */
    deleteApiStripePaymentMethods: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        partner_guid: string;
        payment_method_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, AuthError>({
        path: `/v1/stripe/payment_methods`,
        operation: "deleteApiStripePaymentMethods",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to generate checkout session
     *
     * @tags default
     * @name PostApiStripeSetup
     * @summary Create a Stripe checkout session for the partner
     * @request POST:/v1/stripe/setup
     */
    postApiStripeSetup: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        partner_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StripeCheckoutResponseSuccess, AuthError>({
        path: `/v1/stripe/setup`,
        operation: "postApiStripeSetup",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to handle Stripe webhooks
     *
     * @tags default
     * @name PostApiStripeWebhook
     * @request POST:/v1/stripe/webhook
     */
    postApiStripeWebhook: (params: RequestParams = {}) =>
      this.request<Success, AuthError>({
        path: `/v1/stripe/webhook`,
        operation: "postApiStripeWebhook",
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get summarized partner invoices
     *
     * @tags default
     * @name GetApiSummarizedPartnerInvoiceList
     * @request GET:/v1/summarized_partner_invoices
     */
    getApiSummarizedPartnerInvoiceList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @min 0 */
        billing_cycle_month?: number;
        /** @min 0 */
        billing_cycle_year?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SummarizedPartnerInvoiceListSuccess, AuthError | ForbiddenError>({
        path: `/v1/summarized_partner_invoices`,
        operation: "getApiSummarizedPartnerInvoiceList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get supplier deliveries
     *
     * @tags default
     * @name GetApiSupplierDeliveryList
     * @request GET:/v1/supplier_deliveries
     */
    getApiSupplierDeliveryList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        product_type?: string;
        product_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SupplierDeliveryListSuccess, AuthError | ForbiddenError>({
        path: `/v1/supplier_deliveries`,
        operation: "getApiSupplierDeliveryList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a supplier delivery
     *
     * @tags default
     * @name PostApiSupplierDeliveryList
     * @request POST:/v1/supplier_deliveries
     */
    postApiSupplierDeliveryList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiSupplierDeliveryPost,
      params: RequestParams = {},
    ) =>
      this.request<Success, AuthError | ForbiddenError>({
        path: `/v1/supplier_deliveries`,
        operation: "postApiSupplierDeliveryList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a supplier delivery
     *
     * @tags default
     * @name GetApiSupplierDelivery
     * @request GET:/v1/supplier_deliveries/{supplier_delivery_guid}
     */
    getApiSupplierDelivery: (
      supplierDeliveryGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SupplierDeliverySuccess, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/supplier_deliveries/${supplierDeliveryGuid}`,
        operation: "getApiSupplierDelivery",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a supplier delivery
     *
     * @tags default
     * @name PutApiSupplierDelivery
     * @request PUT:/v1/supplier_deliveries/{supplier_delivery_guid}
     */
    putApiSupplierDelivery: (
      supplierDeliveryGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiSupplierDeliveryPut,
      params: RequestParams = {},
    ) =>
      this.request<Success, AuthError | ForbiddenError>({
        path: `/v1/supplier_deliveries/${supplierDeliveryGuid}`,
        operation: "putApiSupplierDelivery",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Cancel a supplier delivery
     *
     * @tags default
     * @name DeleteApiSupplierDelivery
     * @request DELETE:/v1/supplier_deliveries/{supplier_delivery_guid}
     */
    deleteApiSupplierDelivery: (
      supplierDeliveryGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, AuthError | ForbiddenError>({
        path: `/v1/supplier_deliveries/${supplierDeliveryGuid}`,
        operation: "deleteApiSupplierDelivery",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Receive a supplier delivery item into stock
     *
     * @tags default
     * @name PostApiSupplierDeliveryItemReceipt
     * @request POST:/v1/supplier_delivery_items/{supplier_delivery_item_guid}/receive
     */
    postApiSupplierDeliveryItemReceipt: (
      supplierDeliveryItemGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiSupplierDeliveryItemReceiptPost,
      params: RequestParams = {},
    ) =>
      this.request<Success, AuthError | ForbiddenError>({
        path: `/v1/supplier_delivery_items/${supplierDeliveryItemGuid}/receive`,
        operation: "postApiSupplierDeliveryItemReceipt",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to test DB connection
     *
     * @tags default
     * @name GetTest
     * @request GET:/v1/test
     */
    getTest: (
      query: {
        message: string;
        number?: number;
        date?: string;
        boolean?: boolean;
        /** @default false */
        raise_key_error?: boolean;
        short_string?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSuccess, any>({
        path: `/v1/test`,
        operation: "getTest",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to test DB connection
     *
     * @tags default
     * @name PostTest
     * @request POST:/v1/test
     */
    postTest: (
      query: {
        message: string;
        number?: number;
        date?: string;
        boolean?: boolean;
        /** @default false */
        raise_key_error?: boolean;
        short_string?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSuccess, any>({
        path: `/v1/test`,
        operation: "postTest",
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name GetApiTestExecutionConsent
     * @request GET:/v1/test_execution_consents/{validation_token}
     */
    getApiTestExecutionConsent: (
      validationToken: string,
      query: {
        client_bundle_id: string;
        /** @default "de" */
        device_locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestExecutionConsentSuccess, any>({
        path: `/v1/test_execution_consents/${validationToken}`,
        operation: "getApiTestExecutionConsent",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags default
     * @name PutApiTestExecutionConsent
     * @request PUT:/v1/test_execution_consents/{validation_token}
     */
    putApiTestExecutionConsent: (
      validationToken: string,
      query: {
        client_bundle_id: string;
        /** @default "de" */
        device_locale?: string;
      },
      payload: {
        agb_confirmed?: boolean;
        consent_confirmed?: boolean;
        patient_signature?: string;
        patient_signature_mime_type?: string;
        privacy_confirmed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestExecutionConsentSuccess, ApiTestExecutionConsentError>({
        path: `/v1/test_execution_consents/${validationToken}`,
        operation: "putApiTestExecutionConsent",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get test kit types
     *
     * @tags default
     * @name GetApiTestKitTypeList
     * @request GET:/v1/test_kit_types
     */
    getApiTestKitTypeList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestKitTypeListSuccess, AuthError | ForbiddenError>({
        path: `/v1/test_kit_types`,
        operation: "getApiTestKitTypeList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create test kit type
     *
     * @tags default
     * @name PostApiTestKitTypeList
     * @request POST:/v1/test_kit_types
     */
    postApiTestKitTypeList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiTestKitTypeListPost,
      params: RequestParams = {},
    ) =>
      this.request<TestKitTypeSuccess, ApiTestKitTypeListError | AuthError | ForbiddenError>({
        path: `/v1/test_kit_types`,
        operation: "postApiTestKitTypeList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get test kit type
     *
     * @tags default
     * @name GetApiTestKitType
     * @request GET:/v1/test_kit_types/{i_test_kit_type}
     */
    getApiTestKitType: (
      iTestKitType: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestKitTypeSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/test_kit_types/${iTestKitType}`,
        operation: "getApiTestKitType",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update test kit type
     *
     * @tags default
     * @name PutApiTestKitType
     * @request PUT:/v1/test_kit_types/{i_test_kit_type}
     */
    putApiTestKitType: (
      iTestKitType: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        adaptor_equipment_sku_id?: number;
        i_equipment_sku?: number;
        lanzette_equipment_sku_id?: number;
        specimen_max_amount?: number;
        specimen_type?: string;
        specimen_unit?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestKitTypeSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/test_kit_types/${iTestKitType}`,
        operation: "putApiTestKitType",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to upsert test kit type translation
     *
     * @tags default
     * @name PostApiTestKitTypeTranslation
     * @request POST:/v1/test_kit_types/{i_test_kit_type}/translations
     */
    postApiTestKitTypeTranslation: (
      iTestKitType: number,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        auto_translate?: boolean;
        color_name?: string;
        i_language?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestKitTypeSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/test_kit_types/${iTestKitType}/translations`,
        operation: "postApiTestKitTypeTranslation",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to check test kit
     *
     * @tags default
     * @name GetApiTestKitCheck
     * @request GET:/v1/test_kits/check
     */
    getApiTestKitCheck: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestKitSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/test_kits/check`,
        operation: "getApiTestKitCheck",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to generate test kits
     *
     * @tags default
     * @name PostApiTestKitGeneration
     * @request POST:/v1/test_kits/generate
     */
    postApiTestKitGeneration: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        color?: string;
        end?: number;
        expiration?: string;
        production?: string;
        start?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiTestKitGenerationError | AuthError | ForbiddenError>({
        path: `/v1/test_kits/generate`,
        operation: "postApiTestKitGeneration",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to replace collected test kit
     *
     * @tags default
     * @name PutApiCollectedTestKitReplace
     * @request PUT:/v1/test_kits/replace
     */
    putApiCollectedTestKitReplace: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        code?: string;
        other_code?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiCollectedTestKitReplaceError | AuthError | ForbiddenError>({
        path: `/v1/test_kits/replace`,
        operation: "putApiCollectedTestKitReplace",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get test samples
     *
     * @tags default
     * @name GetApiTestSampleList
     * @request GET:/v1/test_samples
     */
    getApiTestSampleList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        partner_guid?: string;
        vendor_guid?: string;
        start_time?: string;
        end_time?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleListSuccess, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/test_samples`,
        operation: "getApiTestSampleList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get test samples. The structure for the 'filtering' parameter is detailed in the model: {{ TestSamplesFiltering }}
     *
     * @tags default
     * @name GetApiTestSampleListPagination
     * @request GET:/v1/test_samples_paginated
     */
    getApiTestSampleListPagination: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        partner_guid?: string;
        vendor_guid?: string;
        medical_test_guid?: string;
        start_time?: string;
        end_time?: string;
        offset?: number;
        limit?: number;
        sort_field?: string;
        sort_direction?: string;
        created_from?: number;
        created_to?: number;
        collected_from?: number;
        collected_to?: number;
        received_from?: number;
        received_to?: number;
        search_query?: string;
        has_notes?: number;
        status?: string;
        overdue?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleListPaginationSuccess, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/test_samples_paginated`,
        operation: "getApiTestSampleListPagination",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get test sample detail
     *
     * @tags default
     * @name GetApiTestSampleDetail
     * @request GET:/v1/test_samples/{test_sample_guid}
     */
    getApiTestSampleDetail: (
      testSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleSuccess, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/test_samples/${testSampleGuid}`,
        operation: "getApiTestSampleDetail",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to invalidate sample
     *
     * @tags default
     * @name PutApiTestSampleInvalidate
     * @request PUT:/v1/test_samples/{test_sample_guid}/invalidate
     */
    putApiTestSampleInvalidate: (
      testSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        bill_invalidation?: boolean;
        reason?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleSuccess, ApiTestSampleInvalidateError | AuthError | ForbiddenError>({
        path: `/v1/test_samples/${testSampleGuid}/invalidate`,
        operation: "putApiTestSampleInvalidate",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create sample note
     *
     * @tags default
     * @name PostApiTestSampleNoteList
     * @request POST:/v1/test_samples/{test_sample_guid}/notes
     */
    postApiTestSampleNoteList: (
      testSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        attachments?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/test_samples/${testSampleGuid}/notes`,
        operation: "postApiTestSampleNoteList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update sample note
     *
     * @tags default
     * @name PutApiTestSampleNote
     * @request PUT:/v1/test_samples/{test_sample_guid}/notes/{test_sample_note_guid}
     */
    putApiTestSampleNote: (
      testSampleGuid: string,
      testSampleNoteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        attachments?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/test_samples/${testSampleGuid}/notes/${testSampleNoteGuid}`,
        operation: "putApiTestSampleNote",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete sample note
     *
     * @tags default
     * @name DeleteApiTestSampleNote
     * @request DELETE:/v1/test_samples/{test_sample_guid}/notes/{test_sample_note_guid}
     */
    deleteApiTestSampleNote: (
      testSampleGuid: string,
      testSampleNoteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleSuccess, ApiTestSampleNoteError | AuthError | ForbiddenError>({
        path: `/v1/test_samples/${testSampleGuid}/notes/${testSampleNoteGuid}`,
        operation: "deleteApiTestSampleNote",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to publish sample note
     *
     * @tags default
     * @name PutApiTestSampleNotePublish
     * @request PUT:/v1/test_samples/{test_sample_guid}/notes/{test_sample_note_guid}/publish
     */
    putApiTestSampleNotePublish: (
      testSampleGuid: string,
      testSampleNoteGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleSuccess, ApiTestSampleNotePublishError | AuthError | ForbiddenError>({
        path: `/v1/test_samples/${testSampleGuid}/notes/${testSampleNoteGuid}/publish`,
        operation: "putApiTestSampleNotePublish",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get test sample pin
     *
     * @tags default
     * @name GetApiTestSamplePin
     * @request GET:/v1/test_samples/{test_sample_guid}/pin
     */
    getApiTestSamplePin: (
      testSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSamplePinSuccess, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/test_samples/${testSampleGuid}/pin`,
        operation: "getApiTestSamplePin",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get test sample result pdf
     *
     * @tags default
     * @name GetApiTestSampleResultPdf
     * @request GET:/v1/test_samples/{test_sample_guid}/results_pdf
     */
    getApiTestSampleResultPdf: (
      testSampleGuid: string,
      query: {
        pin: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiTestSampleResultPdfError | AuthError | ForbiddenError>({
        path: `/v1/test_samples/${testSampleGuid}/results_pdf`,
        operation: "getApiTestSampleResultPdf",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to get test sample result pdf without URL credentials
     *
     * @tags default
     * @name PostApiTestSampleResultPdf
     * @request POST:/v1/test_samples/{test_sample_guid}/results_pdf
     */
    postApiTestSampleResultPdf: (
      testSampleGuid: string,
      payload: {
        client_bundle_id?: string;
        device_locale?: string;
        pin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiTestSampleResultPdfError>({
        path: `/v1/test_samples/${testSampleGuid}/results_pdf`,
        operation: "postApiTestSampleResultPdf",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Endpoint to invalidate sample result
     *
     * @tags default
     * @name PutApiTestSampleResultInvalidate
     * @request PUT:/v1/test_samples/{test_sample_guid}/results/{name}/invalidate
     */
    putApiTestSampleResultInvalidate: (
      testSampleGuid: string,
      name: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        reason?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleSuccess, ApiTestSampleResultInvalidateError | AuthError | ForbiddenError>({
        path: `/v1/test_samples/${testSampleGuid}/results/${name}/invalidate`,
        operation: "putApiTestSampleResultInvalidate",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to accept test results sharing request
     *
     * @tags default
     * @name PutApiTestSampleAcceptSharingRequest
     * @request PUT:/v1/test_samples/accept_sharing_request
     */
    putApiTestSampleAcceptSharingRequest: (payload: ResultsSharingRequestConsentPayload, params: RequestParams = {}) =>
      this.request<Success, ResultsSharingRequestError>({
        path: `/v1/test_samples/accept_sharing_request`,
        operation: "putApiTestSampleAcceptSharingRequest",
        method: "PUT",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to cancel sharing of an already shared test sample
     *
     * @tags default
     * @name PutApiTestSampleCancelSharing
     * @request PUT:/v1/test_samples/cancel_sharing
     */
    putApiTestSampleCancelSharing: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        test_sample_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleSuccess, AuthError | ForbiddenError | NotFoundError>({
        path: `/v1/test_samples/cancel_sharing`,
        operation: "putApiTestSampleCancelSharing",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to preview a test results sharing request without accepting it
     *
     * @tags default
     * @name PostApiTestSampleSharingRequestPreview
     * @request POST:/v1/test_samples/sharing_request/preview
     */
    postApiTestSampleSharingRequestPreview: (
      payload: ResultsSharingRequestPreviewPayload,
      params: RequestParams = {},
    ) =>
      this.request<ResultsSharingRequestSuccess, ResultsSharingRequestError>({
        path: `/v1/test_samples/sharing_request/preview`,
        operation: "postApiTestSampleSharingRequestPreview",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to test DB connection using Celery worker
     *
     * @tags default
     * @name GetTestCelery
     * @request GET:/v1/test/celery
     */
    getTestCelery: (
      query: {
        message: string;
        short_string?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSuccess, any>({
        path: `/v1/test/celery`,
        operation: "getTestCelery",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete user
     *
     * @tags default
     * @name DeleteApiUser
     * @request DELETE:/v1/users/{user_guid}
     */
    deleteApiUser: (
      userGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiDashboardUserRoleError | AuthError | ForbiddenError>({
        path: `/v1/users/${userGuid}`,
        operation: "deleteApiUser",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get user signature
     *
     * @tags default
     * @name GetApiUserSignature
     * @request GET:/v1/users/{user_guid}/signature
     */
    getApiUserSignature: (
      userGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiUserSignatureResponse, AuthError | ForbiddenError | ApiUserSignatureNotFoundError>({
        path: `/v1/users/${userGuid}/signature`,
        operation: "getApiUserSignature",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to upload user signature
     *
     * @tags default
     * @name PutApiUserSignature
     * @request PUT:/v1/users/{user_guid}/signature
     */
    putApiUserSignature: (
      userGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        signature_image?: string;
        signature_mime_type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserSuccess, ApiUserSignatureError | AuthError | ForbiddenError>({
        path: `/v1/users/${userGuid}/signature`,
        operation: "putApiUserSignature",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete user signature
     *
     * @tags default
     * @name DeleteApiUserSignature
     * @request DELETE:/v1/users/{user_guid}/signature
     */
    deleteApiUserSignature: (
      userGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/users/${userGuid}/signature`,
        operation: "deleteApiUserSignature",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to check user's coupon
     *
     * @tags default
     * @name GetApiUserCouponCheck
     * @request GET:/v1/users/check_coupon
     */
    getApiUserCouponCheck: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        pin: string;
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponSuccess, ApiUserCouponCheckError | AuthError>({
        path: `/v1/users/check_coupon`,
        operation: "getApiUserCouponCheck",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get dashboard users
     *
     * @tags default
     * @name GetApiDashboardUserList
     * @request GET:/v1/users/dashboard_users
     */
    getApiDashboardUserList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DashboardUserListSuccess, AuthError | ForbiddenError>({
        path: `/v1/users/dashboard_users`,
        operation: "getApiDashboardUserList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create dashboard user
     *
     * @tags default
     * @name PostApiDashboardUserList
     * @request POST:/v1/users/dashboard_users
     */
    postApiDashboardUserList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        email?: string;
        first_name?: string;
        last_name?: string;
        role_name?: string;
        sales_organization_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DashboardUserSuccess, ApiDashboardUserListError | AuthError | ForbiddenError>({
        path: `/v1/users/dashboard_users`,
        operation: "postApiDashboardUserList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update dashboard user
     *
     * @tags default
     * @name PutApiDashboardUser
     * @request PUT:/v1/users/dashboard_users/{user_guid}
     */
    putApiDashboardUser: (
      userGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        first_name?: string;
        last_name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DashboardUserSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/users/dashboard_users/${userGuid}`,
        operation: "putApiDashboardUser",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to add dashboard role to user
     *
     * @tags default
     * @name PostApiDashboardUserRole
     * @request POST:/v1/users/dashboard_users/{user_guid}/roles
     */
    postApiDashboardUserRole: (
      userGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        role_name?: string;
        sales_organization_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DashboardUserSuccess, ApiDashboardUserRoleError | AuthError | ForbiddenError>({
        path: `/v1/users/dashboard_users/${userGuid}/roles`,
        operation: "postApiDashboardUserRole",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to remove dashboard role from user
     *
     * @tags default
     * @name DeleteApiDashboardUserRole
     * @request DELETE:/v1/users/dashboard_users/{user_guid}/roles
     */
    deleteApiDashboardUserRole: (
      userGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        role_name?: string;
        sales_organization_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DashboardUserSuccess, ApiDashboardUserRoleError | AuthError | ForbiddenError>({
        path: `/v1/users/dashboard_users/${userGuid}/roles`,
        operation: "deleteApiDashboardUserRole",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to init update user email
     *
     * @tags default
     * @name PutApiInitUserEmailUpdate
     * @request PUT:/v1/users/email/update
     */
    putApiInitUserEmailUpdate: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiInitUserEmailUpdateError | AuthError | ForbiddenError>({
        path: `/v1/users/email/update`,
        operation: "putApiInitUserEmailUpdate",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to complete user email update
     *
     * @tags default
     * @name PutApiCompleteUserEmailUpdate
     * @request PUT:/v1/users/email/update/complete
     */
    putApiCompleteUserEmailUpdate: (
      payload: {
        client_bundle_id?: string;
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/users/email/update/complete`,
        operation: "putApiCompleteUserEmailUpdate",
        method: "PUT",
        body: payload,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Endpoint to get user profile
     *
     * @tags default
     * @name GetApiUserMe
     * @request GET:/v1/users/me
     */
    getApiUserMe: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserSuccess, AuthError>({
        path: `/v1/users/me`,
        operation: "getApiUserMe",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update user profile
     *
     * @tags default
     * @name PutApiUserMe
     * @request PUT:/v1/users/me
     */
    putApiUserMe: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        subscribed_to_blogs?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserSuccess, AuthError>({
        path: `/v1/users/me`,
        operation: "putApiUserMe",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to accept AVV for the current user
     *
     * @tags default
     * @name PutApiUserMeAvv
     * @request PUT:/v1/users/me/avv
     */
    putApiUserMeAvv: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserSuccess, AuthError | ForbiddenError>({
        path: `/v1/users/me/avv`,
        operation: "putApiUserMeAvv",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get user's minigame result
     *
     * @tags default
     * @name GetApiUserMinigameResult
     * @request GET:/v1/users/me/minigame_results
     */
    getApiUserMinigameResult: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinigameResultSuccess, AuthError>({
        path: `/v1/users/me/minigame_results`,
        operation: "getApiUserMinigameResult",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update user password
     *
     * @tags default
     * @name PutApiUserPassword
     * @request PUT:/v1/users/password
     */
    putApiUserPassword: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        old_password?: string;
        password?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiUserPasswordError | AuthError | ForbiddenError>({
        path: `/v1/users/password`,
        operation: "putApiUserPassword",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to request user password reset
     *
     * @tags default
     * @name PostApiInitUserPasswordReset
     * @request POST:/v1/users/password/reset
     */
    postApiInitUserPasswordReset: (
      payload: {
        client_bundle_id?: string;
        device_locale?: string;
        email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/users/password/reset`,
        operation: "postApiInitUserPasswordReset",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Endpoint to complete user password reset
     *
     * @tags default
     * @name PostApiCompleteUserPasswordReset
     * @request POST:/v1/users/password/reset/complete
     */
    postApiCompleteUserPasswordReset: (
      payload: {
        client_bundle_id?: string;
        password?: string;
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/v1/users/password/reset/complete`,
        operation: "postApiCompleteUserPasswordReset",
        method: "POST",
        body: payload,
        ...params,
      }),

    /**
     * @description Update a PIN using old_pin, or replace a temporary PIN using pin_change_proof from its PIN login
     *
     * @tags default
     * @name PutApiUserPin
     * @request PUT:/v1/users/pin
     */
    putApiUserPin: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        old_pin?: string;
        pin?: string;
        pin_change_proof?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiUserPinError | AuthError | EmployeePinRateLimitError | EmployeePinUnavailableError>({
        path: `/v1/users/pin`,
        operation: "putApiUserPin",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get user's test samples
     *
     * @tags default
     * @name GetApiUserTestSampleList
     * @request GET:/v1/users/test_samples
     */
    getApiUserTestSampleList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleListSuccess, AuthError>({
        path: `/v1/users/test_samples`,
        operation: "getApiUserTestSampleList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get user's test sample result pdf
     *
     * @tags default
     * @name GetApiUserTestSampleResultPdf
     * @request GET:/v1/users/test_samples/{test_sample_guid}/results_pdf
     */
    getApiUserTestSampleResultPdf: (
      testSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiUserTestSampleResultPdfError | AuthError | ForbiddenError>({
        path: `/v1/users/test_samples/${testSampleGuid}/results_pdf`,
        operation: "getApiUserTestSampleResultPdf",
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * @description Endpoint to share user's test sample
     *
     * @tags default
     * @name PutApiUserTestSampleShare
     * @request PUT:/v1/users/test_samples/{test_sample_guid}/share
     */
    putApiUserTestSampleShare: (
      testSampleGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TestSampleListSuccess, NotFoundError | AuthError>({
        path: `/v1/users/test_samples/${testSampleGuid}/share`,
        operation: "putApiUserTestSampleShare",
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Public endpoint to get vaccination education data by validation_token
     *
     * @tags default
     * @name GetApiCouponVaccinationEducation
     * @request GET:/v1/vaccination_education/{validation_token}
     */
    getApiCouponVaccinationEducation: (
      validationToken: string,
      query?: {
        client_bundle_id?: string;
        device_locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponVaccinationSuccess, NotFoundError>({
        path: `/v1/vaccination_education/${validationToken}`,
        operation: "getApiCouponVaccinationEducation",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Public endpoint to submit vaccination education by validation_token
     *
     * @tags default
     * @name PutApiCouponVaccinationEducation
     * @request PUT:/v1/vaccination_education/{validation_token}
     */
    putApiCouponVaccinationEducation: (
      validationToken: string,
      payload: {
        education_confirmed?: boolean;
        education_signature?: string;
        education_signature_mime_type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, NotFoundError>({
        path: `/v1/vaccination_education/${validationToken}`,
        operation: "putApiCouponVaccinationEducation",
        method: "PUT",
        body: payload,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Public endpoint to get vaccination form data by validation_token
     *
     * @tags default
     * @name GetApiCouponVaccinationForm
     * @request GET:/v1/vaccination_form/{validation_token}
     */
    getApiCouponVaccinationForm: (
      validationToken: string,
      query?: {
        client_bundle_id?: string;
        device_locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CouponVaccinationSuccess, NotFoundError>({
        path: `/v1/vaccination_form/${validationToken}`,
        operation: "getApiCouponVaccinationForm",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Public endpoint to submit vaccination form answers by validation_token
     *
     * @tags default
     * @name PutApiCouponVaccinationForm
     * @request PUT:/v1/vaccination_form/{validation_token}
     */
    putApiCouponVaccinationForm: (
      validationToken: string,
      payload: {
        answers?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, NotFoundError>({
        path: `/v1/vaccination_form/${validationToken}`,
        operation: "putApiCouponVaccinationForm",
        method: "PUT",
        body: payload,
        ...params,
      }),

    /**
     * @description List all vaccinations
     *
     * @tags default
     * @name GetApiVaccinationList
     * @request GET:/v1/vaccinations
     */
    getApiVaccinationList: (
      query: {
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VaccinationListSuccess, any>({
        path: `/v1/vaccinations`,
        operation: "getApiVaccinationList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new vaccination
     *
     * @tags default
     * @name PostApiVaccinationList
     * @request POST:/v1/vaccinations
     */
    postApiVaccinationList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        education_text?: string;
        name?: string;
        patient_details_form?: string;
        price?: number;
        product_question_group_guid?: string;
        reminder_months?: number;
        vaccine_name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VaccinationSuccess, AuthError>({
        path: `/v1/vaccinations`,
        operation: "postApiVaccinationList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a single vaccination
     *
     * @tags default
     * @name GetApiVaccination
     * @request GET:/v1/vaccinations/{vaccination_guid}
     */
    getApiVaccination: (
      vaccinationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VaccinationSuccess, AuthError | NotFoundError>({
        path: `/v1/vaccinations/${vaccinationGuid}`,
        operation: "getApiVaccination",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update a vaccination
     *
     * @tags default
     * @name PutApiVaccination
     * @request PUT:/v1/vaccinations/{vaccination_guid}
     */
    putApiVaccination: (
      vaccinationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        education_text?: string;
        name?: string;
        patient_details_form?: string;
        price?: number;
        product_question_group_guid?: string;
        reminder_months?: number;
        vaccine_name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VaccinationSuccess, AuthError | NotFoundError>({
        path: `/v1/vaccinations/${vaccinationGuid}`,
        operation: "putApiVaccination",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Soft delete a vaccination
     *
     * @tags default
     * @name DeleteApiVaccination
     * @request DELETE:/v1/vaccinations/{vaccination_guid}
     */
    deleteApiVaccination: (
      vaccinationGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, AuthError | NotFoundError>({
        path: `/v1/vaccinations/${vaccinationGuid}`,
        operation: "deleteApiVaccination",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get vendor test machines
     *
     * @tags default
     * @name GetApiVendorTestMachineList
     * @request GET:/v1/vendor_test_machines
     */
    getApiVendorTestMachineList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorTestMachineListSuccess, AuthError | ForbiddenError>({
        path: `/v1/vendor_test_machines`,
        operation: "getApiVendorTestMachineList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create vendor test machine
     *
     * @tags default
     * @name PostApiVendorTestMachineList
     * @request POST:/v1/vendor_test_machines
     */
    postApiVendorTestMachineList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        dead_specimen_amount?: number;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorTestMachineSuccess, AuthError | ForbiddenError>({
        path: `/v1/vendor_test_machines`,
        operation: "postApiVendorTestMachineList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get vendor test machine
     *
     * @tags default
     * @name GetApiVendorTestMachine
     * @request GET:/v1/vendor_test_machines/{vendor_test_machine_guid}
     */
    getApiVendorTestMachine: (
      vendorTestMachineGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorTestMachineSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/vendor_test_machines/${vendorTestMachineGuid}`,
        operation: "getApiVendorTestMachine",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update vendor test machine
     *
     * @tags default
     * @name PutApiVendorTestMachine
     * @request PUT:/v1/vendor_test_machines/{vendor_test_machine_guid}
     */
    putApiVendorTestMachine: (
      vendorTestMachineGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        dead_specimen_amount?: number;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorTestMachineSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/vendor_test_machines/${vendorTestMachineGuid}`,
        operation: "putApiVendorTestMachine",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get vendors
     *
     * @tags default
     * @name GetApiVendorList
     * @request GET:/v1/vendors
     */
    getApiVendorList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorListSuccess, AuthError | ForbiddenError>({
        path: `/v1/vendors`,
        operation: "getApiVendorList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create vendor
     *
     * @tags default
     * @name PostApiVendorList
     * @request POST:/v1/vendors
     */
    postApiVendorList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        city?: string;
        country?: string;
        name?: string;
        name2?: string;
        name3?: string;
        street?: string;
        zip?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorSuccess, ApiVendorListError | AuthError | ForbiddenError>({
        path: `/v1/vendors`,
        operation: "postApiVendorList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get vendor timeoffs
     *
     * @tags default
     * @name GetApiVendorTimeoffList
     * @request GET:/v1/vendors/{vendor_guid}/timeoffs
     */
    getApiVendorTimeoffList: (
      vendorGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorTimeoffListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/timeoffs`,
        operation: "getApiVendorTimeoffList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to add vendor timeoff
     *
     * @tags default
     * @name PostApiVendorTimeoffList
     * @request POST:/v1/vendors/{vendor_guid}/timeoffs
     */
    postApiVendorTimeoffList: (
      vendorGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        end?: string;
        start?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorTimeoffSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/timeoffs`,
        operation: "postApiVendorTimeoffList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get vendor timeoff
     *
     * @tags default
     * @name GetApiVendorTimeoff
     * @request GET:/v1/vendors/{vendor_guid}/timeoffs/{vendor_time_off_guid}
     */
    getApiVendorTimeoff: (
      vendorGuid: string,
      vendorTimeOffGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorTimeoffSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/timeoffs/${vendorTimeOffGuid}`,
        operation: "getApiVendorTimeoff",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete vendor timeoff
     *
     * @tags default
     * @name DeleteApiVendorTimeoff
     * @request DELETE:/v1/vendors/{vendor_guid}/timeoffs/{vendor_time_off_guid}
     */
    deleteApiVendorTimeoff: (
      vendorGuid: string,
      vendorTimeOffGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/timeoffs/${vendorTimeOffGuid}`,
        operation: "deleteApiVendorTimeoff",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get vendor's medical test parameters
     *
     * @tags default
     * @name GetApiVendorMedicalTestParameterList
     * @request GET:/v1/vendors/{vendor_guid}/vendor_medical_test_parameters
     */
    getApiVendorMedicalTestParameterList: (
      vendorGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorMedicalTestParameterListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/vendor_medical_test_parameters`,
        operation: "getApiVendorMedicalTestParameterList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create vendor medical test parameter
     *
     * @tags default
     * @name PostApiVendorMedicalTestParameterList
     * @request POST:/v1/vendors/{vendor_guid}/vendor_medical_test_parameters
     */
    postApiVendorMedicalTestParameterList: (
      vendorGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        allergen?: string;
        i_test_kit_type?: number;
        labclinic_v11_parameter_id?: string;
        labclinic_v11_parameter_name?: string;
        long_name?: string;
        name?: string;
        price?: number;
        specimen_amount?: number;
        vendor_test_machine_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        VendorMedicalTestParameterSuccess,
        ApiVendorMedicalTestParameterListError | AuthError | ForbiddenError
      >({
        path: `/v1/vendors/${vendorGuid}/vendor_medical_test_parameters`,
        operation: "postApiVendorMedicalTestParameterList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get vendor's medical test parameter
     *
     * @tags default
     * @name GetApiVendorMedicalTestParameter
     * @request GET:/v1/vendors/{vendor_guid}/vendor_medical_test_parameters/{vendor_medical_test_parameter_guid}
     */
    getApiVendorMedicalTestParameter: (
      vendorGuid: string,
      vendorMedicalTestParameterGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorMedicalTestParameterSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/vendor_medical_test_parameters/${vendorMedicalTestParameterGuid}`,
        operation: "getApiVendorMedicalTestParameter",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update vendor's medical test parameter
     *
     * @tags default
     * @name PutApiVendorMedicalTestParameter
     * @request PUT:/v1/vendors/{vendor_guid}/vendor_medical_test_parameters/{vendor_medical_test_parameter_guid}
     */
    putApiVendorMedicalTestParameter: (
      vendorGuid: string,
      vendorMedicalTestParameterGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        allergen?: string;
        i_test_kit_type?: number;
        labclinic_v11_parameter_id?: string;
        labclinic_v11_parameter_name?: string;
        long_name?: string;
        name?: string;
        price?: number;
        specimen_amount?: number;
        vendor_test_machine_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        VendorMedicalTestParameterSuccess,
        ApiVendorMedicalTestParameterPutError | AuthError | ForbiddenError
      >({
        path: `/v1/vendors/${vendorGuid}/vendor_medical_test_parameters/${vendorMedicalTestParameterGuid}`,
        operation: "putApiVendorMedicalTestParameter",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete vendor's medical test parameter
     *
     * @tags default
     * @name DeleteApiVendorMedicalTestParameter
     * @request DELETE:/v1/vendors/{vendor_guid}/vendor_medical_test_parameters/{vendor_medical_test_parameter_guid}
     */
    deleteApiVendorMedicalTestParameter: (
      vendorGuid: string,
      vendorMedicalTestParameterGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, ApiVendorMedicalTestParameterDeleteError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/vendor_medical_test_parameters/${vendorMedicalTestParameterGuid}`,
        operation: "deleteApiVendorMedicalTestParameter",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get vendor's medical tests
     *
     * @tags default
     * @name GetApiVendorMedicalTestList
     * @request GET:/v1/vendors/{vendor_guid}/vendor_medical_tests
     */
    getApiVendorMedicalTestList: (
      vendorGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
        /** @default false */
        include_custom?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorMedicalTestListSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/vendor_medical_tests`,
        operation: "getApiVendorMedicalTestList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create vendor medical test
     *
     * @tags default
     * @name PostApiVendorMedicalTestList
     * @request POST:/v1/vendors/{vendor_guid}/vendor_medical_tests
     */
    postApiVendorMedicalTestList: (
      vendorGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        available?: boolean;
        long_name?: string;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorMedicalTestSuccess, ApiVendorMedicalTestListError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/vendor_medical_tests`,
        operation: "postApiVendorMedicalTestList",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get vendor's medical test
     *
     * @tags default
     * @name GetApiVendorMedicalTest
     * @request GET:/v1/vendors/{vendor_guid}/vendor_medical_tests/{vendor_medical_test_guid}
     */
    getApiVendorMedicalTest: (
      vendorGuid: string,
      vendorMedicalTestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorMedicalTestSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/vendor_medical_tests/${vendorMedicalTestGuid}`,
        operation: "getApiVendorMedicalTest",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update vendor's medical test
     *
     * @tags default
     * @name PutApiVendorMedicalTest
     * @request PUT:/v1/vendors/{vendor_guid}/vendor_medical_tests/{vendor_medical_test_guid}
     */
    putApiVendorMedicalTest: (
      vendorGuid: string,
      vendorMedicalTestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        available?: boolean;
        long_name?: string;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorMedicalTestSuccess, ApiVendorMedicalTestError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/vendor_medical_tests/${vendorMedicalTestGuid}`,
        operation: "putApiVendorMedicalTest",
        method: "PUT",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete vendor's medical test
     *
     * @tags default
     * @name DeleteApiVendorMedicalTest
     * @request DELETE:/v1/vendors/{vendor_guid}/vendor_medical_tests/{vendor_medical_test_guid}
     */
    deleteApiVendorMedicalTest: (
      vendorGuid: string,
      vendorMedicalTestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/vendor_medical_tests/${vendorMedicalTestGuid}`,
        operation: "deleteApiVendorMedicalTest",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update vendor medical test price
     *
     * @tags default
     * @name PostApiVendorMedicalTestPrice
     * @request POST:/v1/vendors/{vendor_guid}/vendor_medical_tests/{vendor_medical_test_guid}/price
     */
    postApiVendorMedicalTestPrice: (
      vendorGuid: string,
      vendorMedicalTestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        price?: number;
        start?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorMedicalTestSuccess, ApiVendorMedicalTestPriceError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/vendor_medical_tests/${vendorMedicalTestGuid}/price`,
        operation: "postApiVendorMedicalTestPrice",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to add parameter to vendor medical test
     *
     * @tags default
     * @name PostApiVendorMedicalTestParameterLink
     * @request POST:/v1/vendors/{vendor_guid}/vendor_medical_tests/{vendor_medical_test_guid}/vendor_medical_test_parameters
     */
    postApiVendorMedicalTestParameterLink: (
      vendorGuid: string,
      vendorMedicalTestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        vendor_medical_test_parameter_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorMedicalTestSuccess, ApiVendorMedicalTestParameterLinkError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/vendor_medical_tests/${vendorMedicalTestGuid}/vendor_medical_test_parameters`,
        operation: "postApiVendorMedicalTestParameterLink",
        method: "POST",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to remove parameter from vendor medical test
     *
     * @tags default
     * @name DeleteApiVendorMedicalTestParameterLink
     * @request DELETE:/v1/vendors/{vendor_guid}/vendor_medical_tests/{vendor_medical_test_guid}/vendor_medical_test_parameters
     */
    deleteApiVendorMedicalTestParameterLink: (
      vendorGuid: string,
      vendorMedicalTestGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        vendor_medical_test_parameter_guid?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VendorMedicalTestSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/vendors/${vendorGuid}/vendor_medical_tests/${vendorMedicalTestGuid}/vendor_medical_test_parameters`,
        operation: "deleteApiVendorMedicalTestParameterLink",
        method: "DELETE",
        query: query,
        body: payload,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get API version
     *
     * @tags default
     * @name GetVersion
     * @request GET:/v1/version
     */
    getVersion: (params: RequestParams = {}) =>
      this.request<VersionSuccess, any>({
        path: `/v1/version`,
        operation: "getVersion",
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to receive Apozin appointments
     *
     * @tags default
     * @name PostApozinAppointmentWebhook
     * @request POST:/v1/webhooks/apozin/appointments
     */
    postApozinAppointmentWebhook: (payload: ApozinAppointmentWebhookPost, params: RequestParams = {}) =>
      this.request<ApozinInboundAppointmentResponseSuccess, ApozinInboundAppointmentError | ForbiddenError>({
        path: `/v1/webhooks/apozin/appointments`,
        operation: "postApozinAppointmentWebhook",
        method: "POST",
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get currently available Apozin partner services
     *
     * @tags default
     * @name GetApozinAvailableServices
     * @request GET:/v1/webhooks/apozin/services
     */
    getApozinAvailableServices: (
      query: {
        apozin_short_code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApozinAvailableServicesResponseSuccess, NotFoundError | ForbiddenError>({
        path: `/v1/webhooks/apozin/services`,
        operation: "getApozinAvailableServices",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to receive DHL webhook events
     *
     * @tags default
     * @name PostDhlWebhook
     * @request POST:/v1/webhooks/dhl
     */
    postDhlWebhook: (
      payload: {
        data?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/v1/webhooks/dhl`,
        operation: "postDhlWebhook",
        method: "POST",
        body: payload,
        ...params,
      }),

    /**
     * @description Endpoint to receive Labordatenbank webhook events
     *
     * @tags default
     * @name PostLabordatenbankWebhook
     * @request POST:/v1/webhooks/labordatenbank
     */
    postLabordatenbankWebhook: (
      payload: {
        data?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/v1/webhooks/labordatenbank`,
        operation: "postLabordatenbankWebhook",
        method: "POST",
        body: payload,
        ...params,
      }),

    /**
     * @description Endpoint to get website banners
     *
     * @tags default
     * @name GetApiWebsiteBannerList
     * @request GET:/v1/website_banners
     */
    getApiWebsiteBannerList: (
      query: {
        device_guid?: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebsiteBannerListSuccess, NotFoundError | AuthError>({
        path: `/v1/website_banners`,
        operation: "getApiWebsiteBannerList",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to create website banner
     *
     * @tags default
     * @name PostApiWebsiteBannerList
     * @request POST:/v1/website_banners
     */
    postApiWebsiteBannerList: (
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: ApiWebsiteBannerListPost,
      params: RequestParams = {},
    ) =>
      this.request<WebsiteBannerSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/website_banners`,
        operation: "postApiWebsiteBannerList",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get website banner
     *
     * @tags default
     * @name GetApiWebsiteBanner
     * @request GET:/v1/website_banners/{website_banner_guid}
     */
    getApiWebsiteBanner: (
      websiteBannerGuid: string,
      query: {
        device_guid?: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebsiteBannerSuccess, NotFoundError | AuthError>({
        path: `/v1/website_banners/${websiteBannerGuid}`,
        operation: "getApiWebsiteBanner",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to update website banner
     *
     * @tags default
     * @name PutApiWebsiteBanner
     * @request PUT:/v1/website_banners/{website_banner_guid}
     */
    putApiWebsiteBanner: (
      websiteBannerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        auto_translate?: boolean;
        available_for_microsite?: boolean;
        available_for_partners?: boolean;
        available_for_users?: boolean;
        available_from?: string;
        available_to?: string;
        background_color?: string;
        url?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebsiteBannerSuccess, NotFoundError | AuthError>({
        path: `/v1/website_banners/${websiteBannerGuid}`,
        operation: "putApiWebsiteBanner",
        method: "PUT",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to delete website banner
     *
     * @tags default
     * @name DeleteApiWebsiteBanner
     * @request DELETE:/v1/website_banners/{website_banner_guid}
     */
    deleteApiWebsiteBanner: (
      websiteBannerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Success, NotFoundError | AuthError>({
        path: `/v1/website_banners/${websiteBannerGuid}`,
        operation: "deleteApiWebsiteBanner",
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to upsert website banner translation
     *
     * @tags default
     * @name PostApiWebsiteBannerTranslation
     * @request POST:/v1/website_banners/{website_banner_guid}/translations
     */
    postApiWebsiteBannerTranslation: (
      websiteBannerGuid: string,
      query: {
        device_guid: string;
        client_bundle_id: string;
        device_locale: string;
      },
      payload: {
        auto_translate?: boolean;
        content?: string;
        i_language?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebsiteBannerSuccess, NotFoundError | AuthError | ForbiddenError>({
        path: `/v1/website_banners/${websiteBannerGuid}/translations`,
        operation: "postApiWebsiteBannerTranslation",
        method: "POST",
        query: query,
        body: payload,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint to get active website banner for public access
     *
     * @tags default
     * @name GetApiActiveWebsiteBanner
     * @request GET:/v1/website_banners/active
     */
    getApiActiveWebsiteBanner: (
      query: {
        client_bundle_id: string;
        device_locale: string;
        banner_type: "microsite" | "partners" | "users";
      },
      params: RequestParams = {},
    ) =>
      this.request<WebsiteBannerSuccess, NotFoundError>({
        path: `/v1/website_banners/active`,
        operation: "getApiActiveWebsiteBanner",
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
